/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/merch/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(175);
	module.exports = __webpack_require__(84);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(186);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(133)();
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(136);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductProvider = exports.CartContext = exports.ShopsContext = exports.CheckoutsContext = exports.ProductsContext = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shopifyBuy = __webpack_require__(8);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	var _reactActivity = __webpack_require__(135);
	
	__webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductsContext = exports.ProductsContext = (0, _react.createContext)([]);
	var CheckoutsContext = exports.CheckoutsContext = (0, _react.createContext)([]);
	var ShopsContext = exports.ShopsContext = (0, _react.createContext)([]);
	var CartContext = exports.CartContext = (0, _react.createContext)([]);
	
	var client = _shopifyBuy2.default.buildClient({
	  domain: 'conecuh-brands.myshopify.com',
	  storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
	});
	
	var ProductProvider = exports.ProductProvider = function ProductProvider(props) {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      products = _useState2[0],
	      setProducts = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hats = _useState4[0],
	      setHats = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      accessarries = _useState6[0],
	      setAccessarries = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      shirts = _useState8[0],
	      setShirts = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      checkout = _useState10[0],
	      setCheckout = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      shop = _useState12[0],
	      setShop = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      showCart = _useState14[0],
	      setShowCart = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      renderData = _useState16[0],
	      setRenderData = _useState16[1];
	
	  (0, _react.useEffect)(function () {
	    setRenderData(false);
	
	    // client.product.fetchAll().then((products) => {
	    //   // Do something with the products
	    //   console.log(products);
	    // });
	
	
	    // Fetch all collections, including their products
	    // client.collection.fetchAllWithProducts().then((collections) => {
	    //   // Do something with the collections
	    //   // console.log(collections);
	    //   console.log(collections);
	    // });
	
	
	    client.checkout.create().then(function (res) {
	      setCheckout(res);
	      client.collection.fetchWithProducts("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzI3NjUzMjgyMjE3MQ==", { productsFirst: 100 }).then(function (collection) {
	
	        //  console.log(collection);
	        setProducts(collection.products);
	        setHats(collection.products);
	        client.collection.fetchWithProducts("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzE2OTk3NjA3MDI4MQ==", { productsFirst: 100 }).then(function (collection) {
	          setProducts(function (products) {
	            return products.concat(collection.products);
	          });
	          setShirts(collection.products);
	          client.collection.fetchWithProducts("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzE4MTMzODIxMDQ0MQ==", { productsFirst: 100 }).then(function (collection) {
	            setProducts(function (products) {
	              return products.concat(collection.products);
	            });
	            setAccessarries(collection.products);
	            client.shop.fetchInfo().then(function (res) {
	              setShop(res);
	              setRenderData(true);
	            });
	          });
	        });
	      });
	    });
	  }, []);
	
	  if (renderData) {
	
	    // console.log(products)
	
	    return _react2.default.createElement(
	      ProductsContext.Provider,
	      { value: { all_products: products, hats: hats, shirts: shirts, accessarries: accessarries } },
	      _react2.default.createElement(
	        CheckoutsContext.Provider,
	        { value: [checkout, setCheckout] },
	        _react2.default.createElement(
	          ShopsContext.Provider,
	          { value: shop },
	          _react2.default.createElement(
	            CartContext.Provider,
	            { value: [showCart, setShowCart] },
	            props.children
	          )
	        )
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      'div',
	      { style: { height: "100vh", textAlign: "center", overflow: "hidden" }, className: 'loader-bg' },
	      _react2.default.createElement(_reactActivity.Sentry, null)
	    );
	  }
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(45);
	var DomHandler = __webpack_require__(35);
	
	function defineProp(name, value) {
	    delete module.exports[name];
	    module.exports[name] = value;
	    return value;
	}
	
	module.exports = {
	    Parser: Parser,
	    Tokenizer: __webpack_require__(46),
	    ElementType: __webpack_require__(9),
	    DomHandler: DomHandler,
	    get FeedHandler() {
	        return defineProp("FeedHandler", __webpack_require__(112));
	    },
	    get Stream() {
	        return defineProp("Stream", __webpack_require__(114));
	    },
	    get WritableStream() {
	        return defineProp("WritableStream", __webpack_require__(47));
	    },
	    get ProxyHandler() {
	        return defineProp("ProxyHandler", __webpack_require__(113));
	    },
	    get DomUtils() {
	        return defineProp("DomUtils", __webpack_require__(37));
	    },
	    get CollectingHandler() {
	        return defineProp(
	            "CollectingHandler",
	            __webpack_require__(111)
	        );
	    },
	    // For legacy support
	    DefaultHandler: DomHandler,
	    get RssHandler() {
	        return defineProp("RssHandler", this.FeedHandler);
	    },
	    //helper methods
	    parseDOM: function(data, options) {
	        var handler = new DomHandler(options);
	        new Parser(handler, options).end(data);
	        return handler.dom;
	    },
	    parseFeed: function(feed, options) {
	        var handler = new module.exports.FeedHandler(options);
	        new Parser(handler, options).end(feed);
	        return handler.dom;
	    },
	    createDomStream: function(cb, options, elementCb) {
	        var handler = new DomHandler(cb, options, elementCb);
	        return new Parser(handler, options);
	    },
	    // List of all events that the parser emits
	    EVENTS: {
	        /* Format: eventname: number of arguments */
	        attribute: 2,
	        cdatastart: 0,
	        cdataend: 0,
	        text: 1,
	        processinginstruction: 2,
	        comment: 1,
	        commentend: 0,
	        closetag: 1,
	        opentag: 2,
	        opentagname: 1,
	        error: 1,
	        end: 0
	    }
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(2);
	
	var ReactCurrentOwner = __webpack_require__(62);
	
	var warning = __webpack_require__(21);
	var canDefineProperty = __webpack_require__(65);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(63);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 8 */
/***/ function(module, exports) {

	/*
	@license
	The MIT License (MIT)
	
	Copyright (c) 2016 Shopify Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a
	copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be included
	in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	*/
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck$1 = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass$1 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits$1 = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn$1 = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/*
	The MIT License (MIT)
	Copyright (c) 2016 Shopify Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	*/
	function join() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return fields.join(' ');
	}
	
	function isObject(value) {
	  return Boolean(value) && Object.prototype.toString.call(value.valueOf()) === '[object Object]';
	}
	
	function deepFreezeCopyExcept(predicate, structure) {
	  if (predicate(structure)) {
	    return structure;
	  } else if (isObject(structure)) {
	    return Object.freeze(Object.keys(structure).reduce(function (copy, key) {
	      copy[key] = deepFreezeCopyExcept(predicate, structure[key]);
	
	      return copy;
	    }, {}));
	  } else if (Array.isArray(structure)) {
	    return Object.freeze(structure.map(function (item) {
	      return deepFreezeCopyExcept(predicate, item);
	    }));
	  } else {
	    return structure;
	  }
	}
	
	function schemaForType(typeBundle, typeName) {
	  var typeSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var type = typeBundle.types[typeName];
	
	  if (type) {
	    return type;
	  } else if (typeSchema && typeSchema.kind === 'INTERFACE') {
	    return typeSchema;
	  }
	
	  throw new Error('No type of ' + typeName + ' found in schema');
	}
	
	var classCallCheck = function classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var toConsumableArray = function toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var VariableDefinition = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#variable} to create a VariableDefinition.
	   *
	   * @param {String} name The name of the variable.
	   * @param {String} type The GraphQL type of the variable.
	   * @param {*} [defaultValue] The default value of the variable.
	   */
	  function VariableDefinition(name, type, defaultValue) {
	    classCallCheck(this, VariableDefinition);
	
	    this.name = name;
	    this.type = type;
	    this.defaultValue = defaultValue;
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the variable as an input value (e.g. `$variableName`).
	   *
	   * @return {String} The GraphQL query string for the variable as an input value.
	   */
	
	  createClass(VariableDefinition, [{
	    key: 'toInputValueString',
	    value: function toInputValueString() {
	      return '$' + this.name;
	    }
	
	    /**
	     * Returns the GraphQL query string for the variable (e.g. `$variableName:VariableType = defaultValue`).
	     *
	     * @return {String} The GraphQL query string for the variable.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var defaultValueString = this.defaultValue ? ' = ' + formatInputValue(this.defaultValue) : '';
	
	      return '$' + this.name + ':' + this.type + defaultValueString;
	    }
	  }]);
	  return VariableDefinition;
	}();
	
	function isVariable(value) {
	  return VariableDefinition.prototype.isPrototypeOf(value);
	}
	
	function variable(name, type, defaultValue) {
	  return new VariableDefinition(name, type, defaultValue);
	}
	
	var Enum = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#enum} to create an Enum.
	   *
	   * @param {String} key The key of the enum.
	   */
	  function Enum(key) {
	    classCallCheck(this, Enum);
	
	    this.key = key;
	  }
	
	  /**
	   * Returns the GraphQL query string for the enum (e.g. `enumKey`).
	   *
	   * @return {String} The GraphQL query string for the enum.
	   */
	
	  createClass(Enum, [{
	    key: "toString",
	    value: function toString() {
	      return this.key;
	    }
	  }, {
	    key: "valueOf",
	    value: function valueOf() {
	      return this.key.valueOf();
	    }
	  }]);
	  return Enum;
	}();
	
	var enumFunction = function enumFunction(key) {
	  return new Enum(key);
	};
	
	var Scalar = function () {
	  function Scalar(value) {
	    classCallCheck(this, Scalar);
	
	    this.value = value;
	  }
	
	  createClass(Scalar, [{
	    key: "toString",
	    value: function toString() {
	      return this.value.toString();
	    }
	  }, {
	    key: "valueOf",
	    value: function valueOf() {
	      return this.value.valueOf();
	    }
	  }, {
	    key: "unwrapped",
	    get: function get$$1() {
	      return this.value;
	    }
	  }]);
	  return Scalar;
	}();
	
	function formatInputValue(value) {
	  if (VariableDefinition.prototype.isPrototypeOf(value)) {
	    return value.toInputValueString();
	  } else if (Enum.prototype.isPrototypeOf(value)) {
	    return String(value);
	  } else if (Scalar.prototype.isPrototypeOf(value)) {
	    return JSON.stringify(value.valueOf());
	  } else if (Array.isArray(value)) {
	    return '[' + join.apply(undefined, toConsumableArray(value.map(formatInputValue))) + ']';
	  } else if (isObject(value)) {
	    return formatObject(value, '{', '}');
	  } else {
	    return JSON.stringify(value);
	  }
	}
	
	function formatObject(value) {
	  var openChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var closeChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var argPairs = Object.keys(value).map(function (key) {
	    return key + ': ' + formatInputValue(value[key]);
	  });
	
	  return '' + openChar + join.apply(undefined, toConsumableArray(argPairs)) + closeChar;
	}
	
	function formatArgs(args) {
	  if (!Object.keys(args).length) {
	    return '';
	  }
	
	  return ' (' + formatObject(args) + ')';
	}
	
	function formatDirectives(directives) {
	  if (!Object.keys(directives).length) {
	    return '';
	  }
	
	  var directiveStrings = Object.keys(directives).map(function (key) {
	    var directiveArgs = directives[key];
	    var arg = directiveArgs && Object.keys(directiveArgs).length ? '(' + formatObject(directiveArgs) + ')' : '';
	
	    return '@' + key + arg;
	  });
	
	  return ' ' + join.apply(undefined, toConsumableArray(directiveStrings));
	}
	
	// eslint-disable-next-line no-empty-function
	var noop = function noop() {};
	
	var Profiler = {
	  trackTypeDependency: noop,
	  trackFieldDependency: noop
	};
	
	var trackTypeDependency = Profiler.trackTypeDependency;
	var trackFieldDependency = Profiler.trackFieldDependency;
	
	function parseFieldCreationArgs(creationArgs) {
	  var callback = noop;
	  var options = {};
	  var selectionSet = null;
	
	  if (creationArgs.length === 2) {
	    if (typeof creationArgs[1] === 'function') {
	      var _creationArgs = slicedToArray(creationArgs, 2);
	
	      options = _creationArgs[0];
	      callback = _creationArgs[1];
	    } else {
	      var _creationArgs2 = slicedToArray(creationArgs, 2);
	
	      options = _creationArgs2[0];
	      selectionSet = _creationArgs2[1];
	    }
	  } else if (creationArgs.length === 1) {
	    // SelectionSet is defined before this function is called since it's
	    // called by SelectionSet
	    // eslint-disable-next-line no-use-before-define
	    if (SelectionSet.prototype.isPrototypeOf(creationArgs[0])) {
	      selectionSet = creationArgs[0];
	    } else if (typeof creationArgs[0] === 'function') {
	      callback = creationArgs[0];
	    } else {
	      options = creationArgs[0];
	    }
	  }
	
	  return { options: options, selectionSet: selectionSet, callback: callback };
	}
	
	var emptyArgs = Object.freeze({});
	var emptyDirectives = Object.freeze({});
	
	var Field = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Fields are added to a selection by {@link SelectionSetBuilder#add}, {@link SelectionSetBuilder#addConnection}
	   * and {@link SelectionSetBuilder#addInlineFragmentOn}.
	   *
	   * @param {String} name The name of the field.
	   * @param {Object} [options] An options object containing:
	   *   @param {Object} [options.args] Arguments for the field.
	   *   @param {String} [options.alias] An alias for the field.
	   *   @param {Object} [options.directives] Directives for the field.
	   * @param {SelectionSet} selectionSet The selection set on the field.
	   */
	  function Field(name, options, selectionSet) {
	    classCallCheck(this, Field);
	
	    this.name = name;
	    this.alias = options.alias || null;
	    this.responseKey = this.alias || this.name;
	    this.args = options.args ? deepFreezeCopyExcept(isVariable, options.args) : emptyArgs;
	    this.directives = options.directives ? deepFreezeCopyExcept(isVariable, options.directives) : emptyDirectives;
	    this.selectionSet = selectionSet;
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the Field (e.g. `catAlias: cat(size: 'small') { name }` or `name`).
	   *
	   * @return {String} The GraphQL query string for the Field.
	   */
	
	  createClass(Field, [{
	    key: 'toString',
	    value: function toString() {
	      var aliasPrefix = this.alias ? this.alias + ': ' : '';
	
	      return '' + aliasPrefix + this.name + formatArgs(this.args) + formatDirectives(this.directives) + this.selectionSet;
	    }
	  }]);
	  return Field;
	}();
	
	// This is an interface that defines a usage, and simplifies type checking
	var Spread = function Spread() {
	  classCallCheck(this, Spread);
	};
	
	var InlineFragment = function (_Spread) {
	  inherits(InlineFragment, _Spread);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link SelectionSetBuilder#addInlineFragmentOn} to create an InlineFragment.
	   *
	   * @param {String} typeName The type of the fragment.
	   * @param {SelectionSet} selectionSet The selection set on the fragment.
	   */
	  function InlineFragment(typeName, selectionSet) {
	    classCallCheck(this, InlineFragment);
	
	    var _this = possibleConstructorReturn(this, (InlineFragment.__proto__ || Object.getPrototypeOf(InlineFragment)).call(this));
	
	    _this.typeName = typeName;
	    _this.selectionSet = selectionSet;
	    Object.freeze(_this);
	    return _this;
	  }
	
	  /**
	   * Returns the GraphQL query string for the InlineFragment (e.g. `... on Cat { name }`).
	   *
	   * @return {String} The GraphQL query string for the InlineFragment.
	   */
	
	  createClass(InlineFragment, [{
	    key: 'toString',
	    value: function toString() {
	      return '... on ' + this.typeName + this.selectionSet;
	    }
	  }]);
	  return InlineFragment;
	}(Spread);
	
	var FragmentSpread = function (_Spread2) {
	  inherits(FragmentSpread, _Spread2);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Document#defineFragment} to create a FragmentSpread.
	   *
	   * @param {FragmentDefinition} fragmentDefinition The corresponding fragment definition.
	   */
	  function FragmentSpread(fragmentDefinition) {
	    classCallCheck(this, FragmentSpread);
	
	    var _this2 = possibleConstructorReturn(this, (FragmentSpread.__proto__ || Object.getPrototypeOf(FragmentSpread)).call(this));
	
	    _this2.name = fragmentDefinition.name;
	    _this2.selectionSet = fragmentDefinition.selectionSet;
	    Object.freeze(_this2);
	    return _this2;
	  }
	
	  /**
	   * Returns the GraphQL query string for the FragmentSpread (e.g. `...catName`).
	   *
	   * @return {String} The GraphQL query string for the FragmentSpread.
	   */
	
	  createClass(FragmentSpread, [{
	    key: 'toString',
	    value: function toString() {
	      return '...' + this.name;
	    }
	  }, {
	    key: 'toDefinition',
	    value: function toDefinition() {
	      // eslint-disable-next-line no-use-before-define
	      return new FragmentDefinition(this.name, this.selectionSet.typeSchema.name, this.selectionSet);
	    }
	  }]);
	  return FragmentSpread;
	}(Spread);
	
	var FragmentDefinition = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Document#defineFragment} to create a FragmentDefinition on a {@link Document}.
	   *
	   * @param {String} name The name of the fragment definition.
	   * @param {String} typeName The type of the fragment.
	   */
	  function FragmentDefinition(name, typeName, selectionSet) {
	    classCallCheck(this, FragmentDefinition);
	
	    this.name = name;
	    this.typeName = typeName;
	    this.selectionSet = selectionSet;
	    this.spread = new FragmentSpread(this);
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the FragmentDefinition (e.g. `fragment catName on Cat { name }`).
	   *
	   * @return {String} The GraphQL query string for the FragmentDefinition.
	   */
	
	  createClass(FragmentDefinition, [{
	    key: 'toString',
	    value: function toString() {
	      return 'fragment ' + this.name + ' on ' + this.typeName + ' ' + this.selectionSet;
	    }
	  }]);
	  return FragmentDefinition;
	}();
	
	function selectionsHaveIdField(selections) {
	  return selections.some(function (fieldOrFragment) {
	    if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
	      return fieldOrFragment.name === 'id';
	    } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
	      return selectionsHaveIdField(fieldOrFragment.selectionSet.selections);
	    }
	
	    return false;
	  });
	}
	
	function selectionsHaveTypenameField(selections) {
	  return selections.some(function (fieldOrFragment) {
	    if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
	      return fieldOrFragment.name === '__typename';
	    } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
	      return selectionsHaveTypenameField(fieldOrFragment.selectionSet.selections);
	    }
	
	    return false;
	  });
	}
	
	function indexSelectionsByResponseKey(selections) {
	  function assignOrPush(obj, key, value) {
	    if (Array.isArray(obj[key])) {
	      obj[key].push(value);
	    } else {
	      obj[key] = [value];
	    }
	  }
	  var unfrozenObject = selections.reduce(function (acc, selection) {
	    if (selection.responseKey) {
	      assignOrPush(acc, selection.responseKey, selection);
	    } else {
	      var responseKeys = Object.keys(selection.selectionSet.selectionsByResponseKey);
	
	      responseKeys.forEach(function (responseKey) {
	        assignOrPush(acc, responseKey, selection);
	      });
	    }
	
	    return acc;
	  }, {});
	
	  Object.keys(unfrozenObject).forEach(function (key) {
	    Object.freeze(unfrozenObject[key]);
	  });
	
	  return Object.freeze(unfrozenObject);
	}
	
	/**
	 * Class that specifies the full selection of data to query.
	 */
	
	var SelectionSet = function () {
	
	  /**
	   * This constructor should not be invoked directly. SelectionSets are created when building queries/mutations.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {(Object|String)} type The type of the current selection.
	   * @param {Function} builderFunction Callback function used to build the SelectionSet.
	   *   The callback takes a {@link SelectionSetBuilder} as its argument.
	   */
	  function SelectionSet(typeBundle, type, builderFunction) {
	    classCallCheck(this, SelectionSet);
	
	    if (typeof type === 'string') {
	      this.typeSchema = schemaForType(typeBundle, type);
	    } else {
	      this.typeSchema = type;
	    }
	
	    trackTypeDependency(this.typeSchema.name);
	
	    this.typeBundle = typeBundle;
	    this.selections = [];
	    if (builderFunction) {
	      // eslint-disable-next-line no-use-before-define
	      builderFunction(new SelectionSetBuilder(this.typeBundle, this.typeSchema, this.selections));
	    }
	
	    if (this.typeSchema.implementsNode || this.typeSchema.name === 'Node') {
	      if (!selectionsHaveIdField(this.selections)) {
	        this.selections.unshift(new Field('id', {}, new SelectionSet(typeBundle, 'ID')));
	      }
	    }
	
	    if (this.typeSchema.kind === 'INTERFACE') {
	      if (!selectionsHaveTypenameField(this.selections)) {
	        this.selections.unshift(new Field('__typename', {}, new SelectionSet(typeBundle, 'String')));
	      }
	    }
	
	    this.selectionsByResponseKey = indexSelectionsByResponseKey(this.selections);
	    Object.freeze(this.selections);
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the SelectionSet (e.g. `{ cat { name } }`).
	   *
	   * @return {String} The GraphQL query string for the SelectionSet.
	   */
	
	  createClass(SelectionSet, [{
	    key: 'toString',
	    value: function toString() {
	      if (this.typeSchema.kind === 'SCALAR' || this.typeSchema.kind === 'ENUM') {
	        return '';
	      } else {
	        return ' { ' + join(this.selections) + ' }';
	      }
	    }
	  }]);
	  return SelectionSet;
	}();
	
	var SelectionSetBuilder = function () {
	
	  /**
	   * This constructor should not be invoked directly. SelectionSetBuilders are created when building queries/mutations.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {Object} typeSchema The schema object for the type of the current selection.
	   * @param {Field[]} selections The fields on the current selection.
	   */
	  function SelectionSetBuilder(typeBundle, typeSchema, selections) {
	    classCallCheck(this, SelectionSetBuilder);
	
	    this.typeBundle = typeBundle;
	    this.typeSchema = typeSchema;
	    this.selections = selections;
	  }
	
	  createClass(SelectionSetBuilder, [{
	    key: 'hasSelectionWithResponseKey',
	    value: function hasSelectionWithResponseKey(responseKey) {
	      return this.selections.some(function (field) {
	        return field.responseKey === responseKey;
	      });
	    }
	
	    /**
	     * Adds a field to be queried on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('cat', {args: {id: '123456'}, alias: 'meow'}, (cat) => {
	     *     cat.add('name');
	     *   });
	     * });
	     *
	     * @param {SelectionSet|String} selectionOrFieldName The selection or name of the field to add.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function|SelectionSet} [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'add',
	    value: function add(selectionOrFieldName) {
	      var selection = void 0;
	
	      if (Object.prototype.toString.call(selectionOrFieldName) === '[object String]') {
	        trackFieldDependency(this.typeSchema.name, selectionOrFieldName);
	
	        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          rest[_key - 1] = arguments[_key];
	        }
	
	        selection = this.field.apply(this, [selectionOrFieldName].concat(rest));
	      } else {
	        if (Field.prototype.isPrototypeOf(selectionOrFieldName)) {
	          trackFieldDependency(this.typeSchema.name, selectionOrFieldName.name);
	        }
	
	        selection = selectionOrFieldName;
	      }
	
	      if (selection.responseKey && this.hasSelectionWithResponseKey(selection.responseKey)) {
	        throw new Error('The field name or alias \'' + selection.responseKey + '\' has already been added.');
	      }
	      this.selections.push(selection);
	    }
	  }, {
	    key: 'field',
	    value: function field(name) {
	      for (var _len2 = arguments.length, creationArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        creationArgs[_key2 - 1] = arguments[_key2];
	      }
	
	      var parsedArgs = parseFieldCreationArgs(creationArgs);
	      var options = parsedArgs.options,
	          callback = parsedArgs.callback;
	      var selectionSet = parsedArgs.selectionSet;
	
	      if (!selectionSet) {
	        if (!this.typeSchema.fieldBaseTypes[name]) {
	          throw new Error('No field of name "' + name + '" found on type "' + this.typeSchema.name + '" in schema');
	        }
	
	        var fieldBaseType = schemaForType(this.typeBundle, this.typeSchema.fieldBaseTypes[name]);
	
	        selectionSet = new SelectionSet(this.typeBundle, fieldBaseType, callback);
	      }
	
	      return new Field(name, options, selectionSet);
	    }
	
	    /**
	     * Creates an inline fragment.
	     *
	     * @access private
	     * @param {String} typeName The type  the inline fragment.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     * @return {InlineFragment} An inline fragment.
	     */
	
	  }, {
	    key: 'inlineFragmentOn',
	    value: function inlineFragmentOn(typeName) {
	      var builderFunctionOrSelectionSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	      var selectionSet = void 0;
	
	      if (SelectionSet.prototype.isPrototypeOf(builderFunctionOrSelectionSet)) {
	        selectionSet = builderFunctionOrSelectionSet;
	      } else {
	        selectionSet = new SelectionSet(this.typeBundle, schemaForType(this.typeBundle, typeName), builderFunctionOrSelectionSet);
	      }
	
	      return new InlineFragment(typeName, selectionSet);
	    }
	
	    /**
	     * Adds a field to be queried on the current selection.
	     *
	     * @access private
	     * @param {String}    name The name of the field to add to the query.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function}  [callback] Callback which will be used to create a new {@link SelectionSet} for the field added.
	     */
	
	  }, {
	    key: 'addField',
	    value: function addField(name) {
	      for (var _len3 = arguments.length, creationArgs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        creationArgs[_key3 - 1] = arguments[_key3];
	      }
	
	      this.add.apply(this, [name].concat(creationArgs));
	    }
	
	    /**
	     * Adds a connection to be queried on the current selection.
	     * This adds all the fields necessary for pagination.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('cat', (cat) => {
	     *     cat.addConnection('friends', {args: {first: 10}, alias: 'coolCats'}, (friends) => {
	     *       friends.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String}    name The name of the connection to add to the query.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{first: 10}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'addConnection',
	    value: function addConnection(name) {
	      for (var _len4 = arguments.length, creationArgs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        creationArgs[_key4 - 1] = arguments[_key4];
	      }
	
	      var _parseFieldCreationAr = parseFieldCreationArgs(creationArgs),
	          options = _parseFieldCreationAr.options,
	          callback = _parseFieldCreationAr.callback,
	          selectionSet = _parseFieldCreationAr.selectionSet;
	
	      this.add(name, options, function (connection) {
	        connection.add('pageInfo', {}, function (pageInfo) {
	          pageInfo.add('hasNextPage');
	          pageInfo.add('hasPreviousPage');
	        });
	        connection.add('edges', {}, function (edges) {
	          edges.add('cursor');
	          edges.addField('node', {}, selectionSet || callback); // This is bad. Don't do this
	        });
	      });
	    }
	
	    /**
	     * Adds an inline fragment on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('animal', (animal) => {
	     *     animal.addInlineFragmentOn('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String} typeName The name of the type of the inline fragment.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'addInlineFragmentOn',
	    value: function addInlineFragmentOn(typeName) {
	      var fieldTypeCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	      this.add(this.inlineFragmentOn(typeName, fieldTypeCb));
	    }
	
	    /**
	     * Adds a fragment spread on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.addFragment(catFragmentSpread);
	     * });
	     *
	     * @param {FragmentSpread} fragmentSpread The fragment spread to add.
	     */
	
	  }, {
	    key: 'addFragment',
	    value: function addFragment(fragmentSpread) {
	      this.add(fragmentSpread);
	    }
	  }]);
	  return SelectionSetBuilder;
	}();
	
	function parseArgs(args) {
	  var name = void 0;
	  var variables = void 0;
	  var selectionSetCallback = void 0;
	
	  if (args.length === 3) {
	    var _args = slicedToArray(args, 3);
	
	    name = _args[0];
	    variables = _args[1];
	    selectionSetCallback = _args[2];
	  } else if (args.length === 2) {
	    if (Object.prototype.toString.call(args[0]) === '[object String]') {
	      name = args[0];
	      variables = null;
	    } else if (Array.isArray(args[0])) {
	      variables = args[0];
	      name = null;
	    }
	
	    selectionSetCallback = args[1];
	  } else {
	    selectionSetCallback = args[0];
	    name = null;
	  }
	
	  return { name: name, variables: variables, selectionSetCallback: selectionSetCallback };
	}
	
	var VariableDefinitions = function () {
	  function VariableDefinitions(variableDefinitions) {
	    classCallCheck(this, VariableDefinitions);
	
	    this.variableDefinitions = variableDefinitions ? [].concat(toConsumableArray(variableDefinitions)) : [];
	    Object.freeze(this.variableDefinitions);
	    Object.freeze(this);
	  }
	
	  createClass(VariableDefinitions, [{
	    key: 'toString',
	    value: function toString() {
	      if (this.variableDefinitions.length === 0) {
	        return '';
	      }
	
	      return ' (' + join(this.variableDefinitions) + ') ';
	    }
	  }]);
	  return VariableDefinitions;
	}();
	
	/**
	 * Base class for {@link Query} and {@link Mutation}.
	 * @abstract
	 */
	
	var Operation = function () {
	
	  /**
	   * This constructor should not be invoked. The subclasses {@link Query} and {@link Mutation} should be used instead.
	   */
	  function Operation(typeBundle, operationType) {
	    classCallCheck(this, Operation);
	
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var _parseArgs = parseArgs(args),
	        name = _parseArgs.name,
	        variables = _parseArgs.variables,
	        selectionSetCallback = _parseArgs.selectionSetCallback;
	
	    this.typeBundle = typeBundle;
	    this.name = name;
	    this.variableDefinitions = new VariableDefinitions(variables);
	    this.operationType = operationType;
	    if (operationType === 'query') {
	      this.selectionSet = new SelectionSet(typeBundle, typeBundle.queryType, selectionSetCallback);
	      this.typeSchema = schemaForType(typeBundle, typeBundle.queryType);
	    } else {
	      this.selectionSet = new SelectionSet(typeBundle, typeBundle.mutationType, selectionSetCallback);
	      this.typeSchema = schemaForType(typeBundle, typeBundle.mutationType);
	    }
	    Object.freeze(this);
	  }
	
	  /**
	   * Whether the operation is anonymous (i.e. has no name).
	   */
	
	  createClass(Operation, [{
	    key: 'toString',
	
	    /**
	     * Returns the GraphQL query or mutation string (e.g. `query myQuery { cat { name } }`).
	     *
	     * @return {String} The GraphQL query or mutation string.
	     */
	    value: function toString() {
	      var nameString = this.name ? ' ' + this.name : '';
	
	      return '' + this.operationType + nameString + this.variableDefinitions + this.selectionSet;
	    }
	  }, {
	    key: 'isAnonymous',
	    get: function get$$1() {
	      return !this.name;
	    }
	  }]);
	  return Operation;
	}();
	
	/**
	 * GraphQL Query class.
	 * @extends Operation
	 */
	
	var Query = function (_Operation) {
	  inherits(Query, _Operation);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory functions {@link Client#query} or {@link Document#addQuery} to create a Query.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {String} [name] A name for the query.
	   * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
	   * @param {Function} selectionSetCallback The query builder callback.
	   *   A {@link SelectionSet} is created using this callback.
	   */
	  function Query(typeBundle) {
	    var _ref;
	
	    classCallCheck(this, Query);
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return possibleConstructorReturn(this, (_ref = Query.__proto__ || Object.getPrototypeOf(Query)).call.apply(_ref, [this, typeBundle, 'query'].concat(args)));
	  }
	
	  return Query;
	}(Operation);
	
	/**
	 * GraphQL Mutation class.
	 * @extends Operation
	 */
	
	var Mutation = function (_Operation) {
	  inherits(Mutation, _Operation);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory functions {@link Client#mutation} or {@link Document#addMutation} to create a Mutation.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {String} [name] A name for the mutation.
	   * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	   * @param {Function} selectionSetCallback The mutation builder callback.
	   *   A {@link SelectionSet} is created using this callback.
	   */
	  function Mutation(typeBundle) {
	    var _ref;
	
	    classCallCheck(this, Mutation);
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return possibleConstructorReturn(this, (_ref = Mutation.__proto__ || Object.getPrototypeOf(Mutation)).call.apply(_ref, [this, typeBundle, 'mutation'].concat(args)));
	  }
	
	  return Mutation;
	}(Operation);
	
	function isAnonymous(operation) {
	  return operation.isAnonymous;
	}
	
	function hasAnonymousOperations(operations) {
	  return operations.some(isAnonymous);
	}
	
	function hasDuplicateOperationNames(operations) {
	  var names = operations.map(function (operation) {
	    return operation.name;
	  });
	
	  return names.reduce(function (hasDuplicates, name, index) {
	    return hasDuplicates || names.indexOf(name) !== index;
	  }, false);
	}
	
	function extractOperation(typeBundle, operationType) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  if (Operation.prototype.isPrototypeOf(args[0])) {
	    return args[0];
	  }
	
	  if (operationType === 'query') {
	    return new (Function.prototype.bind.apply(Query, [null].concat([typeBundle], args)))();
	  } else {
	    return new (Function.prototype.bind.apply(Mutation, [null].concat([typeBundle], args)))();
	  }
	}
	
	function isInvalidOperationCombination(operations) {
	  if (operations.length === 1) {
	    return false;
	  }
	
	  return hasAnonymousOperations(operations) || hasDuplicateOperationNames(operations);
	}
	
	function fragmentNameIsNotUnique(existingDefinitions, name) {
	  return existingDefinitions.some(function (definition) {
	    return definition.name === name;
	  });
	}
	
	var Document = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#document} to create a Document.
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   */
	  function Document(typeBundle) {
	    classCallCheck(this, Document);
	
	    this.typeBundle = typeBundle;
	    this.definitions = [];
	  }
	
	  /**
	   * Returns the GraphQL query string for the Document (e.g. `query queryOne { ... } query queryTwo { ... }`).
	   *
	   * @return {String} The GraphQL query string for the Document.
	   */
	
	  createClass(Document, [{
	    key: 'toString',
	    value: function toString() {
	      return join(this.definitions);
	    }
	
	    /**
	     * Adds an operation to the Document.
	     *
	     * @private
	     * @param {String} operationType The type of the operation. Either 'query' or 'mutation'.
	     * @param {(Operation|String)} [query|queryName] Either an instance of an operation
	     *   object, or the name of an operation. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the operation. See {@link Client#variable}.
	     * @param {Function} [callback] The query builder callback. If an operation
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	      */
	
	  }, {
	    key: 'addOperation',
	    value: function addOperation(operationType) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      var operation = extractOperation.apply(undefined, [this.typeBundle, operationType].concat(args));
	
	      if (isInvalidOperationCombination(this.operations.concat(operation))) {
	        throw new Error('All operations must be uniquely named on a multi-operation document');
	      }
	
	      this.definitions.push(operation);
	    }
	
	    /**
	     * Adds a query to the Document.
	     *
	     * @example
	     * document.addQuery('myQuery', (root) => {
	     *   root.add('cat', (cat) => {
	     *    cat.add('name');
	     *   });
	     * });
	     *
	     * @param {(Query|String)} [query|queryName] Either an instance of a query
	     *   object, or the name of a query. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
	     * @param {Function} [callback] The query builder callback. If a query
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	     */
	
	  }, {
	    key: 'addQuery',
	    value: function addQuery() {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      this.addOperation.apply(this, ['query'].concat(args));
	    }
	
	    /**
	     * Adds a mutation to the Document.
	     *
	     * @example
	     * const input = client.variable('input', 'CatCreateInput!');
	     *
	     * document.addMutation('myMutation', [input], (root) => {
	     *   root.add('catCreate', {args: {input}}, (catCreate) => {
	     *     catCreate.add('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {(Mutation|String)} [mutation|mutationName] Either an instance of a mutation
	     *   object, or the name of a mutation. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	     * @param {Function} [callback] The mutation builder callback. If a mutation
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	     */
	
	  }, {
	    key: 'addMutation',
	    value: function addMutation() {
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      this.addOperation.apply(this, ['mutation'].concat(args));
	    }
	
	    /**
	     * Defines a fragment on the Document.
	     *
	     * @param {String} name The name of the fragment.
	     * @param {String} onType The type the fragment is on.
	     * @param {Function} [builderFunction] The query builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {FragmentSpread} A {@link FragmentSpread} to be used with {@link SelectionSetBuilder#addFragment}.
	     */
	
	  }, {
	    key: 'defineFragment',
	    value: function defineFragment(name, onType, builderFunction) {
	      if (fragmentNameIsNotUnique(this.fragmentDefinitions, name)) {
	        throw new Error('All fragments must be uniquely named on a multi-fragment document');
	      }
	
	      var selectionSet = new SelectionSet(this.typeBundle, onType, builderFunction);
	      var fragment = new FragmentDefinition(name, onType, selectionSet);
	
	      this.definitions.push(fragment);
	
	      return fragment.spread;
	    }
	
	    /**
	     * All operations ({@link Query} and {@link Mutation}) on the Document.
	     */
	
	  }, {
	    key: 'operations',
	    get: function get$$1() {
	      return this.definitions.filter(function (definition) {
	        return Operation.prototype.isPrototypeOf(definition);
	      });
	    }
	
	    /**
	     * All {@link FragmentDefinition}s on the Document.
	     */
	
	  }, {
	    key: 'fragmentDefinitions',
	    get: function get$$1() {
	      return this.definitions.filter(function (definition) {
	        return FragmentDefinition.prototype.isPrototypeOf(definition);
	      });
	    }
	  }]);
	  return Document;
	}();
	
	/**
	 * The base class used when deserializing response data.
	 * Provides rich features, like functions to generate queries to refetch a node or fetch the next page.
	 *
	 * @class
	 */
	var GraphModel =
	
	/**
	 * @param {Object} attrs Attributes on the GraphModel.
	 */
	function GraphModel(attrs) {
	  var _this = this;
	
	  classCallCheck(this, GraphModel);
	
	  Object.defineProperty(this, 'attrs', { value: attrs, enumerable: false });
	
	  Object.keys(this.attrs).filter(function (key) {
	    return !(key in _this);
	  }).forEach(function (key) {
	    var descriptor = void 0;
	
	    if (attrs[key] === null) {
	      descriptor = {
	        enumerable: true,
	        get: function get$$1() {
	          return null;
	        }
	      };
	    } else {
	      descriptor = {
	        enumerable: true,
	        get: function get$$1() {
	          return this.attrs[key].valueOf();
	        }
	      };
	    }
	    Object.defineProperty(_this, key, descriptor);
	  });
	};
	
	/**
	 * A registry of classes used to deserialize the response data. Uses {@link GraphModel} by default.
	 */
	
	var ClassRegistry = function () {
	  function ClassRegistry() {
	    classCallCheck(this, ClassRegistry);
	
	    this.classStore = {};
	  }
	
	  /**
	   * Registers a class for a GraphQL type in the registry.
	   *
	   * @param {Class} constructor The constructor of the class.
	   * @param {String} type The GraphQL type of the object to deserialize into the class.
	   */
	
	  createClass(ClassRegistry, [{
	    key: 'registerClassForType',
	    value: function registerClassForType(constructor, type) {
	      this.classStore[type] = constructor;
	    }
	
	    /**
	     * Unregisters a class for a GraphQL type in the registry.
	     *
	     * @param {String} type The GraphQL type to unregister.
	     */
	
	  }, {
	    key: 'unregisterClassForType',
	    value: function unregisterClassForType(type) {
	      delete this.classStore[type];
	    }
	
	    /**
	     * Returns the class for the given GraphQL type.
	     *
	     * @param {String} type The GraphQL type to look up.
	     * @return {Class|GraphModel} The class for the given GraphQL type. Defaults to {@link GraphModel} if no class is registered for the GraphQL type.
	     */
	
	  }, {
	    key: 'classForType',
	    value: function classForType(type) {
	      return this.classStore[type] || GraphModel;
	    }
	  }]);
	  return ClassRegistry;
	}();
	
	function isValue(arg) {
	  return Object.prototype.toString.call(arg) !== '[object Null]' && Object.prototype.toString.call(arg) !== '[object Undefined]';
	}
	
	function isNodeContext(context) {
	  return context.selection.selectionSet.typeSchema.implementsNode;
	}
	
	function isConnection(context) {
	  return context.selection.selectionSet.typeSchema.name.endsWith('Connection');
	}
	
	function nearestNode(context) {
	  if (context == null) {
	    return null;
	  } else if (isNodeContext(context)) {
	    return context;
	  } else {
	    return nearestNode(context.parent);
	  }
	}
	
	function contextsFromRoot(context) {
	  if (context.parent) {
	    return contextsFromRoot(context.parent).concat(context);
	  } else {
	    return [context];
	  }
	}
	
	function contextsFromNearestNode(context) {
	  if (context.selection.selectionSet.typeSchema.implementsNode) {
	    return [context];
	  } else {
	    return contextsFromNearestNode(context.parent).concat(context);
	  }
	}
	
	function initializeDocumentAndVars(currentContext, contextChain) {
	  var lastInChain = contextChain[contextChain.length - 1];
	  var first = lastInChain.selection.args.first;
	  var variableDefinitions = Object.keys(lastInChain.selection.args).filter(function (key) {
	    return isVariable(lastInChain.selection.args[key]);
	  }).map(function (key) {
	    return lastInChain.selection.args[key];
	  });
	
	  var firstVar = variableDefinitions.find(function (definition) {
	    return definition.name === 'first';
	  });
	
	  if (!firstVar) {
	    if (isVariable(first)) {
	      firstVar = first;
	    } else {
	      firstVar = variable('first', 'Int', first);
	      variableDefinitions.push(firstVar);
	    }
	  }
	
	  var document = new Document(currentContext.selection.selectionSet.typeBundle);
	
	  return [document, variableDefinitions, firstVar];
	}
	
	function addNextFieldTo(currentSelection, contextChain, path, cursor) {
	  // There are always at least two. When we start, it's the root context, and the first set
	  var nextContext = contextChain.shift();
	
	  path.push(nextContext.selection.responseKey);
	
	  if (contextChain.length) {
	    currentSelection.add(nextContext.selection.name, { alias: nextContext.selection.alias, args: nextContext.selection.args }, function (newSelection) {
	      addNextFieldTo(newSelection, contextChain, path, cursor);
	    });
	  } else {
	    var edgesField = nextContext.selection.selectionSet.selections.find(function (field) {
	      return field.name === 'edges';
	    });
	    var nodeField = edgesField.selectionSet.selections.find(function (field) {
	      return field.name === 'node';
	    });
	    var first = void 0;
	
	    if (isVariable(nextContext.selection.args.first)) {
	      first = nextContext.selection.args.first;
	    } else {
	      first = variable('first', 'Int', nextContext.selection.args.first);
	    }
	
	    var options = {
	      alias: nextContext.selection.alias,
	      args: Object.assign({}, nextContext.selection.args, { after: cursor, first: first })
	    };
	
	    currentSelection.addConnection(nextContext.selection.name, options, nodeField.selectionSet);
	  }
	}
	
	function collectFragments(selections) {
	  return selections.reduce(function (fragmentDefinitions, field) {
	    if (FragmentSpread.prototype.isPrototypeOf(field)) {
	      fragmentDefinitions.push(field.toDefinition());
	    }
	
	    fragmentDefinitions.push.apply(fragmentDefinitions, toConsumableArray(collectFragments(field.selectionSet.selections)));
	
	    return fragmentDefinitions;
	  }, []);
	}
	
	function nextPageQueryAndPath(context, cursor) {
	  var nearestNodeContext = nearestNode(context);
	
	  if (nearestNodeContext) {
	    return function () {
	      var _document$definitions;
	
	      var path = [];
	      var nodeType = nearestNodeContext.selection.selectionSet.typeSchema;
	      var nodeId = nearestNodeContext.responseData.id;
	      var contextChain = contextsFromNearestNode(context);
	
	      var _initializeDocumentAn = initializeDocumentAndVars(context, contextChain),
	          _initializeDocumentAn2 = slicedToArray(_initializeDocumentAn, 2),
	          document = _initializeDocumentAn2[0],
	          variableDefinitions = _initializeDocumentAn2[1];
	
	      document.addQuery(variableDefinitions, function (root) {
	        path.push('node');
	        root.add('node', { args: { id: nodeId } }, function (node) {
	          node.addInlineFragmentOn(nodeType.name, function (fragment) {
	            addNextFieldTo(fragment, contextChain.slice(1), path, cursor);
	          });
	        });
	      });
	
	      var fragments = collectFragments(document.operations[0].selectionSet.selections);
	
	      (_document$definitions = document.definitions).unshift.apply(_document$definitions, toConsumableArray(fragments));
	
	      return [document, path];
	    };
	  } else {
	    return function () {
	      var _document$definitions2;
	
	      var path = [];
	      var contextChain = contextsFromRoot(context);
	
	      var _initializeDocumentAn3 = initializeDocumentAndVars(context, contextChain),
	          _initializeDocumentAn4 = slicedToArray(_initializeDocumentAn3, 2),
	          document = _initializeDocumentAn4[0],
	          variableDefinitions = _initializeDocumentAn4[1];
	
	      document.addQuery(variableDefinitions, function (root) {
	        addNextFieldTo(root, contextChain.slice(1), path, cursor);
	      });
	
	      var fragments = collectFragments(document.operations[0].selectionSet.selections);
	
	      (_document$definitions2 = document.definitions).unshift.apply(_document$definitions2, toConsumableArray(fragments));
	
	      return [document, path];
	    };
	  }
	}
	
	function hasNextPage$1(connection, edge) {
	  if (edge !== connection.edges[connection.edges.length - 1]) {
	    return new Scalar(true);
	  }
	
	  return connection.pageInfo.hasNextPage;
	}
	
	function hasPreviousPage(connection, edge) {
	  if (edge !== connection.edges[0]) {
	    return new Scalar(true);
	  }
	
	  return connection.pageInfo.hasPreviousPage;
	}
	
	function transformConnections(variableValues) {
	  return function (context, value) {
	    if (isConnection(context)) {
	      if (!(value.pageInfo && value.pageInfo.hasOwnProperty('hasNextPage') && value.pageInfo.hasOwnProperty('hasPreviousPage'))) {
	        throw new Error('Connections must include the selections "pageInfo { hasNextPage, hasPreviousPage }".');
	      }
	
	      return value.edges.map(function (edge) {
	        return Object.assign(edge.node, {
	          nextPageQueryAndPath: nextPageQueryAndPath(context, edge.cursor),
	          hasNextPage: hasNextPage$1(value, edge),
	          hasPreviousPage: hasPreviousPage(value, edge),
	          variableValues: variableValues
	        });
	      });
	    } else {
	      return value;
	    }
	  };
	}
	
	/* eslint-disable no-warning-comments */
	var DecodingContext = function () {
	  function DecodingContext(selection, responseData) {
	    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    classCallCheck(this, DecodingContext);
	
	    this.selection = selection;
	    this.responseData = responseData;
	    this.parent = parent;
	    Object.freeze(this);
	  }
	
	  createClass(DecodingContext, [{
	    key: 'contextForObjectProperty',
	    value: function contextForObjectProperty(responseKey) {
	      var nestedSelections = this.selection.selectionSet.selectionsByResponseKey[responseKey];
	      var nextSelection = nestedSelections && nestedSelections[0];
	      var nextContext = void 0;
	
	      // fragment spreads operate inside the current context, so we recurse to get the proper
	      // selection set, but retain the current response context
	      if (Spread.prototype.isPrototypeOf(nextSelection)) {
	        nextContext = new DecodingContext(nextSelection, this.responseData, this.parent);
	      } else {
	        nextContext = new DecodingContext(nextSelection, this.responseData[responseKey], this);
	      }
	
	      if (!nextSelection) {
	        throw new Error('Unexpected response key "' + responseKey + '", not found in selection set: ' + this.selection.selectionSet);
	      }
	
	      if (Field.prototype.isPrototypeOf(nextSelection)) {
	        return nextContext;
	      } else {
	        return nextContext.contextForObjectProperty(responseKey);
	      }
	    }
	  }, {
	    key: 'contextForArrayItem',
	    value: function contextForArrayItem(item) {
	      return new DecodingContext(this.selection, item, this.parent);
	    }
	  }]);
	  return DecodingContext;
	}();
	
	function decodeArrayItems(context, transformers) {
	  return context.responseData.map(function (item) {
	    return decodeContext(context.contextForArrayItem(item), transformers);
	  });
	}
	
	function decodeObjectValues(context, transformers) {
	  return Object.keys(context.responseData).reduce(function (acc, responseKey) {
	    acc[responseKey] = decodeContext(context.contextForObjectProperty(responseKey), transformers);
	
	    return acc;
	  }, {});
	}
	
	function runTransformers(transformers, context, value) {
	  return transformers.reduce(function (acc, transformer) {
	    return transformer(context, acc);
	  }, value);
	}
	
	function decodeContext(context, transformers) {
	  var value = context.responseData;
	
	  if (Array.isArray(value)) {
	    value = decodeArrayItems(context, transformers);
	  } else if (isObject(value)) {
	    value = decodeObjectValues(context, transformers);
	  }
	
	  return runTransformers(transformers, context, value);
	}
	
	function generateRefetchQueries(context, value) {
	  if (isValue(value) && isNodeContext(context)) {
	    value.refetchQuery = function () {
	      return new Query(context.selection.selectionSet.typeBundle, function (root) {
	        root.add('node', { args: { id: context.responseData.id } }, function (node) {
	          node.addInlineFragmentOn(context.selection.selectionSet.typeSchema.name, context.selection.selectionSet);
	        });
	      });
	    };
	  }
	
	  return value;
	}
	
	function transformPojosToClassesWithRegistry(classRegistry) {
	  return function transformPojosToClasses(context, value) {
	    if (isObject(value)) {
	      var Klass = classRegistry.classForType(context.selection.selectionSet.typeSchema.name);
	
	      return new Klass(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	function transformScalars(context, value) {
	  if (isValue(value)) {
	    if (context.selection.selectionSet.typeSchema.kind === 'SCALAR') {
	      return new Scalar(value);
	    } else if (context.selection.selectionSet.typeSchema.kind === 'ENUM') {
	      return new Enum(value);
	    }
	  }
	
	  return value;
	}
	
	function recordTypeInformation(context, value) {
	  var _context$selection$se = context.selection.selectionSet,
	      typeBundle = _context$selection$se.typeBundle,
	      typeSchema = _context$selection$se.typeSchema;
	
	  if (isValue(value)) {
	    if (value.__typename) {
	      value.type = schemaForType(typeBundle, value.__typename, typeSchema);
	    } else {
	      value.type = typeSchema;
	    }
	  }
	
	  return value;
	}
	
	function defaultTransformers(_ref) {
	  var _ref$classRegistry = _ref.classRegistry,
	      classRegistry = _ref$classRegistry === undefined ? new ClassRegistry() : _ref$classRegistry,
	      variableValues = _ref.variableValues;
	
	  return [transformScalars, generateRefetchQueries, transformConnections(variableValues), recordTypeInformation, transformPojosToClassesWithRegistry(classRegistry)];
	}
	
	/**
	 * A function used to decode the response data.
	 *
	 * @function decode
	 * @param {SelectionSet} selection The selection set used to query the response data.
	 * @param {Object} responseData The response data returned.
	 * @param {Object} [options] Options to use when decoding including:
	 *   @param {ClassRegistry} [options.classRegistry] A class registry to use when deserializing the data into classes.
	 * @return {GraphModel} The decoded response data.
	 */
	function decode(selection, responseData) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var transformers = options.transformers || defaultTransformers(options);
	  var context = new DecodingContext(selection, responseData);
	
	  return decodeContext(context, transformers);
	}
	
	function httpFetcher(url) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return function fetcher(graphQLParams, headers) {
	    return fetch(url, _extends({
	      body: JSON.stringify(graphQLParams),
	      method: 'POST',
	      mode: 'cors'
	    }, options, {
	      headers: _extends({
	        'Content-Type': 'application/json',
	        Accept: 'application/json'
	      }, options.headers, headers)
	    })).then(function (response) {
	      var contentType = response.headers.get('content-type');
	
	      if (contentType.indexOf('application/json') > -1) {
	        return response.json();
	      }
	
	      return response.text().then(function (text) {
	        return { text: text };
	      });
	    });
	  };
	}
	
	function hasNextPage(paginatedModels) {
	  return paginatedModels && paginatedModels.length && paginatedModels[paginatedModels.length - 1].hasNextPage;
	}
	
	/**
	 * The Client class used to create and send GraphQL documents, fragments, queries and mutations.
	 */
	
	var Client$2 = function () {
	
	  /**
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {Object} options An options object. Must include either `url` and optional `fetcherOptions` OR a `fetcher` function.
	   *   @param {(String|Function)} options.url|fetcher Either the URL of the GraphQL API endpoint, or a custom fetcher function for further customization.
	   *   @param {Object} [options.fetcherOptions] Additional options to use with `fetch`, like headers. Do not specify this argument if `fetcher` is specified.
	   *   @param {ClassRegistry} [options.registry=new ClassRegistry()] A {@link ClassRegistry} used to decode the response data.
	   */
	  function Client(typeBundle, _ref) {
	    var url = _ref.url,
	        fetcherOptions = _ref.fetcherOptions,
	        fetcher = _ref.fetcher,
	        _ref$registry = _ref.registry,
	        registry = _ref$registry === undefined ? new ClassRegistry() : _ref$registry;
	    classCallCheck(this, Client);
	
	    this.typeBundle = typeBundle;
	    this.classRegistry = registry;
	
	    if (url && fetcher) {
	      throw new Error('Arguments not supported: supply either `url` and optional `fetcherOptions` OR use a `fetcher` function for further customization.');
	    }
	
	    if (url) {
	      this.fetcher = httpFetcher(url, fetcherOptions);
	    } else if (fetcher) {
	      if (fetcherOptions) {
	        throw new Error('Arguments not supported: when specifying your own `fetcher`, set options through it and not with `fetcherOptions`');
	      }
	
	      this.fetcher = fetcher;
	    } else {
	      throw new Error('Invalid arguments: one of `url` or `fetcher` is needed.');
	    }
	  }
	
	  /**
	   * Creates a GraphQL document.
	   *
	   * @example
	   * const document = client.document();
	   *
	   * @return {Document} A GraphQL document.
	   */
	
	  createClass(Client, [{
	    key: 'document',
	    value: function document() {
	      return new Document(this.typeBundle);
	    }
	
	    /**
	     * Creates a GraphQL query.
	     *
	     * @example
	     * const query = client.query('myQuery', (root) => {
	     *   root.add('cat', (cat) => {
	     *    cat.add('name');
	     *   });
	     * });
	     *
	     * @param {String} [name] A name for the query.
	     * @param {VariableDefinition[]} [variables] A list of variables in the query. See {@link Client#variable}.
	     * @param {Function} selectionSetCallback The query builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {Query} A GraphQL query.
	     */
	
	  }, {
	    key: 'query',
	    value: function query() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return new (Function.prototype.bind.apply(Query, [null].concat([this.typeBundle], args)))();
	    }
	
	    /**
	     * Creates a GraphQL mutation.
	     *
	     * @example
	     * const input = client.variable('input', 'CatCreateInput!');
	     *
	     * const mutation = client.mutation('myMutation', [input], (root) => {
	     *   root.add('catCreate', {args: {input}}, (catCreate) => {
	     *     catCreate.add('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String} [name] A name for the mutation.
	     * @param {VariableDefinition[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	     * @param {Function} selectionSetCallback The mutation builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {Mutation} A GraphQL mutation.
	     */
	
	  }, {
	    key: 'mutation',
	    value: function mutation() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return new (Function.prototype.bind.apply(Mutation, [null].concat([this.typeBundle], args)))();
	    }
	
	    /**
	     * Sends a GraphQL operation (query or mutation) or a document.
	     *
	     * @example
	     * client.send(query, {id: '12345'}).then((result) => {
	     *   // Do something with the returned result
	     *   console.log(result);
	     * });
	     *
	     * @param {(Query|Mutation|Document|Function)} request The operation or document to send. If represented
	     * as a function, it must return `Query`, `Mutation`, or `Document` and recieve the client as the only param.
	     * @param {Object} [variableValues] The values for variables in the operation or document.
	     * @param {Object} [otherProperties] Other properties to send with the query. For example, a custom operation name.
	     * @param {Object} [headers] Additional headers to be applied on a request by request basis.
	     * @return {Promise.<Object>} A promise resolving to an object containing the response data.
	     */
	
	  }, {
	    key: 'send',
	    value: function send(request) {
	      var variableValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var _this = this;
	
	      var otherProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var operationOrDocument = void 0;
	
	      if (Function.prototype.isPrototypeOf(request)) {
	        operationOrDocument = request(this);
	      } else {
	        operationOrDocument = request;
	      }
	
	      var graphQLParams = { query: operationOrDocument.toString() };
	
	      if (variableValues) {
	        graphQLParams.variables = variableValues;
	      }
	
	      Object.assign(graphQLParams, otherProperties);
	
	      var operation = void 0;
	
	      if (Operation.prototype.isPrototypeOf(operationOrDocument)) {
	        operation = operationOrDocument;
	      } else {
	        var document = operationOrDocument;
	
	        if (document.operations.length === 1) {
	          operation = document.operations[0];
	        } else if (otherProperties.operationName) {
	          operation = document.operations.find(function (documentOperation) {
	            return documentOperation.name === otherProperties.operationName;
	          });
	        } else {
	          throw new Error('\n          A document must contain exactly one operation, or an operationName\n          must be specified. Example:\n\n            client.send(document, null, {operationName: \'myFancyQuery\'});\n        ');
	        }
	      }
	
	      return this.fetcher(graphQLParams, headers).then(function (response) {
	        if (response.data) {
	          response.model = decode(operation, response.data, {
	            classRegistry: _this.classRegistry,
	            variableValues: variableValues
	          });
	        }
	
	        return response;
	      });
	    }
	
	    /**
	     * Fetches the next page of a paginated node or array of nodes.
	     *
	     * @example
	     * client.fetchNextPage(node, {first: 10}).then((result) => {
	     *   // Do something with the next page
	     *   console.log(result);
	     * });
	     *
	     * @param {(GraphModel|GraphModel[])} nodeOrNodes The node or list of nodes on which to fetch the next page.
	     * @param {Object} [options] Options object containing:
	     *   @param {Integer} [options.first] The number of nodes to query on the next page. Defaults to the page size of the previous query.
	     * @return {Promise.<GraphModel[]>} A promise resolving with the next page of {@link GraphModel}s.
	     */
	
	  }, {
	    key: 'fetchNextPage',
	    value: function fetchNextPage(nodeOrNodes, options) {
	      var node = void 0;
	
	      if (Array.isArray(nodeOrNodes)) {
	        node = nodeOrNodes[nodeOrNodes.length - 1];
	      } else {
	        node = nodeOrNodes;
	      }
	
	      var _node$nextPageQueryAn = node.nextPageQueryAndPath(),
	          _node$nextPageQueryAn2 = slicedToArray(_node$nextPageQueryAn, 2),
	          query = _node$nextPageQueryAn2[0],
	          path = _node$nextPageQueryAn2[1];
	
	      var variableValues = void 0;
	
	      if (node.variableValues || options) {
	        variableValues = Object.assign({}, node.variableValues, options);
	      }
	
	      return this.send(query, variableValues).then(function (response) {
	        response.model = path.reduce(function (object, key) {
	          return object[key];
	        }, response.model);
	
	        return response;
	      });
	    }
	
	    /**
	     * Fetches all subsequent pages of a paginated array of nodes.
	     *
	     * @example
	     * client.fetchAllPages(nodes, {pageSize: 20}).then((result) => {
	     *   // Do something with all the models
	     *   console.log(result);
	     * });
	     *
	     * @param {GraphModel[]} paginatedModels The list of nodes on which to fetch all pages.
	     * @param {Object} options Options object containing:
	     *   @param {Integer} options.pageSize The number of nodes to query on each page.
	     * @return {Promise.<GraphModel[]>} A promise resolving with all pages of {@link GraphModel}s, including the original list.
	     */
	
	  }, {
	    key: 'fetchAllPages',
	    value: function fetchAllPages(paginatedModels, _ref2) {
	      var _this2 = this;
	
	      var pageSize = _ref2.pageSize;
	
	      if (hasNextPage(paginatedModels)) {
	        return this.fetchNextPage(paginatedModels, { first: pageSize }).then(function (_ref3) {
	          var model = _ref3.model;
	
	          var pages = paginatedModels.concat(model);
	
	          return _this2.fetchAllPages(pages, { pageSize: pageSize });
	        });
	      }
	
	      return Promise.resolve(paginatedModels);
	    }
	
	    /**
	     * Refetches a {@link GraphModel} whose type implements `Node`.
	     *
	     * @example
	     * client.refetch(node).then((result) => {
	     *   // Do something with the refetched node
	     *   console.log(result);
	     * });
	     *
	     * @param {GraphModel} nodeType A {@link GraphModel} whose type implements `Node`.
	     * @return {Promise.<GraphModel>} The refetched {@link GraphModel}.
	     */
	
	  }, {
	    key: 'refetch',
	    value: function refetch(nodeType) {
	      if (!nodeType) {
	        throw new Error('\'client#refetch\' must be called with a non-null instance of a Node.');
	      } else if (!nodeType.type.implementsNode) {
	        throw new Error('\'client#refetch\' must be called with a type that implements Node. Received ' + nodeType.type.name + '.');
	      }
	
	      return this.send(nodeType.refetchQuery()).then(function (_ref4) {
	        var model = _ref4.model;
	        return model.node;
	      });
	    }
	
	    /**
	     * Creates a variable to be used in a {@link Query} or {@link Mutation}.
	     *
	     * @example
	     * const idVariable = client.variable('id', 'ID!', '12345');
	     *
	     * @param {String} name The name of the variable.
	     * @param {String} type The GraphQL type of the variable.
	     * @param {*} [defaultValue] The default value of the variable.
	     * @return {VariableDefinition} A variable object that can be used in a {@link Query} or {@link Mutation}.
	     */
	
	  }, {
	    key: 'variable',
	    value: function variable$$1(name, type, defaultValue) {
	      return variable(name, type, defaultValue);
	    }
	
	    /**
	     * Creates an enum to be used in a {@link Query} or {@link Mutation}.
	     *
	     * @example
	     * const titleEnum = client.enum('TITLE');
	     *
	     * @param {String} key The key of the enum.
	     * @return {Enum} An enum object that can be used in a {@link Query} or {@link Mutation}.
	     */
	
	  }, {
	    key: 'enum',
	    value: function _enum(key) {
	      return enumFunction(key);
	    }
	  }]);
	  return Client;
	}();
	
	/**
	 * The class used to configure the JS Buy SDK Client.
	 * @class
	 */
	var Config = function () {
	  createClass$1(Config, [{
	    key: 'requiredProperties',
	
	
	    /**
	     * Properties that must be set on initializations
	     * @attribute requiredProperties
	     * @default ['storefrontAccessToken', 'domain']
	     * @type Array
	     * @private
	     */
	    get: function get$$1() {
	      return ['storefrontAccessToken', 'domain'];
	    }
	
	    /**
	     * Deprecated properties that map directly to required properties
	     * @attribute deprecatedProperties
	     * @default {'accessToken': 'storefrontAccessToken', 'apiKey': 'storefrontAccessToken'}
	     * @type Object
	     * @private
	     */
	
	  }, {
	    key: 'deprecatedProperties',
	    get: function get$$1() {
	      return {
	        accessToken: 'storefrontAccessToken',
	        apiKey: 'storefrontAccessToken'
	      };
	    }
	
	    /**
	     * @constructs Config
	     * @param {Object} attrs An object specifying the configuration. Requires the following properties:
	     *   @param {String} attrs.storefrontAccessToken The {@link https://help.shopify.com/api/reference/storefront_access_token|Storefront access token} for the shop.
	     *   @param {String} attrs.domain The `myshopify` domain for the shop (e.g. `graphql.myshopify.com`).
	     */
	
	  }]);
	
	  function Config(attrs) {
	    var _this = this;
	
	    classCallCheck$1(this, Config);
	
	    Object.keys(this.deprecatedProperties).forEach(function (key) {
	      if (!attrs.hasOwnProperty(key)) {
	        return;
	      }
	      // eslint-disable-next-line no-console
	      console.warn('[ShopifyBuy] Config property ' + key + ' is deprecated as of v1.0, please use ' + _this.deprecatedProperties[key] + ' instead.');
	      attrs[_this.deprecatedProperties[key]] = attrs[key];
	    });
	
	    this.requiredProperties.forEach(function (key) {
	      if (attrs.hasOwnProperty(key)) {
	        _this[key] = attrs[key];
	      } else {
	        throw new Error('new Config() requires the option \'' + key + '\'');
	      }
	    });
	
	    if (attrs.hasOwnProperty('apiVersion')) {
	      this.apiVersion = attrs.apiVersion;
	    } else {
	      this.apiVersion = '2023-01';
	    }
	
	    if (attrs.hasOwnProperty('source')) {
	      this.source = attrs.source;
	    }
	
	    if (attrs.hasOwnProperty('language')) {
	      this.language = attrs.language;
	    }
	  }
	
	  return Config;
	}();
	
	var Resource = function Resource(client) {
	  classCallCheck$1(this, Resource);
	
	  this.graphQLClient = client;
	};
	
	var defaultErrors = [{ message: 'an unknown error has occurred.' }];
	
	function defaultResolver(path) {
	  var keys = path.split('.');
	
	  return function (_ref) {
	    var model = _ref.model,
	        errors = _ref.errors;
	
	    return new Promise(function (resolve, reject) {
	      try {
	        var result = keys.reduce(function (ref, key) {
	          return ref[key];
	        }, model);
	
	        resolve(result);
	      } catch (_) {
	        if (errors) {
	          reject(errors);
	        } else {
	          reject(defaultErrors);
	        }
	      }
	    });
	  };
	}
	
	function fetchResourcesForProducts(productOrProduct, client) {
	  var products = [].concat(productOrProduct);
	
	  return Promise.all(products.reduce(function (promiseAcc, product) {
	
	    // If the graphql query doesn't find a match, skip fetching variants and images.
	    if (product === null) {
	      return promiseAcc;
	    }
	
	    // Fetch the rest of the images and variants for this product
	    promiseAcc.push(client.fetchAllPages(product.images, { pageSize: 250 }).then(function (images) {
	      product.attrs.images = images;
	    }));
	
	    promiseAcc.push(client.fetchAllPages(product.variants, { pageSize: 250 }).then(function (variants) {
	      product.attrs.variants = variants;
	    }));
	
	    return promiseAcc;
	  }, []));
	}
	
	function paginateProductConnectionsAndResolve(client) {
	  return function (products) {
	    return fetchResourcesForProducts(products, client).then(function () {
	      return products;
	    });
	  };
	}
	
	function paginateCollectionsProductConnectionsAndResolve(client) {
	  return function (collectionOrCollections) {
	    var collections = [].concat(collectionOrCollections);
	
	    return Promise.all(collections.reduce(function (promiseAcc, collection) {
	      return promiseAcc.concat(fetchResourcesForProducts(collection.products, client));
	    }, [])).then(function () {
	      return collectionOrCollections;
	    });
	  };
	}
	
	/**
	 * @namespace ProductHelpers
	 */
	var productHelpers = {
	
	  /**
	   * Returns the variant of a product corresponding to the options given.
	   *
	   * @example
	   * const selectedVariant = client.product.helpers.variantForOptions(product, {
	   *   size: "Small",
	   *   color: "Red"
	   * });
	   *
	   * @memberof ProductHelpers
	   * @method variantForOptions
	   * @param {GraphModel} product The product to find the variant on. Must include `variants`.
	   * @param {Object} options An object containing the options for the variant.
	   * @return {GraphModel} The variant corresponding to the options given.
	   */
	  variantForOptions: function variantForOptions(product, options) {
	    return product.variants.find(function (variant) {
	      return variant.selectedOptions.every(function (selectedOption) {
	        return options[selectedOption.name] === selectedOption.value.valueOf();
	      });
	    });
	  }
	};
	
	function query(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	function query$1(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.ids = client.variable("ids", "[ID!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.ids], function (root) {
	    root.add("nodes", {
	      args: {
	        ids: variables.__defaultOperation__.ids
	      }
	    }, function (nodes) {
	      nodes.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	function query$2(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "ProductSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
	    root.add("products", {
	      args: {
	        first: variables.__defaultOperation__.first,
	        query: variables.__defaultOperation__.query,
	        sortKey: variables.__defaultOperation__.sortKey,
	        reverse: variables.__defaultOperation__.reverse
	      }
	    }, function (products) {
	      products.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      products.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.ProductFragment);
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$3(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.handle = client.variable("handle", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.handle], function (root) {
	    root.add("productByHandle", {
	      args: {
	        handle: variables.__defaultOperation__.handle
	      }
	    }, function (productByHandle) {
	      productByHandle.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	function query$4(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.productId = client.variable("productId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.productId], function (root) {
	    root.add("productRecommendations", {
	      args: {
	        productId: variables.__defaultOperation__.productId
	      }
	    }, function (productRecommendations) {
	      productRecommendations.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK product resource
	 * @class
	 */
	
	var ProductResource = function (_Resource) {
	  inherits$1(ProductResource, _Resource);
	
	  function ProductResource() {
	    classCallCheck$1(this, ProductResource);
	    return possibleConstructorReturn$1(this, (ProductResource.__proto__ || Object.getPrototypeOf(ProductResource)).apply(this, arguments));
	  }
	
	  createClass$1(ProductResource, [{
	    key: 'fetchAll',
	
	
	    /**
	     * Fetches all products on the shop.
	     *
	     * @example
	     * client.product.fetchAll().then((products) => {
	     *   // Do something with the products
	     * });
	     *
	     * @param {Int} [pageSize] The number of products to fetch per page
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
	     */
	    value: function fetchAll() {
	      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
	
	      return this.graphQLClient.send(query$2, { first: first }).then(defaultResolver('products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single product by ID on the shop.
	     *
	     * @example
	     * client.product.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==').then((product) => {
	     *   // Do something with the product
	     * });
	     *
	     * @param {String} id The id of the product to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetch',
	    value: function fetch(id) {
	      return this.graphQLClient.send(query, { id: id }).then(defaultResolver('node')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches multiple products by ID on the shop.
	     *
	     * @example
	     * const ids = ['Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==', 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc4NTc5ODkzODQ='];
	     * client.product.fetchMultiple(ids).then((products) => {
	     *   // Do something with the products
	     * });
	     *
	     * @param {String[]} ids The ids of the products to fetch
	     * @return {Promise|GraphModel[]} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetchMultiple',
	    value: function fetchMultiple(ids) {
	      return this.graphQLClient.send(query$1, { ids: ids }).then(defaultResolver('nodes')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single product by handle on the shop.
	     *
	     * @example
	     * client.product.fetchByHandle('my-product').then((product) => {
	     *   // Do something with the product
	     * });
	     *
	     * @param {String} handle The handle of the product to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetchByHandle',
	    value: function fetchByHandle(handle) {
	      return this.graphQLClient.send(query$3, { handle: handle }).then(defaultResolver('productByHandle')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches all products on the shop that match the query.
	     *
	     * @example
	     * client.product.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((products) => {
	     *   // Do something with the first 10 products sorted by title in ascending order
	     * });
	     *
	     * @param {Object} [args] An object specifying the query data containing zero or more of:
	     *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
	     *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
	     *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/productsortkeys|Product Sort Keys}.
	     *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#products|here}
	     *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
	     */
	
	  }, {
	    key: 'fetchQuery',
	    value: function fetchQuery() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$first = _ref.first,
	          first = _ref$first === undefined ? 20 : _ref$first,
	          _ref$sortKey = _ref.sortKey,
	          sortKey = _ref$sortKey === undefined ? 'ID' : _ref$sortKey,
	          query$$1 = _ref.query,
	          reverse = _ref.reverse;
	
	      return this.graphQLClient.send(query$2, {
	        first: first,
	        sortKey: sortKey,
	        query: query$$1,
	        reverse: reverse
	      }).then(defaultResolver('products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Find recommended products related to a given productId.
	     * To learn more about how recommendations are generated, see https://shopify.dev/themes/product-merchandising/recommendations.
	     *
	     * @example
	     * const productId 'Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==';
	     * client.product.fetchProductRecommendations(productId).then((products) => {
	     *   // Do something with the products
	     * });
	     *
	     * @param {String} productId The id of the product to fetch.
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
	     */
	
	  }, {
	    key: 'fetchRecommendations',
	    value: function fetchRecommendations(productId) {
	      return this.graphQLClient.send(query$4, { productId: productId }).then(defaultResolver('productRecommendations')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	  }, {
	    key: 'helpers',
	    get: function get$$1() {
	      return productHelpers;
	    }
	  }]);
	  return ProductResource;
	}(Resource);
	
	function query$5(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CollectionFragment);
	    });
	  });
	  return document;
	}
	
	function query$6(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id, variables.__defaultOperation__.productsFirst], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CollectionFragment);
	      node.addInlineFragmentOn("Collection", function (Collection) {
	        Collection.add("products", {
	          args: {
	            first: variables.__defaultOperation__.productsFirst
	          }
	        }, function (products) {
	          products.add("pageInfo", function (pageInfo) {
	            pageInfo.add("hasNextPage");
	            pageInfo.add("hasPreviousPage");
	          });
	          products.add("edges", function (edges) {
	            edges.add("cursor");
	            edges.add("node", function (node) {
	              node.addFragment(spreads.ProductFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$7(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
	    root.add("collections", {
	      args: {
	        first: variables.__defaultOperation__.first,
	        query: variables.__defaultOperation__.query,
	        sortKey: variables.__defaultOperation__.sortKey,
	        reverse: variables.__defaultOperation__.reverse
	      }
	    }, function (collections) {
	      collections.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      collections.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.CollectionFragment);
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$8(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse, variables.__defaultOperation__.productsFirst], function (root) {
	    root.add("collections", {
	      args: {
	        first: variables.__defaultOperation__.first,
	        query: variables.__defaultOperation__.query,
	        sortKey: variables.__defaultOperation__.sortKey,
	        reverse: variables.__defaultOperation__.reverse
	      }
	    }, function (collections) {
	      collections.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      collections.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.CollectionFragment);
	          node.add("products", {
	            args: {
	              first: variables.__defaultOperation__.productsFirst
	            }
	          }, function (products) {
	            products.add("pageInfo", function (pageInfo) {
	              pageInfo.add("hasNextPage");
	              pageInfo.add("hasPreviousPage");
	            });
	            products.add("edges", function (edges) {
	              edges.add("cursor");
	              edges.add("node", function (node) {
	                node.addFragment(spreads.ProductFragment);
	              });
	            });
	          });
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$9(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.handle = client.variable("handle", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("url", {
	            alias: "src"
	          });
	          node.add("altText");
	          node.add("width");
	          node.add("height");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.CollectionsProductsFragment = document.defineFragment("CollectionsProductsFragment", "Collection", function (root) {
	    root.add("products", {
	      args: {
	        first: 20
	      }
	    }, function (products) {
	      products.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      products.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.ProductFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.handle], function (root) {
	    root.add("collectionByHandle", {
	      args: {
	        handle: variables.__defaultOperation__.handle
	      }
	    }, function (collectionByHandle) {
	      collectionByHandle.addFragment(spreads.CollectionFragment);
	      collectionByHandle.addFragment(spreads.CollectionsProductsFragment);
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK collection resource
	 * @class
	 */
	
	var CollectionResource = function (_Resource) {
	  inherits$1(CollectionResource, _Resource);
	
	  function CollectionResource() {
	    classCallCheck$1(this, CollectionResource);
	    return possibleConstructorReturn$1(this, (CollectionResource.__proto__ || Object.getPrototypeOf(CollectionResource)).apply(this, arguments));
	  }
	
	  createClass$1(CollectionResource, [{
	    key: 'fetchAll',
	
	
	    /**
	     * Fetches all collections on the shop, not including products.
	     * To fetch collections with products use [fetchAllsWithProducts]{@link Client#fetchAllsWithProducts}.
	     *
	     * @example
	     * client.collection.fetchAll().then((collections) => {
	     *   // Do something with the collections
	     * });
	     *
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	    value: function fetchAll() {
	      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
	
	      return this.graphQLClient.send(query$7, { first: first }).then(defaultResolver('collections'));
	    }
	
	    /**
	     * Fetches all collections on the shop, including products.
	     *
	     * @example
	     * client.collection.fetchAllWithProducts().then((collections) => {
	     *   // Do something with the collections
	     * });
	     *
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	
	  }, {
	    key: 'fetchAllWithProducts',
	    value: function fetchAllWithProducts() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$first = _ref.first,
	          first = _ref$first === undefined ? 20 : _ref$first,
	          _ref$productsFirst = _ref.productsFirst,
	          productsFirst = _ref$productsFirst === undefined ? 20 : _ref$productsFirst;
	
	      return this.graphQLClient.send(query$8, { first: first, productsFirst: productsFirst }).then(defaultResolver('collections')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single collection by ID on the shop, not including products.
	     * To fetch the collection with products use [fetchWithProducts]{@link Client#fetchWithProducts}.
	     *
	     * @example
	     * client.collection.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} id The id of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetch',
	    value: function fetch(id) {
	      return this.graphQLClient.send(query$5, { id: id }).then(defaultResolver('node'));
	    }
	
	    /**
	     * Fetches a single collection by ID on the shop, including products.
	     *
	     * @example
	     * client.collection.fetchWithProducts('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} id The id of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetchWithProducts',
	    value: function fetchWithProducts(id) {
	      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref2$productsFirst = _ref2.productsFirst,
	          productsFirst = _ref2$productsFirst === undefined ? 20 : _ref2$productsFirst;
	
	      return this.graphQLClient.send(query$6, { id: id, productsFirst: productsFirst }).then(defaultResolver('node')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a collection by handle on the shop.
	     *
	     * @example
	     * client.collection.fetchByHandle('my-collection').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} handle The handle of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetchByHandle',
	    value: function fetchByHandle(handle) {
	      return this.graphQLClient.send(query$9, { handle: handle }).then(defaultResolver('collectionByHandle'));
	    }
	
	    /**
	     * Fetches all collections on the shop that match the query.
	     *
	     * @example
	     * client.collection.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((collections) => {
	     *   // Do something with the first 10 collections sorted by title in ascending order
	     * });
	     *
	     * @param {Object} [args] An object specifying the query data containing zero or more of:
	     *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
	     *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
	     *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/collectionsortkeys|Collection Sort Keys}.
	     *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#collections|here}
	     *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	
	  }, {
	    key: 'fetchQuery',
	    value: function fetchQuery() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$first = _ref3.first,
	          first = _ref3$first === undefined ? 20 : _ref3$first,
	          _ref3$sortKey = _ref3.sortKey,
	          sortKey = _ref3$sortKey === undefined ? 'ID' : _ref3$sortKey,
	          query = _ref3.query,
	          reverse = _ref3.reverse;
	
	      return this.graphQLClient.send(query$7, {
	        first: first,
	        sortKey: sortKey,
	        query: query,
	        reverse: reverse
	      }).then(defaultResolver('collections'));
	    }
	  }]);
	  return CollectionResource;
	}(Resource);
	
	function query$10(client) {
	  var document = client.document();
	  document.addQuery(function (root) {
	    root.add("shop", function (shop) {
	      shop.add("paymentSettings", function (paymentSettings) {
	        paymentSettings.add("enabledPresentmentCurrencies");
	      });
	      shop.add("description");
	      shop.add("moneyFormat");
	      shop.add("name");
	      shop.add("primaryDomain", function (primaryDomain) {
	        primaryDomain.add("host");
	        primaryDomain.add("sslEnabled");
	        primaryDomain.add("url");
	      });
	    });
	  });
	  return document;
	}
	
	function query$11(client) {
	  var document = client.document();
	  var spreads = {};
	  spreads.PolicyFragment = document.defineFragment("PolicyFragment", "ShopPolicy", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("url");
	    root.add("body");
	  });
	  document.addQuery(function (root) {
	    root.add("shop", function (shop) {
	      shop.add("privacyPolicy", function (privacyPolicy) {
	        privacyPolicy.addFragment(spreads.PolicyFragment);
	      });
	      shop.add("termsOfService", function (termsOfService) {
	        termsOfService.addFragment(spreads.PolicyFragment);
	      });
	      shop.add("refundPolicy", function (refundPolicy) {
	        refundPolicy.addFragment(spreads.PolicyFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK shop resource
	 * @class
	 */
	
	var ShopResource = function (_Resource) {
	  inherits$1(ShopResource, _Resource);
	
	  function ShopResource() {
	    classCallCheck$1(this, ShopResource);
	    return possibleConstructorReturn$1(this, (ShopResource.__proto__ || Object.getPrototypeOf(ShopResource)).apply(this, arguments));
	  }
	
	  createClass$1(ShopResource, [{
	    key: 'fetchInfo',
	
	
	    /**
	     * Fetches shop information (`currencyCode`, `description`, `moneyFormat`, `name`, and `primaryDomain`).
	     * See the {@link https://help.shopify.com/api/storefront-api/reference/object/shop|Storefront API reference} for more information.
	     *
	     * @example
	     * client.shop.fetchInfo().then((shop) => {
	     *   // Do something with the shop
	     * });
	     *
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
	     */
	    value: function fetchInfo() {
	      return this.graphQLClient.send(query$10).then(defaultResolver('shop'));
	    }
	
	    /**
	     * Fetches shop policies (privacy policy, terms of service and refund policy).
	     *
	     * @example
	     * client.shop.fetchPolicies().then((shop) => {
	     *   // Do something with the shop
	     * });
	     *
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
	     */
	
	  }, {
	    key: 'fetchPolicies',
	    value: function fetchPolicies() {
	      return this.graphQLClient.send(query$11).then(defaultResolver('shop'));
	    }
	  }]);
	  return ShopResource;
	}(Resource);
	
	function handleCheckoutMutation(mutationRootKey, client) {
	  return function (_ref) {
	    var _ref$data = _ref.data,
	        data = _ref$data === undefined ? {} : _ref$data,
	        errors = _ref.errors,
	        _ref$model = _ref.model,
	        model = _ref$model === undefined ? {} : _ref$model;
	
	    var rootData = data[mutationRootKey];
	    var rootModel = model[mutationRootKey];
	
	    if (rootData && rootData.checkout) {
	      return client.fetchAllPages(rootModel.checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
	        rootModel.checkout.attrs.lineItems = lineItems;
	        rootModel.checkout.errors = errors;
	        rootModel.checkout.userErrors = rootModel.userErrors;
	
	        return rootModel.checkout;
	      });
	    }
	
	    if (errors && errors.length) {
	      return Promise.reject(new Error(JSON.stringify(errors)));
	    }
	
	    if (rootData && rootData.checkoutUserErrors && rootData.checkoutUserErrors.length) {
	      return Promise.reject(new Error(JSON.stringify(rootData.checkoutUserErrors)));
	    }
	
	    if (rootData && rootData.userErrors && rootData.userErrors.length) {
	      return Promise.reject(new Error(JSON.stringify(rootData.userErrors)));
	    }
	
	    return Promise.reject(new Error("The " + mutationRootKey + " mutation failed due to an unknown error."));
	  };
	}
	
	function query$12(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CheckoutFragment);
	    });
	  });
	  return document;
	}
	
	function query$13(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.input = client.variable("input", "CheckoutCreateInput!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.input], function (root) {
	    root.add("checkoutCreate", {
	      args: {
	        input: variables.__defaultOperation__.input
	      }
	    }, function (checkoutCreate) {
	      checkoutCreate.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutCreate.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutCreate.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$14(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsAdd", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsAdd) {
	      checkoutLineItemsAdd.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsAdd.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsAdd.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$15(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItemIds = client.variable("lineItemIds", "[ID!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItemIds], function (root) {
	    root.add("checkoutLineItemsRemove", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItemIds: variables.__defaultOperation__.lineItemIds
	      }
	    }, function (checkoutLineItemsRemove) {
	      checkoutLineItemsRemove.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsRemove.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsRemove.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$16(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsReplace", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsReplace) {
	      checkoutLineItemsReplace.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsReplace.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$17(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemUpdateInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsUpdate", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsUpdate) {
	      checkoutLineItemsUpdate.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsUpdate.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsUpdate.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$18(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutAttributesUpdateV2 = {};
	  variables.checkoutAttributesUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  variables.checkoutAttributesUpdateV2.input = client.variable("input", "CheckoutAttributesUpdateV2Input!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutAttributesUpdateV2", [variables.checkoutAttributesUpdateV2.checkoutId, variables.checkoutAttributesUpdateV2.input], function (root) {
	    root.add("checkoutAttributesUpdateV2", {
	      args: {
	        checkoutId: variables.checkoutAttributesUpdateV2.checkoutId,
	        input: variables.checkoutAttributesUpdateV2.input
	      }
	    }, function (checkoutAttributesUpdateV2) {
	      checkoutAttributesUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutAttributesUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutAttributesUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$19(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutDiscountCodeApplyV2 = {};
	  variables.checkoutDiscountCodeApplyV2.discountCode = client.variable("discountCode", "String!");
	  variables.checkoutDiscountCodeApplyV2.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutDiscountCodeApplyV2", [variables.checkoutDiscountCodeApplyV2.discountCode, variables.checkoutDiscountCodeApplyV2.checkoutId], function (root) {
	    root.add("checkoutDiscountCodeApplyV2", {
	      args: {
	        discountCode: variables.checkoutDiscountCodeApplyV2.discountCode,
	        checkoutId: variables.checkoutDiscountCodeApplyV2.checkoutId
	      }
	    }, function (checkoutDiscountCodeApplyV2) {
	      checkoutDiscountCodeApplyV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutDiscountCodeApplyV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutDiscountCodeApplyV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$20(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutDiscountCodeRemove = {};
	  variables.checkoutDiscountCodeRemove.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutDiscountCodeRemove", [variables.checkoutDiscountCodeRemove.checkoutId], function (root) {
	    root.add("checkoutDiscountCodeRemove", {
	      args: {
	        checkoutId: variables.checkoutDiscountCodeRemove.checkoutId
	      }
	    }, function (checkoutDiscountCodeRemove) {
	      checkoutDiscountCodeRemove.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutDiscountCodeRemove.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutDiscountCodeRemove.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$21(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutGiftCardsAppend = {};
	  variables.checkoutGiftCardsAppend.giftCardCodes = client.variable("giftCardCodes", "[String!]!");
	  variables.checkoutGiftCardsAppend.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutGiftCardsAppend", [variables.checkoutGiftCardsAppend.giftCardCodes, variables.checkoutGiftCardsAppend.checkoutId], function (root) {
	    root.add("checkoutGiftCardsAppend", {
	      args: {
	        giftCardCodes: variables.checkoutGiftCardsAppend.giftCardCodes,
	        checkoutId: variables.checkoutGiftCardsAppend.checkoutId
	      }
	    }, function (checkoutGiftCardsAppend) {
	      checkoutGiftCardsAppend.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutGiftCardsAppend.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutGiftCardsAppend.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$22(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutGiftCardRemoveV2 = {};
	  variables.checkoutGiftCardRemoveV2.appliedGiftCardId = client.variable("appliedGiftCardId", "ID!");
	  variables.checkoutGiftCardRemoveV2.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutGiftCardRemoveV2", [variables.checkoutGiftCardRemoveV2.appliedGiftCardId, variables.checkoutGiftCardRemoveV2.checkoutId], function (root) {
	    root.add("checkoutGiftCardRemoveV2", {
	      args: {
	        appliedGiftCardId: variables.checkoutGiftCardRemoveV2.appliedGiftCardId,
	        checkoutId: variables.checkoutGiftCardRemoveV2.checkoutId
	      }
	    }, function (checkoutGiftCardRemoveV2) {
	      checkoutGiftCardRemoveV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutGiftCardRemoveV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutGiftCardRemoveV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$23(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutEmailUpdateV2 = {};
	  variables.checkoutEmailUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  variables.checkoutEmailUpdateV2.email = client.variable("email", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutEmailUpdateV2", [variables.checkoutEmailUpdateV2.checkoutId, variables.checkoutEmailUpdateV2.email], function (root) {
	    root.add("checkoutEmailUpdateV2", {
	      args: {
	        checkoutId: variables.checkoutEmailUpdateV2.checkoutId,
	        email: variables.checkoutEmailUpdateV2.email
	      }
	    }, function (checkoutEmailUpdateV2) {
	      checkoutEmailUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutEmailUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutEmailUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$24(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutShippingAddressUpdateV2 = {};
	  variables.checkoutShippingAddressUpdateV2.shippingAddress = client.variable("shippingAddress", "MailingAddressInput!");
	  variables.checkoutShippingAddressUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price", function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("price", {
	      alias: "priceV2"
	    }, function (price) {
	      price.add("amount");
	      price.add("currencyCode");
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice", function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("compareAtPrice", {
	      alias: "compareAtPriceV2"
	    }, function (compareAtPrice) {
	      compareAtPrice.add("amount");
	      compareAtPrice.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("url", {
	        alias: "src"
	      });
	      image.add("altText");
	      image.add("width");
	      image.add("height");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	    root.add("unitPrice", function (unitPrice) {
	      unitPrice.add("amount");
	      unitPrice.add("currencyCode");
	    });
	    root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
	      unitPriceMeasurement.add("measuredType");
	      unitPriceMeasurement.add("quantityUnit");
	      unitPriceMeasurement.add("quantityValue");
	      unitPriceMeasurement.add("referenceUnit");
	      unitPriceMeasurement.add("referenceValue");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("title");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsed", function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("amountUsed", {
	      alias: "amountUsedV2"
	    }, function (amountUsed) {
	      amountUsed.add("amount");
	      amountUsed.add("currencyCode");
	    });
	    root.add("balance", function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("balance", {
	      alias: "balanceV2"
	    }, function (balance) {
	      balance.add("amount");
	      balance.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue", function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("paymentDue", {
	      alias: "paymentDueV2"
	    }, function (paymentDue) {
	      paymentDue.add("amount");
	      paymentDue.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax", function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("totalTax", {
	      alias: "totalTaxV2"
	    }, function (totalTax) {
	      totalTax.add("amount");
	      totalTax.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice", {
	      alias: "subtotalPriceV2"
	    }, function (subtotalPrice) {
	      subtotalPrice.add("amount");
	      subtotalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("totalPrice", {
	      alias: "totalPriceV2"
	    }, function (totalPrice) {
	      totalPrice.add("amount");
	      totalPrice.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price", function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("price", {
	        alias: "priceV2"
	      }, function (price) {
	        price.add("amount");
	        price.add("currencyCode");
	      });
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice", function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("subtotalPrice", {
	        alias: "subtotalPriceV2"
	      }, function (subtotalPrice) {
	        subtotalPrice.add("amount");
	        subtotalPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalShippingPrice", {
	        alias: "totalShippingPriceV2"
	      }, function (totalShippingPrice) {
	        totalShippingPrice.add("amount");
	        totalShippingPrice.add("currencyCode");
	      });
	      order.add("totalTax", function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalTax", {
	        alias: "totalTaxV2"
	      }, function (totalTax) {
	        totalTax.add("amount");
	        totalTax.add("currencyCode");
	      });
	      order.add("totalPrice", function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("totalPrice", {
	        alias: "totalPriceV2"
	      }, function (totalPrice) {
	        totalPrice.add("amount");
	        totalPrice.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded", function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("totalRefunded", {
	        alias: "totalRefundedV2"
	      }, function (totalRefunded) {
	        totalRefunded.add("amount");
	        totalRefunded.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutShippingAddressUpdateV2", [variables.checkoutShippingAddressUpdateV2.shippingAddress, variables.checkoutShippingAddressUpdateV2.checkoutId], function (root) {
	    root.add("checkoutShippingAddressUpdateV2", {
	      args: {
	        shippingAddress: variables.checkoutShippingAddressUpdateV2.shippingAddress,
	        checkoutId: variables.checkoutShippingAddressUpdateV2.checkoutId
	      }
	    }, function (checkoutShippingAddressUpdateV2) {
	      checkoutShippingAddressUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutShippingAddressUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutShippingAddressUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK checkout resource
	 * @class
	 */
	
	var CheckoutResource = function (_Resource) {
	  inherits$1(CheckoutResource, _Resource);
	
	  function CheckoutResource() {
	    classCallCheck$1(this, CheckoutResource);
	    return possibleConstructorReturn$1(this, (CheckoutResource.__proto__ || Object.getPrototypeOf(CheckoutResource)).apply(this, arguments));
	  }
	
	  createClass$1(CheckoutResource, [{
	    key: 'fetch',
	
	
	    /**
	     * Fetches a checkout by ID.
	     *
	     * @example
	     * client.checkout.fetch('FlZj9rZXlN5MDY4ZDFiZTUyZTUwNTE2MDNhZjg=').then((checkout) => {
	     *   // Do something with the checkout
	     * });
	     *
	     * @param {String} id The id of the checkout to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the checkout.
	     */
	    value: function fetch(id) {
	      var _this2 = this;
	
	      return this.graphQLClient.send(query$12, { id: id }).then(defaultResolver('node')).then(function (checkout) {
	        if (!checkout) {
	          return null;
	        }
	
	        return _this2.graphQLClient.fetchAllPages(checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
	          checkout.attrs.lineItems = lineItems;
	
	          return checkout;
	        });
	      });
	    }
	
	    /**
	     * Creates a checkout.
	     *
	     * @example
	     * const input = {
	     *   lineItems: [
	     *     {variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}
	     *   ]
	     * };
	     *
	     * client.checkout.create(input).then((checkout) => {
	     *   // Do something with the newly created checkout
	     * });
	     *
	     * @param {Object} [input] An input object containing zero or more of:
	     *   @param {String} [input.email] An email connected to the checkout.
	     *   @param {Object[]} [input.lineItems] A list of line items in the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     *   @param {Object} [input.shippingAddress] A shipping address. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/mailingaddressinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.note] A note for the checkout.
	     *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.presentmentCurrencyCode ] A presentment currency code. See the {@link https://help.shopify.com/en/api/storefront-api/reference/enum/currencycode|Storefront API reference} for valid currency code values.
	     * @return {Promise|GraphModel} A promise resolving with the created checkout.
	     */
	
	  }, {
	    key: 'create',
	    value: function create() {
	      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return this.graphQLClient.send(query$13, { input: input }).then(handleCheckoutMutation('checkoutCreate', this.graphQLClient));
	    }
	
	    /**
	     * Replaces the value of checkout's custom attributes and/or note with values defined in the input
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const input = {customAttributes: [{key: "MyKey", value: "MyValue"}]};
	     *
	     * client.checkout.updateAttributes(checkoutId, input).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update.
	     * @param {Object} [input] An input object containing zero or more of:
	     *   @param {Boolean} [input.allowPartialAddresses] An email connected to the checkout.
	     *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.note] A note for the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateAttributes',
	    value: function updateAttributes(checkoutId) {
	      var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.graphQLClient.send(query$18, { checkoutId: checkoutId, input: input }).then(handleCheckoutMutation('checkoutAttributesUpdateV2', this.graphQLClient));
	    }
	
	    /**
	     * Replaces the value of checkout's email address
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const email = 'user@example.com';
	     *
	     * client.checkout.updateEmail(checkoutId, email).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update.
	     * @param {String} email The email address to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateEmail',
	    value: function updateEmail(checkoutId, email) {
	      return this.graphQLClient.send(query$23, { checkoutId: checkoutId, email: email }).then(handleCheckoutMutation('checkoutEmailUpdateV2', this.graphQLClient));
	    }
	
	    /**
	     * Adds line items to an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
	     *
	     * client.checkout.addLineItems(checkoutId, lineItems).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add line items to.
	     * @param {Object[]} lineItems A list of line items to add to the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addLineItems',
	    value: function addLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$14, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsAdd', this.graphQLClient));
	    }
	
	    /**
	     * Applies a discount to an existing checkout using a discount code.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const discountCode = 'best-discount-ever';
	     *
	     * client.checkout.addDiscount(checkoutId, discountCode).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add discount to.
	     * @param {String} discountCode The discount code to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addDiscount',
	    value: function addDiscount(checkoutId, discountCode) {
	      return this.graphQLClient.send(query$19, { checkoutId: checkoutId, discountCode: discountCode }).then(handleCheckoutMutation('checkoutDiscountCodeApplyV2', this.graphQLClient));
	    }
	
	    /**
	     * Removes the applied discount from an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     *
	     * client.checkout.removeDiscount(checkoutId).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to remove the discount from.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeDiscount',
	    value: function removeDiscount(checkoutId) {
	      return this.graphQLClient.send(query$20, { checkoutId: checkoutId }).then(handleCheckoutMutation('checkoutDiscountCodeRemove', this.graphQLClient));
	    }
	
	    /**
	     * Applies gift cards to an existing checkout using a list of gift card codes
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const giftCardCodes = ['6FD8853DAGAA949F'];
	     *
	     * client.checkout.addGiftCards(checkoutId, giftCardCodes).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add gift cards to.
	     * @param {String[]} giftCardCodes The gift card codes to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addGiftCards',
	    value: function addGiftCards(checkoutId, giftCardCodes) {
	      return this.graphQLClient.send(query$21, { checkoutId: checkoutId, giftCardCodes: giftCardCodes }).then(handleCheckoutMutation('checkoutGiftCardsAppend', this.graphQLClient));
	    }
	
	    /**
	     * Remove a gift card from an existing checkout
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const appliedGiftCardId = 'Z2lkOi8vc2hvcGlmeS9BcHBsaWVkR2lmdENhcmQvNDI4NTQ1ODAzMTI=';
	     *
	     * client.checkout.removeGiftCard(checkoutId, appliedGiftCardId).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add gift cards to.
	     * @param {String} appliedGiftCardId The gift card id to remove from the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeGiftCard',
	    value: function removeGiftCard(checkoutId, appliedGiftCardId) {
	      return this.graphQLClient.send(query$22, { checkoutId: checkoutId, appliedGiftCardId: appliedGiftCardId }).then(handleCheckoutMutation('checkoutGiftCardRemoveV2', this.graphQLClient));
	    }
	
	    /**
	     * Removes line items from an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItemIds = ['TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU='];
	     *
	     * client.checkout.removeLineItems(checkoutId, lineItemIds).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to remove line items from.
	     * @param {String[]} lineItemIds A list of the ids of line items to remove from the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeLineItems',
	    value: function removeLineItems(checkoutId, lineItemIds) {
	      return this.graphQLClient.send(query$15, { checkoutId: checkoutId, lineItemIds: lineItemIds }).then(handleCheckoutMutation('checkoutLineItemsRemove', this.graphQLClient));
	    }
	
	    /**
	     * Replace line items on an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
	     *
	     * client.checkout.replaceLineItems(checkoutId, lineItems).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add line items to.
	     * @param {Object[]} lineItems A list of line items to set on the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'replaceLineItems',
	    value: function replaceLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$16, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsReplace', this.graphQLClient));
	    }
	
	    /**
	     * Updates line items on an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [
	     *   {
	     *     id: 'TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU=',
	     *     quantity: 5,
	     *     variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg=='
	     *   }
	     * ];
	     *
	     * client.checkout.updateLineItems(checkoutId, lineItems).then(checkout => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update a line item on.
	     * @param {Object[]} lineItems A list of line item information to update. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineitemupdateinput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateLineItems',
	    value: function updateLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$17, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsUpdate', this.graphQLClient));
	    }
	
	    /**
	     * Updates shipping address on an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const shippingAddress = {
	     *    address1: 'Chestnut Street 92',
	     *    address2: 'Apartment 2',
	     *    city: 'Louisville',
	     *    company: null,
	     *    country: 'United States',
	     *    firstName: 'Bob',
	     *    lastName: 'Norman',
	     *    phone: '555-625-1199',
	     *    province: 'Kentucky',
	     *    zip: '40202'
	     *  };
	     *
	     * client.checkout.updateShippingAddress(checkoutId, shippingAddress).then(checkout => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param  {String} checkoutId The ID of the checkout to update shipping address.
	     * @param  {Object} shippingAddress A shipping address.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateShippingAddress',
	    value: function updateShippingAddress(checkoutId, shippingAddress) {
	      return this.graphQLClient.send(query$24, { checkoutId: checkoutId, shippingAddress: shippingAddress }).then(handleCheckoutMutation('checkoutShippingAddressUpdateV2', this.graphQLClient));
	    }
	  }]);
	  return CheckoutResource;
	}(Resource);
	
	/**
	 * @namespace ImageHelpers
	 */
	var imageHelpers = {
	
	  /**
	   * Generates the image src for a resized image with maximum dimensions `maxWidth` and `maxHeight`.
	   * Images do not scale up.
	   *
	   * @example
	   * const url = client.image.helpers.imageForSize(product.variants[0].image, {maxWidth: 50, maxHeight: 50});
	   *
	   * @memberof ImageHelpers
	   * @method imageForSize
	   * @param {Object} image The original image model to generate the image src for.
	   * @param {Object} options An options object containing:
	   *  @param {Integer} options.maxWidth The maximum width for the image.
	   *  @param {Integer} options.maxHeight The maximum height for the image.
	   * @return {String} The image src for the resized image.
	   */
	  imageForSize: function imageForSize(image, _ref) {
	    var maxWidth = _ref.maxWidth,
	        maxHeight = _ref.maxHeight;
	
	    var splitUrl = image.src.split('?');
	    var notQuery = splitUrl[0];
	    var query = splitUrl[1] ? '?' + splitUrl[1] : '';
	
	    // Use the section before the query
	    var imageTokens = notQuery.split('.');
	
	    // Take the token before the file extension and append the dimensions
	    var imagePathIndex = imageTokens.length - 2;
	
	    imageTokens[imagePathIndex] = imageTokens[imagePathIndex] + '_' + maxWidth + 'x' + maxHeight;
	
	    return '' + imageTokens.join('.') + query;
	  }
	};
	
	/**
	 * The JS Buy SDK image resource
	 * @class
	 */
	
	var ImageResource = function (_Resource) {
	  inherits$1(ImageResource, _Resource);
	
	  function ImageResource() {
	    classCallCheck$1(this, ImageResource);
	    return possibleConstructorReturn$1(this, (ImageResource.__proto__ || Object.getPrototypeOf(ImageResource)).apply(this, arguments));
	  }
	
	  createClass$1(ImageResource, [{
	    key: 'helpers',
	    get: function get$$1() {
	      return imageHelpers;
	    }
	  }]);
	  return ImageResource;
	}(Resource);
	
	var version = "2.18.0";
	
	var AppliedGiftCard = {
	  "name": "AppliedGiftCard",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "amountUsed": "MoneyV2",
	    "balance": "MoneyV2",
	    "id": "ID",
	    "lastCharacters": "String",
	    "presentmentAmountUsed": "MoneyV2"
	  },
	  "implementsNode": true
	};
	
	var Attribute = {
	  "name": "Attribute",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "key": "String",
	    "value": "String"
	  },
	  "implementsNode": false
	};
	
	var AutomaticDiscountApplication = {
	  "name": "AutomaticDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var Boolean$1 = {
	  "name": "Boolean",
	  "kind": "SCALAR"
	};
	
	var Checkout = {
	  "name": "Checkout",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "appliedGiftCards": "AppliedGiftCard",
	    "completedAt": "DateTime",
	    "createdAt": "DateTime",
	    "currencyCode": "CurrencyCode",
	    "customAttributes": "Attribute",
	    "discountApplications": "DiscountApplicationConnection",
	    "email": "String",
	    "id": "ID",
	    "lineItems": "CheckoutLineItemConnection",
	    "lineItemsSubtotalPrice": "MoneyV2",
	    "note": "String",
	    "order": "Order",
	    "orderStatusUrl": "URL",
	    "paymentDue": "MoneyV2",
	    "ready": "Boolean",
	    "requiresShipping": "Boolean",
	    "shippingAddress": "MailingAddress",
	    "shippingLine": "ShippingRate",
	    "subtotalPrice": "MoneyV2",
	    "taxExempt": "Boolean",
	    "taxesIncluded": "Boolean",
	    "totalPrice": "MoneyV2",
	    "totalTax": "MoneyV2",
	    "updatedAt": "DateTime",
	    "webUrl": "URL"
	  },
	  "implementsNode": true
	};
	
	var CheckoutAttributesUpdateV2Payload = {
	  "name": "CheckoutAttributesUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutCreatePayload = {
	  "name": "CheckoutCreatePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutDiscountCodeApplyV2Payload = {
	  "name": "CheckoutDiscountCodeApplyV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutDiscountCodeRemovePayload = {
	  "name": "CheckoutDiscountCodeRemovePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutEmailUpdateV2Payload = {
	  "name": "CheckoutEmailUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutErrorCode = {
	  "name": "CheckoutErrorCode",
	  "kind": "ENUM"
	};
	
	var CheckoutGiftCardRemoveV2Payload = {
	  "name": "CheckoutGiftCardRemoveV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutGiftCardsAppendPayload = {
	  "name": "CheckoutGiftCardsAppendPayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItem = {
	  "name": "CheckoutLineItem",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "customAttributes": "Attribute",
	    "discountAllocations": "DiscountAllocation",
	    "id": "ID",
	    "quantity": "Int",
	    "title": "String",
	    "variant": "ProductVariant"
	  },
	  "implementsNode": true
	};
	
	var CheckoutLineItemConnection = {
	  "name": "CheckoutLineItemConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "CheckoutLineItemEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemEdge = {
	  "name": "CheckoutLineItemEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "CheckoutLineItem"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsAddPayload = {
	  "name": "CheckoutLineItemsAddPayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsRemovePayload = {
	  "name": "CheckoutLineItemsRemovePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsReplacePayload = {
	  "name": "CheckoutLineItemsReplacePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "CheckoutUserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsUpdatePayload = {
	  "name": "CheckoutLineItemsUpdatePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutShippingAddressUpdateV2Payload = {
	  "name": "CheckoutShippingAddressUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutUserError = {
	  "name": "CheckoutUserError",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "code": "CheckoutErrorCode",
	    "field": "String",
	    "message": "String"
	  },
	  "implementsNode": false
	};
	
	var Collection = {
	  "name": "Collection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String",
	    "descriptionHtml": "HTML",
	    "handle": "String",
	    "id": "ID",
	    "image": "Image",
	    "products": "ProductConnection",
	    "title": "String",
	    "updatedAt": "DateTime"
	  },
	  "implementsNode": true
	};
	
	var CollectionConnection = {
	  "name": "CollectionConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "CollectionEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var CollectionEdge = {
	  "name": "CollectionEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Collection"
	  },
	  "implementsNode": false
	};
	
	var CountryCode = {
	  "name": "CountryCode",
	  "kind": "ENUM"
	};
	
	var CurrencyCode = {
	  "name": "CurrencyCode",
	  "kind": "ENUM"
	};
	
	var DateTime = {
	  "name": "DateTime",
	  "kind": "SCALAR"
	};
	
	var Decimal = {
	  "name": "Decimal",
	  "kind": "SCALAR"
	};
	
	var DiscountAllocation = {
	  "name": "DiscountAllocation",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "allocatedAmount": "MoneyV2",
	    "discountApplication": "DiscountApplication"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplication = {
	  "name": "DiscountApplication",
	  "kind": "INTERFACE",
	  "fieldBaseTypes": {
	    "allocationMethod": "DiscountApplicationAllocationMethod",
	    "targetSelection": "DiscountApplicationTargetSelection",
	    "targetType": "DiscountApplicationTargetType",
	    "value": "PricingValue"
	  },
	  "possibleTypes": ["AutomaticDiscountApplication", "DiscountCodeApplication", "ManualDiscountApplication", "ScriptDiscountApplication"]
	};
	
	var DiscountApplicationAllocationMethod = {
	  "name": "DiscountApplicationAllocationMethod",
	  "kind": "ENUM"
	};
	
	var DiscountApplicationConnection = {
	  "name": "DiscountApplicationConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "DiscountApplicationEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplicationEdge = {
	  "name": "DiscountApplicationEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "node": "DiscountApplication"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplicationTargetSelection = {
	  "name": "DiscountApplicationTargetSelection",
	  "kind": "ENUM"
	};
	
	var DiscountApplicationTargetType = {
	  "name": "DiscountApplicationTargetType",
	  "kind": "ENUM"
	};
	
	var DiscountCodeApplication = {
	  "name": "DiscountCodeApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "applicable": "Boolean",
	    "code": "String"
	  },
	  "implementsNode": false
	};
	
	var Domain = {
	  "name": "Domain",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "host": "String",
	    "sslEnabled": "Boolean",
	    "url": "URL"
	  },
	  "implementsNode": false
	};
	
	var Float = {
	  "name": "Float",
	  "kind": "SCALAR"
	};
	
	var HTML = {
	  "name": "HTML",
	  "kind": "SCALAR"
	};
	
	var ID = {
	  "name": "ID",
	  "kind": "SCALAR"
	};
	
	var Image = {
	  "name": "Image",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "altText": "String",
	    "height": "Int",
	    "id": "ID",
	    "url": "URL",
	    "width": "Int"
	  },
	  "implementsNode": false
	};
	
	var ImageConnection = {
	  "name": "ImageConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ImageEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ImageEdge = {
	  "name": "ImageEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Image"
	  },
	  "implementsNode": false
	};
	
	var Int = {
	  "name": "Int",
	  "kind": "SCALAR"
	};
	
	var MailingAddress = {
	  "name": "MailingAddress",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "address1": "String",
	    "address2": "String",
	    "city": "String",
	    "company": "String",
	    "country": "String",
	    "countryCodeV2": "CountryCode",
	    "firstName": "String",
	    "formatted": "String",
	    "id": "ID",
	    "lastName": "String",
	    "latitude": "Float",
	    "longitude": "Float",
	    "name": "String",
	    "phone": "String",
	    "province": "String",
	    "provinceCode": "String",
	    "zip": "String"
	  },
	  "implementsNode": true
	};
	
	var ManualDiscountApplication = {
	  "name": "ManualDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String",
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var MoneyV2 = {
	  "name": "MoneyV2",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "amount": "Decimal",
	    "currencyCode": "CurrencyCode"
	  },
	  "implementsNode": false
	};
	
	var Mutation$1 = {
	  "name": "Mutation",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Payload",
	    "checkoutCreate": "CheckoutCreatePayload",
	    "checkoutDiscountCodeApplyV2": "CheckoutDiscountCodeApplyV2Payload",
	    "checkoutDiscountCodeRemove": "CheckoutDiscountCodeRemovePayload",
	    "checkoutEmailUpdateV2": "CheckoutEmailUpdateV2Payload",
	    "checkoutGiftCardRemoveV2": "CheckoutGiftCardRemoveV2Payload",
	    "checkoutGiftCardsAppend": "CheckoutGiftCardsAppendPayload",
	    "checkoutLineItemsAdd": "CheckoutLineItemsAddPayload",
	    "checkoutLineItemsRemove": "CheckoutLineItemsRemovePayload",
	    "checkoutLineItemsReplace": "CheckoutLineItemsReplacePayload",
	    "checkoutLineItemsUpdate": "CheckoutLineItemsUpdatePayload",
	    "checkoutShippingAddressUpdateV2": "CheckoutShippingAddressUpdateV2Payload"
	  },
	  "implementsNode": false,
	  "relayInputObjectBaseTypes": {
	    "cartCreate": "CartInput",
	    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Input",
	    "checkoutCreate": "CheckoutCreateInput",
	    "customerAccessTokenCreate": "CustomerAccessTokenCreateInput",
	    "customerActivate": "CustomerActivateInput",
	    "customerCreate": "CustomerCreateInput",
	    "customerReset": "CustomerResetInput"
	  }
	};
	
	var Node = {
	  "name": "Node",
	  "kind": "INTERFACE",
	  "fieldBaseTypes": {},
	  "possibleTypes": ["AppliedGiftCard", "Article", "Blog", "Cart", "CartLine", "Checkout", "CheckoutLineItem", "Collection", "Comment", "ExternalVideo", "GenericFile", "Location", "MailingAddress", "MediaImage", "Menu", "MenuItem", "Metafield", "Metaobject", "Model3d", "Order", "Page", "Payment", "Product", "ProductOption", "ProductVariant", "Shop", "ShopPolicy", "UrlRedirect", "Video"]
	};
	
	var Order = {
	  "name": "Order",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "currencyCode": "CurrencyCode",
	    "customerUrl": "URL",
	    "id": "ID",
	    "lineItems": "OrderLineItemConnection",
	    "orderNumber": "Int",
	    "processedAt": "DateTime",
	    "shippingAddress": "MailingAddress",
	    "subtotalPrice": "MoneyV2",
	    "totalPrice": "MoneyV2",
	    "totalRefunded": "MoneyV2",
	    "totalShippingPrice": "MoneyV2",
	    "totalTax": "MoneyV2"
	  },
	  "implementsNode": true
	};
	
	var OrderLineItem = {
	  "name": "OrderLineItem",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "customAttributes": "Attribute",
	    "quantity": "Int",
	    "title": "String",
	    "variant": "ProductVariant"
	  },
	  "implementsNode": false
	};
	
	var OrderLineItemConnection = {
	  "name": "OrderLineItemConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "OrderLineItemEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var OrderLineItemEdge = {
	  "name": "OrderLineItemEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "OrderLineItem"
	  },
	  "implementsNode": false
	};
	
	var PageInfo = {
	  "name": "PageInfo",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "hasNextPage": "Boolean",
	    "hasPreviousPage": "Boolean"
	  },
	  "implementsNode": false
	};
	
	var PaymentSettings = {
	  "name": "PaymentSettings",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "enabledPresentmentCurrencies": "CurrencyCode"
	  },
	  "implementsNode": false
	};
	
	var PricingPercentageValue = {
	  "name": "PricingPercentageValue",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "percentage": "Float"
	  },
	  "implementsNode": false
	};
	
	var PricingValue = {
	  "name": "PricingValue",
	  "kind": "UNION"
	};
	
	var Product = {
	  "name": "Product",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "availableForSale": "Boolean",
	    "createdAt": "DateTime",
	    "description": "String",
	    "descriptionHtml": "HTML",
	    "handle": "String",
	    "id": "ID",
	    "images": "ImageConnection",
	    "onlineStoreUrl": "URL",
	    "options": "ProductOption",
	    "productType": "String",
	    "publishedAt": "DateTime",
	    "title": "String",
	    "updatedAt": "DateTime",
	    "variants": "ProductVariantConnection",
	    "vendor": "String"
	  },
	  "implementsNode": true
	};
	
	var ProductConnection = {
	  "name": "ProductConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ProductEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ProductEdge = {
	  "name": "ProductEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Product"
	  },
	  "implementsNode": false
	};
	
	var ProductOption = {
	  "name": "ProductOption",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "name": "String",
	    "values": "String"
	  },
	  "implementsNode": true
	};
	
	var ProductVariant = {
	  "name": "ProductVariant",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "availableForSale": "Boolean",
	    "compareAtPrice": "MoneyV2",
	    "id": "ID",
	    "image": "Image",
	    "price": "MoneyV2",
	    "product": "Product",
	    "selectedOptions": "SelectedOption",
	    "sku": "String",
	    "title": "String",
	    "unitPrice": "MoneyV2",
	    "unitPriceMeasurement": "UnitPriceMeasurement",
	    "weight": "Float"
	  },
	  "implementsNode": true
	};
	
	var ProductVariantConnection = {
	  "name": "ProductVariantConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ProductVariantEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ProductVariantEdge = {
	  "name": "ProductVariantEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "ProductVariant"
	  },
	  "implementsNode": false
	};
	
	var QueryRoot = {
	  "name": "QueryRoot",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "collectionByHandle": "Collection",
	    "collections": "CollectionConnection",
	    "node": "Node",
	    "nodes": "Node",
	    "productByHandle": "Product",
	    "productRecommendations": "Product",
	    "products": "ProductConnection",
	    "shop": "Shop"
	  },
	  "implementsNode": false
	};
	
	var ScriptDiscountApplication = {
	  "name": "ScriptDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var SelectedOption = {
	  "name": "SelectedOption",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "name": "String",
	    "value": "String"
	  },
	  "implementsNode": false
	};
	
	var ShippingRate = {
	  "name": "ShippingRate",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "handle": "String",
	    "price": "MoneyV2",
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var Shop = {
	  "name": "Shop",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String",
	    "moneyFormat": "String",
	    "name": "String",
	    "paymentSettings": "PaymentSettings",
	    "primaryDomain": "Domain",
	    "privacyPolicy": "ShopPolicy",
	    "refundPolicy": "ShopPolicy",
	    "termsOfService": "ShopPolicy"
	  },
	  "implementsNode": true
	};
	
	var ShopPolicy = {
	  "name": "ShopPolicy",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "body": "String",
	    "id": "ID",
	    "title": "String",
	    "url": "URL"
	  },
	  "implementsNode": true
	};
	
	var String$1 = {
	  "name": "String",
	  "kind": "SCALAR"
	};
	
	var URL = {
	  "name": "URL",
	  "kind": "SCALAR"
	};
	
	var UnitPriceMeasurement = {
	  "name": "UnitPriceMeasurement",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "measuredType": "UnitPriceMeasurementMeasuredType",
	    "quantityUnit": "UnitPriceMeasurementMeasuredUnit",
	    "quantityValue": "Float",
	    "referenceUnit": "UnitPriceMeasurementMeasuredUnit",
	    "referenceValue": "Int"
	  },
	  "implementsNode": false
	};
	
	var UnitPriceMeasurementMeasuredType = {
	  "name": "UnitPriceMeasurementMeasuredType",
	  "kind": "ENUM"
	};
	
	var UnitPriceMeasurementMeasuredUnit = {
	  "name": "UnitPriceMeasurementMeasuredUnit",
	  "kind": "ENUM"
	};
	
	var UserError = {
	  "name": "UserError",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "field": "String",
	    "message": "String"
	  },
	  "implementsNode": false
	};
	
	var Types = {
	  types: {}
	};
	Types.types["AppliedGiftCard"] = AppliedGiftCard;
	Types.types["Attribute"] = Attribute;
	Types.types["AutomaticDiscountApplication"] = AutomaticDiscountApplication;
	Types.types["Boolean"] = Boolean$1;
	Types.types["Checkout"] = Checkout;
	Types.types["CheckoutAttributesUpdateV2Payload"] = CheckoutAttributesUpdateV2Payload;
	Types.types["CheckoutCreatePayload"] = CheckoutCreatePayload;
	Types.types["CheckoutDiscountCodeApplyV2Payload"] = CheckoutDiscountCodeApplyV2Payload;
	Types.types["CheckoutDiscountCodeRemovePayload"] = CheckoutDiscountCodeRemovePayload;
	Types.types["CheckoutEmailUpdateV2Payload"] = CheckoutEmailUpdateV2Payload;
	Types.types["CheckoutErrorCode"] = CheckoutErrorCode;
	Types.types["CheckoutGiftCardRemoveV2Payload"] = CheckoutGiftCardRemoveV2Payload;
	Types.types["CheckoutGiftCardsAppendPayload"] = CheckoutGiftCardsAppendPayload;
	Types.types["CheckoutLineItem"] = CheckoutLineItem;
	Types.types["CheckoutLineItemConnection"] = CheckoutLineItemConnection;
	Types.types["CheckoutLineItemEdge"] = CheckoutLineItemEdge;
	Types.types["CheckoutLineItemsAddPayload"] = CheckoutLineItemsAddPayload;
	Types.types["CheckoutLineItemsRemovePayload"] = CheckoutLineItemsRemovePayload;
	Types.types["CheckoutLineItemsReplacePayload"] = CheckoutLineItemsReplacePayload;
	Types.types["CheckoutLineItemsUpdatePayload"] = CheckoutLineItemsUpdatePayload;
	Types.types["CheckoutShippingAddressUpdateV2Payload"] = CheckoutShippingAddressUpdateV2Payload;
	Types.types["CheckoutUserError"] = CheckoutUserError;
	Types.types["Collection"] = Collection;
	Types.types["CollectionConnection"] = CollectionConnection;
	Types.types["CollectionEdge"] = CollectionEdge;
	Types.types["CountryCode"] = CountryCode;
	Types.types["CurrencyCode"] = CurrencyCode;
	Types.types["DateTime"] = DateTime;
	Types.types["Decimal"] = Decimal;
	Types.types["DiscountAllocation"] = DiscountAllocation;
	Types.types["DiscountApplication"] = DiscountApplication;
	Types.types["DiscountApplicationAllocationMethod"] = DiscountApplicationAllocationMethod;
	Types.types["DiscountApplicationConnection"] = DiscountApplicationConnection;
	Types.types["DiscountApplicationEdge"] = DiscountApplicationEdge;
	Types.types["DiscountApplicationTargetSelection"] = DiscountApplicationTargetSelection;
	Types.types["DiscountApplicationTargetType"] = DiscountApplicationTargetType;
	Types.types["DiscountCodeApplication"] = DiscountCodeApplication;
	Types.types["Domain"] = Domain;
	Types.types["Float"] = Float;
	Types.types["HTML"] = HTML;
	Types.types["ID"] = ID;
	Types.types["Image"] = Image;
	Types.types["ImageConnection"] = ImageConnection;
	Types.types["ImageEdge"] = ImageEdge;
	Types.types["Int"] = Int;
	Types.types["MailingAddress"] = MailingAddress;
	Types.types["ManualDiscountApplication"] = ManualDiscountApplication;
	Types.types["MoneyV2"] = MoneyV2;
	Types.types["Mutation"] = Mutation$1;
	Types.types["Node"] = Node;
	Types.types["Order"] = Order;
	Types.types["OrderLineItem"] = OrderLineItem;
	Types.types["OrderLineItemConnection"] = OrderLineItemConnection;
	Types.types["OrderLineItemEdge"] = OrderLineItemEdge;
	Types.types["PageInfo"] = PageInfo;
	Types.types["PaymentSettings"] = PaymentSettings;
	Types.types["PricingPercentageValue"] = PricingPercentageValue;
	Types.types["PricingValue"] = PricingValue;
	Types.types["Product"] = Product;
	Types.types["ProductConnection"] = ProductConnection;
	Types.types["ProductEdge"] = ProductEdge;
	Types.types["ProductOption"] = ProductOption;
	Types.types["ProductVariant"] = ProductVariant;
	Types.types["ProductVariantConnection"] = ProductVariantConnection;
	Types.types["ProductVariantEdge"] = ProductVariantEdge;
	Types.types["QueryRoot"] = QueryRoot;
	Types.types["ScriptDiscountApplication"] = ScriptDiscountApplication;
	Types.types["SelectedOption"] = SelectedOption;
	Types.types["ShippingRate"] = ShippingRate;
	Types.types["Shop"] = Shop;
	Types.types["ShopPolicy"] = ShopPolicy;
	Types.types["String"] = String$1;
	Types.types["URL"] = URL;
	Types.types["UnitPriceMeasurement"] = UnitPriceMeasurement;
	Types.types["UnitPriceMeasurementMeasuredType"] = UnitPriceMeasurementMeasuredType;
	Types.types["UnitPriceMeasurementMeasuredUnit"] = UnitPriceMeasurementMeasuredUnit;
	Types.types["UserError"] = UserError;
	Types.queryType = "QueryRoot";
	Types.mutationType = "Mutation";
	Types.subscriptionType = null;
	
	function recursivelyFreezeObject(structure) {
	  Object.getOwnPropertyNames(structure).forEach(function (key) {
	    var value = structure[key];
	    if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
	      recursivelyFreezeObject(value);
	    }
	  });
	  Object.freeze(structure);
	  return structure;
	}
	
	var types = recursivelyFreezeObject(Types);
	
	// GraphQL
	/**
	 * The JS Buy SDK Client.
	 * @class
	 *
	 * @property {ProductResource} product The property under which product fetching methods live.
	 * @property {CollectionResource} collection The property under which collection fetching methods live.
	 * @property {ShopResource} shop The property under which shop fetching methods live.
	 * @property {CheckoutResource} checkout The property under which shop fetching and mutating methods live.
	 * @property {ImageResource} image The property under which image helper methods live.
	 */
	
	var Client = function () {
	  createClass$1(Client, null, [{
	    key: 'buildClient',
	
	
	    /**
	     * Primary entry point for building a new Client.
	     */
	    value: function buildClient(config, fetchFunction) {
	      var newConfig = new Config(config);
	      var client = new Client(newConfig, Client$2, fetchFunction);
	
	      client.config = newConfig;
	
	      return client;
	    }
	
	    /**
	     * @constructs Client
	     * @param {Config} config An instance of {@link Config} used to configure the Client.
	     */
	
	  }]);
	
	  function Client(config) {
	    var GraphQLClientClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Client$2;
	    var fetchFunction = arguments[2];
	    classCallCheck$1(this, Client);
	
	    var url = 'https://' + config.domain + '/api/' + config.apiVersion + '/graphql';
	
	    var headers = {
	      'X-SDK-Variant': 'javascript',
	      'X-SDK-Version': version,
	      'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
	    };
	
	    if (config.source) {
	      headers['X-SDK-Variant-Source'] = config.source;
	    }
	
	    var languageHeader = config.language ? config.language : '*';
	
	    headers['Accept-Language'] = languageHeader;
	
	    if (fetchFunction) {
	      headers['Content-Type'] = 'application/json';
	      headers.Accept = 'application/json';
	
	      this.graphQLClient = new GraphQLClientClass(types, {
	        fetcher: function fetcher(graphQLParams) {
	          return fetchFunction(url, {
	            body: JSON.stringify(graphQLParams),
	            method: 'POST',
	            mode: 'cors',
	            headers: headers
	          }).then(function (response) {
	            return response.json();
	          });
	        }
	      });
	    } else {
	      this.graphQLClient = new GraphQLClientClass(types, {
	        url: url,
	        fetcherOptions: { headers: headers }
	      });
	    }
	
	    this.product = new ProductResource(this.graphQLClient);
	    this.collection = new CollectionResource(this.graphQLClient);
	    this.shop = new ShopResource(this.graphQLClient);
	    this.checkout = new CheckoutResource(this.graphQLClient);
	    this.image = new ImageResource(this.graphQLClient);
	  }
	
	  /**
	   * Fetches the next page of models
	   *
	   * @example
	   * client.fetchNextPage(products).then((nextProducts) => {
	   *   // Do something with the products
	   * });
	   *
	   * @param {models} [Array] The paginated set to fetch the next page of
	   * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the type provided.
	   */
	
	
	  createClass$1(Client, [{
	    key: 'fetchNextPage',
	    value: function fetchNextPage(models) {
	      return this.graphQLClient.fetchNextPage(models);
	    }
	  }]);
	  return Client;
	}();
	
	module.exports = Client;
	//# sourceMappingURL=index.js.map


/***/ },
/* 9 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(172);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(29);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
14,
/* 16 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.trackRef)));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = _reactDom["default"].findDOMNode(spec.listRef) && getHeight(_reactDom["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = {
	      animating: false
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
	      currentSlide: animationSlide
	    })));
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        swipeLeft: null
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread({}, spec, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread({}, spec, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = currentSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	
	    var slickList = _reactDom["default"].findDOMNode(spec.listRef);
	
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	
	    var trackElem = _reactDom["default"].findDOMNode(trackRef);
	
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(27));
	var React = __webpack_require__(1);
	var createCache = _interopDefault(__webpack_require__(28));
	var utils = __webpack_require__(73);
	var serialize = __webpack_require__(29);
	var sheet = __webpack_require__(30);
	var css = _interopDefault(__webpack_require__(12));
	
	var EmotionCacheContext = React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache() : null);
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processNodes;
	
	var _isEmptyTextNode = __webpack_require__(148);
	
	var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);
	
	var _convertNodeToElement = __webpack_require__(53);
	
	var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes the nodes generated by htmlparser2 and convert them all into React elements
	 *
	 * @param {Object[]} nodes List of nodes to process
	 * @param {Function} transform Transform function to optionally apply to nodes
	 * @returns {React.Element[]} The list of processed React elements
	 */
	function processNodes(nodes, transform) {
	
	  return nodes.filter(function (node) {
	    return !(0, _isEmptyTextNode2.default)(node);
	  }).map(function (node, index) {
	
	    // return the result of the transform function if applicable
	    var transformed = void 0;
	    if (typeof transform === 'function') {
	      transformed = transform(node, index);
	      if (transformed === null || !!transformed) {
	        return transformed;
	      }
	    }
	
	    // otherwise convert the node as standard
	    return (0, _convertNodeToElement2.default)(node, index, transform);
	  });
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(149);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(104);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	// ==============================
	// NO OP
	// ==============================
	var noop = function noop() {};
	// Class Name Prefixer
	// ==============================
	
	/**
	 String representation of component state for styling with class names.
	
	 Expects an array of strings OR a string/object pair:
	 - className(['comp', 'comp-arg', 'comp-arg-2'])
	   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
	 - className('comp', { some: true, state: false })
	   @returns 'react-select__comp react-select__comp--some'
	*/
	
	function applyPrefixToName(prefix, name) {
	  if (!name) {
	    return prefix;
	  } else if (name[0] === '-') {
	    return prefix + name;
	  } else {
	    return prefix + '__' + name;
	  }
	}
	
	function classNames(prefix, state, className) {
	  var arr = [className];
	
	  if (state && prefix) {
	    for (var key in state) {
	      if (state.hasOwnProperty(key) && state[key]) {
	        arr.push("" + applyPrefixToName(prefix, key));
	      }
	    }
	  }
	
	  return arr.filter(function (i) {
	    return i;
	  }).map(function (i) {
	    return String(i).trim();
	  }).join(' ');
	} // ==============================
	// Clean Value
	// ==============================
	
	var cleanValue = function cleanValue(value) {
	  if (Array.isArray(value)) return value.filter(Boolean);
	  if (typeof value === 'object' && value !== null) return [value];
	  return [];
	}; // ==============================
	// Handle Input Change
	// ==============================
	
	function handleInputChange(inputValue, actionMeta, onInputChange) {
	  if (onInputChange) {
	    var newValue = onInputChange(inputValue, actionMeta);
	    if (typeof newValue === 'string') return newValue;
	  }
	
	  return inputValue;
	} // ==============================
	// Scroll Helpers
	// ==============================
	
	function isDocumentElement(el) {
	  return [document.documentElement, document.body, window].indexOf(el) > -1;
	} // Normalized Scroll Top
	// ------------------------------
	
	function getScrollTop(el) {
	  if (isDocumentElement(el)) {
	    return window.pageYOffset;
	  }
	
	  return el.scrollTop;
	}
	function scrollTo(el, top) {
	  // with a scroll distance, we perform scroll on the element
	  if (isDocumentElement(el)) {
	    window.scrollTo(0, top);
	    return;
	  }
	
	  el.scrollTop = top;
	} // Get Scroll Parent
	// ------------------------------
	
	function getScrollParent(element) {
	  var style = getComputedStyle(element);
	  var excludeStaticParent = style.position === 'absolute';
	  var overflowRx = /(auto|scroll)/;
	  var docEl = document.documentElement; // suck it, flow...
	
	  if (style.position === 'fixed') return docEl;
	
	  for (var parent = element; parent = parent.parentElement;) {
	    style = getComputedStyle(parent);
	
	    if (excludeStaticParent && style.position === 'static') {
	      continue;
	    }
	
	    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
	      return parent;
	    }
	  }
	
	  return docEl;
	} // Animated Scroll To
	// ------------------------------
	
	/**
	  @param t: time (elapsed)
	  @param b: initial value
	  @param c: amount of change
	  @param d: duration
	*/
	
	function easeOutCubic(t, b, c, d) {
	  return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	
	function animatedScrollTo(element, to, duration, callback) {
	  if (duration === void 0) {
	    duration = 200;
	  }
	
	  if (callback === void 0) {
	    callback = noop;
	  }
	
	  var start = getScrollTop(element);
	  var change = to - start;
	  var increment = 10;
	  var currentTime = 0;
	
	  function animateScroll() {
	    currentTime += increment;
	    var val = easeOutCubic(currentTime, start, change, duration);
	    scrollTo(element, val);
	
	    if (currentTime < duration) {
	      window.requestAnimationFrame(animateScroll);
	    } else {
	      callback(element);
	    }
	  }
	
	  animateScroll();
	} // Scroll Into View
	// ------------------------------
	
	function scrollIntoView(menuEl, focusedEl) {
	  var menuRect = menuEl.getBoundingClientRect();
	  var focusedRect = focusedEl.getBoundingClientRect();
	  var overScroll = focusedEl.offsetHeight / 3;
	
	  if (focusedRect.bottom + overScroll > menuRect.bottom) {
	    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
	  } else if (focusedRect.top - overScroll < menuRect.top) {
	    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
	  }
	} // ==============================
	// Get bounding client object
	// ==============================
	// cannot get keys using array notation with DOMRect
	
	function getBoundingClientObj(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    bottom: rect.bottom,
	    height: rect.height,
	    left: rect.left,
	    right: rect.right,
	    top: rect.top,
	    width: rect.width
	  };
	}
	// Touch Capability Detector
	// ==============================
	
	function isTouchCapable() {
	  try {
	    document.createEvent('TouchEvent');
	    return true;
	  } catch (e) {
	    return false;
	  }
	} // ==============================
	// Mobile Device Detector
	// ==============================
	
	function isMobileDevice() {
	  try {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	  } catch (e) {
	    return false;
	  }
	}
	
	exports.animatedScrollTo = animatedScrollTo;
	exports.classNames = classNames;
	exports.cleanValue = cleanValue;
	exports.getBoundingClientObj = getBoundingClientObj;
	exports.getScrollParent = getScrollParent;
	exports.getScrollTop = getScrollTop;
	exports.handleInputChange = handleInputChange;
	exports.isDocumentElement = isDocumentElement;
	exports.isMobileDevice = isMobileDevice;
	exports.isTouchCapable = isTouchCapable;
	exports.noop = noop;
	exports.scrollIntoView = scrollIntoView;
	exports.scrollTo = scrollTo;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(68);
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(30);
	var Stylis = _interopDefault(__webpack_require__(71));
	__webpack_require__(74);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(69));
	var unitless = _interopDefault(__webpack_require__(72));
	var memoize = _interopDefault(__webpack_require__(70));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shopifyBuy = __webpack_require__(8);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	var _productsContext = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var client = _shopifyBuy2.default.buildClient({
	  domain: 'conecuh-brands.myshopify.com',
	  storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
	});
	
	var Cart = function Cart(props) {
	  // eslint-disable-next-line 
	  var _useContext = (0, _react.useContext)(_productsContext.CartContext),
	      _useContext2 = _slicedToArray(_useContext, 2),
	      showCart = _useContext2[0],
	      setShowCart = _useContext2[1];
	
	  var _useContext3 = (0, _react.useContext)(_productsContext.CheckoutsContext),
	      _useContext4 = _slicedToArray(_useContext3, 2),
	      checkout = _useContext4[0],
	      setCheckout = _useContext4[1];
	
	  var addVariantToCart = function addVariantToCart(variantId, quantity) {
	    setShowCart(true);
	    if (!props.isDetailPage) {
	      props.closeModal();
	    }
	
	    var lineItemsToAdd = [{ variantId: variantId, quantity: parseInt(quantity, 10) }];
	    var checkoutId = checkout.id;
	    client.checkout.addLineItems(checkoutId, lineItemsToAdd).then(function (res) {
	      setCheckout(res);
	    });
	  };
	  return _react2.default.createElement(
	    'button',
	    { className: 'add-to-cart btn btn-default', type: 'button', onClick: function onClick() {
	        return addVariantToCart(props.variant_id, props.variantQuantity);
	      } },
	    'ADD TO CART'
	  );
	};
	
	exports.default = Cart;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(157);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	var _ProductDetails = __webpack_require__(82);
	
	var _ProductDetails2 = _interopRequireDefault(_ProductDetails);
	
	var _reactRouterDom = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customStyles = {
	  overlay: {
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    overflow: "visible",
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var Product = function Product(props) {
	  // eslint-disable-next-line
	
	  // console.log(props.products);
	
	  var products = props.products;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      modalIsOpen = _useState2[0],
	      setModalIsOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      product = _useState4[0],
	      setProduct = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      showProduct = _useState6[0],
	      setShowProduct = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      currentProductIndex = _useState8[0],
	      setCurrentProductIndex = _useState8[1];
	
	  var setProductState = function setProductState(productvalue, Index) {
	    setProduct(productvalue);
	    setCurrentProductIndex(Index);
	    setShowProduct(true);
	  };
	
	  (0, _react.useEffect)(function () {
	    _reactModal2.default.setAppElement('body');
	    setProductState(props.product, props.Index);
	  }, []);
	
	  var openModal = function openModal() {
	    setModalIsOpen(true);
	  };
	
	  var closeModal = function closeModal() {
	    setProductState(props.product, props.Index);
	    setModalIsOpen(false);
	  };
	
	  var changeProductDetails = function changeProductDetails(product_id) {
	    setModalIsOpen(false);
	    props.changeProduct(product_id);
	  };
	
	  var addToCart = function addToCart(id, variantQuantity) {
	    setModalIsOpen(false);
	    props.addVariantToCart(id, variantQuantity);
	  };
	
	  var nextProduct = function nextProduct() {
	    setShowProduct(false);
	    var Index = currentProductIndex + 1;
	    console.log(Index);
	    setProductState(products[Index], Index);
	  };
	
	  var prevProduct = function prevProduct() {
	    setShowProduct(false);
	    var Index = currentProductIndex - 1;
	    console.log(Index);
	    setProductState(products[Index], Index);
	  };
	
	  var changeImageOnHover = function changeImageOnHover(event) {
	    if (props.product.images.length > 1) {
	      event.target.src = props.product.images[1].src;
	    }
	  };
	
	  var changeImageOnMouseOut = function changeImageOnMouseOut(event) {
	    if (props.product.images.length > 0) {
	      event.target.src = props.product.images[0].src;
	    }
	  };
	
	  if (showProduct) {
	    return _react2.default.createElement(
	      'div',
	      { className: props.isproductForSlide ? "main_container1" : "main_container col-md-4 col-sm-6" },
	      _react2.default.createElement(
	        'div',
	        { className: 'Product_view_modal' },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: { pathname: "/ProductDetail/" + props.category, search: "?id=" + props.product.id.toString() },
	            onClick: function onClick() {
	              return props.isproductForSlide ? changeProductDetails(props.product.id) : null;
	            }, className: 'desktop_views' },
	          product.images.length ? _react2.default.createElement('img', { className: props.isproductForSlide ? "Product_image1" : "Product_image",
	            src: props.product.images[0].src, onMouseOver: changeImageOnHover,
	            onMouseOut: changeImageOnMouseOut, alt: props.product.title + ' product shot' }) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile_views' },
	          product.images.length ? _react2.default.createElement('img', { className: props.isproductForSlide ? "Product_image1" : "Product_image",
	            src: props.product.images[0].src, onMouseOver: changeImageOnHover,
	            onMouseOut: changeImageOnMouseOut, alt: props.product.title + ' product shot' }) : null
	        ),
	        _react2.default.createElement('div', { className: 'overlay' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'button_view', onClick: openModal },
	          ' Quick View '
	        )
	      ),
	      _react2.default.createElement(
	        'h5',
	        { className: 'Product__title desktop_views' },
	        props.product.title,
	        ' '
	      ),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: { pathname: "/ProductDetail/" + props.category, search: "?id=" + props.product.id.toString() },
	          onClick: function onClick() {
	            return props.isproductForSlide ? changeProductDetails(props.product.id) : null;
	          } },
	        _react2.default.createElement(
	          'h5',
	          { className: 'Product__title mobile_views' },
	          props.product.title
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'Product__price' },
	        '$ ',
	        props.product.variants[0].price.amount
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            isOpen: modalIsOpen,
	            onRequestClose: closeModal,
	            contentLabel: 'Detail Modal',
	            style: customStyles },
	          _react2.default.createElement(_ProductDetails2.default, {
	            category: props.category,
	            productsCount: products.length,
	            Index: currentProductIndex,
	            addVariantToCart: props.addVariantToCart,
	            client: props.client,
	            product: product,
	            addToCart: addToCart,
	            closeModal: closeModal,
	            openModal: openModal,
	            isproductForSlide: props.isproductForSlide,
	            changeProduct: changeProductDetails,
	            nextProduct: nextProduct,
	            prevProduct: prevProduct
	          })
	        )
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      'div',
	      null,
	      'Loading'
	    );
	  }
	};
	
	exports.default = Product;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(177);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VariantSelector = function (_Component) {
	  _inherits(VariantSelector, _Component);
	
	  function VariantSelector() {
	    _classCallCheck(this, VariantSelector);
	
	    return _possibleConstructorReturn(this, (VariantSelector.__proto__ || Object.getPrototypeOf(VariantSelector)).apply(this, arguments));
	  }
	
	  _createClass(VariantSelector, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var colourOptions = [];
	
	      this.props.option.values.map(function (value) {
	        colourOptions.push({
	          value: "" + value,
	          label: "" + value
	        });
	      });
	
	      var field_Name = this.props.fieldName;
	
	      if (field_Name === "Size") {
	        return _react2.default.createElement(
	          "div",
	          { className: "color_select" },
	          _react2.default.createElement(_reactSelect2.default, {
	            className: "basic-single",
	            classNamePrefix: "select",
	            name: this.props.fieldName,
	            options: colourOptions,
	            defaultValue: colourOptions[0],
	            onChange: function onChange(e) {
	              return _this2.props.handleOptionChange(e, field_Name);
	            },
	            value: colourOptions.filter(function (_ref) {
	              var value = _ref.value;
	              return value === _this2.props.selectedSizeValue;
	            })
	          })
	        );
	      } else if (field_Name === "Color") {
	        return _react2.default.createElement(
	          "div",
	          { className: "color_select" },
	          _react2.default.createElement(_reactSelect2.default, {
	            className: "basic-single",
	            classNamePrefix: "select",
	            name: this.props.fieldName,
	            defaultValue: colourOptions[0],
	            options: colourOptions,
	            onChange: function onChange(e) {
	              return _this2.props.handleOptionChange(e, field_Name);
	            },
	            value: this.props.selectedColorValue && colourOptions.filter(function (_ref2) {
	              var value = _ref2.value;
	              return value === _this2.props.selectedColorValue;
	            })
	          })
	        );
	      } else {
	        return _react2.default.createElement(
	          "div",
	          { className: "color_select" },
	          _react2.default.createElement(_reactSelect2.default, {
	            className: "basic-single",
	            classNamePrefix: "select",
	            name: this.props.fieldName,
	            defaultValue: colourOptions[0],
	            options: colourOptions,
	            onChange: function onChange(e) {
	              return _this2.props.handleOptionChange(e, field_Name);
	            },
	            value: this.props.selectedColorValue && colourOptions.filter(function (_ref3) {
	              var value = _ref3.value;
	              return value === _this2.props.selectedColorValue;
	            })
	          })
	        );
	      }
	    }
	  }]);
	
	  return VariantSelector;
	}(_react.Component);
	
	exports.default = VariantSelector;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(85)
	var ieee754 = __webpack_require__(116)
	var isArray = __webpack_require__(86)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(9);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(36);
	var ElementPrototype = __webpack_require__(90);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ },
/* 36 */
/***/ function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(95),
		__webpack_require__(96),
		__webpack_require__(93),
		__webpack_require__(94),
		__webpack_require__(92),
		__webpack_require__(91)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var entities_json_1 = __importDefault(__webpack_require__(48));
	var legacy_json_1 = __importDefault(__webpack_require__(120));
	var xml_json_1 = __importDefault(__webpack_require__(49));
	var decode_codepoint_1 = __importDefault(__webpack_require__(101));
	exports.decodeXML = getStrictDecoder(xml_json_1.default);
	exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
	function getStrictDecoder(map) {
	    var keys = Object.keys(map).join("|");
	    var replace = getReplacer(map);
	    keys += "|#[xX][\\da-fA-F]+|#\\d+";
	    var re = new RegExp("&(?:" + keys + ");", "g");
	    return function (str) { return String(str).replace(re, replace); };
	}
	var sorter = function (a, b) { return (a < b ? 1 : -1); };
	exports.decodeHTML = (function () {
	    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
	    var keys = Object.keys(entities_json_1.default).sort(sorter);
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        }
	        else {
	            keys[i] += ";";
	        }
	    }
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
	    var replace = getReplacer(entities_json_1.default);
	    function replacer(str) {
	        if (str.substr(-1) !== ";")
	            str += ";";
	        return replace(str);
	    }
	    //TODO consider creating a merged map
	    return function (str) {
	        return String(str).replace(re, replacer);
	    };
	})();
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
	                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
	            }
	            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
	        }
	        return map[str.slice(1, -1)];
	    };
	}


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var xml_json_1 = __importDefault(__webpack_require__(49));
	var inverseXML = getInverseObj(xml_json_1.default);
	var xmlReplacer = getInverseReplacer(inverseXML);
	exports.encodeXML = getInverse(inverseXML, xmlReplacer);
	var entities_json_1 = __importDefault(__webpack_require__(48));
	var inverseHTML = getInverseObj(entities_json_1.default);
	var htmlReplacer = getInverseReplacer(inverseHTML);
	exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function (inverse, name) {
	        inverse[obj[name]] = "&" + name + ";";
	        return inverse;
	    }, {});
	}
	function getInverseReplacer(inverse) {
	    var single = [];
	    var multiple = [];
	    Object.keys(inverse).forEach(function (k) {
	        return k.length === 1
	            ? // Add value to single array
	                single.push("\\" + k)
	            : // Add value to multiple array
	                multiple.push(k);
	    });
	    //TODO add ranges
	    multiple.unshift("[" + single.join("") + "]");
	    return new RegExp(multiple.join("|"), "g");
	}
	var reNonASCII = /[^\0-\x7F]/g;
	var reAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	function singleCharReplacer(c) {
	    return "&#x" + c
	        .charCodeAt(0)
	        .toString(16)
	        .toUpperCase() + ";";
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
	function astralReplacer(c, _) {
	    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	    var high = c.charCodeAt(0);
	    var low = c.charCodeAt(1);
	    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
	    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
	}
	function getInverse(inverse, re) {
	    return function (data) {
	        return data
	            .replace(re, function (name) { return inverse[name]; })
	            .replace(reAstralSymbols, astralReplacer)
	            .replace(reNonASCII, singleCharReplacer);
	    };
	}
	var reXmlChars = getInverseReplacer(inverseXML);
	function escape(data) {
	    return data
	        .replace(reXmlChars, singleCharReplacer)
	        .replace(reAstralSymbols, astralReplacer)
	        .replace(reNonASCII, singleCharReplacer);
	}
	exports.escape = escape;


/***/ },
/* 41 */
14,
/* 42 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(109);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(46);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(16)(Parser, __webpack_require__(103).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(115);
	var entityMap = __webpack_require__(122);
	var legacyMap = __webpack_require__(123);
	var xmlMap = __webpack_require__(124);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(45);
	var WritableStream = __webpack_require__(202).Writable;
	var StringDecoder = __webpack_require__(194).StringDecoder;
	var Buffer = __webpack_require__(34).Buffer;
	
	function Stream(cbs, options) {
	    var parser = (this._parser = new Parser(cbs, options));
	    var decoder = (this._decoder = new StringDecoder());
	
	    WritableStream.call(this, { decodeStrings: false });
	
	    this.once("finish", function() {
	        parser.end(decoder.end());
	    });
	}
	
	__webpack_require__(16)(Stream, WritableStream);
	
	Stream.prototype._write = function(chunk, encoding, cb) {
	    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	    this._parser.write(chunk);
	    cb();
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (newInputs[i] !== lastInputs[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(75);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 52 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertNodeToElement;
	
	var _elementTypes = __webpack_require__(145);
	
	var _elementTypes2 = _interopRequireDefault(_elementTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a htmlparser2 node to a React element
	 *
	 * @param {Object} node The htmlparser2 node to convert
	 * @param {Number} index The index of the current node
	 * @param {Function} transform Transform function to apply to children of the node
	 * @returns {React.Element}
	 */
	function convertNodeToElement(node, index, transform) {
	  return _elementTypes2.default[node.type](node, index, transform);
	}

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;
	
	var _processNodes = __webpack_require__(22);
	
	Object.defineProperty(exports, 'processNodes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_processNodes).default;
	  }
	});
	
	var _convertNodeToElement = __webpack_require__(53);
	
	Object.defineProperty(exports, 'convertNodeToElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_convertNodeToElement).default;
	  }
	});
	
	var _htmlparser = __webpack_require__(6);
	
	Object.defineProperty(exports, 'htmlparser2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_htmlparser).default;
	  }
	});
	
	var _HtmlParser = __webpack_require__(137);
	
	var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HtmlParser2.default;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = generatePropsFromAttributes;
	
	var _htmlAttributesToReact = __webpack_require__(146);
	
	var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);
	
	var _inlineStyleToObject = __webpack_require__(147);
	
	var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates props for a React element from an object of HTML attributes
	 *
	 * @param {Object} attributes The HTML attributes
	 * @param {String} key The key to give the react element
	 */
	function generatePropsFromAttributes(attributes, key) {
	
	  // generate props
	  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });
	
	  // if there is an inline/string style prop then convert it to a React style object
	  // otherwise, it is invalid and omitted
	  if (typeof props.style === 'string' || props.style instanceof String) {
	    props.style = (0, _inlineStyleToObject2.default)(props.style);
	  } else {
	    delete props.style;
	  }
	
	  return props;
	}

/***/ },
/* 56 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidTagOrAttributeName;
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	
	var nameCache = {};
	
	function isValidTagOrAttributeName(tagName) {
	  if (!nameCache.hasOwnProperty(tagName)) {
	    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
	  }
	  return nameCache[tagName];
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(200);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Tracks portals that are open and emits events to subscribers
	
	var PortalOpenInstances = function PortalOpenInstances() {
	  var _this = this;
	
	  _classCallCheck(this, PortalOpenInstances);
	
	  this.register = function (openInstance) {
	    if (_this.openInstances.indexOf(openInstance) !== -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Cannot register modal instance that's already open");
	      }
	      return;
	    }
	    _this.openInstances.push(openInstance);
	    _this.emit("register");
	  };
	
	  this.deregister = function (openInstance) {
	    var index = _this.openInstances.indexOf(openInstance);
	    if (index === -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
	      }
	      return;
	    }
	    _this.openInstances.splice(index, 1);
	    _this.emit("deregister");
	  };
	
	  this.subscribe = function (callback) {
	    _this.subscribers.push(callback);
	  };
	
	  this.emit = function (eventType) {
	    _this.subscribers.forEach(function (subscriber) {
	      return subscriber(eventType,
	      // shallow copy to avoid accidental mutation
	      _this.openInstances.slice());
	    });
	  };
	
	  this.openInstances = [];
	  this.subscribers = [];
	};
	
	var portalOpenInstances = new PortalOpenInstances();
	
	exports.default = portalOpenInstances;
	module.exports = exports["default"];

/***/ },
/* 60 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
	  // if 'overflow: visible' set, check if there is actually any overflow
	  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(2);
	
	var ReactNoopUpdateQueue = __webpack_require__(64);
	
	var canDefineProperty = __webpack_require__(65);
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(10);
	var lowPriorityWarning = __webpack_require__(167);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(21);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var core = __webpack_require__(20);
	var reactDom = __webpack_require__(4);
	var PropTypes = _interopDefault(__webpack_require__(3));
	var utils = __webpack_require__(25);
	var _css = _interopDefault(__webpack_require__(12));
	var AutosizeInput = _interopDefault(__webpack_require__(57));
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	function getMenuPlacement(_ref) {
	  var maxHeight = _ref.maxHeight,
	      menuEl = _ref.menuEl,
	      minHeight = _ref.minHeight,
	      placement = _ref.placement,
	      shouldScroll = _ref.shouldScroll,
	      isFixedPosition = _ref.isFixedPosition,
	      theme = _ref.theme;
	  var spacing = theme.spacing;
	  var scrollParent = utils.getScrollParent(menuEl);
	  var defaultState = {
	    placement: 'bottom',
	    maxHeight: maxHeight
	  }; // something went wrong, return default state
	
	  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
	  // the menu is rendered
	
	  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
	      scrollHeight = _scrollParent$getBoun.height;
	
	  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
	      menuBottom = _menuEl$getBoundingCl.bottom,
	      menuHeight = _menuEl$getBoundingCl.height,
	      menuTop = _menuEl$getBoundingCl.top;
	
	  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
	      containerTop = _menuEl$offsetParent$.top;
	
	  var viewHeight = window.innerHeight;
	  var scrollTop = utils.getScrollTop(scrollParent);
	  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
	  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
	  var viewSpaceAbove = containerTop - marginTop;
	  var viewSpaceBelow = viewHeight - menuTop;
	  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
	  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
	  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
	  var scrollUp = scrollTop + menuTop - marginTop;
	  var scrollDuration = 160;
	
	  switch (placement) {
	    case 'auto':
	    case 'bottom':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceBelow >= menuHeight) {
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          utils.animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        }
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
	        if (shouldScroll) {
	          utils.animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        } // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	
	        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
	        return {
	          placement: 'bottom',
	          maxHeight: constrainedHeight
	        };
	      } // 4. Forked beviour when there isn't enough space below
	      // AUTO: flip the menu, render above
	
	
	      if (placement === 'auto' || isFixedPosition) {
	        // may need to be constrained after flipping
	        var _constrainedHeight = maxHeight;
	        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
	
	        if (spaceAbove >= minHeight) {
	          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight
	        };
	      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
	
	
	      if (placement === 'bottom') {
	        utils.scrollTo(scrollParent, scrollDown);
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      }
	
	      break;
	
	    case 'top':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceAbove >= menuHeight) {
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          utils.animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
	        }
	
	        if (shouldScroll) {
	          utils.animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight2
	        };
	      } // 4. not enough space, the browser WILL NOT increase scrollable area when
	      // absolutely positioned element rendered above the viewport (only below).
	      // Flip the menu, render below
	
	
	      return {
	        placement: 'bottom',
	        maxHeight: maxHeight
	      };
	
	    default:
	      throw new Error("Invalid placement provided \"" + placement + "\".");
	  } // fulfil contract with flow: implicit return value of undefined
	
	
	  return defaultState;
	} // Menu Component
	// ------------------------------
	
	function alignToControl(placement) {
	  var placementToCSSProp = {
	    bottom: 'top',
	    top: 'bottom'
	  };
	  return placement ? placementToCSSProp[placement] : 'bottom';
	}
	
	var coercePlacement = function coercePlacement(p) {
	  return p === 'auto' ? 'bottom' : p;
	};
	
	var menuCSS = function menuCSS(_ref2) {
	  var _ref3;
	
	  var placement = _ref2.placement,
	      _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      spacing = _ref2$theme.spacing,
	      colors = _ref2$theme.colors;
	  return _ref3 = {
	    label: 'menu'
	  }, _ref3[alignToControl(placement)] = '100%', _ref3.backgroundColor = colors.neutral0, _ref3.borderRadius = borderRadius, _ref3.boxShadow = '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)', _ref3.marginBottom = spacing.menuGutter, _ref3.marginTop = spacing.menuGutter, _ref3.position = 'absolute', _ref3.width = '100%', _ref3.zIndex = 1, _ref3;
	}; // NOTE: internal only
	
	var MenuPlacer =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(MenuPlacer, _Component);
	
	  function MenuPlacer() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.state = {
	      maxHeight: _this.props.maxMenuHeight,
	      placement: null
	    };
	
	    _this.getPlacement = function (ref) {
	      var _this$props = _this.props,
	          minMenuHeight = _this$props.minMenuHeight,
	          maxMenuHeight = _this$props.maxMenuHeight,
	          menuPlacement = _this$props.menuPlacement,
	          menuPosition = _this$props.menuPosition,
	          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
	          theme = _this$props.theme;
	      var getPortalPlacement = _this.context.getPortalPlacement;
	      if (!ref) return; // DO NOT scroll if position is fixed
	
	      var isFixedPosition = menuPosition === 'fixed';
	      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
	      var state = getMenuPlacement({
	        maxHeight: maxMenuHeight,
	        menuEl: ref,
	        minHeight: minMenuHeight,
	        placement: menuPlacement,
	        shouldScroll: shouldScroll,
	        isFixedPosition: isFixedPosition,
	        theme: theme
	      });
	      if (getPortalPlacement) getPortalPlacement(state);
	
	      _this.setState(state);
	    };
	
	    _this.getUpdatedProps = function () {
	      var menuPlacement = _this.props.menuPlacement;
	      var placement = _this.state.placement || coercePlacement(menuPlacement);
	      return _extends({}, _this.props, {
	        placement: placement,
	        maxHeight: _this.state.maxHeight
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = MenuPlacer.prototype;
	
	  _proto.render = function render() {
	    var children = this.props.children;
	    return children({
	      ref: this.getPlacement,
	      placerProps: this.getUpdatedProps()
	    });
	  };
	
	  return MenuPlacer;
	}(React.Component);
	MenuPlacer.contextTypes = {
	  getPortalPlacement: PropTypes.func
	};
	
	var Menu = function Menu(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('menu', props),
	    className: cx({
	      menu: true
	    }, className)
	  }, innerProps, {
	    ref: innerRef
	  }), children);
	};
	// Menu List
	// ==============================
	
	var menuListCSS = function menuListCSS(_ref4) {
	  var maxHeight = _ref4.maxHeight,
	      baseUnit = _ref4.theme.spacing.baseUnit;
	  return {
	    maxHeight: maxHeight,
	    overflowY: 'auto',
	    paddingBottom: baseUnit,
	    paddingTop: baseUnit,
	    position: 'relative',
	    // required for offset[Height, Top] > keyboard scroll
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	var MenuList = function MenuList(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isMulti = props.isMulti,
	      innerRef = props.innerRef;
	  return core.jsx("div", {
	    css: getStyles('menuList', props),
	    className: cx({
	      'menu-list': true,
	      'menu-list--is-multi': isMulti
	    }, className),
	    ref: innerRef
	  }, children);
	}; // ==============================
	// Menu Notices
	// ==============================
	
	var noticeCSS = function noticeCSS(_ref5) {
	  var _ref5$theme = _ref5.theme,
	      baseUnit = _ref5$theme.spacing.baseUnit,
	      colors = _ref5$theme.colors;
	  return {
	    color: colors.neutral40,
	    padding: baseUnit * 2 + "px " + baseUnit * 3 + "px",
	    textAlign: 'center'
	  };
	};
	
	var noOptionsMessageCSS = noticeCSS;
	var loadingMessageCSS = noticeCSS;
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('noOptionsMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--no-options': true
	    }, className)
	  }, innerProps), children);
	};
	NoOptionsMessage.defaultProps = {
	  children: 'No options'
	};
	var LoadingMessage = function LoadingMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('loadingMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--loading': true
	    }, className)
	  }, innerProps), children);
	};
	LoadingMessage.defaultProps = {
	  children: 'Loading...'
	}; // ==============================
	// Menu Portal
	// ==============================
	
	var menuPortalCSS = function menuPortalCSS(_ref6) {
	  var rect = _ref6.rect,
	      offset = _ref6.offset,
	      position = _ref6.position;
	  return {
	    left: rect.left,
	    position: position,
	    top: offset,
	    width: rect.width,
	    zIndex: 1
	  };
	};
	var MenuPortal =
	/*#__PURE__*/
	function (_Component2) {
	  _inheritsLoose(MenuPortal, _Component2);
	
	  function MenuPortal() {
	    var _this2;
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _Component2.call.apply(_Component2, [this].concat(args)) || this;
	    _this2.state = {
	      placement: null
	    };
	
	    _this2.getPortalPlacement = function (_ref7) {
	      var placement = _ref7.placement;
	      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
	
	      if (placement !== initialPlacement) {
	        _this2.setState({
	          placement: placement
	        });
	      }
	    };
	
	    return _this2;
	  }
	
	  var _proto2 = MenuPortal.prototype;
	
	  _proto2.getChildContext = function getChildContext() {
	    return {
	      getPortalPlacement: this.getPortalPlacement
	    };
	  } // callback for occassions where the menu must "flip"
	  ;
	
	  _proto2.render = function render() {
	    var _this$props2 = this.props,
	        appendTo = _this$props2.appendTo,
	        children = _this$props2.children,
	        controlElement = _this$props2.controlElement,
	        menuPlacement = _this$props2.menuPlacement,
	        position = _this$props2.menuPosition,
	        getStyles = _this$props2.getStyles;
	    var isFixed = position === 'fixed'; // bail early if required elements aren't present
	
	    if (!appendTo && !isFixed || !controlElement) {
	      return null;
	    }
	
	    var placement = this.state.placement || coercePlacement(menuPlacement);
	    var rect = utils.getBoundingClientObj(controlElement);
	    var scrollDistance = isFixed ? 0 : window.pageYOffset;
	    var offset = rect[placement] + scrollDistance;
	    var state = {
	      offset: offset,
	      position: position,
	      rect: rect
	    }; // same wrapper element whether fixed or portalled
	
	    var menuWrapper = core.jsx("div", {
	      css: getStyles('menuPortal', state)
	    }, children);
	    return appendTo ? reactDom.createPortal(menuWrapper, appendTo) : menuWrapper;
	  };
	
	  return MenuPortal;
	}(React.Component);
	MenuPortal.childContextTypes = {
	  getPortalPlacement: PropTypes.func
	};
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a),
	        arrB = isArray(b),
	        i,
	        length,
	        key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	
	      for (i = length; i-- !== 0;) {
	        if (!equal(a[i], b[i])) return false;
	      }
	
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	    var dateA = a instanceof Date,
	        dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	    var regexpA = a instanceof RegExp,
	        regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length) {
	      return false;
	    }
	
	    for (i = length; i-- !== 0;) {
	      if (!hasProp.call(b, keys[i])) return false;
	    } // end fast-deep-equal
	    // Custom handling for React
	
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    } // fast-deep-equal index.js 2.0.1
	
	
	    return true;
	  }
	
	  return a !== a && b !== b;
	} // end fast-deep-equal
	
	
	function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (error.message && error.message.match(/stack|recursion/i)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    } // some other error. we should definitely know about these
	
	
	    throw error;
	  }
	}
	
	function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
	var containerCSS = function containerCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isRtl = _ref.isRtl;
	  return {
	    label: 'container',
	    direction: isRtl ? 'rtl' : null,
	    pointerEvents: isDisabled ? 'none' : null,
	    // cancel mouse events when disabled
	    position: 'relative'
	  };
	};
	var SelectContainer = function SelectContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends$1({
	    css: getStyles('container', props),
	    className: cx({
	      '--is-disabled': isDisabled,
	      '--is-rtl': isRtl
	    }, className)
	  }, innerProps), children);
	}; // ==============================
	// Value Container
	// ==============================
	
	var valueContainerCSS = function valueContainerCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    alignItems: 'center',
	    display: 'flex',
	    flex: 1,
	    flexWrap: 'wrap',
	    padding: spacing.baseUnit / 2 + "px " + spacing.baseUnit * 2 + "px",
	    WebkitOverflowScrolling: 'touch',
	    position: 'relative',
	    overflow: 'hidden'
	  };
	};
	var ValueContainer = function ValueContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      isMulti = props.isMulti,
	      getStyles = props.getStyles,
	      hasValue = props.hasValue;
	  return core.jsx("div", {
	    css: getStyles('valueContainer', props),
	    className: cx({
	      'value-container': true,
	      'value-container--is-multi': isMulti,
	      'value-container--has-value': hasValue
	    }, className)
	  }, children);
	}; // ==============================
	// Indicator Container
	// ==============================
	
	var indicatorsContainerCSS = function indicatorsContainerCSS() {
	  return {
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    display: 'flex',
	    flexShrink: 0
	  };
	};
	var IndicatorsContainer = function IndicatorsContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles;
	  return core.jsx("div", {
	    css: getStyles('indicatorsContainer', props),
	    className: cx({
	      indicators: true
	    }, className)
	  }, children);
	};
	
	function _templateObject() {
	  var data = _taggedTemplateLiteralLoose(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
	
	function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var _ref2 =  true ? {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
	} : {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
	};
	
	// ==============================
	// Dropdown & Clear Icons
	// ==============================
	var Svg = function Svg(_ref) {
	  var size = _ref.size,
	      props = _objectWithoutPropertiesLoose(_ref, ["size"]);
	
	  return core.jsx("svg", _extends$2({
	    height: size,
	    width: size,
	    viewBox: "0 0 20 20",
	    "aria-hidden": "true",
	    focusable: "false",
	    css: _ref2
	  }, props));
	};
	
	var CrossIcon = function CrossIcon(props) {
	  return core.jsx(Svg, _extends$2({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
	  }));
	};
	var DownChevron = function DownChevron(props) {
	  return core.jsx(Svg, _extends$2({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
	  }));
	}; // ==============================
	// Dropdown & Clear Buttons
	// ==============================
	
	var baseCSS = function baseCSS(_ref3) {
	  var isFocused = _ref3.isFocused,
	      _ref3$theme = _ref3.theme,
	      baseUnit = _ref3$theme.spacing.baseUnit,
	      colors = _ref3$theme.colors;
	  return {
	    label: 'indicatorContainer',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    ':hover': {
	      color: isFocused ? colors.neutral80 : colors.neutral40
	    }
	  };
	};
	
	var dropdownIndicatorCSS = baseCSS;
	var DropdownIndicator = function DropdownIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends$2({}, innerProps, {
	    css: getStyles('dropdownIndicator', props),
	    className: cx({
	      indicator: true,
	      'dropdown-indicator': true
	    }, className)
	  }), children || core.jsx(DownChevron, null));
	};
	var clearIndicatorCSS = baseCSS;
	var ClearIndicator = function ClearIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends$2({}, innerProps, {
	    css: getStyles('clearIndicator', props),
	    className: cx({
	      indicator: true,
	      'clear-indicator': true
	    }, className)
	  }), children || core.jsx(CrossIcon, null));
	}; // ==============================
	// Separator
	// ==============================
	
	var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
	  var isDisabled = _ref4.isDisabled,
	      _ref4$theme = _ref4.theme,
	      baseUnit = _ref4$theme.spacing.baseUnit,
	      colors = _ref4$theme.colors;
	  return {
	    label: 'indicatorSeparator',
	    alignSelf: 'stretch',
	    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
	    marginBottom: baseUnit * 2,
	    marginTop: baseUnit * 2,
	    width: 1
	  };
	};
	var IndicatorSeparator = function IndicatorSeparator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("span", _extends$2({}, innerProps, {
	    css: getStyles('indicatorSeparator', props),
	    className: cx({
	      'indicator-separator': true
	    }, className)
	  }));
	}; // ==============================
	// Loading
	// ==============================
	
	var loadingDotAnimations = core.keyframes(_templateObject());
	var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
	  var isFocused = _ref5.isFocused,
	      size = _ref5.size,
	      _ref5$theme = _ref5.theme,
	      colors = _ref5$theme.colors,
	      baseUnit = _ref5$theme.spacing.baseUnit;
	  return {
	    label: 'loadingIndicator',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    alignSelf: 'center',
	    fontSize: size,
	    lineHeight: 1,
	    marginRight: size,
	    textAlign: 'center',
	    verticalAlign: 'middle'
	  };
	};
	
	var LoadingDot = function LoadingDot(_ref6) {
	  var delay = _ref6.delay,
	      offset = _ref6.offset;
	  return core.jsx("span", {
	    css:
	    /*#__PURE__*/
	    _css({
	      animation: loadingDotAnimations + " 1s ease-in-out " + delay + "ms infinite;",
	      backgroundColor: 'currentColor',
	      borderRadius: '1em',
	      display: 'inline-block',
	      marginLeft: offset ? '1em' : null,
	      height: '1em',
	      verticalAlign: 'top',
	      width: '1em'
	    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  });
	};
	
	var LoadingIndicator = function LoadingIndicator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends$2({}, innerProps, {
	    css: getStyles('loadingIndicator', props),
	    className: cx({
	      indicator: true,
	      'loading-indicator': true
	    }, className)
	  }), core.jsx(LoadingDot, {
	    delay: 0,
	    offset: isRtl
	  }), core.jsx(LoadingDot, {
	    delay: 160,
	    offset: true
	  }), core.jsx(LoadingDot, {
	    delay: 320,
	    offset: !isRtl
	  }));
	};
	LoadingIndicator.defaultProps = {
	  size: 4
	};
	
	function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      _ref$theme = _ref.theme,
	      colors = _ref$theme.colors,
	      borderRadius = _ref$theme.borderRadius,
	      spacing = _ref$theme.spacing;
	  return {
	    label: 'control',
	    alignItems: 'center',
	    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
	    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
	    borderRadius: borderRadius,
	    borderStyle: 'solid',
	    borderWidth: 1,
	    boxShadow: isFocused ? "0 0 0 1px " + colors.primary : null,
	    cursor: 'default',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    minHeight: spacing.controlHeight,
	    outline: '0 !important',
	    position: 'relative',
	    transition: 'all 100ms',
	    '&:hover': {
	      borderColor: isFocused ? colors.primary : colors.neutral30
	    }
	  };
	};
	
	var Control = function Control(props) {
	  var children = props.children,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      className = props.className,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps,
	      menuIsOpen = props.menuIsOpen;
	  return core.jsx("div", _extends$3({
	    ref: innerRef,
	    css: getStyles('control', props),
	    className: cx({
	      control: true,
	      'control--is-disabled': isDisabled,
	      'control--is-focused': isFocused,
	      'control--menu-is-open': menuIsOpen
	    }, className)
	  }, innerProps), children);
	};
	
	function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
	var groupCSS = function groupCSS(_ref) {
	  var spacing = _ref.theme.spacing;
	  return {
	    paddingBottom: spacing.baseUnit * 2,
	    paddingTop: spacing.baseUnit * 2
	  };
	};
	
	var Group = function Group(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      Heading = props.Heading,
	      headingProps = props.headingProps,
	      label = props.label,
	      theme = props.theme,
	      selectProps = props.selectProps;
	  return core.jsx("div", {
	    css: getStyles('group', props),
	    className: cx({
	      group: true
	    }, className)
	  }, core.jsx(Heading, _extends$4({}, headingProps, {
	    selectProps: selectProps,
	    theme: theme,
	    getStyles: getStyles,
	    cx: cx
	  }), label), core.jsx("div", null, children));
	};
	
	var groupHeadingCSS = function groupHeadingCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    label: 'group',
	    color: '#999',
	    cursor: 'default',
	    display: 'block',
	    fontSize: '75%',
	    fontWeight: '500',
	    marginBottom: '0.25em',
	    paddingLeft: spacing.baseUnit * 3,
	    paddingRight: spacing.baseUnit * 3,
	    textTransform: 'uppercase'
	  };
	};
	var GroupHeading = function GroupHeading(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      theme = props.theme,
	      selectProps = props.selectProps,
	      cleanProps = _objectWithoutPropertiesLoose$1(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
	
	  return core.jsx("div", _extends$4({
	    css: getStyles('groupHeading', _extends$4({
	      theme: theme
	    }, cleanProps)),
	    className: cx({
	      'group-heading': true
	    }, className)
	  }, cleanProps));
	};
	
	function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	var inputCSS = function inputCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    margin: spacing.baseUnit / 2,
	    paddingBottom: spacing.baseUnit / 2,
	    paddingTop: spacing.baseUnit / 2,
	    visibility: isDisabled ? 'hidden' : 'visible',
	    color: colors.neutral80
	  };
	};
	
	var inputStyle = function inputStyle(isHidden) {
	  return {
	    label: 'input',
	    background: 0,
	    border: 0,
	    fontSize: 'inherit',
	    opacity: isHidden ? 0 : 1,
	    outline: 0,
	    padding: 0,
	    color: 'inherit'
	  };
	};
	
	var Input = function Input(_ref2) {
	  var className = _ref2.className,
	      cx = _ref2.cx,
	      getStyles = _ref2.getStyles,
	      innerRef = _ref2.innerRef,
	      isHidden = _ref2.isHidden,
	      isDisabled = _ref2.isDisabled,
	      theme = _ref2.theme,
	      selectProps = _ref2.selectProps,
	      props = _objectWithoutPropertiesLoose$2(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
	
	  return core.jsx("div", {
	    css: getStyles('input', _extends$5({
	      theme: theme
	    }, props))
	  }, core.jsx(AutosizeInput, _extends$5({
	    className: cx({
	      input: true
	    }, className),
	    inputRef: innerRef,
	    inputStyle: inputStyle(isHidden),
	    disabled: isDisabled
	  }, props)));
	};
	
	function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
	var multiValueCSS = function multiValueCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      borderRadius = _ref$theme.borderRadius,
	      colors = _ref$theme.colors;
	  return {
	    label: 'multiValue',
	    backgroundColor: colors.neutral10,
	    borderRadius: borderRadius / 2,
	    display: 'flex',
	    margin: spacing.baseUnit / 2,
	    minWidth: 0 // resolves flex/text-overflow bug
	
	  };
	};
	var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
	  var _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      colors = _ref2$theme.colors,
	      cropWithEllipsis = _ref2.cropWithEllipsis;
	  return {
	    borderRadius: borderRadius / 2,
	    color: colors.neutral80,
	    fontSize: '85%',
	    overflow: 'hidden',
	    padding: 3,
	    paddingLeft: 6,
	    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
	    whiteSpace: 'nowrap'
	  };
	};
	var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
	  var _ref3$theme = _ref3.theme,
	      spacing = _ref3$theme.spacing,
	      borderRadius = _ref3$theme.borderRadius,
	      colors = _ref3$theme.colors,
	      isFocused = _ref3.isFocused;
	  return {
	    alignItems: 'center',
	    borderRadius: borderRadius / 2,
	    backgroundColor: isFocused && colors.dangerLight,
	    display: 'flex',
	    paddingLeft: spacing.baseUnit,
	    paddingRight: spacing.baseUnit,
	    ':hover': {
	      backgroundColor: colors.dangerLight,
	      color: colors.danger
	    }
	  };
	};
	var MultiValueGeneric = function MultiValueGeneric(_ref4) {
	  var children = _ref4.children,
	      innerProps = _ref4.innerProps;
	  return core.jsx("div", innerProps, children);
	};
	var MultiValueContainer = MultiValueGeneric;
	var MultiValueLabel = MultiValueGeneric;
	function MultiValueRemove(_ref5) {
	  var children = _ref5.children,
	      innerProps = _ref5.innerProps;
	  return core.jsx("div", innerProps, children || core.jsx(CrossIcon, {
	    size: 14
	  }));
	}
	
	var MultiValue = function MultiValue(props) {
	  var children = props.children,
	      className = props.className,
	      components = props.components,
	      cx = props.cx,
	      data = props.data,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      removeProps = props.removeProps,
	      selectProps = props.selectProps;
	  var Container = components.Container,
	      Label = components.Label,
	      Remove = components.Remove;
	  return core.jsx(core.ClassNames, null, function (_ref6) {
	    var css = _ref6.css,
	        emotionCx = _ref6.cx;
	    return core.jsx(Container, {
	      data: data,
	      innerProps: _extends$6({}, innerProps, {
	        className: emotionCx(css(getStyles('multiValue', props)), cx({
	          'multi-value': true,
	          'multi-value--is-disabled': isDisabled
	        }, className))
	      }),
	      selectProps: selectProps
	    }, core.jsx(Label, {
	      data: data,
	      innerProps: {
	        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
	          'multi-value__label': true
	        }, className))
	      },
	      selectProps: selectProps
	    }, children), core.jsx(Remove, {
	      data: data,
	      innerProps: _extends$6({
	        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
	          'multi-value__remove': true
	        }, className))
	      }, removeProps),
	      selectProps: selectProps
	    }));
	  });
	};
	
	MultiValue.defaultProps = {
	  cropWithEllipsis: true
	};
	
	function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
	var optionCSS = function optionCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      isSelected = _ref.isSelected,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'option',
	    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
	    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
	    cursor: 'default',
	    display: 'block',
	    fontSize: 'inherit',
	    padding: spacing.baseUnit * 2 + "px " + spacing.baseUnit * 3 + "px",
	    width: '100%',
	    userSelect: 'none',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    // provide some affordance on touch devices
	    ':active': {
	      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
	    }
	  };
	};
	
	var Option = function Option(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      isSelected = props.isSelected,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends$7({
	    css: getStyles('option', props),
	    className: cx({
	      option: true,
	      'option--is-disabled': isDisabled,
	      'option--is-focused': isFocused,
	      'option--is-selected': isSelected
	    }, className),
	    ref: innerRef
	  }, innerProps), children);
	};
	
	function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
	var placeholderCSS = function placeholderCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'placeholder',
	    color: colors.neutral50,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    position: 'absolute',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var Placeholder = function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends$8({
	    css: getStyles('placeholder', props),
	    className: cx({
	      placeholder: true
	    }, className)
	  }, innerProps), children);
	};
	
	function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
	var css$1 = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'singleValue',
	    color: isDisabled ? colors.neutral40 : colors.neutral80,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    maxWidth: "calc(100% - " + spacing.baseUnit * 2 + "px)",
	    overflow: 'hidden',
	    position: 'absolute',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var SingleValue = function SingleValue(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends$9({
	    css: getStyles('singleValue', props),
	    className: cx({
	      'single-value': true,
	      'single-value--is-disabled': isDisabled
	    }, className)
	  }, innerProps), children);
	};
	
	function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
	var components = {
	  ClearIndicator: ClearIndicator,
	  Control: Control,
	  DropdownIndicator: DropdownIndicator,
	  DownChevron: DownChevron,
	  CrossIcon: CrossIcon,
	  Group: Group,
	  GroupHeading: GroupHeading,
	  IndicatorsContainer: IndicatorsContainer,
	  IndicatorSeparator: IndicatorSeparator,
	  Input: Input,
	  LoadingIndicator: LoadingIndicator,
	  Menu: Menu,
	  MenuList: MenuList,
	  MenuPortal: MenuPortal,
	  LoadingMessage: LoadingMessage,
	  NoOptionsMessage: NoOptionsMessage,
	  MultiValue: MultiValue,
	  MultiValueContainer: MultiValueContainer,
	  MultiValueLabel: MultiValueLabel,
	  MultiValueRemove: MultiValueRemove,
	  Option: Option,
	  Placeholder: Placeholder,
	  SelectContainer: SelectContainer,
	  SingleValue: SingleValue,
	  ValueContainer: ValueContainer
	};
	var defaultComponents = function defaultComponents(props) {
	  return _extends$a({}, components, props.components);
	};
	
	exports.MenuPlacer = MenuPlacer;
	exports.clearIndicatorCSS = clearIndicatorCSS;
	exports.components = components;
	exports.containerCSS = containerCSS;
	exports.css = css;
	exports.css$1 = css$1;
	exports.defaultComponents = defaultComponents;
	exports.dropdownIndicatorCSS = dropdownIndicatorCSS;
	exports.exportedEqual = exportedEqual;
	exports.groupCSS = groupCSS;
	exports.groupHeadingCSS = groupHeadingCSS;
	exports.indicatorSeparatorCSS = indicatorSeparatorCSS;
	exports.indicatorsContainerCSS = indicatorsContainerCSS;
	exports.inputCSS = inputCSS;
	exports.loadingIndicatorCSS = loadingIndicatorCSS;
	exports.loadingMessageCSS = loadingMessageCSS;
	exports.menuCSS = menuCSS;
	exports.menuListCSS = menuListCSS;
	exports.menuPortalCSS = menuPortalCSS;
	exports.multiValueCSS = multiValueCSS;
	exports.multiValueLabelCSS = multiValueLabelCSS;
	exports.multiValueRemoveCSS = multiValueRemoveCSS;
	exports.noOptionsMessageCSS = noOptionsMessageCSS;
	exports.optionCSS = optionCSS;
	exports.placeholderCSS = placeholderCSS;
	exports.valueContainerCSS = valueContainerCSS;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(184));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ },
/* 68 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// Inspired by https://github.com/garycourt/murmurhash-js
	// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
	function murmur2(str) {
	  // 'm' and 'r' are mixing constants generated offline.
	  // They're not really 'magic', they just happen to work well.
	  // const m = 0x5bd1e995;
	  // const r = 24;
	  // Initialize the hash
	  var h = 0; // Mix 4 bytes at a time into the hash
	
	  var k,
	      i = 0,
	      len = str.length;
	
	  for (; len >= 4; ++i, len -= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
	    k ^=
	    /* k >>> r: */
	    k >>> 24;
	    h =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
	    /* Math.imul(h, m): */
	    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Handle the last few bytes of the input array
	
	
	  switch (len) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h =
	      /* Math.imul(h, m): */
	      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Do a few final mixes of the hash to ensure the last few
	  // bytes are well-incorporated.
	
	
	  h ^= h >>> 13;
	  h =
	  /* Math.imul(h, m): */
	  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  return ((h ^ h >>> 15) >>> 0).toString(36);
	}
	
	exports.default = murmur2;


/***/ },
/* 70 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ },
/* 75 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shopifyBuy = __webpack_require__(8);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	__webpack_require__(41);
	
	var _ProductList = __webpack_require__(77);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _ProductDetailPage = __webpack_require__(81);
	
	var _ProductDetailPage2 = _interopRequireDefault(_ProductDetailPage);
	
	var _Navbar = __webpack_require__(80);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _reactRouterDom = __webpack_require__(11);
	
	var _productsContext = __webpack_require__(5);
	
	var _CartDetails = __webpack_require__(78);
	
	var _CartDetails2 = _interopRequireDefault(_CartDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_shopifyBuy2.default.buildClient({
	  domain: 'conecuh-brands.myshopify.com',
	  storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
	});
	
	var App = function App() {
	  return _react2.default.createElement(
	    _productsContext.ProductProvider,
	    null,
	    _react2.default.createElement(
	      _reactRouterDom.BrowserRouter,
	      null,
	      _react2.default.createElement(_Navbar2.default, null),
	      _react2.default.createElement(_CartDetails2.default, null),
	      _react2.default.createElement(
	        _reactRouterDom.Switch,
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/merch', component: _ProductList2.default }),
	        _react2.default.createElement(_reactRouterDom.Route, { path: '/ProductDetail/:category', component: _ProductDetailPage2.default })
	      )
	    )
	  );
	};
	
	exports.default = App;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Products = __webpack_require__(83);
	
	var _Products2 = _interopRequireDefault(_Products);
	
	var _productsContext = __webpack_require__(5);
	
	var _shopifyBuy = __webpack_require__(8);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductList = function ProductList() {
	  // eslint-disable-next-line
	  var products = (0, _react.useContext)(_productsContext.ProductsContext);
	  // eslint-disable-next-line
	
	  var _useContext = (0, _react.useContext)(_productsContext.CheckoutsContext),
	      _useContext2 = _slicedToArray(_useContext, 2),
	      checkout = _useContext2[0],
	      setCheckout = _useContext2[1];
	  // eslint-disable-next-line 
	
	
	  var _useContext3 = (0, _react.useContext)(_productsContext.CartContext),
	      _useContext4 = _slicedToArray(_useContext3, 2),
	      showCart = _useContext4[0],
	      setShowCart = _useContext4[1];
	
	  var client = _shopifyBuy2.default.buildClient({
	    domain: 'conecuh-brands.myshopify.com',
	    storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'App' },
	    _react2.default.createElement(
	      'button',
	      { className: 'cart-button mobile-view', style: checkout.lineItems.length > 0 && !showCart ? {} : { display: "none" },
	        onClick: function onClick() {
	          return setShowCart(true);
	        } },
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: "27px", color: "white" } },
	        checkout.lineItems.length
	      ),
	      _react2.default.createElement('img', { style: { height: "39px", marginLeft: "12px" }, src: __webpack_require__(196), alt: 'Icon not avilable' })
	    ),
	    _react2.default.createElement(_Products2.default, {
	      shirts: products.shirts,
	      hats: products.hats,
	      accessarries: products.accessarries,
	      client: client
	    })
	  );
	};
	exports.default = ProductList;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LineItem = __webpack_require__(79);
	
	var _LineItem2 = _interopRequireDefault(_LineItem);
	
	var _shopifyBuy = __webpack_require__(8);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	var _productsContext = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var client = _shopifyBuy2.default.buildClient({
	  domain: 'conecuh-brands.myshopify.com',
	  storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
	});
	
	var CartDetails = function CartDetails(props) {
	  var _useContext = (0, _react.useContext)(_productsContext.CartContext),
	      _useContext2 = _slicedToArray(_useContext, 2),
	      showCart = _useContext2[0],
	      setShowCart = _useContext2[1];
	
	  var _useContext3 = (0, _react.useContext)(_productsContext.CheckoutsContext),
	      _useContext4 = _slicedToArray(_useContext3, 2),
	      checkout = _useContext4[0],
	      setCheckout = _useContext4[1];
	
	  var openCheckout = function openCheckout() {
	    window.open(checkout.webUrl);
	  };
	
	  var updateQuantityInCart = function updateQuantityInCart(lineItemId, quantity) {
	    var checkoutId = checkout.id;
	    var lineItemsToUpdate = [{ id: lineItemId, quantity: parseInt(quantity, 10) }];
	    client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(function (res) {
	      setCheckout(res);
	    });
	  };
	
	  var removeLineItemInCart = function removeLineItemInCart(lineItemId) {
	    var checkoutId = checkout.id;
	    client.checkout.removeLineItems(checkoutId, [lineItemId]).then(function (res) {
	      setCheckout(res);
	    });
	  };
	
	  var handleCloseCart = function handleCloseCart() {
	    setShowCart(false);
	  };
	
	  var line_items = checkout.lineItems.map(function (line_item) {
	    return _react2.default.createElement(_LineItem2.default, {
	      updateQuantityInCart: updateQuantityInCart,
	      removeLineItemInCart: removeLineItemInCart,
	      key: line_item.id.toString(),
	      line_item: line_item
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: showCart ? "Cart Cart--open" : "Cart Cart__close display-none" },
	    _react2.default.createElement(
	      'header',
	      { className: 'Cart__header' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Your cart'
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          onClick: handleCloseCart,
	          className: 'Cart__close' },
	        '\xD7'
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'Cart__line-items' },
	      line_items
	    ),
	    _react2.default.createElement(
	      'footer',
	      { className: 'Cart__footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Cart-info clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Cart-info__total Cart-info__small' },
	          'Subtotal'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Cart-info__pricing' },
	          _react2.default.createElement(
	            'span',
	            { className: 'pricing' },
	            '$ ',
	            checkout.subtotalPrice.amount
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Cart-info clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Cart-info__total Cart-info__small' },
	          'Taxes'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Cart-info__pricing' },
	          _react2.default.createElement(
	            'span',
	            { className: 'pricing' },
	            '$ ',
	            checkout.totalTax.amount
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Cart-info clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Cart-info__total Cart-info__small' },
	          'Total'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Cart-info__pricing' },
	          _react2.default.createElement(
	            'span',
	            { className: 'pricing' },
	            '$ ',
	            checkout.totalPrice.amount
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'Cart__checkout button', onClick: openCheckout },
	        'Checkout'
	      )
	    )
	  );
	};
	
	exports.default = CartDetails;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineItem = function (_Component) {
	  _inherits(LineItem, _Component);
	
	  function LineItem(props) {
	    _classCallCheck(this, LineItem);
	
	    var _this = _possibleConstructorReturn(this, (LineItem.__proto__ || Object.getPrototypeOf(LineItem)).call(this, props));
	
	    _this.decrementQuantity = _this.decrementQuantity.bind(_this);
	    _this.incrementQuantity = _this.incrementQuantity.bind(_this);
	    return _this;
	  }
	
	  _createClass(LineItem, [{
	    key: "decrementQuantity",
	    value: function decrementQuantity(lineItemId) {
	      var updatedQuantity = this.props.line_item.quantity - 1;
	      this.props.updateQuantityInCart(lineItemId, updatedQuantity);
	    }
	  }, {
	    key: "incrementQuantity",
	    value: function incrementQuantity(lineItemId) {
	      var updatedQuantity = this.props.line_item.quantity + 1;
	      this.props.updateQuantityInCart(lineItemId, updatedQuantity);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "li",
	        { className: "Line-item" },
	        _react2.default.createElement(
	          "div",
	          { className: "Line-item__img" },
	          this.props.line_item.variant.image ? _react2.default.createElement("img", { src: this.props.line_item.variant.image.src, alt: this.props.line_item.title + " product shot" }) : null
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "Line-item__content" },
	          _react2.default.createElement(
	            "div",
	            { className: "Line-item__content-row" },
	            _react2.default.createElement(
	              "div",
	              { className: "Line-item__variant-title" },
	              this.props.line_item.variant.title
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "Line-item__title" },
	              this.props.line_item.title
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "Line-item__content-row" },
	            _react2.default.createElement(
	              "div",
	              { className: "Line-item__quantity-container" },
	              _react2.default.createElement(
	                "button",
	                { className: "Line-item__quantity-update", onClick: function onClick() {
	                    return _this2.decrementQuantity(_this2.props.line_item.id);
	                  } },
	                "-"
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "Line-item__quantity" },
	                this.props.line_item.quantity
	              ),
	              _react2.default.createElement(
	                "button",
	                { className: "Line-item__quantity-update", onClick: function onClick() {
	                    return _this2.incrementQuantity(_this2.props.line_item.id);
	                  } },
	                "+"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "Line-item__price" },
	              "$ ",
	              (this.props.line_item.quantity * this.props.line_item.variant.price.amount).toFixed(2)
	            ),
	            _react2.default.createElement(
	              "button",
	              { className: "Line-item__remove", onClick: function onClick() {
	                  return _this2.props.removeLineItemInCart(_this2.props.line_item.id);
	                } },
	              "\xD7"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LineItem;
	}(_react.Component);
	
	exports.default = LineItem;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	var _reactRouterDom = __webpack_require__(11);
	
	var _productsContext = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import CartImage from './images/cart'
	
	var Navbar = function Navbar() {
	  var _useContext = (0, _react.useContext)(_productsContext.CartContext),
	      _useContext2 = _slicedToArray(_useContext, 2),
	      showCart = _useContext2[0],
	      setShowCart = _useContext2[1];
	
	  var handleCartOpen = function handleCartOpen() {
	    setShowCart(true);
	  };
	
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar navbar-expand-md fixed-bottom  p-3 mb-5 rounded' },
	    _react2.default.createElement(
	      'div',
	      { className: 'navbar-header' },
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { className: 'navbar-brand', to: '/merch' },
	        _react2.default.createElement('img', { alt: '', src: 'https://www.prosperotequila.com/wp-content/uploads/2019/03/horse-header-3.png', style: { maxWidth: 150 } })
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'navbar-toggler toggle-button', type: 'button', 'data-toggle': 'collapse',
	          'data-target': '#navbarSupportedContent', 'aria-controls': 'navbarSupportedContent' },
	        _react2.default.createElement('span', { className: 'navbar-toggler-icon' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'collapse navbar-collapse', id: 'navbarSupportedContent' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'navbar-nav mr-auto' },
	        _react2.default.createElement(
	          'li',
	          { className: 'nav-item active ' },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/merch', className: 'nav-link pt-4 my-2 my-lg-0' },
	            'Home ',
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              '(current)'
	            )
	          )
	        ),
	        !showCart && _react2.default.createElement(
	          'li',
	          { className: 'nav-item', onClick: handleCartOpen },
	          _react2.default.createElement(
	            'div',
	            { className: 'nav-link my-2 my-lg-0' },
	            _react2.default.createElement(
	              'p',
	              { className: 'nav-item cart-image' },
	              _react2.default.createElement('img', { src: __webpack_require__(197), className: 'cart-icon', alt: 'Icon not avilable' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Navbar;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _productsContext = __webpack_require__(5);
	
	var _VariantSelector = __webpack_require__(33);
	
	var _VariantSelector2 = _interopRequireDefault(_VariantSelector);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	var _reactRouterDom = __webpack_require__(11);
	
	var _Product = __webpack_require__(32);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Cart = __webpack_require__(31);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _shopifyBuy = __webpack_require__(8);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	var _reactHtmlParser = __webpack_require__(54);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _reactOwlCarousel = __webpack_require__(171);
	
	var _reactOwlCarousel2 = _interopRequireDefault(_reactOwlCarousel);
	
	__webpack_require__(105);
	
	__webpack_require__(106);
	
	var _reactSlick = __webpack_require__(67);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var client = _shopifyBuy2.default.buildClient({
	  domain: "conecuh-brands.myshopify.com",
	  storefrontAccessToken: "fd73aae121a8110089143a1d450c7b6e"
	});
	var options = {
	  items: 4,
	  loop: true,
	  margin: 10,
	  nav: false,
	  autoplay: true,
	  autoplayHoverPause: true,
	  autoplayTimeout: 3000,
	  responsive: {
	    0: {
	      items: 1
	    },
	    600: {
	      items: 3
	    },
	    1000: {
	      items: 4
	    },
	    1500: {
	      items: 4
	    }
	  }
	};
	
	var ProductDetailPage1 = function ProductDetailPage1(props) {
	
	  // console.log(props);
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      products = _useState2[0],
	      setProducts = _useState2[1];
	
	  var data = (0, _react.useContext)(_productsContext.ProductsContext);
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      product = _useState4[0],
	      setProduct = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      showProduct = _useState6[0],
	      setShowProduct = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      currentProductIndex = _useState8[0],
	      setCurrentProductIndex = _useState8[1];
	  // eslint-disable-next-line
	
	
	  var _useState9 = (0, _react.useState)(),
	      _useState10 = _slicedToArray(_useState9, 2),
	      selectedVariantImage = _useState10[0],
	      setSelectedVariantImage = _useState10[1];
	
	  var changeProduct = function changeProduct(product_id) {
	    var elementIndex = -1;
	    var temp = null;
	    if (props.match.params.category.toString() === "clyde-mays-shirts") {
	      temp = data.shirts;
	      setProducts(data.shirts);
	    }
	    if (props.match.params.category.toString() === "clyde-mays-hats") {
	      temp = data.hats;
	      setProducts(data.hats);
	    }
	    if (props.match.params.category.toString() === "clyde-mays-accessarries") {
	      temp = data.accessarries;
	      setProducts(data.accessarries);
	    }
	
	    temp.map(function (product) {
	      elementIndex += 1;
	      if (product.id === product_id) {
	        setCurrentProductIndex(elementIndex);
	        setProduct(product);
	        setShowProduct(true);
	      }
	      return null;
	    });
	  };
	
	  var getParamsValue = function getParamsValue(attribute) {
	
	    var urlSearch = window.location.search.replace("?", "");
	    if (urlSearch.indexOf(attribute) === -1) {
	      return null;
	    }
	    var splitArray = urlSearch.split(attribute + "=");
	
	    var value = null;
	    if (splitArray[1]) {
	      value = splitArray[1].split('&')[0];
	    }
	    return value;
	  };
	
	  (0, _react.useEffect)(function () {
	    changeProduct(getParamsValue('id'));
	  }, []);
	
	  var nextProduct = function nextProduct() {
	    setShowProduct(false);
	    setCurrentProductIndex(currentProductIndex + 1);
	    setProduct(products[currentProductIndex + 1]);
	    setShowProduct(true);
	  };
	
	  var prevProduct = function prevProduct() {
	    setShowProduct(false);
	    setCurrentProductIndex(currentProductIndex - 1);
	    setProduct(products[currentProductIndex - 1]);
	    setShowProduct(true);
	  };
	
	  if (showProduct) {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(ProductDetailPage, {
	          totalProducts: products.length,
	          client: client,
	          nextProduct: nextProduct,
	          prevProduct: prevProduct,
	          currentProductIndex: currentProductIndex,
	          product: product,
	          selectedVariantImage: selectedVariantImage
	        })
	      ),
	      _react2.default.createElement(SliderClass, {
	        category: props.match.params.category.toString(),
	        client: client,
	        products: products,
	        changeProduct: changeProduct
	      })
	    );
	  } else {
	    return _react2.default.createElement(
	      "div",
	      null,
	      "LOADING........."
	    );
	  }
	};
	
	var SliderClass = function (_Component) {
	  _inherits(SliderClass, _Component);
	
	  function SliderClass() {
	    _classCallCheck(this, SliderClass);
	
	    return _possibleConstructorReturn(this, (SliderClass.__proto__ || Object.getPrototypeOf(SliderClass)).apply(this, arguments));
	  }
	
	  _createClass(SliderClass, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var elementIndex = -1;
	      var products = this.props.products.map(function (product) {
	        elementIndex += 1;
	        return _react2.default.createElement(
	          "div",
	          { key: product.id.toString() },
	          _react2.default.createElement(_Product2.default, {
	            Index: elementIndex,
	            addVariantToCart: _this2.props.addVariantToCart,
	            client: _this2.props.client,
	            product: product,
	            category: _this2.props.category,
	            isproductForSlide: true,
	            changeProduct: _this2.props.changeProduct,
	            products: _this2.props.products
	          })
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid owl_slider" },
	        _react2.default.createElement(
	          _reactOwlCarousel2.default,
	          Object.assign({ className: "owl-theme" }, options),
	          products
	        )
	      );
	    }
	  }]);
	
	  return SliderClass;
	}(_react.Component);
	
	var ProductDetailPage = function (_Component2) {
	  _inherits(ProductDetailPage, _Component2);
	
	  function ProductDetailPage(props) {
	    _classCallCheck(this, ProductDetailPage);
	
	    var _this3 = _possibleConstructorReturn(this, (ProductDetailPage.__proto__ || Object.getPrototypeOf(ProductDetailPage)).call(this, props));
	
	    _this3.state = {
	      modalIsOpen: false,
	      setIsOpen: false,
	      selectedVariantQuantity: 1
	    };
	    var defaultOptionValues = {};
	    _this3.props.product.options.forEach(function (selector) {
	      defaultOptionValues[selector.name] = selector.values[0].value;
	    });
	    _this3.state = { selectedOptions: defaultOptionValues };
	    _this3.handleOptionChange = _this3.handleOptionChange.bind(_this3);
	    _this3.handleQuantityChange = _this3.handleQuantityChange.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(ProductDetailPage, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var defaultOptionValues = {};
	      if (prevProps !== this.props) {
	        this.props.product.options.forEach(function (selector) {
	          defaultOptionValues[selector.name] = selector.values[0].value;
	        });
	        this.setState({
	          selectedOptions: defaultOptionValues,
	          selectedVariant: null,
	          selectedVariantImage: null,
	          selectedValue: this.props.product.options[0].values[0].value
	        });
	      }
	    }
	  }, {
	    key: "handleOptionChange",
	    value: function handleOptionChange(event, fieldName) {
	      var selectedOptions = this.state.selectedOptions;
	      selectedOptions[fieldName] = "" + event.value;
	      var selectedVariant = this.props.client.product.helpers.variantForOptions(this.props.product, selectedOptions);
	
	      if (fieldName === "Color") {
	        this.setState({
	          selectedVariant: selectedVariant,
	          selectedColorValue: "" + event.value
	        });
	      } else if (fieldName === "Size") {
	        this.setState({
	          selectedVariant: selectedVariant,
	          selectedSizeValue: "" + event.value
	        });
	      } else {
	        this.setState({
	          selectedVariant: selectedVariant,
	          selectedColorValue: "" + event.value
	        });
	      }
	
	      if (this.props.product.images.length > 0) {
	        var index = this.props.product.images.map(function (e) {
	          return e.id;
	        }).indexOf(selectedVariant.image.attrs.id.value);
	
	        this.slider.slickGoTo(index);
	      }
	    }
	  }, {
	    key: "handleQuantityChange",
	    value: function handleQuantityChange(event) {
	      this.setState({
	        selectedVariantQuantity: event.target.value
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var selectedOptions = this.state.selectedOptions;
	      // selectedOptions["Color"] = this.props.product.options[0].values[0].value;
	      var iniialSelectedVariant = this.props.client.product.helpers.variantForOptions(this.props.product, selectedOptions);
	      var index = 0;
	      if (this.props.product.images.length > 0 && iniialSelectedVariant !== undefined) {
	        var index = this.props.product.images.map(function (e) {
	          return e.id;
	        }).indexOf(iniialSelectedVariant.image.attrs.id.value);
	      }
	
	      var settings = {
	        customPaging: function customPaging(i) {
	          return _react2.default.createElement(
	            "a",
	            null,
	            _react2.default.createElement("img", { src: variantImage[i].src })
	          );
	        },
	        dots: true,
	        dotsClass: "slick-dots slick-thumb",
	        infinite: false,
	        initialSlide: index,
	        fade: true,
	        slidesToShow: 1,
	        slidesToScroll: 1
	      };
	      var variantImage = this.props.product.images;
	      var variant = this.state.selectedVariant || this.props.product.variants[0];
	      var variantQuantity = this.state.selectedVariantQuantity || 1;
	      var desc1 = this.props.product.descriptionHtml;
	      var variantSelectors = this.props.product.options.map(function (option) {
	        return _react2.default.createElement(_VariantSelector2.default, {
	          handleOptionChange: _this4.handleOptionChange,
	          key: option.id.toString(),
	          option: option,
	          fieldName: option.name.toString(),
	          selectedSizeValue: _this4.state.selectedSizeValue,
	          selectedColorValue: _this4.state.selectedColorValue
	        });
	      });
	      return _react2.default.createElement(
	        "div",
	        { style: { backgroundColor: "#eee" } },
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid p-0" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "card",
	              style: { border: "none", backgroundColor: "#eee" } },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-6" },
	                _react2.default.createElement(
	                  "nav",
	                  { "aria-label": "breadcrumb" },
	                  _react2.default.createElement(
	                    "ol",
	                    { className: "breadcrumb" },
	                    _react2.default.createElement(
	                      "li",
	                      { className: "breadcrumb-item" },
	                      "  ",
	                      _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { to: "/merch", style: { color: "#95895f" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "Home"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "breadcrumb-item active", "aria-current": "page" },
	                      " ",
	                      this.props.product.title
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-6" },
	                _react2.default.createElement(
	                  "nav",
	                  { "aria-label": "breadcrumb slide_right"
	                  },
	                  _react2.default.createElement(
	                    "ol",
	                    { className: "breadcrumb slide_right" },
	                    _react2.default.createElement(
	                      "li",
	                      { className: "breadcrumb-item", style: { color: "#95895f", cursor: "pointer" },
	                        onClick: this.props.currentProductIndex > 0 ? this.props.prevProduct : null },
	                      " < Previous"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "breadcrumb-item active", "aria-current": "page", style: { color: "#95895f", cursor: "pointer" },
	                        onClick: this.props.currentProductIndex < this.props.totalProducts - 1 ? this.props.nextProduct : null },
	                      "Next >"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "container-fliud p-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "wrapper row pt-4 mt-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "preview col-md-6" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "preview-pic tab-content detal_page_product" },
	                    _react2.default.createElement(
	                      _reactSlick2.default,
	                      Object.assign({
	                        ref: function ref(slider) {
	                          return _this4.slider = slider;
	                        }
	                      }, settings),
	                      variantImage.map(function (img, index) {
	                        return _react2.default.createElement(
	                          "div",
	                          { key: index },
	                          _react2.default.createElement("img", { src: img.src })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "details col-md-6" },
	                  _react2.default.createElement("div", { id: "myPortal" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { className: "product-title" },
	                    this.props.product.title
	                  ),
	                  _react2.default.createElement(
	                    "h4",
	                    { className: "price" },
	                    _react2.default.createElement(
	                      "span",
	                      { style: { color: "#95895f" } },
	                      "$   ",
	                      variant.price.amount
	                    )
	                  ),
	                  variantSelectors,
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        float: "left",
	                        marginTop: "15px",
	                        paddingBottom: "15px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "quality_no" },
	                      "Quantity"
	                    ),
	                    _react2.default.createElement("input", {
	                      min: "1",
	                      className: "Product_quantity_option mobile-view",
	                      type: "number",
	                      defaultValue: variantQuantity,
	                      onChange: this.handleQuantityChange
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "action" },
	                    _react2.default.createElement(_Cart2.default, {
	                      variant_id: variant.id,
	                      variantQuantity: variantQuantity,
	                      isDetailPage: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "product-description" },
	                    (0, _reactHtmlParser2.default)(desc1)
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "social-icons" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://www.facebook.com/DrinkProspero/",
	                        target: "_balnk",
	                        style: { marginLeft: "0px !important" }
	                      },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement("i", { className: "fa fa-facebook-f" }),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "icon-items" },
	                          "FACEBOOK"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://www.instagram.com/prosperotequila",
	                        target: "_balnk"
	                      },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement("i", { className: "fa fa-instagram", "aria-hidden": "true" }),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "icon-items" },
	                          "Instagram"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductDetailPage;
	}(_react.Component);
	
	exports.default = ProductDetailPage1;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VariantSelector = __webpack_require__(33);
	
	var _VariantSelector2 = _interopRequireDefault(_VariantSelector);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	var _reactRouterDom = __webpack_require__(11);
	
	var _Cart = __webpack_require__(31);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _reactHtmlParser = __webpack_require__(54);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _reactSlick = __webpack_require__(67);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductDetails = function (_Component) {
	  _inherits(ProductDetails, _Component);
	
	  function ProductDetails(props) {
	    _classCallCheck(this, ProductDetails);
	
	    var _this = _possibleConstructorReturn(this, (ProductDetails.__proto__ || Object.getPrototypeOf(ProductDetails)).call(this, props));
	
	    _this.state = {
	      modalIsOpen: false,
	      setIsOpen: false,
	      selectedVariant: null,
	      selectedColorValue: null,
	      selectedSizeValue: null,
	      selectedsizevalue: null
	    };
	    var defaultOptionValues = {};
	    _this.props.product.options.forEach(function (selector) {
	      defaultOptionValues[selector.name] = selector.values[0].value;
	    });
	    _this.state = { selectedOptions: defaultOptionValues };
	    _this.handleOptionChange = _this.handleOptionChange.bind(_this);
	    _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProductDetails, [{
	    key: "componentWillMount",
	    value: function componentWillMount(prevProps) {
	      var defaultOptionValues = {};
	      if (prevProps !== this.props) {
	        this.props.product.options.forEach(function (selector) {
	          defaultOptionValues[selector.name] = selector.values[0].value;
	        });
	        this.setState({
	          selectedOptions: defaultOptionValues,
	          selectedVariant: null,
	          selectedVariantImage: null,
	          selectedValue: this.props.product.options[0].values[0].value
	        });
	      }
	    }
	  }, {
	    key: "handleOptionChange",
	    value: function handleOptionChange(event, fieldName) {
	      var selectedOptions = this.state.selectedOptions;
	      selectedOptions[fieldName] = "" + event.value;
	      var selectedVariant = this.props.client.product.helpers.variantForOptions(this.props.product, selectedOptions);
	
	      if (fieldName === "Color") {
	        this.setState({
	          selectedVariant: selectedVariant,
	          selectedColorValue: "" + event.value
	        });
	      } else if (fieldName === "Size") {
	        this.setState({
	          selectedVariant: selectedVariant,
	          selectedSizeValue: "" + event.value
	        });
	      } else {
	        this.setState({
	          selectedVariant: selectedVariant,
	          selectedColorValue: "" + event.value
	        });
	      }
	
	      var index = this.props.product.images.map(function (e) {
	        return e.id;
	      }).indexOf(selectedVariant.image.attrs.id.value);
	
	      this.slider.slickGoTo(index);
	    }
	  }, {
	    key: "handleQuantityChange",
	    value: function handleQuantityChange(event) {
	      this.setState({
	        selectedVariantQuantity: event.target.value
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var selectedOptions = this.state.selectedOptions;
	      // selectedOptions["Color"] = this.props.product.options[0].values[0].value;
	      var iniialSelectedVariant = this.props.client.product.helpers.variantForOptions(this.props.product, selectedOptions);
	      var index = 0;
	      if (this.props.product.images.length > 0 && iniialSelectedVariant !== undefined) {
	        var index = this.props.product.images.map(function (e) {
	          return e.id;
	        }).indexOf(iniialSelectedVariant.image.attrs.id.value);
	      }
	
	      var variantImage = this.props.product.images;
	      var variant = this.state.selectedVariant || this.props.product.variants[0];
	
	      var settings = {
	        customPaging: function customPaging(i) {
	          return _react2.default.createElement(
	            "a",
	            null,
	            _react2.default.createElement("img", { src: variantImage[i].src })
	          );
	        },
	        dots: true,
	        dotsClass: "slick-dots slick-thumb",
	        infinite: true,
	        initialSlide: index,
	        fade: true,
	        speed: 500,
	        slidesToShow: 1,
	        slidesToScroll: 1
	      };
	
	      var variantQuantity = this.state.selectedVariantQuantity || 1;
	      var desc1 = this.props.product.descriptionHtml;
	      var desc = this.props.product.description.split("•");
	      var firstInfo = desc[0];
	
	      var variantSelectors = this.props.product.options.map(function (option) {
	        return _react2.default.createElement(_VariantSelector2.default, {
	          handleOptionChange: _this2.handleOptionChange,
	          key: option.id.toString(),
	          option: option,
	          fieldName: option.name.toString(),
	          selectedSizeValue: _this2.state.selectedSizeValue,
	          selectedColorValue: _this2.state.selectedColorValue
	        });
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { style: { height: "100%" } },
	        _react2.default.createElement(
	          "button",
	          {
	            onClick: this.props.closeModal,
	            className: "Product__buy button modalCloseButton"
	          },
	          "X"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container", style: { height: "100%", overflow: "auto" } },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "card",
	              style: { border: "none", backgroundColor: "#fff" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "container-fliud pt-4 mt-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "wrapper row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "preview col-md-7 " },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "preview-pic tab-content " },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "container " },
	                      _react2.default.createElement(
	                        _reactSlick2.default,
	                        Object.assign({
	                          ref: function ref(slider) {
	                            return _this2.slider = slider;
	                          }
	                        }, settings),
	                        variantImage.map(function (img, index) {
	                          return _react2.default.createElement(
	                            "div",
	                            { key: index },
	                            _react2.default.createElement("img", { src: img.src })
	                          );
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "details col-md-5 " },
	                  _react2.default.createElement(
	                    "h3",
	                    { className: "product-title" },
	                    this.props.product.title
	                  ),
	                  _react2.default.createElement(
	                    "h4",
	                    { className: "price" },
	                    _react2.default.createElement(
	                      "span",
	                      { style: { color: "#cca63d" } },
	                      "$ ",
	                      variant.price.amount
	                    )
	                  ),
	                  variantSelectors,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "qty-for-desktop" },
	                    _react2.default.createElement(
	                      "label",
	                      { style: { fontSize: "14px", display: "block" } },
	                      "Quantity"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "action" },
	                    _react2.default.createElement("input", {
	                      min: "1",
	                      className: "Product_quantity_option mobile-view",
	                      type: "number",
	                      defaultValue: variantQuantity,
	                      onChange: this.handleQuantityChange
	                    }),
	                    _react2.default.createElement(_Cart2.default, {
	                      variant_id: variant.id,
	                      variantQuantity: variantQuantity,
	                      isDetailPage: false,
	                      closeModal: this.props.closeModal
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "product-description mobile-view" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      (0, _reactHtmlParser2.default)(desc1)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "product-description desktop-view" },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        to: { pathname: "/ProductDetail/" + this.props.category, search: "?id=" + this.props.product.id.toString() },
	                        className: "add-to-cart btn btn-default"
	                      },
	                      "View Detail"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductDetails;
	}(_react.Component);
	
	exports.default = ProductDetails;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Product = __webpack_require__(32);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Products = function (_Component) {
	  _inherits(Products, _Component);
	
	  function Products() {
	    _classCallCheck(this, Products);
	
	    return _possibleConstructorReturn(this, (Products.__proto__ || Object.getPrototypeOf(Products)).apply(this, arguments));
	  }
	
	  _createClass(Products, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var elementIndex = -1;
	      var shirts = this.props.shirts.map(function (product) {
	        elementIndex += 1;
	        return _react2.default.createElement(_Product2.default, {
	          Index: elementIndex,
	          addVariantToCart: _this2.props.addVariantToCart,
	          client: _this2.props.client,
	          key: product.id.toString(),
	          category: 'clyde-mays-shirts',
	          product: product,
	          products: _this2.props.shirts
	        });
	      });
	
	      elementIndex = -1;
	      var hats = this.props.hats.map(function (product) {
	        elementIndex += 1;
	        return _react2.default.createElement(_Product2.default, {
	          Index: elementIndex,
	          addVariantToCart: _this2.props.addVariantToCart,
	          client: _this2.props.client,
	          category: 'clyde-mays-hats',
	          key: product.id.toString(),
	          product: product,
	          products: _this2.props.hats
	        });
	      });
	
	      elementIndex = -1;
	      var accessarries = this.props.accessarries.map(function (product) {
	        elementIndex += 1;
	        return _react2.default.createElement(_Product2.default, {
	          Index: elementIndex,
	          addVariantToCart: _this2.props.addVariantToCart,
	          client: _this2.props.client,
	          category: 'clyde-mays-accessarries',
	          key: product.id.toString(),
	          product: product,
	          products: _this2.props.accessarries
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'Product_section' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Pr\xF3spero Tequila Merchandise'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'product_breadcrumb' },
	            _react2.default.createElement(
	              'h5',
	              { align: 'center' },
	              _react2.default.createElement(
	                'a',
	                { href: '#HATS' },
	                'HATS'
	              ),
	              '-',
	              _react2.default.createElement(
	                'a',
	                { href: '#SHIRTS' },
	                'SHIRTS'
	              ),
	              ' -',
	              _react2.default.createElement(
	                'a',
	                { href: '#ACCESSORIES' },
	                'ACCESSORIES'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Product_page' },
	            _react2.default.createElement('div', { className: 'row', id: 'HATS' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row pt-4' },
	              hats
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row', id: 'SHIRTS', style: { borderBottom: "1px solid white" } },
	              _react2.default.createElement(
	                'h4',
	                { className: 'header-product' },
	                'PR\xD3SPERO Shirts Collection'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row pt-4' },
	              shirts
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row', id: 'ACCESSORIES', style: { borderBottom: "1px solid white" } },
	              _react2.default.createElement(
	                'h4',
	                { className: 'header-product' },
	                'PR\xD3SPERO Accessories'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row pt-4' },
	              accessarries
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'footer',
	          { className: 'footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'section',
	              { className: 'footer__main' },
	              _react2.default.createElement(
	                'div',
	                { className: 'footer__inner' },
	                _react2.default.createElement(
	                  'nav',
	                  { className: 'footer__nav new-ff' },
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/#about' },
	                        'OUR CULTURE'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/#product' },
	                        'EXPRESSIONS'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/#women' },
	                        'WOMEN OF PR\xD3SPERO'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/#gallery' },
	                        'GALLERY'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/pressandmedia/' },
	                        'PRESS'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/locator' },
	                        'LOCATOR'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/#contact' },
	                        'CONTACT'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.prosperotequila.com/buyonlineorinstore/' },
	                        'BUY NOW'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'footer__bottom f-New' },
	                  '\xA9 2021 Pr\xF3spero Tequila. All Rights Reserved - PLEASE DRINK RESPONSIBLY - DISTRIBUTOR LOGIN - LEGAL - PRIVACY',
	                  _react2.default.createElement('br', null),
	                  'Pr\xF3spero brought to you by Conecuh Brands',
	                  _react2.default.createElement('br', null),
	                  'Conecuh Brands, LLC 1050 Franklin Ave., Suite 304 Garden City, NY 11530'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'copyright-area' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xl-12 col-lg-12 text-center ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'footer__bottom' },
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'COPYRIGHT \xA9 2017 PR\xD3SPERO'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'PLEASE DRINK RESPONSIBLY YA\u2019 RASCAL'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'https://clydemays.com/terms-of-use.html' },
	                            'LEGAL'
	                          ),
	                          ' | ',
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'https://PR\xD3SPERO.com/privacy-policy.html' },
	                            'PRIVACY POLICY'
	                          )
	                        )
	                      )
	                    ),
	                    '                  '
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Products;
	}(_react.Component);
	
	exports.default = Products;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(195);
	
	__webpack_require__(41);
	
	var _App = __webpack_require__(76);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 85 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 86 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(2);
	
	var emptyObject = __webpack_require__(43);
	var _invariant = __webpack_require__(10);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(89);
	var entities = __webpack_require__(102);
	
	/* mixed-case SVG and MathML tags & attributes
	   recognized by the HTML parser, see
	   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	*/
	var foreignNames = __webpack_require__(118);
	foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
	foreignNames.attributeNames.__proto__ = null;
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '';
	  var value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (opts.xmlMode === 'foreign') {
	      /* fix up mixed-case attribute names */
	      key = foreignNames.attributeNames[key] || key;
	    }
	    output += key;
	    if ((value !== null && value !== '') || opts.xmlMode) {
	      output +=
	        '="' +
	        (opts.decodeEntities
	          ? entities.encodeXML(value)
	          : value.replace(/\"/g, '&quot;')) +
	        '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	};
	
	var render = (module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for (var i = 0; i < dom.length; i++) {
	    var elem = dom[i];
	
	    if (elem.type === 'root') output += render(elem.children, opts);
	    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment) output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
	    else output += renderText(elem, opts);
	  }
	
	  return output;
	});
	
	var foreignModeIntegrationPoints = [
	  'mi',
	  'mo',
	  'mn',
	  'ms',
	  'mtext',
	  'annotation-xml',
	  'foreignObject',
	  'desc',
	  'title'
	];
	
	function renderTag(elem, opts) {
	  // Handle SVG / MathML in HTML
	  if (opts.xmlMode === 'foreign') {
	    /* fix up mixed-case element names */
	    elem.name = foreignNames.elementNames[elem.name] || elem.name;
	    /* exit foreign mode at integration points */
	    if (
	      elem.parent &&
	      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
	    )
	      opts = Object.assign({}, opts, { xmlMode: false });
	  }
	  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
	    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
	  }
	
	  var tag = '<' + elem.name;
	  var attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (
	    opts.decodeEntities &&
	    !(elem.parent && elem.parent.name in unencodedElements)
	  ) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */
	function isTag(elem) {
	    return (elem.type === "tag" /* Tag */ ||
	        elem.type === "script" /* Script */ ||
	        elem.type === "style" /* Style */);
	}
	exports.isTag = isTag;
	// Exports for backwards compatibility
	exports.Text = "text" /* Text */; //Text
	exports.Directive = "directive" /* Directive */; //<? ... ?>
	exports.Comment = "comment" /* Comment */; //<!-- ... -->
	exports.Script = "script" /* Script */; //<script> tags
	exports.Style = "style" /* Style */; //<style> tags
	exports.Tag = "tag" /* Tag */; //Any tag
	exports.CDATA = "cdata" /* CDATA */; //<![CDATA[ ... ]]>
	exports.Doctype = "doctype" /* Doctype */;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(36);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 91 */
/***/ function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(9);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ },
/* 93 */
/***/ function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(9).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, elems){
		var result = [];
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
	
			if(elems[i].children.length > 0){
				result = result.concat(findAll(test, elems[i].children));
			}
		}
		return result;
	}


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(9),
	    getOuterHTML = __webpack_require__(88),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem) || elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ },
/* 96 */
/***/ function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(99);
	var each = __webpack_require__(38).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(97);
	var Util = __webpack_require__(38);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(98);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decode_json_1 = __importDefault(__webpack_require__(119));
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	    if (codePoint in decode_json_1.default) {
	        // @ts-ignore
	        codePoint = decode_json_1.default[codePoint];
	    }
	    var output = "";
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	    output += String.fromCharCode(codePoint);
	    return output;
	}
	exports.default = decodeCodePoint;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var decode_1 = __webpack_require__(39);
	var encode_1 = __webpack_require__(40);
	function decode(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
	}
	exports.decode = decode;
	function decodeStrict(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
	}
	exports.decodeStrict = decodeStrict;
	function encode(data, level) {
	    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
	}
	exports.encode = encode;
	var encode_2 = __webpack_require__(40);
	exports.encodeXML = encode_2.encodeXML;
	exports.encodeHTML = encode_2.encodeHTML;
	exports.escape = encode_2.escape;
	// Legacy aliases
	exports.encodeHTML4 = encode_2.encodeHTML;
	exports.encodeHTML5 = encode_2.encodeHTML;
	var decode_2 = __webpack_require__(39);
	exports.decodeXML = decode_2.decodeXML;
	exports.decodeHTML = decode_2.decodeHTML;
	exports.decodeHTMLStrict = decode_2.decodeHTMLStrict;
	// Legacy aliases
	exports.decodeHTML4 = decode_2.decodeHTML;
	exports.decodeHTML5 = decode_2.decodeHTML;
	exports.decodeHTML4Strict = decode_2.decodeHTMLStrict;
	exports.decodeHTML5Strict = decode_2.decodeHTMLStrict;
	exports.decodeXMLStrict = decode_2.decodeXML;


/***/ },
/* 103 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 105 */
14,
/* 106 */
14,
/* 107 */
14,
/* 108 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(189)),valueEqual=_interopDefault(__webpack_require__(199));__webpack_require__(19);var invariant=_interopDefault(__webpack_require__(26));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(23);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs) {
	    this._cbs = cbs || {};
	    this.events = [];
	}
	
	var EVENTS = __webpack_require__(6).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function() {
	            this.events.push([name]);
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a) {
	            this.events.push([name, a]);
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a, b) {
	            this.events.push([name, a, b]);
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});
	
	CollectingHandler.prototype.onreset = function() {
	    this.events = [];
	    if (this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	
	    for (var i = 0, len = this.events.length; i < len; i++) {
	        if (this._cbs[this.events[i][0]]) {
	            var num = this.events[i].length;
	
	            if (num === 1) {
	                this._cbs[this.events[i][0]]();
	            } else if (num === 2) {
	                this._cbs[this.events[i][0]](this.events[i][1]);
	            } else {
	                this._cbs[this.events[i][0]](
	                    this.events[i][1],
	                    this.events[i][2]
	                );
	            }
	        }
	    }
	};


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var DomHandler = __webpack_require__(35);
	var DomUtils = __webpack_require__(37);
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options) {
	    this.init(callback, options);
	}
	
	__webpack_require__(16)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    return DomUtils.getText(
	        DomUtils.getElementsByTagName(what, where, recurse, 1)
	    ).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse) {
	    var tmp = fetch(what, where, recurse);
	    if (tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function() {
	    var feed = {},
	        feedRoot = getOneElement(isValidFeed, this.dom),
	        tmp,
	        childs;
	
	    if (feedRoot) {
	        if (feedRoot.name === "feed") {
	            childs = feedRoot.children;
	
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            if (
	                (tmp = getOneElement("link", childs)) &&
	                (tmp = tmp.attribs) &&
	                (tmp = tmp.href)
	            )
	                feed.link = tmp;
	            addConditionally(feed, "description", "subtitle", childs);
	            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "email", childs, true);
	
	            feed.items = getElements("entry", childs).map(function(item) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "id", item);
	                addConditionally(entry, "title", "title", item);
	                if (
	                    (tmp = getOneElement("link", item)) &&
	                    (tmp = tmp.attribs) &&
	                    (tmp = tmp.href)
	                )
	                    entry.link = tmp;
	                if ((tmp = fetch("summary", item) || fetch("content", item)))
	                    entry.description = tmp;
	                if ((tmp = fetch("updated", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        } else {
	            childs = getOneElement("channel", feedRoot.children).children;
	
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            if ((tmp = fetch("lastBuildDate", childs)))
	                feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "managingEditor", childs, true);
	
	            feed.items = getElements("item", feedRoot.children).map(function(
	                item
	            ) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "guid", item);
	                addConditionally(entry, "title", "title", item);
	                addConditionally(entry, "link", "link", item);
	                addConditionally(entry, "description", "description", item);
	                if ((tmp = fetch("pubDate", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        }
	    }
	    this.dom = feed;
	    DomHandler.prototype._handleCallback.call(
	        this,
	        feedRoot ? null : Error("couldn't find root of feed")
	    );
	};
	
	module.exports = FeedHandler;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs) {
	    this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(6).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function() {
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a) {
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a, b) {
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(47);
	
	function Stream(options) {
	    Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(16)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope) {
	    this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(6).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        Cbs.prototype["on" + name] = function() {
	            this.scope.emit(name);
	        };
	    } else if (EVENTS[name] === 1) {
	        Cbs.prototype["on" + name] = function(a) {
	            this.scope.emit(name, a);
	        };
	    } else if (EVENTS[name] === 2) {
	        Cbs.prototype["on" + name] = function(a, b) {
	            this.scope.emit(name, a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments!");
	    }
	});


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(121);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ },
/* 116 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports = {
		"elementNames": {
			"altglyph": "altGlyph",
			"altglyphdef": "altGlyphDef",
			"altglyphitem": "altGlyphItem",
			"animatecolor": "animateColor",
			"animatemotion": "animateMotion",
			"animatetransform": "animateTransform",
			"clippath": "clipPath",
			"feblend": "feBlend",
			"fecolormatrix": "feColorMatrix",
			"fecomponenttransfer": "feComponentTransfer",
			"fecomposite": "feComposite",
			"feconvolvematrix": "feConvolveMatrix",
			"fediffuselighting": "feDiffuseLighting",
			"fedisplacementmap": "feDisplacementMap",
			"fedistantlight": "feDistantLight",
			"fedropshadow": "feDropShadow",
			"feflood": "feFlood",
			"fefunca": "feFuncA",
			"fefuncb": "feFuncB",
			"fefuncg": "feFuncG",
			"fefuncr": "feFuncR",
			"fegaussianblur": "feGaussianBlur",
			"feimage": "feImage",
			"femerge": "feMerge",
			"femergenode": "feMergeNode",
			"femorphology": "feMorphology",
			"feoffset": "feOffset",
			"fepointlight": "fePointLight",
			"fespecularlighting": "feSpecularLighting",
			"fespotlight": "feSpotLight",
			"fetile": "feTile",
			"feturbulence": "feTurbulence",
			"foreignobject": "foreignObject",
			"glyphref": "glyphRef",
			"lineargradient": "linearGradient",
			"radialgradient": "radialGradient",
			"textpath": "textPath"
		},
		"attributeNames": {
			"definitionurl": "definitionURL",
			"attributename": "attributeName",
			"attributetype": "attributeType",
			"basefrequency": "baseFrequency",
			"baseprofile": "baseProfile",
			"calcmode": "calcMode",
			"clippathunits": "clipPathUnits",
			"diffuseconstant": "diffuseConstant",
			"edgemode": "edgeMode",
			"filterunits": "filterUnits",
			"glyphref": "glyphRef",
			"gradienttransform": "gradientTransform",
			"gradientunits": "gradientUnits",
			"kernelmatrix": "kernelMatrix",
			"kernelunitlength": "kernelUnitLength",
			"keypoints": "keyPoints",
			"keysplines": "keySplines",
			"keytimes": "keyTimes",
			"lengthadjust": "lengthAdjust",
			"limitingconeangle": "limitingConeAngle",
			"markerheight": "markerHeight",
			"markerunits": "markerUnits",
			"markerwidth": "markerWidth",
			"maskcontentunits": "maskContentUnits",
			"maskunits": "maskUnits",
			"numoctaves": "numOctaves",
			"pathlength": "pathLength",
			"patterncontentunits": "patternContentUnits",
			"patterntransform": "patternTransform",
			"patternunits": "patternUnits",
			"pointsatx": "pointsAtX",
			"pointsaty": "pointsAtY",
			"pointsatz": "pointsAtZ",
			"preservealpha": "preserveAlpha",
			"preserveaspectratio": "preserveAspectRatio",
			"primitiveunits": "primitiveUnits",
			"refx": "refX",
			"refy": "refY",
			"repeatcount": "repeatCount",
			"repeatdur": "repeatDur",
			"requiredextensions": "requiredExtensions",
			"requiredfeatures": "requiredFeatures",
			"specularconstant": "specularConstant",
			"specularexponent": "specularExponent",
			"spreadmethod": "spreadMethod",
			"startoffset": "startOffset",
			"stddeviation": "stdDeviation",
			"stitchtiles": "stitchTiles",
			"surfacescale": "surfaceScale",
			"systemlanguage": "systemLanguage",
			"tablevalues": "tableValues",
			"targetx": "targetX",
			"targety": "targetY",
			"textlength": "textLength",
			"viewbox": "viewBox",
			"viewtarget": "viewTarget",
			"xchannelselector": "xChannelSelector",
			"ychannelselector": "yChannelSelector",
			"zoomandpan": "zoomAndPan"
		}
	};

/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 121 */
119,
/* 122 */
48,
/* 123 */
120,
/* 124 */
49,
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(193);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 126 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';function _interopDefault(e){return(e&&(typeof e==='object')&&'default'in e)?e['default']:e}var React=__webpack_require__(1),React__default=_interopDefault(React),_inheritsLoose=_interopDefault(__webpack_require__(27)),PropTypes=_interopDefault(__webpack_require__(3)),gud=_interopDefault(__webpack_require__(108)),warning=_interopDefault(__webpack_require__(19));var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + gud() + '__';
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes.object.isRequired, _Provider$childContex);
	
	  var Consumer =
	  /*#__PURE__*/
	  function (_Component2) {
	    _inheritsLoose(Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes.object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default.createContext || createReactContext;module.exports=index;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(117)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(51);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(51);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(134);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(52);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(23);
	var assign = __webpack_require__(2);
	
	var ReactPropTypesSecret = __webpack_require__(52);
	var checkPropTypes = __webpack_require__(131);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["ReactActivity"] = factory(require("react"));
		else
			root["ReactActivity"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.Windmill = exports.Bounce = exports.Digital = exports.Squares = exports.Spinner = exports.Sentry = exports.Levels = exports.Dots = undefined;
	
		var _Dots = __webpack_require__(1);
	
		var _Dots2 = _interopRequireDefault(_Dots);
	
		var _Levels = __webpack_require__(15);
	
		var _Levels2 = _interopRequireDefault(_Levels);
	
		var _Sentry = __webpack_require__(17);
	
		var _Sentry2 = _interopRequireDefault(_Sentry);
	
		var _Spinner = __webpack_require__(19);
	
		var _Spinner2 = _interopRequireDefault(_Spinner);
	
		var _Squares = __webpack_require__(21);
	
		var _Squares2 = _interopRequireDefault(_Squares);
	
		var _Digital = __webpack_require__(23);
	
		var _Digital2 = _interopRequireDefault(_Digital);
	
		var _Bounce = __webpack_require__(25);
	
		var _Bounce2 = _interopRequireDefault(_Bounce);
	
		var _Windmill = __webpack_require__(27);
	
		var _Windmill2 = _interopRequireDefault(_Windmill);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.Dots = _Dots2.default;
		exports.Levels = _Levels2.default;
		exports.Sentry = _Sentry2.default;
		exports.Spinner = _Spinner2.default;
		exports.Squares = _Squares2.default;
		exports.Digital = _Digital2.default;
		exports.Bounce = _Bounce2.default;
		exports.Windmill = _Windmill2.default;
		exports.default = { Dots: _Dots2.default, Levels: _Levels2.default, Sentry: _Sentry2.default, Spinner: _Spinner2.default, Squares: _Squares2.default, Digital: _Digital2.default, Bounce: _Bounce2.default, Windmill: _Windmill2.default };
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Dots = __webpack_require__(2);
	
		var _Dots2 = _interopRequireDefault(_Dots);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Dots2.default;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Dots = function Dots(props) {
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-dots' },
		    _react2.default.createElement('div', {
		      className: 'rai-circle',
		      style: props.getFillStyle(0.3)
		    }),
		    _react2.default.createElement('div', {
		      className: 'rai-circle',
		      style: props.getFillStyle(0.2)
		    }),
		    _react2.default.createElement('div', {
		      className: 'rai-circle',
		      style: props.getFillStyle(0.1)
		    })
		  );
		};
	
		exports.default = (0, _activityIndicator2.default)(Dots, 0.8);
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(5);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		exports.default = function (ComposedComponent, defaultAnimationDuration) {
		  var ActivityIndicator = function (_React$Component) {
		    _inherits(ActivityIndicator, _React$Component);
	
		    function ActivityIndicator(props) {
		      _classCallCheck(this, ActivityIndicator);
	
		      var _this = _possibleConstructorReturn(this, (ActivityIndicator.__proto__ || Object.getPrototypeOf(ActivityIndicator)).call(this, props));
	
		      _this.getDelayStyle = _this.getDelayStyle.bind(_this);
		      _this.getFillStyle = _this.getFillStyle.bind(_this);
		      _this.getBorderStyle = _this.getBorderStyle.bind(_this);
		      return _this;
		    }
	
		    _createClass(ActivityIndicator, [{
		      key: 'getDelayStyle',
		      value: function getDelayStyle(delay) {
		        var style = {};
		        if (delay) {
		          style.animationDelay = '-' + delay * (1 / this.props.speed) + 's';
		        }
		        return style;
		      }
		    }, {
		      key: 'getFillStyle',
		      value: function getFillStyle(delay) {
		        var style = this.getDelayStyle(delay);
		        if (this.props.color) {
		          style.backgroundColor = this.props.color;
		        }
		        return style;
		      }
		    }, {
		      key: 'getBorderStyle',
		      value: function getBorderStyle(delay) {
		        var style = this.getDelayStyle(delay);
		        if (this.props.color) {
		          style.borderColor = this.props.color;
		        }
		        return style;
		      }
		    }, {
		      key: 'render',
		      value: function render() {
		        if (!this.props.animating) {
		          return null;
		        }
		        var containerStyle = {
		          display: 'inline-block',
		          fontSize: '16px',
		          lineHeight: '0'
		        };
		        var indicatorStyle = {
		          animationDuration: this.props.animationDuration * (1 / this.props.speed) + 's'
		        };
		        if (this.props.size) {
		          indicatorStyle.fontSize = this.props.size;
		        }
		        return _react2.default.createElement(
		          'div',
		          {
		            style: containerStyle,
		            className: 'rai-activity-indicator ' + this.props.className
		          },
		          _react2.default.createElement(ComposedComponent, {
		            getFillStyle: this.getFillStyle,
		            getBorderStyle: this.getBorderStyle,
		            style: indicatorStyle
		          })
		        );
		      }
		    }]);
	
		    return ActivityIndicator;
		  }(_react2.default.Component);
	
		  ActivityIndicator.propTypes = {
		    animationDuration: _propTypes2.default.number.isRequired,
		    speed: _propTypes2.default.number,
		    animating: _propTypes2.default.bool.isRequired
		  };
	
		  ActivityIndicator.defaultProps = {
		    animationDuration: defaultAnimationDuration,
		    speed: 1,
		    animating: true
		  };
	
		  ActivityIndicator.displayName = ComposedComponent.name;
	
		  return ActivityIndicator;
		};
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		if (process.env.NODE_ENV !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(7)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(14)();
		}
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
	
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
	
		var cachedSetTimeout;
		var cachedClearTimeout;
	
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
	
	
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
	
	
	
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
	
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
	
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
	
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
	
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
	
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
	
		function noop() {}
	
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
	
		process.listeners = function (name) { return [] }
	
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
	
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(8);
		var invariant = __webpack_require__(9);
		var warning = __webpack_require__(10);
		var assign = __webpack_require__(11);
	
		var ReactPropTypesSecret = __webpack_require__(12);
		var checkPropTypes = __webpack_require__(13);
	
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker,
		    exact: createStrictShapeTypeChecker,
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    if (process.env.NODE_ENV !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createStrictShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      // We need to check all keys in case some are required but missing from
		      // props.
		      var allKeys = assign({}, props[propName], shapeTypes);
		      for (var key in allKeys) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          return new PropTypeError(
		            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
		            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
		            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
		          );
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
	
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (process.env.NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2014-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(8);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (process.env.NODE_ENV !== 'production') {
		  var printWarning = function printWarning(format) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
	
		    var argIndex = 0;
		    var message = 'Warning: ' + format.replace(/%s/g, function () {
		      return args[argIndex++];
		    });
		    if (typeof console !== 'undefined') {
		      console.error(message);
		    }
		    try {
		      // --- Welcome to debugging React ---
		      // This error was thrown as a convenience so that you can use this stack
		      // to find the callsite that caused this warning to fire.
		      throw new Error(message);
		    } catch (x) {}
		  };
	
		  warning = function warning(condition, format) {
		    if (format === undefined) {
		      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		    }
	
		    if (format.indexOf('Failed Composite propType: ') === 0) {
		      return; // Ignore CompositeComponent proptype check.
		    }
	
		    if (!condition) {
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
	
		      printWarning.apply(undefined, [format].concat(args));
		    }
		  };
		}
	
		module.exports = warning;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		if (process.env.NODE_ENV !== 'production') {
		  var invariant = __webpack_require__(9);
		  var warning = __webpack_require__(10);
		  var ReactPropTypesSecret = __webpack_require__(12);
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (process.env.NODE_ENV !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		module.exports = checkPropTypes;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(8);
		var invariant = __webpack_require__(9);
		var ReactPropTypesSecret = __webpack_require__(12);
	
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim,
		    exact: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Levels = __webpack_require__(16);
	
		var _Levels2 = _interopRequireDefault(_Levels);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Levels2.default;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Levels = function Levels(props) {
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-levels' },
		    _react2.default.createElement(
		      'div',
		      { className: 'rai-levels-container' },
		      _react2.default.createElement('div', { className: 'rai-bar', style: props.getFillStyle() }),
		      _react2.default.createElement('div', { className: 'rai-bar', style: props.getFillStyle(0.25) }),
		      _react2.default.createElement('div', { className: 'rai-bar', style: props.getFillStyle(0.4) })
		    )
		  );
		};
	
		exports.default = (0, _activityIndicator2.default)(Levels, 1.5);
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Sentry = __webpack_require__(18);
	
		var _Sentry2 = _interopRequireDefault(_Sentry);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Sentry2.default;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Sentry = function Sentry(props) {
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-sentry' },
		    _react2.default.createElement(
		      'div',
		      { className: 'rai-wave-container' },
		      _react2.default.createElement('div', { className: 'rai-wave', style: props.getBorderStyle(0) })
		    ),
		    _react2.default.createElement(
		      'div',
		      { className: 'rai-wave-container' },
		      _react2.default.createElement('div', { className: 'rai-wave', style: props.getBorderStyle(0.4) })
		    )
		  );
		};
	
		exports.default = (0, _activityIndicator2.default)(Sentry, 0.8);
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Spinner = __webpack_require__(20);
	
		var _Spinner2 = _interopRequireDefault(_Spinner);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Spinner2.default;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Spinner = function Spinner(props) {
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-spinner' },
		    _react2.default.createElement('div', { className: 'rai-spinner-outer', style: props.getBorderStyle() }),
		    _react2.default.createElement('div', { className: 'rai-spinner-inner', style: props.getBorderStyle() })
		  );
		};
	
		exports.default = (0, _activityIndicator2.default)(Spinner, 0.6);
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Squares = __webpack_require__(22);
	
		var _Squares2 = _interopRequireDefault(_Squares);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Squares2.default;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(5);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Squares = function Squares(props) {
		  var squares = [];
		  for (var i = 1; i <= props.squareCount; i++) {
		    squares.unshift(_react2.default.createElement('div', {
		      key: i,
		      className: 'rai-square',
		      style: props.getFillStyle(i / 10)
		    }));
		  }
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-squares' },
		    squares
		  );
		};
	
		Squares.propTypes = {
		  squareCount: _propTypes2.default.number.isRequired
	
		};
	
		Squares.defaultProps = {
		  squareCount: 3
		};
	
		exports.default = (0, _activityIndicator2.default)(Squares, 0.8);
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Digital = __webpack_require__(24);
	
		var _Digital2 = _interopRequireDefault(_Digital);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Digital2.default;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(5);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Digital = function Digital(props) {
		  var rects = [];
		  for (var i = 1; i <= props.count; i++) {
		    rects.unshift(_react2.default.createElement('div', {
		      key: i,
		      style: props.getFillStyle(i / 10)
		    }));
		  }
	
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-digital' },
		    rects
		  );
		};
	
		Digital.propTypes = {
		  count: _propTypes2.default.number.isRequired
		};
	
		Digital.defaultProps = {
		  count: 3
		};
	
		exports.default = (0, _activityIndicator2.default)(Digital, 0.8);
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Bounce = __webpack_require__(26);
	
		var _Bounce2 = _interopRequireDefault(_Bounce);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Bounce2.default;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(5);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Bounce = function Bounce(props) {
		  var squares = [];
		  for (var i = 1; i <= props.count; i++) {
		    squares.unshift(_react2.default.createElement('div', {
		      key: i,
		      style: props.getFillStyle(i / 10)
		    }));
		  }
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-bounce' },
		    squares
		  );
		};
	
		Bounce.propTypes = {
		  count: _propTypes2.default.number.isRequired
		};
	
		Bounce.defaultProps = {
		  count: 3
		};
	
		exports.default = (0, _activityIndicator2.default)(Bounce, 0.8);
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Windmill = __webpack_require__(28);
	
		var _Windmill2 = _interopRequireDefault(_Windmill);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Windmill2.default;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(5);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _activityIndicator = __webpack_require__(4);
	
		var _activityIndicator2 = _interopRequireDefault(_activityIndicator);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var animationDuration = 0.8;
	
		var Windmill = function Windmill(props) {
		  var windill = [];
		  for (var i = 1; i <= props.count; i++) {
		    var style = props.getFillStyle(i / (props.count * 2 / animationDuration));
		    windill.unshift(_react2.default.createElement('div', {
		      key: i,
		      style: style
		    }));
		  }
		  return _react2.default.createElement(
		    'div',
		    { style: props.style, className: 'rai-windill' },
		    windill
		  );
		};
	
		Windmill.propTypes = {
		  count: _propTypes2.default.number.isRequired
		};
	
		Windmill.defaultProps = {
		  count: 1
		};
	
		exports.default = (0, _activityIndicator2.default)(Windmill, animationDuration);
	
	/***/ })
	/******/ ])
	});
	;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(2),r=__webpack_require__(192);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HtmlParser;
	
	var _htmlparser = __webpack_require__(6);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	var _processNodes = __webpack_require__(22);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Parses a HTML string and returns a list of React components generated from it
	 *
	 * @param {String} html The HTML to convert into React component
	 * @param {Object} options Options to pass
	 * @returns {Array} List of top level React elements
	 */
	function HtmlParser(html) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$decodeEntities = _ref.decodeEntities,
	      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
	      transform = _ref.transform,
	      _ref$preprocessNodes = _ref.preprocessNodes,
	      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
	    return nodes;
	  } : _ref$preprocessNodes;
	
	  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
	  return (0, _processNodes2.default)(nodes, transform);
	}

/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of boolean attributes
	 * These attributes should have their React attribute value set to be the same as their name
	 * E.g. <input disabled> = <input disabled>
	 *      <input disabled=""> = <input disabled>
	 *      <input disabled="disabled"> = <input disabled>
	 * @type {Array}
	 */
	exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Mapping of standard HTML attributes to their React counterparts
	 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * @type {Object}
	 */
	exports.default = {
	  /**
	   * Standard Properties
	   */
	  accept: 'accept',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  allowtransparency: 'allowTransparency',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocomplete: 'autoComplete',
	  autoplay: 'autoPlay',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  charset: 'charSet',
	  challenge: 'challenge',
	  checked: 'checked',
	  cite: 'cite',
	  classid: 'classID',
	  class: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlsList: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  form: 'form',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formmethod: 'formMethod',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  for: 'htmlFor',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginheight: 'marginHeight',
	  marginwidth: 'marginWidth',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  slot: 'slot',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  /**
	   * RDFa Properties
	   */
	  about: 'about',
	  datatype: 'datatype',
	  inlist: 'inlist',
	  prefix: 'prefix',
	  property: 'property',
	  resource: 'resource',
	  typeof: 'typeof',
	  vocab: 'vocab',
	  /**
	   * Non-standard Properties
	   */
	  autocapitalize: 'autoCapitalize',
	  autocorrect: 'autoCorrect',
	  autosave: 'autoSave',
	  color: 'color',
	  itemprop: 'itemProp',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  itemid: 'itemID',
	  itemref: 'itemRef',
	  results: 'results',
	  security: 'security',
	  unselectable: 'unselectable'
	};

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of void elements
	 * These elements are not allowed to have children
	 * @type {Array}
	 */
	exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StyleElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generatePropsFromAttributes = __webpack_require__(55);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a <style> element to a React element
	 *
	 * @param {Object} node The style node
	 * @param {String} index The index of the React element relative to it's parent
	 * @returns {React.Element} The React style element
	 */
	function StyleElementType(node, index) {
	
	  // The style element only ever has a single child which is the styles so try and find this to add as
	  // a child to the style element that will be created
	  var styles = void 0;
	  if (node.children.length > 0) {
	    styles = node.children[0].data;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // create and return the element
	  return _react2.default.createElement('style', props, styles);
	}

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _processNodes = __webpack_require__(22);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	var _generatePropsFromAttributes = __webpack_require__(55);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	var _VoidElements = __webpack_require__(140);
	
	var _VoidElements2 = _interopRequireDefault(_VoidElements);
	
	var _isValidTagOrAttributeName = __webpack_require__(56);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
	 *
	 * @param {Object} node The tag node
	 * @param {String} index The index of the React element relative to it's parent
	 * @param {Function} transform The transform function to apply to all children
	 * @returns {React.Element} The React tag element
	 */
	function TagElementType(node, index, transform) {
	
	  var tagName = node.name;
	
	  // validate tag name
	  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
	    return null;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // If the node is not a void element and has children then process them
	  var children = null;
	  if (_VoidElements2.default.indexOf(tagName) === -1) {
	    children = (0, _processNodes2.default)(node.children, transform);
	  }
	
	  // create and return the element
	  return _react2.default.createElement(tagName, props, children);
	}

/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextElementType;
	/**
	 * Converts a text node to a React text element
	 *
	 * @param {Object} node The text node
	 * @returns {String} The text
	 */
	function TextElementType(node) {
	
	  // React will accept plain text for rendering so just return the node data
	  return node.data;
	}

/***/ },
/* 144 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnsupportedElementType;
	/**
	 * Handles an unsupported element type by returning null so nothing is rendered
	 * @returns {null}
	 */
	function UnsupportedElementType() {
	
	  // do nothing because the element type is unsupported
	  // comment, directive, script, cdata, doctype are all currently unsupported
	  return null;
	}

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ElementType$Text$Ele;
	
	var _htmlparser = __webpack_require__(6);
	
	var _TextElementType = __webpack_require__(143);
	
	var _TextElementType2 = _interopRequireDefault(_TextElementType);
	
	var _TagElementType = __webpack_require__(142);
	
	var _TagElementType2 = _interopRequireDefault(_TagElementType);
	
	var _StyleElementType = __webpack_require__(141);
	
	var _StyleElementType2 = _interopRequireDefault(_StyleElementType);
	
	var _UnsupportedElementType = __webpack_require__(144);
	
	var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
	                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
	                                                                                                                                                                                                                   * value
	                                                                                                                                                                                                                   */
	
	exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = htmlAttributesToReact;
	
	var _BooleanAttributes = __webpack_require__(138);
	
	var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);
	
	var _ReactAttributes = __webpack_require__(139);
	
	var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);
	
	var _isValidTagOrAttributeName = __webpack_require__(56);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the parsed attribute value taking into account things like boolean attributes
	 *
	 * @param {String} attribute The name of the attribute
	 * @param {*} value The value of the attribute from the HTML
	 * @returns {*} The parsed attribute value
	 */
	var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {
	
	  // if the attribute if a boolean then it's value should be the same as it's name
	  // e.g. disabled="disabled"
	  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
	    return attr.toLowerCase();
	  });
	  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
	    value = attribute;
	  }
	
	  return value;
	};
	
	/**
	 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
	 * version does not exist for an attribute then just use it as it is
	 *
	 * @param {Object} attributes The HTML attributes to convert
	 * @returns {Object} The React attributes
	 */
	function htmlAttributesToReact(attributes) {
	
	  return Object.keys(attributes).filter(function (attr) {
	    return (0, _isValidTagOrAttributeName2.default)(attr);
	  }).reduce(function (mappedAttributes, attribute) {
	
	    // lowercase the attribute name and find it in the react attribute map
	    var lowerCaseAttribute = attribute.toLowerCase();
	
	    // format the attribute name
	    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;
	
	    // add the parsed attribute value to the mapped attributes
	    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
	
	    return mappedAttributes;
	  }, {});
	}

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InlineStyleToObject;
	/**
	 * Converts an inline style string into an object of React style properties
	 *
	 * @param {String} inlineStyle='' The inline style to convert
	 * @returns {Object} The converted style
	 */
	function InlineStyleToObject() {
	  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	  // just return empty object if the inlineStyle is empty
	  if (inlineStyle === '') {
	    return {};
	  }
	
	  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {
	
	    // extract the style property name and value
	    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
	      return i > 0;
	    }).map(function (item) {
	      return item.trim().toLowerCase();
	    }),
	        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
	        property = _stylePropertyValue$s2[0],
	        value = _stylePropertyValue$s2[1];
	
	    // if there is no value (i.e. no : in the style) then ignore it
	
	
	    if (value === undefined) {
	      return styleObject;
	    }
	
	    // convert the property name into the correct React format
	    // remove all hyphens and convert the letter immediately after each hyphen to upper case
	    // additionally don't uppercase any -ms- prefix
	    // e.g. -ms-style-property = msStyleProperty
	    //      -webkit-style-property = WebkitStyleProperty
	    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
	      return character.toUpperCase();
	    });
	
	    // add the new style property and value to the style object
	    styleObject[property] = value;
	
	    return styleObject;
	  }, {});
	}

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmptyTextNode;
	/**
	 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
	 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
	 *
	 * @param {Object} node The element object as created by htmlparser2
	 * @returns {boolean} Whether the node is an empty text node
	 */
	function isEmptyTextNode(node) {
	  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
	}

/***/ },
/* 149 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 150 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(152);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(58);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(24);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(150);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      if (parent) {
	        parent.removeChild(_this.node);
	      } else {
	        // eslint-disable-next-line no-console
	        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
	      }
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	exports.default = Modal;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(155);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(156);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(58);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(154);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(24);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _portalOpenInstances = __webpack_require__(59);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	__webpack_require__(153);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	
	      _portalOpenInstances2.default.deregister(_this);
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen({
	              overlayEl: _this.overlay,
	              contentEl: _this.content
	            });
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	
	      _portalOpenInstances2.default.register(this);
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            id: id,
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
	            "data-testid": this.props.testId
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _portalOpenInstances = __webpack_require__(59);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Body focus trap see Issue #742
	
	var before = void 0,
	    after = void 0,
	    instances = [];
	
	function focusContent() {
	  if (instances.length === 0) {
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("React-Modal: Open instances > 0 expected");
	    }
	    return;
	  }
	  instances[instances.length - 1].focusContent();
	}
	
	function bodyTrap(eventType, openInstances) {
	  if (!before || !after) {
	    before = document.createElement("div");
	    before.setAttribute("data-react-modal-body-trap", "");
	    before.style.position = "absolute";
	    before.style.opacity = "0";
	    before.setAttribute("tabindex", "0");
	    before.addEventListener("focus", focusContent);
	    after = before.cloneNode();
	    after.addEventListener("focus", focusContent);
	  }
	
	  instances = openInstances;
	
	  if (instances.length > 0) {
	    // Add focus trap
	    if (document.body.firstChild !== before) {
	      document.body.insertBefore(before, document.body.firstChild);
	    }
	    if (document.body.lastChild !== after) {
	      document.body.appendChild(after);
	    }
	  } else {
	    // Remove focus trap
	    if (before.parentElement) {
	      before.parentElement.removeChild(before);
	    }
	    if (after.parentElement) {
	      after.parentElement.removeChild(after);
	    }
	  }
	}
	
	_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(60);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(60);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var target = void 0;
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  target = tabbable[x];
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  target.focus();
	}
	module.exports = exports["default"];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(151);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(2);
	
	var ReactBaseClasses = __webpack_require__(61);
	var ReactChildren = __webpack_require__(161);
	var ReactDOMFactories = __webpack_require__(162);
	var ReactElement = __webpack_require__(7);
	var ReactPropTypes = __webpack_require__(163);
	var ReactVersion = __webpack_require__(164);
	
	var createReactClass = __webpack_require__(165);
	var onlyChild = __webpack_require__(168);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(159);
	var ReactElement = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(42);
	var traverseAllChildren = __webpack_require__(169);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(7),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(132);
	
	module.exports = factory(isValidElement);

/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(61),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(7),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(64);
	var factory = __webpack_require__(87);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactElement = __webpack_require__(7);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var REACT_ELEMENT_TYPE = __webpack_require__(63);
	
	var getIteratorFn = __webpack_require__(166);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(158);
	var warning = __webpack_require__(21);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(160);


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? module.exports = factory(__webpack_require__(170)) :
	    typeof define === 'function' && define.amd ? define(['react'], factory) :
	    (global.ReactOwlCarousel = factory(global.React));
	}(this, (function (React) { 'use strict';
	
	    var React__default = 'default' in React ? React['default'] : React;
	
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation. All rights reserved.
	    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	    this file except in compliance with the License. You may obtain a copy of the
	    License at http://www.apache.org/licenses/LICENSE-2.0
	
	    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	    MERCHANTABLITY OR NON-INFRINGEMENT.
	
	    See the Apache Version 2.0 License for specific language governing permissions
	    and limitations under the License.
	    ***************************************************************************** */
	    /* global Reflect, Promise */
	
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    function __extends(d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }
	
	    var __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    function __rest(s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	                t[p[i]] = s[p[i]];
	        return t;
	    }
	
	    /**
	     * Owl Carousel v2.3.4
	     * Copyright 2013-2018 David Deutsch
	     * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
	     */
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates a carousel.
	    	 * @class The Owl Carousel.
	    	 * @public
	    	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
	    	 * @param {Object} [options] - The options
	    	 */
	    	function Owl(element, options) {
	
	    		/**
	    		 * Current settings for the carousel.
	    		 * @public
	    		 */
	    		this.settings = null;
	
	    		/**
	    		 * Current options set by the caller including defaults.
	    		 * @public
	    		 */
	    		this.options = $.extend({}, Owl.Defaults, options);
	
	    		/**
	    		 * Plugin element.
	    		 * @public
	    		 */
	    		this.$element = $(element);
	
	    		/**
	    		 * Proxied event handlers.
	    		 * @protected
	    		 */
	    		this._handlers = {};
	
	    		/**
	    		 * References to the running plugins of this carousel.
	    		 * @protected
	    		 */
	    		this._plugins = {};
	
	    		/**
	    		 * Currently suppressed events to prevent them from being retriggered.
	    		 * @protected
	    		 */
	    		this._supress = {};
	
	    		/**
	    		 * Absolute current position.
	    		 * @protected
	    		 */
	    		this._current = null;
	
	    		/**
	    		 * Animation speed in milliseconds.
	    		 * @protected
	    		 */
	    		this._speed = null;
	
	    		/**
	    		 * Coordinates of all items in pixel.
	    		 * @todo The name of this member is missleading.
	    		 * @protected
	    		 */
	    		this._coordinates = [];
	
	    		/**
	    		 * Current breakpoint.
	    		 * @todo Real media queries would be nice.
	    		 * @protected
	    		 */
	    		this._breakpoint = null;
	
	    		/**
	    		 * Current width of the plugin element.
	    		 */
	    		this._width = null;
	
	    		/**
	    		 * All real items.
	    		 * @protected
	    		 */
	    		this._items = [];
	
	    		/**
	    		 * All cloned items.
	    		 * @protected
	    		 */
	    		this._clones = [];
	
	    		/**
	    		 * Merge values of all items.
	    		 * @todo Maybe this could be part of a plugin.
	    		 * @protected
	    		 */
	    		this._mergers = [];
	
	    		/**
	    		 * Widths of all items.
	    		 */
	    		this._widths = [];
	
	    		/**
	    		 * Invalidated parts within the update process.
	    		 * @protected
	    		 */
	    		this._invalidated = {};
	
	    		/**
	    		 * Ordered list of workers for the update process.
	    		 * @protected
	    		 */
	    		this._pipe = [];
	
	    		/**
	    		 * Current state information for the drag operation.
	    		 * @todo #261
	    		 * @protected
	    		 */
	    		this._drag = {
	    			time: null,
	    			target: null,
	    			pointer: null,
	    			stage: {
	    				start: null,
	    				current: null
	    			},
	    			direction: null
	    		};
	
	    		/**
	    		 * Current state information and their tags.
	    		 * @type {Object}
	    		 * @protected
	    		 */
	    		this._states = {
	    			current: {},
	    			tags: {
	    				'initializing': [ 'busy' ],
	    				'animating': [ 'busy' ],
	    				'dragging': [ 'interacting' ]
	    			}
	    		};
	
	    		$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
	    			this._handlers[handler] = $.proxy(this[handler], this);
	    		}, this));
	
	    		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
	    			this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
	    				= new plugin(this);
	    		}, this));
	
	    		$.each(Owl.Workers, $.proxy(function(priority, worker) {
	    			this._pipe.push({
	    				'filter': worker.filter,
	    				'run': $.proxy(worker.run, this)
	    			});
	    		}, this));
	
	    		this.setup();
	    		this.initialize();
	    	}
	
	    	/**
	    	 * Default options for the carousel.
	    	 * @public
	    	 */
	    	Owl.Defaults = {
	    		items: 3,
	    		loop: false,
	    		center: false,
	    		rewind: false,
	    		checkVisibility: true,
	
	    		mouseDrag: true,
	    		touchDrag: true,
	    		pullDrag: true,
	    		freeDrag: false,
	
	    		margin: 0,
	    		stagePadding: 0,
	
	    		merge: false,
	    		mergeFit: true,
	    		autoWidth: false,
	
	    		startPosition: 0,
	    		rtl: false,
	
	    		smartSpeed: 250,
	    		fluidSpeed: false,
	    		dragEndSpeed: false,
	
	    		responsive: {},
	    		responsiveRefreshRate: 200,
	    		responsiveBaseElement: window,
	
	    		fallbackEasing: 'swing',
	    		slideTransition: '',
	
	    		info: false,
	
	    		nestedItemSelector: false,
	    		itemElement: 'div',
	    		stageElement: 'div',
	
	    		refreshClass: 'owl-refresh',
	    		loadedClass: 'owl-loaded',
	    		loadingClass: 'owl-loading',
	    		rtlClass: 'owl-rtl',
	    		responsiveClass: 'owl-responsive',
	    		dragClass: 'owl-drag',
	    		itemClass: 'owl-item',
	    		stageClass: 'owl-stage',
	    		stageOuterClass: 'owl-stage-outer',
	    		grabClass: 'owl-grab'
	    	};
	
	    	/**
	    	 * Enumeration for width.
	    	 * @public
	    	 * @readonly
	    	 * @enum {String}
	    	 */
	    	Owl.Width = {
	    		Default: 'default',
	    		Inner: 'inner',
	    		Outer: 'outer'
	    	};
	
	    	/**
	    	 * Enumeration for types.
	    	 * @public
	    	 * @readonly
	    	 * @enum {String}
	    	 */
	    	Owl.Type = {
	    		Event: 'event',
	    		State: 'state'
	    	};
	
	    	/**
	    	 * Contains all registered plugins.
	    	 * @public
	    	 */
	    	Owl.Plugins = {};
	
	    	/**
	    	 * List of workers involved in the update process.
	    	 */
	    	Owl.Workers = [ {
	    		filter: [ 'width', 'settings' ],
	    		run: function() {
	    			this._width = this.$element.width();
	    		}
	    	}, {
	    		filter: [ 'width', 'items', 'settings' ],
	    		run: function(cache) {
	    			cache.current = this._items && this._items[this.relative(this._current)];
	    		}
	    	}, {
	    		filter: [ 'items', 'settings' ],
	    		run: function() {
	    			this.$stage.children('.cloned').remove();
	    		}
	    	}, {
	    		filter: [ 'width', 'items', 'settings' ],
	    		run: function(cache) {
	    			var margin = this.settings.margin || '',
	    				grid = !this.settings.autoWidth,
	    				rtl = this.settings.rtl,
	    				css = {
	    					'width': 'auto',
	    					'margin-left': rtl ? margin : '',
	    					'margin-right': rtl ? '' : margin
	    				};
	
	    			!grid && this.$stage.children().css(css);
	
	    			cache.css = css;
	    		}
	    	}, {
	    		filter: [ 'width', 'items', 'settings' ],
	    		run: function(cache) {
	    			var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
	    				merge = null,
	    				iterator = this._items.length,
	    				grid = !this.settings.autoWidth,
	    				widths = [];
	
	    			cache.items = {
	    				merge: false,
	    				width: width
	    			};
	
	    			while (iterator--) {
	    				merge = this._mergers[iterator];
	    				merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;
	
	    				cache.items.merge = merge > 1 || cache.items.merge;
	
	    				widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
	    			}
	
	    			this._widths = widths;
	    		}
	    	}, {
	    		filter: [ 'items', 'settings' ],
	    		run: function() {
	    			var clones = [],
	    				items = this._items,
	    				settings = this.settings,
	    				// TODO: Should be computed from number of min width items in stage
	    				view = Math.max(settings.items * 2, 4),
	    				size = Math.ceil(items.length / 2) * 2,
	    				repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
	    				append = '',
	    				prepend = '';
	
	    			repeat /= 2;
	
	    			while (repeat > 0) {
	    				// Switch to only using appended clones
	    				clones.push(this.normalize(clones.length / 2, true));
	    				append = append + items[clones[clones.length - 1]][0].outerHTML;
	    				clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
	    				prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
	    				repeat -= 1;
	    			}
	
	    			this._clones = clones;
	
	    			$(append).addClass('cloned').appendTo(this.$stage);
	    			$(prepend).addClass('cloned').prependTo(this.$stage);
	    		}
	    	}, {
	    		filter: [ 'width', 'items', 'settings' ],
	    		run: function() {
	    			var rtl = this.settings.rtl ? 1 : -1,
	    				size = this._clones.length + this._items.length,
	    				iterator = -1,
	    				previous = 0,
	    				current = 0,
	    				coordinates = [];
	
	    			while (++iterator < size) {
	    				previous = coordinates[iterator - 1] || 0;
	    				current = this._widths[this.relative(iterator)] + this.settings.margin;
	    				coordinates.push(previous + current * rtl);
	    			}
	
	    			this._coordinates = coordinates;
	    		}
	    	}, {
	    		filter: [ 'width', 'items', 'settings' ],
	    		run: function() {
	    			var padding = this.settings.stagePadding,
	    				coordinates = this._coordinates,
	    				css = {
	    					'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
	    					'padding-left': padding || '',
	    					'padding-right': padding || ''
	    				};
	
	    			this.$stage.css(css);
	    		}
	    	}, {
	    		filter: [ 'width', 'items', 'settings' ],
	    		run: function(cache) {
	    			var iterator = this._coordinates.length,
	    				grid = !this.settings.autoWidth,
	    				items = this.$stage.children();
	
	    			if (grid && cache.items.merge) {
	    				while (iterator--) {
	    					cache.css.width = this._widths[this.relative(iterator)];
	    					items.eq(iterator).css(cache.css);
	    				}
	    			} else if (grid) {
	    				cache.css.width = cache.items.width;
	    				items.css(cache.css);
	    			}
	    		}
	    	}, {
	    		filter: [ 'items' ],
	    		run: function() {
	    			this._coordinates.length < 1 && this.$stage.removeAttr('style');
	    		}
	    	}, {
	    		filter: [ 'width', 'items', 'settings' ],
	    		run: function(cache) {
	    			cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
	    			cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
	    			this.reset(cache.current);
	    		}
	    	}, {
	    		filter: [ 'position' ],
	    		run: function() {
	    			this.animate(this.coordinates(this._current));
	    		}
	    	}, {
	    		filter: [ 'width', 'position', 'items', 'settings' ],
	    		run: function() {
	    			var rtl = this.settings.rtl ? 1 : -1,
	    				padding = this.settings.stagePadding * 2,
	    				begin = this.coordinates(this.current()) + padding,
	    				end = begin + this.width() * rtl,
	    				inner, outer, matches = [], i, n;
	
	    			for (i = 0, n = this._coordinates.length; i < n; i++) {
	    				inner = this._coordinates[i - 1] || 0;
	    				outer = Math.abs(this._coordinates[i]) + padding * rtl;
	
	    				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
	    					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
	    					matches.push(i);
	    				}
	    			}
	
	    			this.$stage.children('.active').removeClass('active');
	    			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');
	
	    			this.$stage.children('.center').removeClass('center');
	    			if (this.settings.center) {
	    				this.$stage.children().eq(this.current()).addClass('center');
	    			}
	    		}
	    	} ];
	
	    	/**
	    	 * Create the stage DOM element
	    	 */
	    	Owl.prototype.initializeStage = function() {
	    		this.$stage = this.$element.find('.' + this.settings.stageClass);
	
	    		// if the stage is already in the DOM, grab it and skip stage initialization
	    		if (this.$stage.length) {
	    			return;
	    		}
	
	    		this.$element.addClass(this.options.loadingClass);
	
	    		// create stage
	    		this.$stage = $('<' + this.settings.stageElement + '>', {
	    			"class": this.settings.stageClass
	    		}).wrap( $( '<div/>', {
	    			"class": this.settings.stageOuterClass
	    		}));
	
	    		// append stage
	    		this.$element.append(this.$stage.parent());
	    	};
	
	    	/**
	    	 * Create item DOM elements
	    	 */
	    	Owl.prototype.initializeItems = function() {
	    		var $items = this.$element.find('.owl-item');
	
	    		// if the items are already in the DOM, grab them and skip item initialization
	    		if ($items.length) {
	    			this._items = $items.get().map(function(item) {
	    				return $(item);
	    			});
	
	    			this._mergers = this._items.map(function() {
	    				return 1;
	    			});
	
	    			this.refresh();
	
	    			return;
	    		}
	
	    		// append content
	    		this.replace(this.$element.children().not(this.$stage.parent()));
	
	    		// check visibility
	    		if (this.isVisible()) {
	    			// update view
	    			this.refresh();
	    		} else {
	    			// invalidate width
	    			this.invalidate('width');
	    		}
	
	    		this.$element
	    			.removeClass(this.options.loadingClass)
	    			.addClass(this.options.loadedClass);
	    	};
	
	    	/**
	    	 * Initializes the carousel.
	    	 * @protected
	    	 */
	    	Owl.prototype.initialize = function() {
	    		this.enter('initializing');
	    		this.trigger('initialize');
	
	    		this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);
	
	    		if (this.settings.autoWidth && !this.is('pre-loading')) {
	    			var imgs, nestedSelector, width;
	    			imgs = this.$element.find('img');
	    			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
	    			width = this.$element.children(nestedSelector).width();
	
	    			if (imgs.length && width <= 0) {
	    				this.preloadAutoWidthImages(imgs);
	    			}
	    		}
	
	    		this.initializeStage();
	    		this.initializeItems();
	
	    		// register event handlers
	    		this.registerEventHandlers();
	
	    		this.leave('initializing');
	    		this.trigger('initialized');
	    	};
	
	    	/**
	    	 * @returns {Boolean} visibility of $element
	    	 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
	    	 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
	    	 */
	    	Owl.prototype.isVisible = function() {
	    		return this.settings.checkVisibility
	    			? this.$element.is(':visible')
	    			: true;
	    	};
	
	    	/**
	    	 * Setups the current settings.
	    	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
	    	 * @todo Support for media queries by using `matchMedia` would be nice.
	    	 * @public
	    	 */
	    	Owl.prototype.setup = function() {
	    		var viewport = this.viewport(),
	    			overwrites = this.options.responsive,
	    			match = -1,
	    			settings = null;
	
	    		if (!overwrites) {
	    			settings = $.extend({}, this.options);
	    		} else {
	    			$.each(overwrites, function(breakpoint) {
	    				if (breakpoint <= viewport && breakpoint > match) {
	    					match = Number(breakpoint);
	    				}
	    			});
	
	    			settings = $.extend({}, this.options, overwrites[match]);
	    			if (typeof settings.stagePadding === 'function') {
	    				settings.stagePadding = settings.stagePadding();
	    			}
	    			delete settings.responsive;
	
	    			// responsive class
	    			if (settings.responsiveClass) {
	    				this.$element.attr('class',
	    					this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
	    				);
	    			}
	    		}
	
	    		this.trigger('change', { property: { name: 'settings', value: settings } });
	    		this._breakpoint = match;
	    		this.settings = settings;
	    		this.invalidate('settings');
	    		this.trigger('changed', { property: { name: 'settings', value: this.settings } });
	    	};
	
	    	/**
	    	 * Updates option logic if necessery.
	    	 * @protected
	    	 */
	    	Owl.prototype.optionsLogic = function() {
	    		if (this.settings.autoWidth) {
	    			this.settings.stagePadding = false;
	    			this.settings.merge = false;
	    		}
	    	};
	
	    	/**
	    	 * Prepares an item before add.
	    	 * @todo Rename event parameter `content` to `item`.
	    	 * @protected
	    	 * @returns {jQuery|HTMLElement} - The item container.
	    	 */
	    	Owl.prototype.prepare = function(item) {
	    		var event = this.trigger('prepare', { content: item });
	
	    		if (!event.data) {
	    			event.data = $('<' + this.settings.itemElement + '/>')
	    				.addClass(this.options.itemClass).append(item);
	    		}
	
	    		this.trigger('prepared', { content: event.data });
	
	    		return event.data;
	    	};
	
	    	/**
	    	 * Updates the view.
	    	 * @public
	    	 */
	    	Owl.prototype.update = function() {
	    		var i = 0,
	    			n = this._pipe.length,
	    			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
	    			cache = {};
	
	    		while (i < n) {
	    			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
	    				this._pipe[i].run(cache);
	    			}
	    			i++;
	    		}
	
	    		this._invalidated = {};
	
	    		!this.is('valid') && this.enter('valid');
	    	};
	
	    	/**
	    	 * Gets the width of the view.
	    	 * @public
	    	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
	    	 * @returns {Number} - The width of the view in pixel.
	    	 */
	    	Owl.prototype.width = function(dimension) {
	    		dimension = dimension || Owl.Width.Default;
	    		switch (dimension) {
	    			case Owl.Width.Inner:
	    			case Owl.Width.Outer:
	    				return this._width;
	    			default:
	    				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
	    		}
	    	};
	
	    	/**
	    	 * Refreshes the carousel primarily for adaptive purposes.
	    	 * @public
	    	 */
	    	Owl.prototype.refresh = function() {
	    		this.enter('refreshing');
	    		this.trigger('refresh');
	
	    		this.setup();
	
	    		this.optionsLogic();
	
	    		this.$element.addClass(this.options.refreshClass);
	
	    		this.update();
	
	    		this.$element.removeClass(this.options.refreshClass);
	
	    		this.leave('refreshing');
	    		this.trigger('refreshed');
	    	};
	
	    	/**
	    	 * Checks window `resize` event.
	    	 * @protected
	    	 */
	    	Owl.prototype.onThrottledResize = function() {
	    		window.clearTimeout(this.resizeTimer);
	    		this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
	    	};
	
	    	/**
	    	 * Checks window `resize` event.
	    	 * @protected
	    	 */
	    	Owl.prototype.onResize = function() {
	    		if (!this._items.length) {
	    			return false;
	    		}
	
	    		if (this._width === this.$element.width()) {
	    			return false;
	    		}
	
	    		if (!this.isVisible()) {
	    			return false;
	    		}
	
	    		this.enter('resizing');
	
	    		if (this.trigger('resize').isDefaultPrevented()) {
	    			this.leave('resizing');
	    			return false;
	    		}
	
	    		this.invalidate('width');
	
	    		this.refresh();
	
	    		this.leave('resizing');
	    		this.trigger('resized');
	    	};
	
	    	/**
	    	 * Registers event handlers.
	    	 * @todo Check `msPointerEnabled`
	    	 * @todo #261
	    	 * @protected
	    	 */
	    	Owl.prototype.registerEventHandlers = function() {
	    		if ($.support.transition) {
	    			this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
	    		}
	
	    		if (this.settings.responsive !== false) {
	    			this.on(window, 'resize', this._handlers.onThrottledResize);
	    		}
	
	    		if (this.settings.mouseDrag) {
	    			this.$element.addClass(this.options.dragClass);
	    			this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
	    			this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
	    		}
	
	    		if (this.settings.touchDrag){
	    			this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
	    			this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
	    		}
	    	};
	
	    	/**
	    	 * Handles `touchstart` and `mousedown` events.
	    	 * @todo Horizontal swipe threshold as option
	    	 * @todo #261
	    	 * @protected
	    	 * @param {Event} event - The event arguments.
	    	 */
	    	Owl.prototype.onDragStart = function(event) {
	    		var stage = null;
	
	    		if (event.which === 3) {
	    			return;
	    		}
	
	    		if ($.support.transform) {
	    			stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
	    			stage = {
	    				x: stage[stage.length === 16 ? 12 : 4],
	    				y: stage[stage.length === 16 ? 13 : 5]
	    			};
	    		} else {
	    			stage = this.$stage.position();
	    			stage = {
	    				x: this.settings.rtl ?
	    					stage.left + this.$stage.width() - this.width() + this.settings.margin :
	    					stage.left,
	    				y: stage.top
	    			};
	    		}
	
	    		if (this.is('animating')) {
	    			$.support.transform ? this.animate(stage.x) : this.$stage.stop();
	    			this.invalidate('position');
	    		}
	
	    		this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');
	
	    		this.speed(0);
	
	    		this._drag.time = new Date().getTime();
	    		this._drag.target = $(event.target);
	    		this._drag.stage.start = stage;
	    		this._drag.stage.current = stage;
	    		this._drag.pointer = this.pointer(event);
	
	    		$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));
	
	    		$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
	    			var delta = this.difference(this._drag.pointer, this.pointer(event));
	
	    			$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));
	
	    			if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
	    				return;
	    			}
	
	    			event.preventDefault();
	
	    			this.enter('dragging');
	    			this.trigger('drag');
	    		}, this));
	    	};
	
	    	/**
	    	 * Handles the `touchmove` and `mousemove` events.
	    	 * @todo #261
	    	 * @protected
	    	 * @param {Event} event - The event arguments.
	    	 */
	    	Owl.prototype.onDragMove = function(event) {
	    		var minimum = null,
	    			maximum = null,
	    			pull = null,
	    			delta = this.difference(this._drag.pointer, this.pointer(event)),
	    			stage = this.difference(this._drag.stage.start, delta);
	
	    		if (!this.is('dragging')) {
	    			return;
	    		}
	
	    		event.preventDefault();
	
	    		if (this.settings.loop) {
	    			minimum = this.coordinates(this.minimum());
	    			maximum = this.coordinates(this.maximum() + 1) - minimum;
	    			stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
	    		} else {
	    			minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
	    			maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
	    			pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
	    			stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
	    		}
	
	    		this._drag.stage.current = stage;
	
	    		this.animate(stage.x);
	    	};
	
	    	/**
	    	 * Handles the `touchend` and `mouseup` events.
	    	 * @todo #261
	    	 * @todo Threshold for click event
	    	 * @protected
	    	 * @param {Event} event - The event arguments.
	    	 */
	    	Owl.prototype.onDragEnd = function(event) {
	    		var delta = this.difference(this._drag.pointer, this.pointer(event)),
	    			stage = this._drag.stage.current,
	    			direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';
	
	    		$(document).off('.owl.core');
	
	    		this.$element.removeClass(this.options.grabClass);
	
	    		if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
	    			this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
	    			this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
	    			this.invalidate('position');
	    			this.update();
	
	    			this._drag.direction = direction;
	
	    			if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
	    				this._drag.target.one('click.owl.core', function() { return false; });
	    			}
	    		}
	
	    		if (!this.is('dragging')) {
	    			return;
	    		}
	
	    		this.leave('dragging');
	    		this.trigger('dragged');
	    	};
	
	    	/**
	    	 * Gets absolute position of the closest item for a coordinate.
	    	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
	    	 * @protected
	    	 * @param {Number} coordinate - The coordinate in pixel.
	    	 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
	    	 * @return {Number} - The absolute position of the closest item.
	    	 */
	    	Owl.prototype.closest = function(coordinate, direction) {
	    		var position = -1,
	    			pull = 30,
	    			width = this.width(),
	    			coordinates = this.coordinates();
	
	    		if (!this.settings.freeDrag) {
	    			// check closest item
	    			$.each(coordinates, $.proxy(function(index, value) {
	    				// on a left pull, check on current index
	    				if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
	    					position = index;
	    				// on a right pull, check on previous index
	    				// to do so, subtract width from value and set position = index + 1
	    				} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
	    					position = index + 1;
	    				} else if (this.op(coordinate, '<', value)
	    					&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
	    					position = direction === 'left' ? index + 1 : index;
	    				}
	    				return position === -1;
	    			}, this));
	    		}
	
	    		if (!this.settings.loop) {
	    			// non loop boundries
	    			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
	    				position = coordinate = this.minimum();
	    			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
	    				position = coordinate = this.maximum();
	    			}
	    		}
	
	    		return position;
	    	};
	
	    	/**
	    	 * Animates the stage.
	    	 * @todo #270
	    	 * @public
	    	 * @param {Number} coordinate - The coordinate in pixels.
	    	 */
	    	Owl.prototype.animate = function(coordinate) {
	    		var animate = this.speed() > 0;
	
	    		this.is('animating') && this.onTransitionEnd();
	
	    		if (animate) {
	    			this.enter('animating');
	    			this.trigger('translate');
	    		}
	
	    		if ($.support.transform3d && $.support.transition) {
	    			this.$stage.css({
	    				transform: 'translate3d(' + coordinate + 'px,0px,0px)',
	    				transition: (this.speed() / 1000) + 's' + (
	    					this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
	    				)
	    			});
	    		} else if (animate) {
	    			this.$stage.animate({
	    				left: coordinate + 'px'
	    			}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
	    		} else {
	    			this.$stage.css({
	    				left: coordinate + 'px'
	    			});
	    		}
	    	};
	
	    	/**
	    	 * Checks whether the carousel is in a specific state or not.
	    	 * @param {String} state - The state to check.
	    	 * @returns {Boolean} - The flag which indicates if the carousel is busy.
	    	 */
	    	Owl.prototype.is = function(state) {
	    		return this._states.current[state] && this._states.current[state] > 0;
	    	};
	
	    	/**
	    	 * Sets the absolute position of the current item.
	    	 * @public
	    	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
	    	 * @returns {Number} - The absolute position of the current item.
	    	 */
	    	Owl.prototype.current = function(position) {
	    		if (position === undefined) {
	    			return this._current;
	    		}
	
	    		if (this._items.length === 0) {
	    			return undefined;
	    		}
	
	    		position = this.normalize(position);
	
	    		if (this._current !== position) {
	    			var event = this.trigger('change', { property: { name: 'position', value: position } });
	
	    			if (event.data !== undefined) {
	    				position = this.normalize(event.data);
	    			}
	
	    			this._current = position;
	
	    			this.invalidate('position');
	
	    			this.trigger('changed', { property: { name: 'position', value: this._current } });
	    		}
	
	    		return this._current;
	    	};
	
	    	/**
	    	 * Invalidates the given part of the update routine.
	    	 * @param {String} [part] - The part to invalidate.
	    	 * @returns {Array.<String>} - The invalidated parts.
	    	 */
	    	Owl.prototype.invalidate = function(part) {
	    		if ($.type(part) === 'string') {
	    			this._invalidated[part] = true;
	    			this.is('valid') && this.leave('valid');
	    		}
	    		return $.map(this._invalidated, function(v, i) { return i });
	    	};
	
	    	/**
	    	 * Resets the absolute position of the current item.
	    	 * @public
	    	 * @param {Number} position - The absolute position of the new item.
	    	 */
	    	Owl.prototype.reset = function(position) {
	    		position = this.normalize(position);
	
	    		if (position === undefined) {
	    			return;
	    		}
	
	    		this._speed = 0;
	    		this._current = position;
	
	    		this.suppress([ 'translate', 'translated' ]);
	
	    		this.animate(this.coordinates(position));
	
	    		this.release([ 'translate', 'translated' ]);
	    	};
	
	    	/**
	    	 * Normalizes an absolute or a relative position of an item.
	    	 * @public
	    	 * @param {Number} position - The absolute or relative position to normalize.
	    	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
	    	 * @returns {Number} - The normalized position.
	    	 */
	    	Owl.prototype.normalize = function(position, relative) {
	    		var n = this._items.length,
	    			m = relative ? 0 : this._clones.length;
	
	    		if (!this.isNumeric(position) || n < 1) {
	    			position = undefined;
	    		} else if (position < 0 || position >= n + m) {
	    			position = ((position - m / 2) % n + n) % n + m / 2;
	    		}
	
	    		return position;
	    	};
	
	    	/**
	    	 * Converts an absolute position of an item into a relative one.
	    	 * @public
	    	 * @param {Number} position - The absolute position to convert.
	    	 * @returns {Number} - The converted position.
	    	 */
	    	Owl.prototype.relative = function(position) {
	    		position -= this._clones.length / 2;
	    		return this.normalize(position, true);
	    	};
	
	    	/**
	    	 * Gets the maximum position for the current item.
	    	 * @public
	    	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	    	 * @returns {Number}
	    	 */
	    	Owl.prototype.maximum = function(relative) {
	    		var settings = this.settings,
	    			maximum = this._coordinates.length,
	    			iterator,
	    			reciprocalItemsWidth,
	    			elementWidth;
	
	    		if (settings.loop) {
	    			maximum = this._clones.length / 2 + this._items.length - 1;
	    		} else if (settings.autoWidth || settings.merge) {
	    			iterator = this._items.length;
	    			if (iterator) {
	    				reciprocalItemsWidth = this._items[--iterator].width();
	    				elementWidth = this.$element.width();
	    				while (iterator--) {
	    					reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
	    					if (reciprocalItemsWidth > elementWidth) {
	    						break;
	    					}
	    				}
	    			}
	    			maximum = iterator + 1;
	    		} else if (settings.center) {
	    			maximum = this._items.length - 1;
	    		} else {
	    			maximum = this._items.length - settings.items;
	    		}
	
	    		if (relative) {
	    			maximum -= this._clones.length / 2;
	    		}
	
	    		return Math.max(maximum, 0);
	    	};
	
	    	/**
	    	 * Gets the minimum position for the current item.
	    	 * @public
	    	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	    	 * @returns {Number}
	    	 */
	    	Owl.prototype.minimum = function(relative) {
	    		return relative ? 0 : this._clones.length / 2;
	    	};
	
	    	/**
	    	 * Gets an item at the specified relative position.
	    	 * @public
	    	 * @param {Number} [position] - The relative position of the item.
	    	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	    	 */
	    	Owl.prototype.items = function(position) {
	    		if (position === undefined) {
	    			return this._items.slice();
	    		}
	
	    		position = this.normalize(position, true);
	    		return this._items[position];
	    	};
	
	    	/**
	    	 * Gets an item at the specified relative position.
	    	 * @public
	    	 * @param {Number} [position] - The relative position of the item.
	    	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	    	 */
	    	Owl.prototype.mergers = function(position) {
	    		if (position === undefined) {
	    			return this._mergers.slice();
	    		}
	
	    		position = this.normalize(position, true);
	    		return this._mergers[position];
	    	};
	
	    	/**
	    	 * Gets the absolute positions of clones for an item.
	    	 * @public
	    	 * @param {Number} [position] - The relative position of the item.
	    	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
	    	 */
	    	Owl.prototype.clones = function(position) {
	    		var odd = this._clones.length / 2,
	    			even = odd + this._items.length,
	    			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };
	
	    		if (position === undefined) {
	    			return $.map(this._clones, function(v, i) { return map(i) });
	    		}
	
	    		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
	    	};
	
	    	/**
	    	 * Sets the current animation speed.
	    	 * @public
	    	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
	    	 * @returns {Number} - The current animation speed in milliseconds.
	    	 */
	    	Owl.prototype.speed = function(speed) {
	    		if (speed !== undefined) {
	    			this._speed = speed;
	    		}
	
	    		return this._speed;
	    	};
	
	    	/**
	    	 * Gets the coordinate of an item.
	    	 * @todo The name of this method is missleanding.
	    	 * @public
	    	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
	    	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
	    	 */
	    	Owl.prototype.coordinates = function(position) {
	    		var multiplier = 1,
	    			newPosition = position - 1,
	    			coordinate;
	
	    		if (position === undefined) {
	    			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
	    				return this.coordinates(index);
	    			}, this));
	    		}
	
	    		if (this.settings.center) {
	    			if (this.settings.rtl) {
	    				multiplier = -1;
	    				newPosition = position + 1;
	    			}
	
	    			coordinate = this._coordinates[position];
	    			coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
	    		} else {
	    			coordinate = this._coordinates[newPosition] || 0;
	    		}
	
	    		coordinate = Math.ceil(coordinate);
	
	    		return coordinate;
	    	};
	
	    	/**
	    	 * Calculates the speed for a translation.
	    	 * @protected
	    	 * @param {Number} from - The absolute position of the start item.
	    	 * @param {Number} to - The absolute position of the target item.
	    	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	    	 * @returns {Number} - The time in milliseconds for the translation.
	    	 */
	    	Owl.prototype.duration = function(from, to, factor) {
	    		if (factor === 0) {
	    			return 0;
	    		}
	
	    		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
	    	};
	
	    	/**
	    	 * Slides to the specified item.
	    	 * @public
	    	 * @param {Number} position - The position of the item.
	    	 * @param {Number} [speed] - The time in milliseconds for the transition.
	    	 */
	    	Owl.prototype.to = function(position, speed) {
	    		var current = this.current(),
	    			revert = null,
	    			distance = position - this.relative(current),
	    			direction = (distance > 0) - (distance < 0),
	    			items = this._items.length,
	    			minimum = this.minimum(),
	    			maximum = this.maximum();
	
	    		if (this.settings.loop) {
	    			if (!this.settings.rewind && Math.abs(distance) > items / 2) {
	    				distance += direction * -1 * items;
	    			}
	
	    			position = current + distance;
	    			revert = ((position - minimum) % items + items) % items + minimum;
	
	    			if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
	    				current = revert - distance;
	    				position = revert;
	    				this.reset(current);
	    			}
	    		} else if (this.settings.rewind) {
	    			maximum += 1;
	    			position = (position % maximum + maximum) % maximum;
	    		} else {
	    			position = Math.max(minimum, Math.min(maximum, position));
	    		}
	
	    		this.speed(this.duration(current, position, speed));
	    		this.current(position);
	
	    		if (this.isVisible()) {
	    			this.update();
	    		}
	    	};
	
	    	/**
	    	 * Slides to the next item.
	    	 * @public
	    	 * @param {Number} [speed] - The time in milliseconds for the transition.
	    	 */
	    	Owl.prototype.next = function(speed) {
	    		speed = speed || false;
	    		this.to(this.relative(this.current()) + 1, speed);
	    	};
	
	    	/**
	    	 * Slides to the previous item.
	    	 * @public
	    	 * @param {Number} [speed] - The time in milliseconds for the transition.
	    	 */
	    	Owl.prototype.prev = function(speed) {
	    		speed = speed || false;
	    		this.to(this.relative(this.current()) - 1, speed);
	    	};
	
	    	/**
	    	 * Handles the end of an animation.
	    	 * @protected
	    	 * @param {Event} event - The event arguments.
	    	 */
	    	Owl.prototype.onTransitionEnd = function(event) {
	
	    		// if css2 animation then event object is undefined
	    		if (event !== undefined) {
	    			event.stopPropagation();
	
	    			// Catch only owl-stage transitionEnd event
	    			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
	    				return false;
	    			}
	    		}
	
	    		this.leave('animating');
	    		this.trigger('translated');
	    	};
	
	    	/**
	    	 * Gets viewport width.
	    	 * @protected
	    	 * @return {Number} - The width in pixel.
	    	 */
	    	Owl.prototype.viewport = function() {
	    		var width;
	    		if (this.options.responsiveBaseElement !== window) {
	    			width = $(this.options.responsiveBaseElement).width();
	    		} else if (window.innerWidth) {
	    			width = window.innerWidth;
	    		} else if (document.documentElement && document.documentElement.clientWidth) {
	    			width = document.documentElement.clientWidth;
	    		} else {
	    			console.warn('Can not detect viewport width.');
	    		}
	    		return width;
	    	};
	
	    	/**
	    	 * Replaces the current content.
	    	 * @public
	    	 * @param {HTMLElement|jQuery|String} content - The new content.
	    	 */
	    	Owl.prototype.replace = function(content) {
	    		this.$stage.empty();
	    		this._items = [];
	
	    		if (content) {
	    			content = (content instanceof jQuery) ? content : $(content);
	    		}
	
	    		if (this.settings.nestedItemSelector) {
	    			content = content.find('.' + this.settings.nestedItemSelector);
	    		}
	
	    		content.filter(function() {
	    			return this.nodeType === 1;
	    		}).each($.proxy(function(index, item) {
	    			item = this.prepare(item);
	    			this.$stage.append(item);
	    			this._items.push(item);
	    			this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
	    		}, this));
	
	    		this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);
	
	    		this.invalidate('items');
	    	};
	
	    	/**
	    	 * Adds an item.
	    	 * @todo Use `item` instead of `content` for the event arguments.
	    	 * @public
	    	 * @param {HTMLElement|jQuery|String} content - The item content to add.
	    	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
	    	 */
	    	Owl.prototype.add = function(content, position) {
	    		var current = this.relative(this._current);
	
	    		position = position === undefined ? this._items.length : this.normalize(position, true);
	    		content = content instanceof jQuery ? content : $(content);
	
	    		this.trigger('add', { content: content, position: position });
	
	    		content = this.prepare(content);
	
	    		if (this._items.length === 0 || position === this._items.length) {
	    			this._items.length === 0 && this.$stage.append(content);
	    			this._items.length !== 0 && this._items[position - 1].after(content);
	    			this._items.push(content);
	    			this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
	    		} else {
	    			this._items[position].before(content);
	    			this._items.splice(position, 0, content);
	    			this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
	    		}
	
	    		this._items[current] && this.reset(this._items[current].index());
	
	    		this.invalidate('items');
	
	    		this.trigger('added', { content: content, position: position });
	    	};
	
	    	/**
	    	 * Removes an item by its position.
	    	 * @todo Use `item` instead of `content` for the event arguments.
	    	 * @public
	    	 * @param {Number} position - The relative position of the item to remove.
	    	 */
	    	Owl.prototype.remove = function(position) {
	    		position = this.normalize(position, true);
	
	    		if (position === undefined) {
	    			return;
	    		}
	
	    		this.trigger('remove', { content: this._items[position], position: position });
	
	    		this._items[position].remove();
	    		this._items.splice(position, 1);
	    		this._mergers.splice(position, 1);
	
	    		this.invalidate('items');
	
	    		this.trigger('removed', { content: null, position: position });
	    	};
	
	    	/**
	    	 * Preloads images with auto width.
	    	 * @todo Replace by a more generic approach
	    	 * @protected
	    	 */
	    	Owl.prototype.preloadAutoWidthImages = function(images) {
	    		images.each($.proxy(function(i, element) {
	    			this.enter('pre-loading');
	    			element = $(element);
	    			$(new Image()).one('load', $.proxy(function(e) {
	    				element.attr('src', e.target.src);
	    				element.css('opacity', 1);
	    				this.leave('pre-loading');
	    				!this.is('pre-loading') && !this.is('initializing') && this.refresh();
	    			}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
	    		}, this));
	    	};
	
	    	/**
	    	 * Destroys the carousel.
	    	 * @public
	    	 */
	    	Owl.prototype.destroy = function() {
	
	    		this.$element.off('.owl.core');
	    		this.$stage.off('.owl.core');
	    		$(document).off('.owl.core');
	
	    		if (this.settings.responsive !== false) {
	    			window.clearTimeout(this.resizeTimer);
	    			this.off(window, 'resize', this._handlers.onThrottledResize);
	    		}
	
	    		for (var i in this._plugins) {
	    			this._plugins[i].destroy();
	    		}
	
	    		this.$stage.children('.cloned').remove();
	
	    		this.$stage.unwrap();
	    		this.$stage.children().contents().unwrap();
	    		this.$stage.children().unwrap();
	    		this.$stage.remove();
	    		this.$element
	    			.removeClass(this.options.refreshClass)
	    			.removeClass(this.options.loadingClass)
	    			.removeClass(this.options.loadedClass)
	    			.removeClass(this.options.rtlClass)
	    			.removeClass(this.options.dragClass)
	    			.removeClass(this.options.grabClass)
	    			.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
	    			.removeData('owl.carousel');
	    	};
	
	    	/**
	    	 * Operators to calculate right-to-left and left-to-right.
	    	 * @protected
	    	 * @param {Number} [a] - The left side operand.
	    	 * @param {String} [o] - The operator.
	    	 * @param {Number} [b] - The right side operand.
	    	 */
	    	Owl.prototype.op = function(a, o, b) {
	    		var rtl = this.settings.rtl;
	    		switch (o) {
	    			case '<':
	    				return rtl ? a > b : a < b;
	    			case '>':
	    				return rtl ? a < b : a > b;
	    			case '>=':
	    				return rtl ? a <= b : a >= b;
	    			case '<=':
	    				return rtl ? a >= b : a <= b;
	    			default:
	    				break;
	    		}
	    	};
	
	    	/**
	    	 * Attaches to an internal event.
	    	 * @protected
	    	 * @param {HTMLElement} element - The event source.
	    	 * @param {String} event - The event name.
	    	 * @param {Function} listener - The event handler to attach.
	    	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
	    	 */
	    	Owl.prototype.on = function(element, event, listener, capture) {
	    		if (element.addEventListener) {
	    			element.addEventListener(event, listener, capture);
	    		} else if (element.attachEvent) {
	    			element.attachEvent('on' + event, listener);
	    		}
	    	};
	
	    	/**
	    	 * Detaches from an internal event.
	    	 * @protected
	    	 * @param {HTMLElement} element - The event source.
	    	 * @param {String} event - The event name.
	    	 * @param {Function} listener - The attached event handler to detach.
	    	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
	    	 */
	    	Owl.prototype.off = function(element, event, listener, capture) {
	    		if (element.removeEventListener) {
	    			element.removeEventListener(event, listener, capture);
	    		} else if (element.detachEvent) {
	    			element.detachEvent('on' + event, listener);
	    		}
	    	};
	
	    	/**
	    	 * Triggers a public event.
	    	 * @todo Remove `status`, `relatedTarget` should be used instead.
	    	 * @protected
	    	 * @param {String} name - The event name.
	    	 * @param {*} [data=null] - The event data.
	    	 * @param {String} [namespace=carousel] - The event namespace.
	    	 * @param {String} [state] - The state which is associated with the event.
	    	 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
	    	 * @returns {Event} - The event arguments.
	    	 */
	    	Owl.prototype.trigger = function(name, data, namespace, state, enter) {
	    		var status = {
	    			item: { count: this._items.length, index: this.current() }
	    		}, handler = $.camelCase(
	    			$.grep([ 'on', name, namespace ], function(v) { return v })
	    				.join('-').toLowerCase()
	    		), event = $.Event(
	    			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
	    			$.extend({ relatedTarget: this }, status, data)
	    		);
	
	    		if (!this._supress[name]) {
	    			$.each(this._plugins, function(name, plugin) {
	    				if (plugin.onTrigger) {
	    					plugin.onTrigger(event);
	    				}
	    			});
	
	    			this.register({ type: Owl.Type.Event, name: name });
	    			this.$element.trigger(event);
	
	    			if (this.settings && typeof this.settings[handler] === 'function') {
	    				this.settings[handler].call(this, event);
	    			}
	    		}
	
	    		return event;
	    	};
	
	    	/**
	    	 * Enters a state.
	    	 * @param name - The state name.
	    	 */
	    	Owl.prototype.enter = function(name) {
	    		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
	    			if (this._states.current[name] === undefined) {
	    				this._states.current[name] = 0;
	    			}
	
	    			this._states.current[name]++;
	    		}, this));
	    	};
	
	    	/**
	    	 * Leaves a state.
	    	 * @param name - The state name.
	    	 */
	    	Owl.prototype.leave = function(name) {
	    		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
	    			this._states.current[name]--;
	    		}, this));
	    	};
	
	    	/**
	    	 * Registers an event or state.
	    	 * @public
	    	 * @param {Object} object - The event or state to register.
	    	 */
	    	Owl.prototype.register = function(object) {
	    		if (object.type === Owl.Type.Event) {
	    			if (!$.event.special[object.name]) {
	    				$.event.special[object.name] = {};
	    			}
	
	    			if (!$.event.special[object.name].owl) {
	    				var _default = $.event.special[object.name]._default;
	    				$.event.special[object.name]._default = function(e) {
	    					if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
	    						return _default.apply(this, arguments);
	    					}
	    					return e.namespace && e.namespace.indexOf('owl') > -1;
	    				};
	    				$.event.special[object.name].owl = true;
	    			}
	    		} else if (object.type === Owl.Type.State) {
	    			if (!this._states.tags[object.name]) {
	    				this._states.tags[object.name] = object.tags;
	    			} else {
	    				this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
	    			}
	
	    			this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
	    				return $.inArray(tag, this._states.tags[object.name]) === i;
	    			}, this));
	    		}
	    	};
	
	    	/**
	    	 * Suppresses events.
	    	 * @protected
	    	 * @param {Array.<String>} events - The events to suppress.
	    	 */
	    	Owl.prototype.suppress = function(events) {
	    		$.each(events, $.proxy(function(index, event) {
	    			this._supress[event] = true;
	    		}, this));
	    	};
	
	    	/**
	    	 * Releases suppressed events.
	    	 * @protected
	    	 * @param {Array.<String>} events - The events to release.
	    	 */
	    	Owl.prototype.release = function(events) {
	    		$.each(events, $.proxy(function(index, event) {
	    			delete this._supress[event];
	    		}, this));
	    	};
	
	    	/**
	    	 * Gets unified pointer coordinates from event.
	    	 * @todo #261
	    	 * @protected
	    	 * @param {Event} - The `mousedown` or `touchstart` event.
	    	 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
	    	 */
	    	Owl.prototype.pointer = function(event) {
	    		var result = { x: null, y: null };
	
	    		event = event.originalEvent || event || window.event;
	
	    		event = event.touches && event.touches.length ?
	    			event.touches[0] : event.changedTouches && event.changedTouches.length ?
	    				event.changedTouches[0] : event;
	
	    		if (event.pageX) {
	    			result.x = event.pageX;
	    			result.y = event.pageY;
	    		} else {
	    			result.x = event.clientX;
	    			result.y = event.clientY;
	    		}
	
	    		return result;
	    	};
	
	    	/**
	    	 * Determines if the input is a Number or something that can be coerced to a Number
	    	 * @protected
	    	 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
	    	 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
	    	 */
	    	Owl.prototype.isNumeric = function(number) {
	    		return !isNaN(parseFloat(number));
	    	};
	
	    	/**
	    	 * Gets the difference of two vectors.
	    	 * @todo #261
	    	 * @protected
	    	 * @param {Object} - The first vector.
	    	 * @param {Object} - The second vector.
	    	 * @returns {Object} - The difference.
	    	 */
	    	Owl.prototype.difference = function(first, second) {
	    		return {
	    			x: first.x - second.x,
	    			y: first.y - second.y
	    		};
	    	};
	
	    	/**
	    	 * The jQuery Plugin for the Owl Carousel
	    	 * @todo Navigation plugin `next` and `prev`
	    	 * @public
	    	 */
	    	$.fn.owlCarousel = function(option) {
	    		var args = Array.prototype.slice.call(arguments, 1);
	
	    		return this.each(function() {
	    			var $this = $(this),
	    				data = $this.data('owl.carousel');
	
	    			if (!data) {
	    				data = new Owl(this, typeof option == 'object' && option);
	    				$this.data('owl.carousel', data);
	
	    				$.each([
	    					'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
	    				], function(i, event) {
	    					data.register({ type: Owl.Type.Event, name: event });
	    					data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
	    						if (e.namespace && e.relatedTarget !== this) {
	    							this.suppress([ event ]);
	    							data[event].apply(this, [].slice.call(arguments, 1));
	    							this.release([ event ]);
	    						}
	    					}, data));
	    				});
	    			}
	
	    			if (typeof option == 'string' && option.charAt(0) !== '_') {
	    				data[option].apply(data, args);
	    			}
	    		});
	    	};
	
	    	/**
	    	 * The constructor for the jQuery Plugin
	    	 * @public
	    	 */
	    	$.fn.owlCarousel.Constructor = Owl;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the auto refresh plugin.
	    	 * @class The Auto Refresh Plugin
	    	 * @param {Owl} carousel - The Owl Carousel
	    	 */
	    	var AutoRefresh = function(carousel) {
	    		/**
	    		 * Reference to the core.
	    		 * @protected
	    		 * @type {Owl}
	    		 */
	    		this._core = carousel;
	
	    		/**
	    		 * Refresh interval.
	    		 * @protected
	    		 * @type {number}
	    		 */
	    		this._interval = null;
	
	    		/**
	    		 * Whether the element is currently visible or not.
	    		 * @protected
	    		 * @type {Boolean}
	    		 */
	    		this._visible = null;
	
	    		/**
	    		 * All event handlers.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._handlers = {
	    			'initialized.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.autoRefresh) {
	    					this.watch();
	    				}
	    			}, this)
	    		};
	
	    		// set default options
	    		this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);
	
	    		// register event handlers
	    		this._core.$element.on(this._handlers);
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 */
	    	AutoRefresh.Defaults = {
	    		autoRefresh: true,
	    		autoRefreshInterval: 500
	    	};
	
	    	/**
	    	 * Watches the element.
	    	 */
	    	AutoRefresh.prototype.watch = function() {
	    		if (this._interval) {
	    			return;
	    		}
	
	    		this._visible = this._core.isVisible();
	    		this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
	    	};
	
	    	/**
	    	 * Refreshes the element.
	    	 */
	    	AutoRefresh.prototype.refresh = function() {
	    		if (this._core.isVisible() === this._visible) {
	    			return;
	    		}
	
	    		this._visible = !this._visible;
	
	    		this._core.$element.toggleClass('owl-hidden', !this._visible);
	
	    		this._visible && (this._core.invalidate('width') && this._core.refresh());
	    	};
	
	    	/**
	    	 * Destroys the plugin.
	    	 */
	    	AutoRefresh.prototype.destroy = function() {
	    		var handler, property;
	
	    		window.clearInterval(this._interval);
	
	    		for (handler in this._handlers) {
	    			this._core.$element.off(handler, this._handlers[handler]);
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] != 'function' && (this[property] = null);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the lazy plugin.
	    	 * @class The Lazy Plugin
	    	 * @param {Owl} carousel - The Owl Carousel
	    	 */
	    	var Lazy = function(carousel) {
	
	    		/**
	    		 * Reference to the core.
	    		 * @protected
	    		 * @type {Owl}
	    		 */
	    		this._core = carousel;
	
	    		/**
	    		 * Already loaded items.
	    		 * @protected
	    		 * @type {Array.<jQuery>}
	    		 */
	    		this._loaded = [];
	
	    		/**
	    		 * Event handlers.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._handlers = {
	    			'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
	    				if (!e.namespace) {
	    					return;
	    				}
	
	    				if (!this._core.settings || !this._core.settings.lazyLoad) {
	    					return;
	    				}
	
	    				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
	    					var settings = this._core.settings,
	    						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
	    						i = ((settings.center && n * -1) || 0),
	    						position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
	    						clones = this._core.clones().length,
	    						load = $.proxy(function(i, v) { this.load(v); }, this);
	    					//TODO: Need documentation for this new option
	    					if (settings.lazyLoadEager > 0) {
	    						n += settings.lazyLoadEager;
	    						// If the carousel is looping also preload images that are to the "left"
	    						if (settings.loop) {
	                  position -= settings.lazyLoadEager;
	                  n++;
	                }
	    					}
	
	    					while (i++ < n) {
	    						this.load(clones / 2 + this._core.relative(position));
	    						clones && $.each(this._core.clones(this._core.relative(position)), load);
	    						position++;
	    					}
	    				}
	    			}, this)
	    		};
	
	    		// set the default options
	    		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);
	
	    		// register event handler
	    		this._core.$element.on(this._handlers);
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 */
	    	Lazy.Defaults = {
	    		lazyLoad: false,
	    		lazyLoadEager: 0
	    	};
	
	    	/**
	    	 * Loads all resources of an item at the specified position.
	    	 * @param {Number} position - The absolute position of the item.
	    	 * @protected
	    	 */
	    	Lazy.prototype.load = function(position) {
	    		var $item = this._core.$stage.children().eq(position),
	    			$elements = $item && $item.find('.owl-lazy');
	
	    		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
	    			return;
	    		}
	
	    		$elements.each($.proxy(function(index, element) {
	    			var $element = $(element), image,
	                    url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');
	
	    			this._core.trigger('load', { element: $element, url: url }, 'lazy');
	
	    			if ($element.is('img')) {
	    				$element.one('load.owl.lazy', $.proxy(function() {
	    					$element.css('opacity', 1);
	    					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
	    				}, this)).attr('src', url);
	                } else if ($element.is('source')) {
	                    $element.one('load.owl.lazy', $.proxy(function() {
	                        this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
	                    }, this)).attr('srcset', url);
	    			} else {
	    				image = new Image();
	    				image.onload = $.proxy(function() {
	    					$element.css({
	    						'background-image': 'url("' + url + '")',
	    						'opacity': '1'
	    					});
	    					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
	    				}, this);
	    				image.src = url;
	    			}
	    		}, this));
	
	    		this._loaded.push($item.get(0));
	    	};
	
	    	/**
	    	 * Destroys the plugin.
	    	 * @public
	    	 */
	    	Lazy.prototype.destroy = function() {
	    		var handler, property;
	
	    		for (handler in this.handlers) {
	    			this._core.$element.off(handler, this.handlers[handler]);
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] != 'function' && (this[property] = null);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the auto height plugin.
	    	 * @class The Auto Height Plugin
	    	 * @param {Owl} carousel - The Owl Carousel
	    	 */
	    	var AutoHeight = function(carousel) {
	    		/**
	    		 * Reference to the core.
	    		 * @protected
	    		 * @type {Owl}
	    		 */
	    		this._core = carousel;
	
	    		this._previousHeight = null;
	
	    		/**
	    		 * All event handlers.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._handlers = {
	    			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.autoHeight) {
	    					this.update();
	    				}
	    			}, this),
	    			'changed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
	    					this.update();
	    				}
	    			}, this),
	    			'loaded.owl.lazy': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.autoHeight
	    					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
	    					this.update();
	    				}
	    			}, this)
	    		};
	
	    		// set default options
	    		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);
	
	    		// register event handlers
	    		this._core.$element.on(this._handlers);
	    		this._intervalId = null;
	    		var refThis = this;
	
	    		// These changes have been taken from a PR by gavrochelegnou proposed in #1575
	    		// and have been made compatible with the latest jQuery version
	    		$(window).on('load', function() {
	    			if (refThis._core.settings.autoHeight) {
	    				refThis.update();
	    			}
	    		});
	
	    		// Autoresize the height of the carousel when window is resized
	    		// When carousel has images, the height is dependent on the width
	    		// and should also change on resize
	    		$(window).resize(function() {
	    			if (refThis._core.settings.autoHeight) {
	    				if (refThis._intervalId != null) {
	    					clearTimeout(refThis._intervalId);
	    				}
	
	    				refThis._intervalId = setTimeout(function() {
	    					refThis.update();
	    				}, 250);
	    			}
	    		});
	
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 */
	    	AutoHeight.Defaults = {
	    		autoHeight: false,
	    		autoHeightClass: 'owl-height'
	    	};
	
	    	/**
	    	 * Updates the view.
	    	 */
	    	AutoHeight.prototype.update = function() {
	    		var start = this._core._current,
	    			end = start + this._core.settings.items,
	    			lazyLoadEnabled = this._core.settings.lazyLoad,
	    			visible = this._core.$stage.children().toArray().slice(start, end),
	    			heights = [],
	    			maxheight = 0;
	
	    		$.each(visible, function(index, item) {
	    			heights.push($(item).height());
	    		});
	
	    		maxheight = Math.max.apply(null, heights);
	
	    		if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
	    			maxheight = this._previousHeight;
	    		}
	
	    		this._previousHeight = maxheight;
	
	    		this._core.$stage.parent()
	    			.height(maxheight)
	    			.addClass(this._core.settings.autoHeightClass);
	    	};
	
	    	AutoHeight.prototype.destroy = function() {
	    		var handler, property;
	
	    		for (handler in this._handlers) {
	    			this._core.$element.off(handler, this._handlers[handler]);
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] !== 'function' && (this[property] = null);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the video plugin.
	    	 * @class The Video Plugin
	    	 * @param {Owl} carousel - The Owl Carousel
	    	 */
	    	var Video = function(carousel) {
	    		/**
	    		 * Reference to the core.
	    		 * @protected
	    		 * @type {Owl}
	    		 */
	    		this._core = carousel;
	
	    		/**
	    		 * Cache all video URLs.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._videos = {};
	
	    		/**
	    		 * Current playing item.
	    		 * @protected
	    		 * @type {jQuery}
	    		 */
	    		this._playing = null;
	
	    		/**
	    		 * All event handlers.
	    		 * @todo The cloned content removale is too late
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._handlers = {
	    			'initialized.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace) {
	    					this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
	    				}
	    			}, this),
	    			'resize.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
	    					e.preventDefault();
	    				}
	    			}, this),
	    			'refreshed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.is('resizing')) {
	    					this._core.$stage.find('.cloned .owl-video-frame').remove();
	    				}
	    			}, this),
	    			'changed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && e.property.name === 'position' && this._playing) {
	    					this.stop();
	    				}
	    			}, this),
	    			'prepared.owl.carousel': $.proxy(function(e) {
	    				if (!e.namespace) {
	    					return;
	    				}
	
	    				var $element = $(e.content).find('.owl-video');
	
	    				if ($element.length) {
	    					$element.css('display', 'none');
	    					this.fetch($element, $(e.content));
	    				}
	    			}, this)
	    		};
	
	    		// set default options
	    		this._core.options = $.extend({}, Video.Defaults, this._core.options);
	
	    		// register event handlers
	    		this._core.$element.on(this._handlers);
	
	    		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
	    			this.play(e);
	    		}, this));
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 */
	    	Video.Defaults = {
	    		video: false,
	    		videoHeight: false,
	    		videoWidth: false
	    	};
	
	    	/**
	    	 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
	    	 * @protected
	    	 * @param {jQuery} target - The target containing the video data.
	    	 * @param {jQuery} item - The item containing the video.
	    	 */
	    	Video.prototype.fetch = function(target, item) {
	    			var type = (function() {
	    					if (target.attr('data-vimeo-id')) {
	    						return 'vimeo';
	    					} else if (target.attr('data-vzaar-id')) {
	    						return 'vzaar'
	    					} else {
	    						return 'youtube';
	    					}
	    				})(),
	    				id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
	    				width = target.attr('data-width') || this._core.settings.videoWidth,
	    				height = target.attr('data-height') || this._core.settings.videoHeight,
	    				url = target.attr('href');
	
	    		if (url) {
	
	    			/*
	    					Parses the id's out of the following urls (and probably more):
	    					https://www.youtube.com/watch?v=:id
	    					https://youtu.be/:id
	    					https://vimeo.com/:id
	    					https://vimeo.com/channels/:channel/:id
	    					https://vimeo.com/groups/:group/videos/:id
	    					https://app.vzaar.com/videos/:id
	
	    					Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
	    			*/
	
	    			id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
	
	    			if (id[3].indexOf('youtu') > -1) {
	    				type = 'youtube';
	    			} else if (id[3].indexOf('vimeo') > -1) {
	    				type = 'vimeo';
	    			} else if (id[3].indexOf('vzaar') > -1) {
	    				type = 'vzaar';
	    			} else {
	    				throw new Error('Video URL not supported.');
	    			}
	    			id = id[6];
	    		} else {
	    			throw new Error('Missing video URL.');
	    		}
	
	    		this._videos[url] = {
	    			type: type,
	    			id: id,
	    			width: width,
	    			height: height
	    		};
	
	    		item.attr('data-video', url);
	
	    		this.thumbnail(target, this._videos[url]);
	    	};
	
	    	/**
	    	 * Creates video thumbnail.
	    	 * @protected
	    	 * @param {jQuery} target - The target containing the video data.
	    	 * @param {Object} info - The video info object.
	    	 * @see `fetch`
	    	 */
	    	Video.prototype.thumbnail = function(target, video) {
	    		var tnLink,
	    			icon,
	    			path,
	    			dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
	    			customTn = target.find('img'),
	    			srcType = 'src',
	    			lazyClass = '',
	    			settings = this._core.settings,
	    			create = function(path) {
	    				icon = '<div class="owl-video-play-icon"></div>';
	
	    				if (settings.lazyLoad) {
	    					tnLink = $('<div/>',{
	    						"class": 'owl-video-tn ' + lazyClass,
	    						"srcType": path
	    					});
	    				} else {
	    					tnLink = $( '<div/>', {
	    						"class": "owl-video-tn",
	    						"style": 'opacity:1;background-image:url(' + path + ')'
	    					});
	    				}
	    				target.after(tnLink);
	    				target.after(icon);
	    			};
	
	    		// wrap video content into owl-video-wrapper div
	    		target.wrap( $( '<div/>', {
	    			"class": "owl-video-wrapper",
	    			"style": dimensions
	    		}));
	
	    		if (this._core.settings.lazyLoad) {
	    			srcType = 'data-src';
	    			lazyClass = 'owl-lazy';
	    		}
	
	    		// custom thumbnail
	    		if (customTn.length) {
	    			create(customTn.attr(srcType));
	    			customTn.remove();
	    			return false;
	    		}
	
	    		if (video.type === 'youtube') {
	    			path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
	    			create(path);
	    		} else if (video.type === 'vimeo') {
	    			$.ajax({
	    				type: 'GET',
	    				url: '//vimeo.com/api/v2/video/' + video.id + '.json',
	    				jsonp: 'callback',
	    				dataType: 'jsonp',
	    				success: function(data) {
	    					path = data[0].thumbnail_large;
	    					create(path);
	    				}
	    			});
	    		} else if (video.type === 'vzaar') {
	    			$.ajax({
	    				type: 'GET',
	    				url: '//vzaar.com/api/videos/' + video.id + '.json',
	    				jsonp: 'callback',
	    				dataType: 'jsonp',
	    				success: function(data) {
	    					path = data.framegrab_url;
	    					create(path);
	    				}
	    			});
	    		}
	    	};
	
	    	/**
	    	 * Stops the current video.
	    	 * @public
	    	 */
	    	Video.prototype.stop = function() {
	    		this._core.trigger('stop', null, 'video');
	    		this._playing.find('.owl-video-frame').remove();
	    		this._playing.removeClass('owl-video-playing');
	    		this._playing = null;
	    		this._core.leave('playing');
	    		this._core.trigger('stopped', null, 'video');
	    	};
	
	    	/**
	    	 * Starts the current video.
	    	 * @public
	    	 * @param {Event} event - The event arguments.
	    	 */
	    	Video.prototype.play = function(event) {
	    		var target = $(event.target),
	    			item = target.closest('.' + this._core.settings.itemClass),
	    			video = this._videos[item.attr('data-video')],
	    			width = video.width || '100%',
	    			height = video.height || this._core.$stage.height(),
	    			html,
	    			iframe;
	
	    		if (this._playing) {
	    			return;
	    		}
	
	    		this._core.enter('playing');
	    		this._core.trigger('play', null, 'video');
	
	    		item = this._core.items(this._core.relative(item.index()));
	
	    		this._core.reset(item.index());
	
	    		html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
	    		html.attr( 'height', height );
	    		html.attr( 'width', width );
	    		if (video.type === 'youtube') {
	    			html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
	    		} else if (video.type === 'vimeo') {
	    			html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
	    		} else if (video.type === 'vzaar') {
	    			html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
	    		}
	
	    		iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));
	
	    		this._playing = item.addClass('owl-video-playing');
	    	};
	
	    	/**
	    	 * Checks whether an video is currently in full screen mode or not.
	    	 * @todo Bad style because looks like a readonly method but changes members.
	    	 * @protected
	    	 * @returns {Boolean}
	    	 */
	    	Video.prototype.isInFullScreen = function() {
	    		var element = document.fullscreenElement || document.mozFullScreenElement ||
	    				document.webkitFullscreenElement;
	
	    		return element && $(element).parent().hasClass('owl-video-frame');
	    	};
	
	    	/**
	    	 * Destroys the plugin.
	    	 */
	    	Video.prototype.destroy = function() {
	    		var handler, property;
	
	    		this._core.$element.off('click.owl.video');
	
	    		for (handler in this._handlers) {
	    			this._core.$element.off(handler, this._handlers[handler]);
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] != 'function' && (this[property] = null);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.Video = Video;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the animate plugin.
	    	 * @class The Navigation Plugin
	    	 * @param {Owl} scope - The Owl Carousel
	    	 */
	    	var Animate = function(scope) {
	    		this.core = scope;
	    		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
	    		this.swapping = true;
	    		this.previous = undefined;
	    		this.next = undefined;
	
	    		this.handlers = {
	    			'change.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && e.property.name == 'position') {
	    					this.previous = this.core.current();
	    					this.next = e.property.value;
	    				}
	    			}, this),
	    			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace) {
	    					this.swapping = e.type == 'translated';
	    				}
	    			}, this),
	    			'translate.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
	    					this.swap();
	    				}
	    			}, this)
	    		};
	
	    		this.core.$element.on(this.handlers);
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 */
	    	Animate.Defaults = {
	    		animateOut: false,
	    		animateIn: false
	    	};
	
	    	/**
	    	 * Toggles the animation classes whenever an translations starts.
	    	 * @protected
	    	 * @returns {Boolean|undefined}
	    	 */
	    	Animate.prototype.swap = function() {
	
	    		if (this.core.settings.items !== 1) {
	    			return;
	    		}
	
	    		if (!$.support.animation || !$.support.transition) {
	    			return;
	    		}
	
	    		this.core.speed(0);
	
	    		var left,
	    			clear = $.proxy(this.clear, this),
	    			previous = this.core.$stage.children().eq(this.previous),
	    			next = this.core.$stage.children().eq(this.next),
	    			incoming = this.core.settings.animateIn,
	    			outgoing = this.core.settings.animateOut;
	
	    		if (this.core.current() === this.previous) {
	    			return;
	    		}
	
	    		if (outgoing) {
	    			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
	    			previous.one($.support.animation.end, clear)
	    				.css( { 'left': left + 'px' } )
	    				.addClass('animated owl-animated-out')
	    				.addClass(outgoing);
	    		}
	
	    		if (incoming) {
	    			next.one($.support.animation.end, clear)
	    				.addClass('animated owl-animated-in')
	    				.addClass(incoming);
	    		}
	    	};
	
	    	Animate.prototype.clear = function(e) {
	    		$(e.target).css( { 'left': '' } )
	    			.removeClass('animated owl-animated-out owl-animated-in')
	    			.removeClass(this.core.settings.animateIn)
	    			.removeClass(this.core.settings.animateOut);
	    		this.core.onTransitionEnd();
	    	};
	
	    	/**
	    	 * Destroys the plugin.
	    	 * @public
	    	 */
	    	Animate.prototype.destroy = function() {
	    		var handler, property;
	
	    		for (handler in this.handlers) {
	    			this.core.$element.off(handler, this.handlers[handler]);
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] != 'function' && (this[property] = null);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the autoplay plugin.
	    	 * @class The Autoplay Plugin
	    	 * @param {Owl} scope - The Owl Carousel
	    	 */
	    	var Autoplay = function(carousel) {
	    		/**
	    		 * Reference to the core.
	    		 * @protected
	    		 * @type {Owl}
	    		 */
	    		this._core = carousel;
	
	    		/**
	    		 * The autoplay timeout id.
	    		 * @type {Number}
	    		 */
	    		this._call = null;
	
	    		/**
	    		 * Depending on the state of the plugin, this variable contains either
	    		 * the start time of the timer or the current timer value if it's
	    		 * paused. Since we start in a paused state we initialize the timer
	    		 * value.
	    		 * @type {Number}
	    		 */
	    		this._time = 0;
	
	    		/**
	    		 * Stores the timeout currently used.
	    		 * @type {Number}
	    		 */
	    		this._timeout = 0;
	
	    		/**
	    		 * Indicates whenever the autoplay is paused.
	    		 * @type {Boolean}
	    		 */
	    		this._paused = true;
	
	    		/**
	    		 * All event handlers.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._handlers = {
	    			'changed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && e.property.name === 'settings') {
	    					if (this._core.settings.autoplay) {
	    						this.play();
	    					} else {
	    						this.stop();
	    					}
	    				} else if (e.namespace && e.property.name === 'position' && this._paused) {
	    					// Reset the timer. This code is triggered when the position
	    					// of the carousel was changed through user interaction.
	    					this._time = 0;
	    				}
	    			}, this),
	    			'initialized.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.autoplay) {
	    					this.play();
	    				}
	    			}, this),
	    			'play.owl.autoplay': $.proxy(function(e, t, s) {
	    				if (e.namespace) {
	    					this.play(t, s);
	    				}
	    			}, this),
	    			'stop.owl.autoplay': $.proxy(function(e) {
	    				if (e.namespace) {
	    					this.stop();
	    				}
	    			}, this),
	    			'mouseover.owl.autoplay': $.proxy(function() {
	    				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
	    					this.pause();
	    				}
	    			}, this),
	    			'mouseleave.owl.autoplay': $.proxy(function() {
	    				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
	    					this.play();
	    				}
	    			}, this),
	    			'touchstart.owl.core': $.proxy(function() {
	    				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
	    					this.pause();
	    				}
	    			}, this),
	    			'touchend.owl.core': $.proxy(function() {
	    				if (this._core.settings.autoplayHoverPause) {
	    					this.play();
	    				}
	    			}, this)
	    		};
	
	    		// register event handlers
	    		this._core.$element.on(this._handlers);
	
	    		// set default options
	    		this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 */
	    	Autoplay.Defaults = {
	    		autoplay: false,
	    		autoplayTimeout: 5000,
	    		autoplayHoverPause: false,
	    		autoplaySpeed: false
	    	};
	
	    	/**
	    	 * Transition to the next slide and set a timeout for the next transition.
	    	 * @private
	    	 * @param {Number} [speed] - The animation speed for the animations.
	    	 */
	    	Autoplay.prototype._next = function(speed) {
	    		this._call = window.setTimeout(
	    			$.proxy(this._next, this, speed),
	    			this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
	    		);
	
	    		if (this._core.is('interacting') || document.hidden) {
	    			return;
	    		}
	    		this._core.next(speed || this._core.settings.autoplaySpeed);
	    	};
	
	    	/**
	    	 * Reads the current timer value when the timer is playing.
	    	 * @public
	    	 */
	    	Autoplay.prototype.read = function() {
	    		return new Date().getTime() - this._time;
	    	};
	
	    	/**
	    	 * Starts the autoplay.
	    	 * @public
	    	 * @param {Number} [timeout] - The interval before the next animation starts.
	    	 * @param {Number} [speed] - The animation speed for the animations.
	    	 */
	    	Autoplay.prototype.play = function(timeout, speed) {
	    		var elapsed;
	
	    		if (!this._core.is('rotating')) {
	    			this._core.enter('rotating');
	    		}
	
	    		timeout = timeout || this._core.settings.autoplayTimeout;
	
	    		// Calculate the elapsed time since the last transition. If the carousel
	    		// wasn't playing this calculation will yield zero.
	    		elapsed = Math.min(this._time % (this._timeout || timeout), timeout);
	
	    		if (this._paused) {
	    			// Start the clock.
	    			this._time = this.read();
	    			this._paused = false;
	    		} else {
	    			// Clear the active timeout to allow replacement.
	    			window.clearTimeout(this._call);
	    		}
	
	    		// Adjust the origin of the timer to match the new timeout value.
	    		this._time += this.read() % timeout - elapsed;
	
	    		this._timeout = timeout;
	    		this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
	    	};
	
	    	/**
	    	 * Stops the autoplay.
	    	 * @public
	    	 */
	    	Autoplay.prototype.stop = function() {
	    		if (this._core.is('rotating')) {
	    			// Reset the clock.
	    			this._time = 0;
	    			this._paused = true;
	
	    			window.clearTimeout(this._call);
	    			this._core.leave('rotating');
	    		}
	    	};
	
	    	/**
	    	 * Pauses the autoplay.
	    	 * @public
	    	 */
	    	Autoplay.prototype.pause = function() {
	    		if (this._core.is('rotating') && !this._paused) {
	    			// Pause the clock.
	    			this._time = this.read();
	    			this._paused = true;
	
	    			window.clearTimeout(this._call);
	    		}
	    	};
	
	    	/**
	    	 * Destroys the plugin.
	    	 */
	    	Autoplay.prototype.destroy = function() {
	    		var handler, property;
	
	    		this.stop();
	
	    		for (handler in this._handlers) {
	    			this._core.$element.off(handler, this._handlers[handler]);
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] != 'function' && (this[property] = null);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the navigation plugin.
	    	 * @class The Navigation Plugin
	    	 * @param {Owl} carousel - The Owl Carousel.
	    	 */
	    	var Navigation = function(carousel) {
	    		/**
	    		 * Reference to the core.
	    		 * @protected
	    		 * @type {Owl}
	    		 */
	    		this._core = carousel;
	
	    		/**
	    		 * Indicates whether the plugin is initialized or not.
	    		 * @protected
	    		 * @type {Boolean}
	    		 */
	    		this._initialized = false;
	
	    		/**
	    		 * The current paging indexes.
	    		 * @protected
	    		 * @type {Array}
	    		 */
	    		this._pages = [];
	
	    		/**
	    		 * All DOM elements of the user interface.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._controls = {};
	
	    		/**
	    		 * Markup for an indicator.
	    		 * @protected
	    		 * @type {Array.<String>}
	    		 */
	    		this._templates = [];
	
	    		/**
	    		 * The carousel element.
	    		 * @type {jQuery}
	    		 */
	    		this.$element = this._core.$element;
	
	    		/**
	    		 * Overridden methods of the carousel.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._overrides = {
	    			next: this._core.next,
	    			prev: this._core.prev,
	    			to: this._core.to
	    		};
	
	    		/**
	    		 * All event handlers.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._handlers = {
	    			'prepared.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.dotsData) {
	    					this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
	    						$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
	    				}
	    			}, this),
	    			'added.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.dotsData) {
	    					this._templates.splice(e.position, 0, this._templates.pop());
	    				}
	    			}, this),
	    			'remove.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.dotsData) {
	    					this._templates.splice(e.position, 1);
	    				}
	    			}, this),
	    			'changed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && e.property.name == 'position') {
	    					this.draw();
	    				}
	    			}, this),
	    			'initialized.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && !this._initialized) {
	    					this._core.trigger('initialize', null, 'navigation');
	    					this.initialize();
	    					this.update();
	    					this.draw();
	    					this._initialized = true;
	    					this._core.trigger('initialized', null, 'navigation');
	    				}
	    			}, this),
	    			'refreshed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._initialized) {
	    					this._core.trigger('refresh', null, 'navigation');
	    					this.update();
	    					this.draw();
	    					this._core.trigger('refreshed', null, 'navigation');
	    				}
	    			}, this)
	    		};
	
	    		// set default options
	    		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);
	
	    		// register event handlers
	    		this.$element.on(this._handlers);
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 * @todo Rename `slideBy` to `navBy`
	    	 */
	    	Navigation.Defaults = {
	    		nav: false,
	    		navText: [
	    			'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
	    			'<span aria-label="' + 'Next' + '">&#x203a;</span>'
	    		],
	    		navSpeed: false,
	    		navElement: 'button type="button" role="presentation"',
	    		navContainer: false,
	    		navContainerClass: 'owl-nav',
	    		navClass: [
	    			'owl-prev',
	    			'owl-next'
	    		],
	    		slideBy: 1,
	    		dotClass: 'owl-dot',
	    		dotsClass: 'owl-dots',
	    		dots: true,
	    		dotsEach: false,
	    		dotsData: false,
	    		dotsSpeed: false,
	    		dotsContainer: false
	    	};
	
	    	/**
	    	 * Initializes the layout of the plugin and extends the carousel.
	    	 * @protected
	    	 */
	    	Navigation.prototype.initialize = function() {
	    		var override,
	    			settings = this._core.settings;
	
	    		// create DOM structure for relative navigation
	    		this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
	    			: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');
	
	    		this._controls.$previous = $('<' + settings.navElement + '>')
	    			.addClass(settings.navClass[0])
	    			.html(settings.navText[0])
	    			.prependTo(this._controls.$relative)
	    			.on('click', $.proxy(function(e) {
	    				this.prev(settings.navSpeed);
	    			}, this));
	    		this._controls.$next = $('<' + settings.navElement + '>')
	    			.addClass(settings.navClass[1])
	    			.html(settings.navText[1])
	    			.appendTo(this._controls.$relative)
	    			.on('click', $.proxy(function(e) {
	    				this.next(settings.navSpeed);
	    			}, this));
	
	    		// create DOM structure for absolute navigation
	    		if (!settings.dotsData) {
	    			this._templates = [ $('<button role="button">')
	    				.addClass(settings.dotClass)
	    				.append($('<span>'))
	    				.prop('outerHTML') ];
	    		}
	
	    		this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
	    			: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');
	
	    		this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
	    			var index = $(e.target).parent().is(this._controls.$absolute)
	    				? $(e.target).index() : $(e.target).parent().index();
	
	    			e.preventDefault();
	
	    			this.to(index, settings.dotsSpeed);
	    		}, this));
	
	    		/*$el.on('focusin', function() {
	    			$(document).off(".carousel");
	
	    			$(document).on('keydown.carousel', function(e) {
	    				if(e.keyCode == 37) {
	    					$el.trigger('prev.owl')
	    				}
	    				if(e.keyCode == 39) {
	    					$el.trigger('next.owl')
	    				}
	    			});
	    		});*/
	
	    		// override public methods of the carousel
	    		for (override in this._overrides) {
	    			this._core[override] = $.proxy(this[override], this);
	    		}
	    	};
	
	    	/**
	    	 * Destroys the plugin.
	    	 * @protected
	    	 */
	    	Navigation.prototype.destroy = function() {
	    		var handler, control, property, override, settings;
	    		settings = this._core.settings;
	
	    		for (handler in this._handlers) {
	    			this.$element.off(handler, this._handlers[handler]);
	    		}
	    		for (control in this._controls) {
	    			if (control === '$relative' && settings.navContainer) {
	    				this._controls[control].html('');
	    			} else {
	    				this._controls[control].remove();
	    			}
	    		}
	    		for (override in this.overides) {
	    			this._core[override] = this._overrides[override];
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] != 'function' && (this[property] = null);
	    		}
	    	};
	
	    	/**
	    	 * Updates the internal state.
	    	 * @protected
	    	 */
	    	Navigation.prototype.update = function() {
	    		var i, j, k,
	    			lower = this._core.clones().length / 2,
	    			upper = lower + this._core.items().length,
	    			maximum = this._core.maximum(true),
	    			settings = this._core.settings,
	    			size = settings.center || settings.autoWidth || settings.dotsData
	    				? 1 : settings.dotsEach || settings.items;
	
	    		if (settings.slideBy !== 'page') {
	    			settings.slideBy = Math.min(settings.slideBy, settings.items);
	    		}
	
	    		if (settings.dots || settings.slideBy == 'page') {
	    			this._pages = [];
	
	    			for (i = lower, j = 0, k = 0; i < upper; i++) {
	    				if (j >= size || j === 0) {
	    					this._pages.push({
	    						start: Math.min(maximum, i - lower),
	    						end: i - lower + size - 1
	    					});
	    					if (Math.min(maximum, i - lower) === maximum) {
	    						break;
	    					}
	    					j = 0, ++k;
	    				}
	    				j += this._core.mergers(this._core.relative(i));
	    			}
	    		}
	    	};
	
	    	/**
	    	 * Draws the user interface.
	    	 * @todo The option `dotsData` wont work.
	    	 * @protected
	    	 */
	    	Navigation.prototype.draw = function() {
	    		var difference,
	    			settings = this._core.settings,
	    			disabled = this._core.items().length <= settings.items,
	    			index = this._core.relative(this._core.current()),
	    			loop = settings.loop || settings.rewind;
	
	    		this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);
	
	    		if (settings.nav) {
	    			this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
	    			this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
	    		}
	
	    		this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);
	
	    		if (settings.dots) {
	    			difference = this._pages.length - this._controls.$absolute.children().length;
	
	    			if (settings.dotsData && difference !== 0) {
	    				this._controls.$absolute.html(this._templates.join(''));
	    			} else if (difference > 0) {
	    				this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
	    			} else if (difference < 0) {
	    				this._controls.$absolute.children().slice(difference).remove();
	    			}
	
	    			this._controls.$absolute.find('.active').removeClass('active');
	    			this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
	    		}
	    	};
	
	    	/**
	    	 * Extends event data.
	    	 * @protected
	    	 * @param {Event} event - The event object which gets thrown.
	    	 */
	    	Navigation.prototype.onTrigger = function(event) {
	    		var settings = this._core.settings;
	
	    		event.page = {
	    			index: $.inArray(this.current(), this._pages),
	    			count: this._pages.length,
	    			size: settings && (settings.center || settings.autoWidth || settings.dotsData
	    				? 1 : settings.dotsEach || settings.items)
	    		};
	    	};
	
	    	/**
	    	 * Gets the current page position of the carousel.
	    	 * @protected
	    	 * @returns {Number}
	    	 */
	    	Navigation.prototype.current = function() {
	    		var current = this._core.relative(this._core.current());
	    		return $.grep(this._pages, $.proxy(function(page, index) {
	    			return page.start <= current && page.end >= current;
	    		}, this)).pop();
	    	};
	
	    	/**
	    	 * Gets the current succesor/predecessor position.
	    	 * @protected
	    	 * @returns {Number}
	    	 */
	    	Navigation.prototype.getPosition = function(successor) {
	    		var position, length,
	    			settings = this._core.settings;
	
	    		if (settings.slideBy == 'page') {
	    			position = $.inArray(this.current(), this._pages);
	    			length = this._pages.length;
	    			successor ? ++position : --position;
	    			position = this._pages[((position % length) + length) % length].start;
	    		} else {
	    			position = this._core.relative(this._core.current());
	    			length = this._core.items().length;
	    			successor ? position += settings.slideBy : position -= settings.slideBy;
	    		}
	
	    		return position;
	    	};
	
	    	/**
	    	 * Slides to the next item or page.
	    	 * @public
	    	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	    	 */
	    	Navigation.prototype.next = function(speed) {
	    		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
	    	};
	
	    	/**
	    	 * Slides to the previous item or page.
	    	 * @public
	    	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	    	 */
	    	Navigation.prototype.prev = function(speed) {
	    		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
	    	};
	
	    	/**
	    	 * Slides to the specified item or page.
	    	 * @public
	    	 * @param {Number} position - The position of the item or page.
	    	 * @param {Number} [speed] - The time in milliseconds for the transition.
	    	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
	    	 */
	    	Navigation.prototype.to = function(position, speed, standard) {
	    		var length;
	
	    		if (!standard && this._pages.length) {
	    			length = this._pages.length;
	    			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
	    		} else {
	    			$.proxy(this._overrides.to, this._core)(position, speed);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	/**
	    	 * Creates the hash plugin.
	    	 * @class The Hash Plugin
	    	 * @param {Owl} carousel - The Owl Carousel
	    	 */
	    	var Hash = function(carousel) {
	    		/**
	    		 * Reference to the core.
	    		 * @protected
	    		 * @type {Owl}
	    		 */
	    		this._core = carousel;
	
	    		/**
	    		 * Hash index for the items.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._hashes = {};
	
	    		/**
	    		 * The carousel element.
	    		 * @type {jQuery}
	    		 */
	    		this.$element = this._core.$element;
	
	    		/**
	    		 * All event handlers.
	    		 * @protected
	    		 * @type {Object}
	    		 */
	    		this._handlers = {
	    			'initialized.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && this._core.settings.startPosition === 'URLHash') {
	    					$(window).trigger('hashchange.owl.navigation');
	    				}
	    			}, this),
	    			'prepared.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace) {
	    					var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');
	
	    					if (!hash) {
	    						return;
	    					}
	
	    					this._hashes[hash] = e.content;
	    				}
	    			}, this),
	    			'changed.owl.carousel': $.proxy(function(e) {
	    				if (e.namespace && e.property.name === 'position') {
	    					var current = this._core.items(this._core.relative(this._core.current())),
	    						hash = $.map(this._hashes, function(item, hash) {
	    							return item === current ? hash : null;
	    						}).join();
	
	    					if (!hash || window.location.hash.slice(1) === hash) {
	    						return;
	    					}
	
	    					window.location.hash = hash;
	    				}
	    			}, this)
	    		};
	
	    		// set default options
	    		this._core.options = $.extend({}, Hash.Defaults, this._core.options);
	
	    		// register the event handlers
	    		this.$element.on(this._handlers);
	
	    		// register event listener for hash navigation
	    		$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
	    			var hash = window.location.hash.substring(1),
	    				items = this._core.$stage.children(),
	    				position = this._hashes[hash] && items.index(this._hashes[hash]);
	
	    			if (position === undefined || position === this._core.current()) {
	    				return;
	    			}
	
	    			this._core.to(this._core.relative(position), false, true);
	    		}, this));
	    	};
	
	    	/**
	    	 * Default options.
	    	 * @public
	    	 */
	    	Hash.Defaults = {
	    		URLhashListener: false
	    	};
	
	    	/**
	    	 * Destroys the plugin.
	    	 * @public
	    	 */
	    	Hash.prototype.destroy = function() {
	    		var handler, property;
	
	    		$(window).off('hashchange.owl.navigation');
	
	    		for (handler in this._handlers) {
	    			this._core.$element.off(handler, this._handlers[handler]);
	    		}
	    		for (property in Object.getOwnPropertyNames(this)) {
	    			typeof this[property] != 'function' && (this[property] = null);
	    		}
	    	};
	
	    	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;
	
	    })(window.Zepto || window.jQuery, window, document);
	    (function($, window, document, undefined) {
	
	    	var style = $('<support>').get(0).style,
	    		prefixes = 'Webkit Moz O ms'.split(' '),
	    		events = {
	    			transition: {
	    				end: {
	    					WebkitTransition: 'webkitTransitionEnd',
	    					MozTransition: 'transitionend',
	    					OTransition: 'oTransitionEnd',
	    					transition: 'transitionend'
	    				}
	    			},
	    			animation: {
	    				end: {
	    					WebkitAnimation: 'webkitAnimationEnd',
	    					MozAnimation: 'animationend',
	    					OAnimation: 'oAnimationEnd',
	    					animation: 'animationend'
	    				}
	    			}
	    		},
	    		tests = {
	    			csstransforms: function() {
	    				return !!test('transform');
	    			},
	    			csstransforms3d: function() {
	    				return !!test('perspective');
	    			},
	    			csstransitions: function() {
	    				return !!test('transition');
	    			},
	    			cssanimations: function() {
	    				return !!test('animation');
	    			}
	    		};
	
	    	function test(property, prefixed) {
	    		var result = false,
	    			upper = property.charAt(0).toUpperCase() + property.slice(1);
	
	    		$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
	    			if (style[property] !== undefined) {
	    				result = prefixed ? property : true;
	    				return false;
	    			}
	    		});
	
	    		return result;
	    	}
	
	    	function prefixed(property) {
	    		return test(property, true);
	    	}
	
	    	if (tests.csstransitions()) {
	    		/* jshint -W053 */
	    		$.support.transition = new String(prefixed('transition'));
	    		$.support.transition.end = events.transition.end[ $.support.transition ];
	    	}
	
	    	if (tests.cssanimations()) {
	    		/* jshint -W053 */
	    		$.support.animation = new String(prefixed('animation'));
	    		$.support.animation.end = events.animation.end[ $.support.animation ];
	    	}
	
	    	if (tests.csstransforms()) {
	    		/* jshint -W053 */
	    		$.support.transform = new String(prefixed('transform'));
	    		$.support.transform3d = tests.csstransforms3d();
	    	}
	
	    })(window.Zepto || window.jQuery, window, document);
	
	    var $ = window.jQuery;
	    var ReactOwlCarousel = /** @class */ (function (_super) {
	        __extends(ReactOwlCarousel, _super);
	        function ReactOwlCarousel(props) {
	            var _this = _super.call(this, props) || this;
	            _this.containerRef = function (inst) {
	                _this.container = inst;
	            };
	            var _a = filterOptions(_this.props), options = _a[0], propsWithoutOptions = _a[1];
	            _this.options = options;
	            _this.propsWithoutOptions = propsWithoutOptions;
	            return _this;
	        }
	        ReactOwlCarousel.prototype.componentDidMount = function () {
	            this.$ele = $(this.container);
	            this.create();
	        };
	        ReactOwlCarousel.prototype.componentWillReceiveProps = function () {
	            this.destory();
	        };
	        ReactOwlCarousel.prototype.componentDidUpdate = function () {
	            var _a = filterOptions(this.props), options = _a[0], propsWithoutOptions = _a[1];
	            this.options = options;
	            this.propsWithoutOptions = propsWithoutOptions;
	            this.create();
	        };
	        ReactOwlCarousel.prototype.next = function (speed) {
	            if (!this.$ele)
	                throw new Error('OwlCarousel is not created');
	            if (typeof speed === 'number') {
	                this.$ele.trigger('next.owl.carousel', [speed]);
	            }
	            else {
	                this.$ele.trigger('next.owl.carousel', speed);
	            }
	        };
	        ReactOwlCarousel.prototype.prev = function (speed) {
	            if (!this.$ele)
	                throw new Error('OwlCarousel is not created');
	            if (typeof speed === 'number') {
	                this.$ele.trigger('prev.owl.carousel', [speed]);
	            }
	            else {
	                this.$ele.trigger('prev.owl.carousel', speed);
	            }
	        };
	        ReactOwlCarousel.prototype.to = function (position, speed) {
	            if (!this.$ele)
	                throw new Error('OwlCarousel is not created');
	            if (typeof position === 'number' && typeof speed === 'number') {
	                this.$ele.trigger('to.owl.carousel', [position, speed]);
	            }
	            else {
	                this.$ele.trigger('to.owl.carousel');
	            }
	        };
	        ReactOwlCarousel.prototype.create = function (options) {
	            if (!this.$ele)
	                throw new Error('OwlCarousel is not created');
	            this.$ele.owlCarousel(options || this.options);
	        };
	        ReactOwlCarousel.prototype.destory = function () {
	            if (!this.$ele)
	                throw new Error('OwlCarousel is not created');
	            this.$ele.trigger('destroy.owl.carousel');
	        };
	        ReactOwlCarousel.prototype.play = function (timeout, speed) {
	            if (!this.$ele)
	                throw new Error('OwlCarousel is not created');
	            if (typeof timeout === 'number' && typeof speed === 'number') {
	                this.$ele.trigger('play.owl.autoplay', [timeout, speed]);
	            }
	            else {
	                this.$ele.trigger('play.owl.autoplay');
	            }
	        };
	        ReactOwlCarousel.prototype.stop = function () {
	            if (!this.$ele)
	                throw new Error('OwlCarousel is not created');
	            this.$ele.trigger('stop.owl.autoplay');
	        };
	        ReactOwlCarousel.prototype.render = function () {
	            var _a = this.propsWithoutOptions, className = _a.className, props = __rest(_a, ["className"]);
	            return (React__default.createElement("div", __assign({ className: "owl-carousel " + className, ref: this.containerRef }, props)));
	        };
	        return ReactOwlCarousel;
	    }(React.Component));
	    var OPTIONS = new Set([
	        'items',
	        'margin',
	        'loop',
	        'center',
	        'mouseDrag',
	        'touchDrag',
	        'pullDrag',
	        'freeDrag',
	        'stagePadding',
	        'merge',
	        'mergeFit',
	        'autoWidth',
	        'startPosition',
	        'URLhashListener',
	        'nav',
	        'rewind',
	        'navText',
	        'navElement',
	        'slideBy',
	        'dots',
	        'dotsEach',
	        'dotData',
	        'lazyLoad',
	        'lazyContent',
	        'autoplay',
	        'autoplayTimeout',
	        'autoplayHoverPause',
	        'smartSpeed',
	        'fluidSpeed',
	        'autoplaySpeed',
	        'navSpeed',
	        'dotsSpeed',
	        'dragEndSpeed',
	        'callbacks',
	        'responsive',
	        'responsiveRefreshRate',
	        'responsiveBaseElement',
	        'video',
	        'videoHeight',
	        'videoWidth',
	        'animateOut',
	        'animateIn',
	        'fallbackEasing',
	        'info',
	        'nestedItemSelector',
	        'itemElement',
	        'stageElement',
	        'navContainer',
	        'dotsContainer',
	        // 'CLASSES'
	        'refreshClass',
	        'loadingClass',
	        'loadedClass',
	        'rtlClass',
	        'dragClass',
	        'grabClass',
	        'stageClass',
	        'stageOuterClass',
	        'navContainerClass',
	        'navClass',
	        'controlsClass',
	        'dotClass',
	        'dotsClass',
	        'autoHeightClass',
	        'responsiveClass',
	        // 'EVENTS'
	        'onInitialize',
	        'onInitialized',
	        'onResize',
	        'onResized',
	        'onRefresh',
	        'onRefreshed',
	        'onDrag',
	        'onDragged',
	        'onTranslate',
	        'onTranslated',
	        'onChange',
	        'onChanged',
	        'onLoadLazy',
	        'onLoadedLazy',
	        'onStopVideo',
	        'onPlayVideo',
	    ]);
	    function filterOptions(item) {
	        var options = {};
	        var propsWithoutOptions = {};
	        Object.keys(item).forEach(function (key) {
	            if (OPTIONS.has(key)) {
	                options[key] = item[key];
	            }
	            else {
	                propsWithoutOptions[key] = item[key];
	            }
	        });
	        return [options, propsWithoutOptions];
	    }
	
	    return ReactOwlCarousel;
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(174),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(44);__webpack_require__(3),__webpack_require__(19);var invariant=_interopDefault(__webpack_require__(26));function _extends(){return(_extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,r){e.prototype=Object.create(r.prototype),(e.prototype.constructor=e).__proto__=r}function _objectWithoutPropertiesLoose(e,r){if(null==e)return{};var t,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)t=a[o],0<=r.indexOf(t)||(n[t]=e[t]);return n}var BrowserRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,r){return"function"==typeof e?e(r):e},normalizeToLocation=function(e,r){return"string"==typeof e?history.createLocation(e,null,null,r):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,r){var t=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(r){try{n&&n(r)}catch(e){throw r.preventDefault(),e}r.defaultPrevented||0!==r.button||i&&"_self"!==i||isModifiedEvent(r)||(r.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&r||t,React.createElement("a",c)}),Link=forwardRef(function(e,a){var r=e.component,i=void 0===r?LinkAnchor:r,c=e.replace,f=e.to,u=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var t=r.history,e=normalizeToLocation(resolveToLocation(f,r.location),r.location),o=e?t.createHref(e):"",n=_extends({},s,{href:o,navigate:function(){var e=resolveToLocation(f,r.location);(c?t.replace:t.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||u:n.innerRef=u,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,r=new Array(e),t=0;t<e;t++)r[t]=arguments[t];return r.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var r=e["aria-current"],l=void 0===r?"page":r,t=e.activeClassName,p=void 0===t?"active":t,h=e.activeStyle,R=e.className,d=e.exact,v=e.isActive,y=e.location,m=e.strict,w=e.style,_=e.to,L=e.innerRef,x=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var r=y||e.location,t=normalizeToLocation(resolveToLocation(_,r),r),o=t.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(r.pathname,{path:n,exact:d,strict:m}):null,i=!!(v?v(a,r):a),c=i?joinClassnames(R,p):R,f=i?_extends({},w,{},h):w,u=_extends({"aria-current":i&&l||null,className:c,style:f,to:t},x);return forwardRefShim$1!==forwardRef$1?u.ref=s||L:u.innerRef=L,React.createElement(Link,u)})});Object.keys(reactRouter).forEach(function(e){"default"!==e&&Object.defineProperty(exports,e,{enumerable:!0,get:function(){return reactRouter[e]}})}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1));__webpack_require__(3);var history=__webpack_require__(44);__webpack_require__(19);var createContext=_interopDefault(__webpack_require__(127)),invariant=_interopDefault(__webpack_require__(26)),pathToRegexp=_interopDefault(__webpack_require__(128));__webpack_require__(23);var hoistStatics=_interopDefault(__webpack_require__(110));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(context).history}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){return t?matchPath(useLocation().pathname,t):useContext(context).match}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(173);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(130).enable();
	  window.Promise = __webpack_require__(129);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(201);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(2);


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var memoizeOne = _interopDefault(__webpack_require__(50));
	var core = __webpack_require__(20);
	var reactDom = __webpack_require__(4);
	var utils = __webpack_require__(25);
	var index = __webpack_require__(66);
	var _css = _interopDefault(__webpack_require__(12));
	
	var diacritics = [{
	  base: 'A',
	  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
	}, {
	  base: 'AA',
	  letters: /[\uA732]/g
	}, {
	  base: 'AE',
	  letters: /[\u00C6\u01FC\u01E2]/g
	}, {
	  base: 'AO',
	  letters: /[\uA734]/g
	}, {
	  base: 'AU',
	  letters: /[\uA736]/g
	}, {
	  base: 'AV',
	  letters: /[\uA738\uA73A]/g
	}, {
	  base: 'AY',
	  letters: /[\uA73C]/g
	}, {
	  base: 'B',
	  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
	}, {
	  base: 'C',
	  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
	}, {
	  base: 'D',
	  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
	}, {
	  base: 'DZ',
	  letters: /[\u01F1\u01C4]/g
	}, {
	  base: 'Dz',
	  letters: /[\u01F2\u01C5]/g
	}, {
	  base: 'E',
	  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
	}, {
	  base: 'F',
	  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
	}, {
	  base: 'G',
	  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
	}, {
	  base: 'H',
	  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
	}, {
	  base: 'I',
	  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
	}, {
	  base: 'J',
	  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
	}, {
	  base: 'K',
	  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
	}, {
	  base: 'L',
	  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
	}, {
	  base: 'LJ',
	  letters: /[\u01C7]/g
	}, {
	  base: 'Lj',
	  letters: /[\u01C8]/g
	}, {
	  base: 'M',
	  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
	}, {
	  base: 'N',
	  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
	}, {
	  base: 'NJ',
	  letters: /[\u01CA]/g
	}, {
	  base: 'Nj',
	  letters: /[\u01CB]/g
	}, {
	  base: 'O',
	  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
	}, {
	  base: 'OI',
	  letters: /[\u01A2]/g
	}, {
	  base: 'OO',
	  letters: /[\uA74E]/g
	}, {
	  base: 'OU',
	  letters: /[\u0222]/g
	}, {
	  base: 'P',
	  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
	}, {
	  base: 'Q',
	  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
	}, {
	  base: 'R',
	  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
	}, {
	  base: 'S',
	  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
	}, {
	  base: 'T',
	  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
	}, {
	  base: 'TZ',
	  letters: /[\uA728]/g
	}, {
	  base: 'U',
	  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
	}, {
	  base: 'V',
	  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
	}, {
	  base: 'VY',
	  letters: /[\uA760]/g
	}, {
	  base: 'W',
	  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
	}, {
	  base: 'X',
	  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
	}, {
	  base: 'Y',
	  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
	}, {
	  base: 'Z',
	  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
	}, {
	  base: 'a',
	  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
	}, {
	  base: 'aa',
	  letters: /[\uA733]/g
	}, {
	  base: 'ae',
	  letters: /[\u00E6\u01FD\u01E3]/g
	}, {
	  base: 'ao',
	  letters: /[\uA735]/g
	}, {
	  base: 'au',
	  letters: /[\uA737]/g
	}, {
	  base: 'av',
	  letters: /[\uA739\uA73B]/g
	}, {
	  base: 'ay',
	  letters: /[\uA73D]/g
	}, {
	  base: 'b',
	  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
	}, {
	  base: 'c',
	  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
	}, {
	  base: 'd',
	  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
	}, {
	  base: 'dz',
	  letters: /[\u01F3\u01C6]/g
	}, {
	  base: 'e',
	  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
	}, {
	  base: 'f',
	  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
	}, {
	  base: 'g',
	  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
	}, {
	  base: 'h',
	  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
	}, {
	  base: 'hv',
	  letters: /[\u0195]/g
	}, {
	  base: 'i',
	  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
	}, {
	  base: 'j',
	  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
	}, {
	  base: 'k',
	  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
	}, {
	  base: 'l',
	  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
	}, {
	  base: 'lj',
	  letters: /[\u01C9]/g
	}, {
	  base: 'm',
	  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
	}, {
	  base: 'n',
	  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
	}, {
	  base: 'nj',
	  letters: /[\u01CC]/g
	}, {
	  base: 'o',
	  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
	}, {
	  base: 'oi',
	  letters: /[\u01A3]/g
	}, {
	  base: 'ou',
	  letters: /[\u0223]/g
	}, {
	  base: 'oo',
	  letters: /[\uA74F]/g
	}, {
	  base: 'p',
	  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
	}, {
	  base: 'q',
	  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
	}, {
	  base: 'r',
	  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
	}, {
	  base: 's',
	  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
	}, {
	  base: 't',
	  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
	}, {
	  base: 'tz',
	  letters: /[\uA729]/g
	}, {
	  base: 'u',
	  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
	}, {
	  base: 'v',
	  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
	}, {
	  base: 'vy',
	  letters: /[\uA761]/g
	}, {
	  base: 'w',
	  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
	}, {
	  base: 'x',
	  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
	}, {
	  base: 'y',
	  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
	}, {
	  base: 'z',
	  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
	}];
	var stripDiacritics = function stripDiacritics(str) {
	  for (var i = 0; i < diacritics.length; i++) {
	    str = str.replace(diacritics[i].letters, diacritics[i].base);
	  }
	
	  return str;
	};
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var trimString = function trimString(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	var defaultStringify = function defaultStringify(option) {
	  return option.label + " " + option.value;
	};
	
	var createFilter = function createFilter(config) {
	  return function (option, rawInput) {
	    var _ignoreCase$ignoreAcc = _extends({
	      ignoreCase: true,
	      ignoreAccents: true,
	      stringify: defaultStringify,
	      trim: true,
	      matchFrom: 'any'
	    }, config),
	        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
	        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
	        stringify = _ignoreCase$ignoreAcc.stringify,
	        trim = _ignoreCase$ignoreAcc.trim,
	        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
	
	    var input = trim ? trimString(rawInput) : rawInput;
	    var candidate = trim ? trimString(stringify(option)) : stringify(option);
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	      candidate = candidate.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = stripDiacritics(input);
	      candidate = stripDiacritics(candidate);
	    }
	
	    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
	  };
	};
	
	function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
	
	var _ref =  true ? {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
	} : {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
	};
	
	var A11yText = function A11yText(props) {
	  return core.jsx("span", _extends$1({
	    css: _ref
	  }, props));
	};
	
	function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	function DummyInput(_ref) {
	  var inProp = _ref.in,
	      out = _ref.out,
	      onExited = _ref.onExited,
	      appear = _ref.appear,
	      enter = _ref.enter,
	      exit = _ref.exit,
	      innerRef = _ref.innerRef,
	      emotion = _ref.emotion,
	      props = _objectWithoutPropertiesLoose(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
	
	  return core.jsx("input", _extends$2({
	    ref: innerRef
	  }, props, {
	    css:
	    /*#__PURE__*/
	    _css({
	      label: 'dummyInput',
	      // get rid of any default styles
	      background: 0,
	      border: 0,
	      fontSize: 'inherit',
	      outline: 0,
	      padding: 0,
	      // important! without `width` browsers won't allow focus
	      width: 1,
	      // remove cursor on desktop
	      color: 'transparent',
	      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
	      left: -100,
	      opacity: 0,
	      position: 'relative',
	      transform: 'scale(0)'
	    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
	  }));
	}
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var NodeResolver =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(NodeResolver, _Component);
	
	  function NodeResolver() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NodeResolver.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.props.innerRef(reactDom.findDOMNode(this));
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.props.innerRef(null);
	  };
	
	  _proto.render = function render() {
	    return this.props.children;
	  };
	
	  return NodeResolver;
	}(React.Component);
	
	var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
	var LOCK_STYLES = {
	  boxSizing: 'border-box',
	  // account for possible declaration `width: 100%;` on body
	  overflow: 'hidden',
	  position: 'relative',
	  height: '100%'
	};
	
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	} // `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	function _inheritsLoose$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	var canUseDOM = !!( window.document && window.document.createElement);
	var activeScrollLocks = 0;
	
	var ScrollLock =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose$1(ScrollLock, _Component);
	
	  function ScrollLock() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.originalStyles = {};
	    _this.listenerOptions = {
	      capture: false,
	      passive: false
	    };
	    return _this;
	  }
	
	  var _proto = ScrollLock.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if (!canUseDOM) return;
	    var _this$props = this.props,
	        accountForScrollbars = _this$props.accountForScrollbars,
	        touchScrollTarget = _this$props.touchScrollTarget;
	    var target = document.body;
	    var targetStyle = target && target.style;
	
	    if (accountForScrollbars) {
	      // store any styles already applied to the body
	      STYLE_KEYS.forEach(function (key) {
	        var val = targetStyle && targetStyle[key];
	        _this2.originalStyles[key] = val;
	      });
	    } // apply the lock styles and padding if this is the first scroll lock
	
	
	    if (accountForScrollbars && activeScrollLocks < 1) {
	      var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
	      var clientWidth = document.body ? document.body.clientWidth : 0;
	      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	      Object.keys(LOCK_STYLES).forEach(function (key) {
	        var val = LOCK_STYLES[key];
	
	        if (targetStyle) {
	          targetStyle[key] = val;
	        }
	      });
	
	      if (targetStyle) {
	        targetStyle.paddingRight = adjustedPadding + "px";
	      }
	    } // account for touch devices
	
	
	    if (target && isTouchDevice()) {
	      // Mobile Safari ignores { overflow: hidden } declaration on the body.
	      target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target
	
	      if (touchScrollTarget) {
	        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	        touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
	      }
	    } // increment active scroll locks
	
	
	    activeScrollLocks += 1;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var _this3 = this;
	
	    if (!canUseDOM) return;
	    var _this$props2 = this.props,
	        accountForScrollbars = _this$props2.accountForScrollbars,
	        touchScrollTarget = _this$props2.touchScrollTarget;
	    var target = document.body;
	    var targetStyle = target && target.style; // safely decrement active scroll locks
	
	    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
	
	    if (accountForScrollbars && activeScrollLocks < 1) {
	      STYLE_KEYS.forEach(function (key) {
	        var val = _this3.originalStyles[key];
	
	        if (targetStyle) {
	          targetStyle[key] = val;
	        }
	      });
	    } // remove touch listeners
	
	
	    if (target && isTouchDevice()) {
	      target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);
	
	      if (touchScrollTarget) {
	        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
	      }
	    }
	  };
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  return ScrollLock;
	}(React.Component);
	
	ScrollLock.defaultProps = {
	  accountForScrollbars: true
	};
	
	function _inheritsLoose$2(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _ref$1 =  true ? {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
	} : {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
	};
	
	// NOTE:
	// We shouldn't need this after updating to React v16.3.0, which introduces:
	// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
	// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
	var ScrollBlock =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inheritsLoose$2(ScrollBlock, _PureComponent);
	
	  function ScrollBlock() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
	    _this.state = {
	      touchScrollTarget: null
	    };
	
	    _this.getScrollTarget = function (ref) {
	      if (ref === _this.state.touchScrollTarget) return;
	
	      _this.setState({
	        touchScrollTarget: ref
	      });
	    };
	
	    _this.blurSelectInput = function () {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = ScrollBlock.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        isEnabled = _this$props.isEnabled;
	    var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
	
	    if (!isEnabled) return children;
	    /*
	     * Div
	     * ------------------------------
	     * blocks scrolling on non-body elements behind the menu
	      * NodeResolver
	     * ------------------------------
	     * we need a reference to the scrollable element to "unlock" scroll on
	     * mobile devices
	      * ScrollLock
	     * ------------------------------
	     * actually does the scroll locking
	     */
	
	    return core.jsx("div", null, core.jsx("div", {
	      onClick: this.blurSelectInput,
	      css: _ref$1
	    }), core.jsx(NodeResolver, {
	      innerRef: this.getScrollTarget
	    }, children), touchScrollTarget ? core.jsx(ScrollLock, {
	      touchScrollTarget: touchScrollTarget
	    }) : null);
	  };
	
	  return ScrollBlock;
	}(React.PureComponent);
	
	function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose$3(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var ScrollCaptor =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose$3(ScrollCaptor, _Component);
	
	  function ScrollCaptor() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.isBottom = false;
	    _this.isTop = false;
	    _this.scrollTarget = void 0;
	    _this.touchStart = void 0;
	
	    _this.cancelScroll = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    };
	
	    _this.handleEventDelta = function (event, delta) {
	      var _this$props = _this.props,
	          onBottomArrive = _this$props.onBottomArrive,
	          onBottomLeave = _this$props.onBottomLeave,
	          onTopArrive = _this$props.onTopArrive,
	          onTopLeave = _this$props.onTopLeave;
	      var _this$scrollTarget = _this.scrollTarget,
	          scrollTop = _this$scrollTarget.scrollTop,
	          scrollHeight = _this$scrollTarget.scrollHeight,
	          clientHeight = _this$scrollTarget.clientHeight;
	      var target = _this.scrollTarget;
	      var isDeltaPositive = delta > 0;
	      var availableScroll = scrollHeight - clientHeight - scrollTop;
	      var shouldCancelScroll = false; // reset bottom/top flags
	
	      if (availableScroll > delta && _this.isBottom) {
	        if (onBottomLeave) onBottomLeave(event);
	        _this.isBottom = false;
	      }
	
	      if (isDeltaPositive && _this.isTop) {
	        if (onTopLeave) onTopLeave(event);
	        _this.isTop = false;
	      } // bottom limit
	
	
	      if (isDeltaPositive && delta > availableScroll) {
	        if (onBottomArrive && !_this.isBottom) {
	          onBottomArrive(event);
	        }
	
	        target.scrollTop = scrollHeight;
	        shouldCancelScroll = true;
	        _this.isBottom = true; // top limit
	      } else if (!isDeltaPositive && -delta > scrollTop) {
	        if (onTopArrive && !_this.isTop) {
	          onTopArrive(event);
	        }
	
	        target.scrollTop = 0;
	        shouldCancelScroll = true;
	        _this.isTop = true;
	      } // cancel scroll
	
	
	      if (shouldCancelScroll) {
	        _this.cancelScroll(event);
	      }
	    };
	
	    _this.onWheel = function (event) {
	      _this.handleEventDelta(event, event.deltaY);
	    };
	
	    _this.onTouchStart = function (event) {
	      // set touch start so we can calculate touchmove delta
	      _this.touchStart = event.changedTouches[0].clientY;
	    };
	
	    _this.onTouchMove = function (event) {
	      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
	
	      _this.handleEventDelta(event, deltaY);
	    };
	
	    _this.getScrollTarget = function (ref) {
	      _this.scrollTarget = ref;
	    };
	
	    return _this;
	  }
	
	  var _proto = ScrollCaptor.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.startListening(this.scrollTarget);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.stopListening(this.scrollTarget);
	  };
	
	  _proto.startListening = function startListening(el) {
	    // bail early if no element is available to attach to
	    if (!el) return; // all the if statements are to appease Flow 😢
	
	    if (typeof el.addEventListener === 'function') {
	      el.addEventListener('wheel', this.onWheel, false);
	    }
	
	    if (typeof el.addEventListener === 'function') {
	      el.addEventListener('touchstart', this.onTouchStart, false);
	    }
	
	    if (typeof el.addEventListener === 'function') {
	      el.addEventListener('touchmove', this.onTouchMove, false);
	    }
	  };
	
	  _proto.stopListening = function stopListening(el) {
	    // all the if statements are to appease Flow 😢
	    if (typeof el.removeEventListener === 'function') {
	      el.removeEventListener('wheel', this.onWheel, false);
	    }
	
	    if (typeof el.removeEventListener === 'function') {
	      el.removeEventListener('touchstart', this.onTouchStart, false);
	    }
	
	    if (typeof el.removeEventListener === 'function') {
	      el.removeEventListener('touchmove', this.onTouchMove, false);
	    }
	  };
	
	  _proto.render = function render() {
	    return React__default.createElement(NodeResolver, {
	      innerRef: this.getScrollTarget
	    }, this.props.children);
	  };
	
	  return ScrollCaptor;
	}(React.Component);
	
	function ScrollCaptorSwitch(_ref) {
	  var _ref$isEnabled = _ref.isEnabled,
	      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
	      props = _objectWithoutPropertiesLoose$1(_ref, ["isEnabled"]);
	
	  return isEnabled ? React__default.createElement(ScrollCaptor, props) : props.children;
	}
	
	var instructionsAriaMessage = function instructionsAriaMessage(event, context) {
	  if (context === void 0) {
	    context = {};
	  }
	
	  var _context = context,
	      isSearchable = _context.isSearchable,
	      isMulti = _context.isMulti,
	      label = _context.label,
	      isDisabled = _context.isDisabled;
	
	  switch (event) {
	    case 'menu':
	      return "Use Up and Down to choose options" + (isDisabled ? '' : ', press Enter to select the currently focused option') + ", press Escape to exit the menu, press Tab to select the option and exit the menu.";
	
	    case 'input':
	      return (label ? label : 'Select') + " is focused " + (isSearchable ? ',type to refine list' : '') + ", press Down to open the menu, " + (isMulti ? ' press left to focus selected values' : '');
	
	    case 'value':
	      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
	  }
	};
	var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
	  var value = context.value,
	      isDisabled = context.isDisabled;
	  if (!value) return;
	
	  switch (event) {
	    case 'deselect-option':
	    case 'pop-value':
	    case 'remove-value':
	      return "option " + value + ", deselected.";
	
	    case 'select-option':
	      return isDisabled ? "option " + value + " is disabled. Select another option." : "option " + value + ", selected.";
	  }
	};
	var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
	  var focusedValue = _ref.focusedValue,
	      getOptionLabel = _ref.getOptionLabel,
	      selectValue = _ref.selectValue;
	  return "value " + getOptionLabel(focusedValue) + " focused, " + (selectValue.indexOf(focusedValue) + 1) + " of " + selectValue.length + ".";
	};
	var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
	  var focusedOption = _ref2.focusedOption,
	      getOptionLabel = _ref2.getOptionLabel,
	      options = _ref2.options;
	  return "option " + getOptionLabel(focusedOption) + " focused" + (focusedOption.isDisabled ? ' disabled' : '') + ", " + (options.indexOf(focusedOption) + 1) + " of " + options.length + ".";
	};
	var resultsAriaMessage = function resultsAriaMessage(_ref3) {
	  var inputValue = _ref3.inputValue,
	      screenReaderMessage = _ref3.screenReaderMessage;
	  return "" + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + ".";
	};
	
	var formatGroupLabel = function formatGroupLabel(group) {
	  return group.label;
	};
	var getOptionLabel = function getOptionLabel(option) {
	  return option.label;
	};
	var getOptionValue = function getOptionValue(option) {
	  return option.value;
	};
	var isOptionDisabled = function isOptionDisabled(option) {
	  return !!option.isDisabled;
	};
	
	function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
	var defaultStyles = {
	  clearIndicator: index.clearIndicatorCSS,
	  container: index.containerCSS,
	  control: index.css,
	  dropdownIndicator: index.dropdownIndicatorCSS,
	  group: index.groupCSS,
	  groupHeading: index.groupHeadingCSS,
	  indicatorsContainer: index.indicatorsContainerCSS,
	  indicatorSeparator: index.indicatorSeparatorCSS,
	  input: index.inputCSS,
	  loadingIndicator: index.loadingIndicatorCSS,
	  loadingMessage: index.loadingMessageCSS,
	  menu: index.menuCSS,
	  menuList: index.menuListCSS,
	  menuPortal: index.menuPortalCSS,
	  multiValue: index.multiValueCSS,
	  multiValueLabel: index.multiValueLabelCSS,
	  multiValueRemove: index.multiValueRemoveCSS,
	  noOptionsMessage: index.noOptionsMessageCSS,
	  option: index.optionCSS,
	  placeholder: index.placeholderCSS,
	  singleValue: index.css$1,
	  valueContainer: index.valueContainerCSS
	}; // Merge Utility
	// Allows consumers to extend a base Select with additional styles
	
	function mergeStyles(source, target) {
	  if (target === void 0) {
	    target = {};
	  }
	
	  // initialize with source styles
	  var styles = _extends$3({}, source); // massage in target styles
	
	
	  Object.keys(target).forEach(function (key) {
	    if (source[key]) {
	      styles[key] = function (rsCss, props) {
	        return target[key](source[key](rsCss, props), props);
	      };
	    } else {
	      styles[key] = target[key];
	    }
	  });
	  return styles;
	}
	
	var colors = {
	  primary: '#2684FF',
	  primary75: '#4C9AFF',
	  primary50: '#B2D4FF',
	  primary25: '#DEEBFF',
	  danger: '#DE350B',
	  dangerLight: '#FFBDAD',
	  neutral0: 'hsl(0, 0%, 100%)',
	  neutral5: 'hsl(0, 0%, 95%)',
	  neutral10: 'hsl(0, 0%, 90%)',
	  neutral20: 'hsl(0, 0%, 80%)',
	  neutral30: 'hsl(0, 0%, 70%)',
	  neutral40: 'hsl(0, 0%, 60%)',
	  neutral50: 'hsl(0, 0%, 50%)',
	  neutral60: 'hsl(0, 0%, 40%)',
	  neutral70: 'hsl(0, 0%, 30%)',
	  neutral80: 'hsl(0, 0%, 20%)',
	  neutral90: 'hsl(0, 0%, 10%)'
	};
	var borderRadius = 4; // Used to calculate consistent margin/padding on elements
	
	var baseUnit = 4; // The minimum height of the control
	
	var controlHeight = 38; // The amount of space between the control and menu */
	
	var menuGutter = baseUnit * 2;
	var spacing = {
	  baseUnit: baseUnit,
	  controlHeight: controlHeight,
	  menuGutter: menuGutter
	};
	var defaultTheme = {
	  borderRadius: borderRadius,
	  colors: colors,
	  spacing: spacing
	};
	
	function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
	
	function _inheritsLoose$4(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	var defaultProps = {
	  backspaceRemovesValue: true,
	  blurInputOnSelect: utils.isTouchCapable(),
	  captureMenuScroll: !utils.isTouchCapable(),
	  closeMenuOnSelect: true,
	  closeMenuOnScroll: false,
	  components: {},
	  controlShouldRenderValue: true,
	  escapeClearsValue: false,
	  filterOption: createFilter(),
	  formatGroupLabel: formatGroupLabel,
	  getOptionLabel: getOptionLabel,
	  getOptionValue: getOptionValue,
	  isDisabled: false,
	  isLoading: false,
	  isMulti: false,
	  isRtl: false,
	  isSearchable: true,
	  isOptionDisabled: isOptionDisabled,
	  loadingMessage: function loadingMessage() {
	    return 'Loading...';
	  },
	  maxMenuHeight: 300,
	  minMenuHeight: 140,
	  menuIsOpen: false,
	  menuPlacement: 'bottom',
	  menuPosition: 'absolute',
	  menuShouldBlockScroll: false,
	  menuShouldScrollIntoView: !utils.isMobileDevice(),
	  noOptionsMessage: function noOptionsMessage() {
	    return 'No options';
	  },
	  openMenuOnFocus: false,
	  openMenuOnClick: true,
	  options: [],
	  pageSize: 5,
	  placeholder: 'Select...',
	  screenReaderStatus: function screenReaderStatus(_ref) {
	    var count = _ref.count;
	    return count + " result" + (count !== 1 ? 's' : '') + " available";
	  },
	  styles: {},
	  tabIndex: '0',
	  tabSelectsValue: true
	};
	var instanceId = 1;
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose$4(Select, _Component);
	
	  // Misc. Instance Properties
	  // ------------------------------
	  // TODO
	  // Refs
	  // ------------------------------
	  // Lifecycle
	  // ------------------------------
	  function Select(_props) {
	    var _this;
	
	    _this = _Component.call(this, _props) || this;
	    _this.state = {
	      ariaLiveSelection: '',
	      ariaLiveContext: '',
	      focusedOption: null,
	      focusedValue: null,
	      inputIsHidden: false,
	      isFocused: false,
	      menuOptions: {
	        render: [],
	        focusable: []
	      },
	      selectValue: []
	    };
	    _this.blockOptionHover = false;
	    _this.isComposing = false;
	    _this.clearFocusValueOnUpdate = false;
	    _this.commonProps = void 0;
	    _this.components = void 0;
	    _this.hasGroups = false;
	    _this.initialTouchX = 0;
	    _this.initialTouchY = 0;
	    _this.inputIsHiddenAfterUpdate = void 0;
	    _this.instancePrefix = '';
	    _this.openAfterFocus = false;
	    _this.scrollToFocusedOptionOnUpdate = false;
	    _this.userIsDragging = void 0;
	    _this.controlRef = null;
	
	    _this.getControlRef = function (ref) {
	      _this.controlRef = ref;
	    };
	
	    _this.focusedOptionRef = null;
	
	    _this.getFocusedOptionRef = function (ref) {
	      _this.focusedOptionRef = ref;
	    };
	
	    _this.menuListRef = null;
	
	    _this.getMenuListRef = function (ref) {
	      _this.menuListRef = ref;
	    };
	
	    _this.inputRef = null;
	
	    _this.getInputRef = function (ref) {
	      _this.inputRef = ref;
	    };
	
	    _this.cacheComponents = function (components) {
	      _this.components = index.defaultComponents({
	        components: components
	      });
	    };
	
	    _this.focus = _this.focusInput;
	    _this.blur = _this.blurInput;
	
	    _this.onChange = function (newValue, actionMeta) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	      onChange(newValue, _extends$4({}, actionMeta, {
	        name: name
	      }));
	    };
	
	    _this.setValue = function (newValue, action, option) {
	      if (action === void 0) {
	        action = 'set-value';
	      }
	
	      var _this$props2 = _this.props,
	          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
	          isMulti = _this$props2.isMulti;
	
	      _this.onInputChange('', {
	        action: 'set-value'
	      });
	
	      if (closeMenuOnSelect) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } // when the select value should change, we should reset focusedValue
	
	
	      _this.clearFocusValueOnUpdate = true;
	
	      _this.onChange(newValue, {
	        action: action,
	        option: option
	      });
	    };
	
	    _this.selectOption = function (newValue) {
	      var _this$props3 = _this.props,
	          blurInputOnSelect = _this$props3.blurInputOnSelect,
	          isMulti = _this$props3.isMulti;
	      var selectValue = _this.state.selectValue;
	
	      if (isMulti) {
	        if (_this.isOptionSelected(newValue, selectValue)) {
	          var candidate = _this.getOptionValue(newValue);
	
	          _this.setValue(selectValue.filter(function (i) {
	            return _this.getOptionValue(i) !== candidate;
	          }), 'deselect-option', newValue);
	
	          _this.announceAriaLiveSelection({
	            event: 'deselect-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          if (!_this.isOptionDisabled(newValue, selectValue)) {
	            _this.setValue([].concat(selectValue, [newValue]), 'select-option', newValue);
	
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue)
	              }
	            });
	          } else {
	            // announce that option is disabled
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue),
	                isDisabled: true
	              }
	            });
	          }
	        }
	      } else {
	        if (!_this.isOptionDisabled(newValue, selectValue)) {
	          _this.setValue(newValue, 'select-option');
	
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          // announce that option is disabled
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue),
	              isDisabled: true
	            }
	          });
	        }
	      }
	
	      if (blurInputOnSelect) {
	        _this.blurInput();
	      }
	    };
	
	    _this.removeValue = function (removedValue) {
	      var selectValue = _this.state.selectValue;
	
	      var candidate = _this.getOptionValue(removedValue);
	
	      var newValue = selectValue.filter(function (i) {
	        return _this.getOptionValue(i) !== candidate;
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'remove-value',
	        removedValue: removedValue
	      });
	
	      _this.announceAriaLiveSelection({
	        event: 'remove-value',
	        context: {
	          value: removedValue ? _this.getOptionLabel(removedValue) : ''
	        }
	      });
	
	      _this.focusInput();
	    };
	
	    _this.clearValue = function () {
	      var isMulti = _this.props.isMulti;
	
	      _this.onChange(isMulti ? [] : null, {
	        action: 'clear'
	      });
	    };
	
	    _this.popValue = function () {
	      var selectValue = _this.state.selectValue;
	      var lastSelectedValue = selectValue[selectValue.length - 1];
	      var newValue = selectValue.slice(0, selectValue.length - 1);
	
	      _this.announceAriaLiveSelection({
	        event: 'pop-value',
	        context: {
	          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
	        }
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'pop-value',
	        removedValue: lastSelectedValue
	      });
	    };
	
	    _this.getOptionLabel = function (data) {
	      return _this.props.getOptionLabel(data);
	    };
	
	    _this.getOptionValue = function (data) {
	      return _this.props.getOptionValue(data);
	    };
	
	    _this.getStyles = function (key, props) {
	      var base = defaultStyles[key](props);
	      base.boxSizing = 'border-box';
	      var custom = _this.props.styles[key];
	      return custom ? custom(base, props) : base;
	    };
	
	    _this.getElementId = function (element) {
	      return _this.instancePrefix + "-" + element;
	    };
	
	    _this.getActiveDescendentId = function () {
	      var menuIsOpen = _this.props.menuIsOpen;
	      var _this$state = _this.state,
	          menuOptions = _this$state.menuOptions,
	          focusedOption = _this$state.focusedOption;
	      if (!focusedOption || !menuIsOpen) return undefined;
	      var index = menuOptions.focusable.indexOf(focusedOption);
	      var option = menuOptions.render[index];
	      return option && option.key;
	    };
	
	    _this.announceAriaLiveSelection = function (_ref2) {
	      var event = _ref2.event,
	          context = _ref2.context;
	
	      _this.setState({
	        ariaLiveSelection: valueEventAriaMessage(event, context)
	      });
	    };
	
	    _this.announceAriaLiveContext = function (_ref3) {
	      var event = _ref3.event,
	          context = _ref3.context;
	
	      _this.setState({
	        ariaLiveContext: instructionsAriaMessage(event, _extends$4({}, context, {
	          label: _this.props['aria-label']
	        }))
	      });
	    };
	
	    _this.onMenuMouseDown = function (event) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.stopPropagation();
	      event.preventDefault();
	
	      _this.focusInput();
	    };
	
	    _this.onMenuMouseMove = function (event) {
	      _this.blockOptionHover = false;
	    };
	
	    _this.onControlMouseDown = function (event) {
	      var openMenuOnClick = _this.props.openMenuOnClick;
	
	      if (!_this.state.isFocused) {
	        if (openMenuOnClick) {
	          _this.openAfterFocus = true;
	        }
	
	        _this.focusInput();
	      } else if (!_this.props.menuIsOpen) {
	        if (openMenuOnClick) {
	          _this.openMenu('first');
	        }
	      } else {
	        if ( // $FlowFixMe
	        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
	          _this.onMenuClose();
	        }
	      }
	
	      if ( // $FlowFixMe
	      event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
	        event.preventDefault();
	      }
	    };
	
	    _this.onDropdownIndicatorMouseDown = function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      if (_this.props.isDisabled) return;
	      var _this$props4 = _this.props,
	          isMulti = _this$props4.isMulti,
	          menuIsOpen = _this$props4.menuIsOpen;
	
	      _this.focusInput();
	
	      if (menuIsOpen) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } else {
	        _this.openMenu('first');
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	    };
	
	    _this.onClearIndicatorMouseDown = function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      _this.clearValue();
	
	      event.stopPropagation();
	      _this.openAfterFocus = false;
	
	      if (event.type === 'touchend') {
	        _this.focusInput();
	      } else {
	        setTimeout(function () {
	          return _this.focusInput();
	        });
	      }
	    };
	
	    _this.onScroll = function (event) {
	      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
	        if (event.target instanceof HTMLElement && utils.isDocumentElement(event.target)) {
	          _this.props.onMenuClose();
	        }
	      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
	        if (_this.props.closeMenuOnScroll(event)) {
	          _this.props.onMenuClose();
	        }
	      }
	    };
	
	    _this.onCompositionStart = function () {
	      _this.isComposing = true;
	    };
	
	    _this.onCompositionEnd = function () {
	      _this.isComposing = false;
	    };
	
	    _this.onTouchStart = function (_ref4) {
	      var touches = _ref4.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      _this.initialTouchX = touch.clientX;
	      _this.initialTouchY = touch.clientY;
	      _this.userIsDragging = false;
	    };
	
	    _this.onTouchMove = function (_ref5) {
	      var touches = _ref5.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
	      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
	      var moveThreshold = 5;
	      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
	    };
	
	    _this.onTouchEnd = function (event) {
	      if (_this.userIsDragging) return; // close the menu if the user taps outside
	      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
	      // on events on child elements, not the document (which we've attached this handler to).
	
	      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
	        _this.blurInput();
	      } // reset move vars
	
	
	      _this.initialTouchX = 0;
	      _this.initialTouchY = 0;
	    };
	
	    _this.onControlTouchEnd = function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onControlMouseDown(event);
	    };
	
	    _this.onClearIndicatorTouchEnd = function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onClearIndicatorMouseDown(event);
	    };
	
	    _this.onDropdownIndicatorTouchEnd = function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onDropdownIndicatorMouseDown(event);
	    };
	
	    _this.handleInputChange = function (event) {
	      var inputValue = event.currentTarget.value;
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.onInputChange(inputValue, {
	        action: 'input-change'
	      });
	
	      _this.onMenuOpen();
	    };
	
	    _this.onInputFocus = function (event) {
	      var _this$props5 = _this.props,
	          isSearchable = _this$props5.isSearchable,
	          isMulti = _this$props5.isMulti;
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	
	      _this.setState({
	        isFocused: true
	      });
	
	      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
	        _this.openMenu('first');
	      }
	
	      _this.openAfterFocus = false;
	    };
	
	    _this.onInputBlur = function (event) {
	      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
	        _this.inputRef.focus();
	
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      _this.onInputChange('', {
	        action: 'input-blur'
	      });
	
	      _this.onMenuClose();
	
	      _this.setState({
	        focusedValue: null,
	        isFocused: false
	      });
	    };
	
	    _this.onOptionHover = function (focusedOption) {
	      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
	        return;
	      }
	
	      _this.setState({
	        focusedOption: focusedOption
	      });
	    };
	
	    _this.shouldHideSelectedOptions = function () {
	      var _this$props6 = _this.props,
	          hideSelectedOptions = _this$props6.hideSelectedOptions,
	          isMulti = _this$props6.isMulti;
	      if (hideSelectedOptions === undefined) return isMulti;
	      return hideSelectedOptions;
	    };
	
	    _this.onKeyDown = function (event) {
	      var _this$props7 = _this.props,
	          isMulti = _this$props7.isMulti,
	          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
	          escapeClearsValue = _this$props7.escapeClearsValue,
	          inputValue = _this$props7.inputValue,
	          isClearable = _this$props7.isClearable,
	          isDisabled = _this$props7.isDisabled,
	          menuIsOpen = _this$props7.menuIsOpen,
	          onKeyDown = _this$props7.onKeyDown,
	          tabSelectsValue = _this$props7.tabSelectsValue,
	          openMenuOnFocus = _this$props7.openMenuOnFocus;
	      var _this$state2 = _this.state,
	          focusedOption = _this$state2.focusedOption,
	          focusedValue = _this$state2.focusedValue,
	          selectValue = _this$state2.selectValue;
	      if (isDisabled) return;
	
	      if (typeof onKeyDown === 'function') {
	        onKeyDown(event);
	
	        if (event.defaultPrevented) {
	          return;
	        }
	      } // Block option hover events when the user has just pressed a key
	
	
	      _this.blockOptionHover = true;
	
	      switch (event.key) {
	        case 'ArrowLeft':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('previous');
	
	          break;
	
	        case 'ArrowRight':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('next');
	
	          break;
	
	        case 'Delete':
	        case 'Backspace':
	          if (inputValue) return;
	
	          if (focusedValue) {
	            _this.removeValue(focusedValue);
	          } else {
	            if (!backspaceRemovesValue) return;
	
	            if (isMulti) {
	              _this.popValue();
	            } else if (isClearable) {
	              _this.clearValue();
	            }
	          }
	
	          break;
	
	        case 'Tab':
	          if (_this.isComposing) return;
	
	          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
	          // option is already selected; it breaks the flow of navigation
	          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
	            return;
	          }
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'Enter':
	          if (event.keyCode === 229) {
	            // ignore the keydown event from an Input Method Editor(IME)
	            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
	            break;
	          }
	
	          if (menuIsOpen) {
	            if (!focusedOption) return;
	            if (_this.isComposing) return;
	
	            _this.selectOption(focusedOption);
	
	            break;
	          }
	
	          return;
	
	        case 'Escape':
	          if (menuIsOpen) {
	            _this.inputIsHiddenAfterUpdate = false;
	
	            _this.onInputChange('', {
	              action: 'menu-close'
	            });
	
	            _this.onMenuClose();
	          } else if (isClearable && escapeClearsValue) {
	            _this.clearValue();
	          }
	
	          break;
	
	        case ' ':
	          // space
	          if (inputValue) {
	            return;
	          }
	
	          if (!menuIsOpen) {
	            _this.openMenu('first');
	
	            break;
	          }
	
	          if (!focusedOption) return;
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'ArrowUp':
	          if (menuIsOpen) {
	            _this.focusOption('up');
	          } else {
	            _this.openMenu('last');
	          }
	
	          break;
	
	        case 'ArrowDown':
	          if (menuIsOpen) {
	            _this.focusOption('down');
	          } else {
	            _this.openMenu('first');
	          }
	
	          break;
	
	        case 'PageUp':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pageup');
	
	          break;
	
	        case 'PageDown':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pagedown');
	
	          break;
	
	        case 'Home':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('first');
	
	          break;
	
	        case 'End':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('last');
	
	          break;
	
	        default:
	          return;
	      }
	
	      event.preventDefault();
	    };
	
	    _this.buildMenuOptions = function (props, selectValue) {
	      var _props$inputValue = props.inputValue,
	          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
	          options = props.options;
	
	      var toOption = function toOption(option, id) {
	        var isDisabled = _this.isOptionDisabled(option, selectValue);
	
	        var isSelected = _this.isOptionSelected(option, selectValue);
	
	        var label = _this.getOptionLabel(option);
	
	        var value = _this.getOptionValue(option);
	
	        if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
	          label: label,
	          value: value,
	          data: option
	        }, inputValue)) {
	          return;
	        }
	
	        var onHover = isDisabled ? undefined : function () {
	          return _this.onOptionHover(option);
	        };
	        var onSelect = isDisabled ? undefined : function () {
	          return _this.selectOption(option);
	        };
	        var optionId = _this.getElementId('option') + "-" + id;
	        return {
	          innerProps: {
	            id: optionId,
	            onClick: onSelect,
	            onMouseMove: onHover,
	            onMouseOver: onHover,
	            tabIndex: -1
	          },
	          data: option,
	          isDisabled: isDisabled,
	          isSelected: isSelected,
	          key: optionId,
	          label: label,
	          type: 'option',
	          value: value
	        };
	      };
	
	      return options.reduce(function (acc, item, itemIndex) {
	        if (item.options) {
	          // TODO needs a tidier implementation
	          if (!_this.hasGroups) _this.hasGroups = true;
	          var items = item.options;
	          var children = items.map(function (child, i) {
	            var option = toOption(child, itemIndex + "-" + i);
	            if (option) acc.focusable.push(child);
	            return option;
	          }).filter(Boolean);
	
	          if (children.length) {
	            var groupId = _this.getElementId('group') + "-" + itemIndex;
	            acc.render.push({
	              type: 'group',
	              key: groupId,
	              data: item,
	              options: children
	            });
	          }
	        } else {
	          var option = toOption(item, "" + itemIndex);
	
	          if (option) {
	            acc.render.push(option);
	            acc.focusable.push(item);
	          }
	        }
	
	        return acc;
	      }, {
	        render: [],
	        focusable: []
	      });
	    };
	
	    var _value = _props.value;
	    _this.cacheComponents = memoizeOne(_this.cacheComponents, index.exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    _this.cacheComponents(_props.components);
	
	    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
	
	    var _selectValue = utils.cleanValue(_value);
	
	    _this.buildMenuOptions = memoizeOne(_this.buildMenuOptions, function (newArgs, lastArgs) {
	      var _ref6 = newArgs,
	          newProps = _ref6[0],
	          newSelectValue = _ref6[1];
	      var _ref7 = lastArgs,
	          lastProps = _ref7[0],
	          lastSelectValue = _ref7[1];
	      return index.exportedEqual(newSelectValue, lastSelectValue) && index.exportedEqual(newProps.inputValue, lastProps.inputValue) && index.exportedEqual(newProps.options, lastProps.options);
	    }).bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
	      render: [],
	      focusable: []
	    };
	
	    _this.state.menuOptions = _menuOptions;
	    _this.state.selectValue = _selectValue;
	    return _this;
	  }
	
	  var _proto = Select.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.startListeningComposition();
	    this.startListeningToTouch();
	
	    if (this.props.closeMenuOnScroll && document && document.addEventListener) {
	      // Listen to all scroll events, and filter them out inside of 'onScroll'
	      document.addEventListener('scroll', this.onScroll, true);
	    }
	
	    if (this.props.autoFocus) {
	      this.focusInput();
	    }
	  };
	
	  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    var _this$props8 = this.props,
	        options = _this$props8.options,
	        value = _this$props8.value,
	        menuIsOpen = _this$props8.menuIsOpen,
	        inputValue = _this$props8.inputValue; // re-cache custom components
	
	    this.cacheComponents(nextProps.components); // rebuild the menu options
	
	    if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
	      var selectValue = utils.cleanValue(nextProps.value);
	      var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
	        render: [],
	        focusable: []
	      };
	      var focusedValue = this.getNextFocusedValue(selectValue);
	      var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
	      this.setState({
	        menuOptions: menuOptions,
	        selectValue: selectValue,
	        focusedOption: focusedOption,
	        focusedValue: focusedValue
	      });
	    } // some updates should toggle the state of the input visibility
	
	
	    if (this.inputIsHiddenAfterUpdate != null) {
	      this.setState({
	        inputIsHidden: this.inputIsHiddenAfterUpdate
	      });
	      delete this.inputIsHiddenAfterUpdate;
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this$props9 = this.props,
	        isDisabled = _this$props9.isDisabled,
	        menuIsOpen = _this$props9.menuIsOpen;
	    var isFocused = this.state.isFocused;
	
	    if ( // ensure focus is restored correctly when the control becomes enabled
	    isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
	    isFocused && menuIsOpen && !prevProps.menuIsOpen) {
	      this.focusInput();
	    } // scroll the focused option into view if necessary
	
	
	    if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
	      utils.scrollIntoView(this.menuListRef, this.focusedOptionRef);
	      this.scrollToFocusedOptionOnUpdate = false;
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.stopListeningComposition();
	    this.stopListeningToTouch();
	    document.removeEventListener('scroll', this.onScroll, true);
	  };
	
	  // ==============================
	  // Consumer Handlers
	  // ==============================
	  _proto.onMenuOpen = function onMenuOpen() {
	    this.props.onMenuOpen();
	  };
	
	  _proto.onMenuClose = function onMenuClose() {
	    var _this$props10 = this.props,
	        isSearchable = _this$props10.isSearchable,
	        isMulti = _this$props10.isMulti;
	    this.announceAriaLiveContext({
	      event: 'input',
	      context: {
	        isSearchable: isSearchable,
	        isMulti: isMulti
	      }
	    });
	    this.onInputChange('', {
	      action: 'menu-close'
	    });
	    this.props.onMenuClose();
	  };
	
	  _proto.onInputChange = function onInputChange(newValue, actionMeta) {
	    this.props.onInputChange(newValue, actionMeta);
	  } // ==============================
	  // Methods
	  // ==============================
	  ;
	
	  _proto.focusInput = function focusInput() {
	    if (!this.inputRef) return;
	    this.inputRef.focus();
	  };
	
	  _proto.blurInput = function blurInput() {
	    if (!this.inputRef) return;
	    this.inputRef.blur();
	  } // aliased for consumers
	  ;
	
	  _proto.openMenu = function openMenu(focusOption) {
	    var _this2 = this;
	
	    var _this$state3 = this.state,
	        selectValue = _this$state3.selectValue,
	        isFocused = _this$state3.isFocused;
	    var menuOptions = this.buildMenuOptions(this.props, selectValue);
	    var isMulti = this.props.isMulti;
	    var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
	
	    if (!isMulti) {
	      var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
	
	      if (selectedIndex > -1) {
	        openAtIndex = selectedIndex;
	      }
	    } // only scroll if the menu isn't already open
	
	
	    this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
	    this.inputIsHiddenAfterUpdate = false;
	    this.setState({
	      menuOptions: menuOptions,
	      focusedValue: null,
	      focusedOption: menuOptions.focusable[openAtIndex]
	    }, function () {
	      _this2.onMenuOpen();
	
	      _this2.announceAriaLiveContext({
	        event: 'menu'
	      });
	    });
	  };
	
	  _proto.focusValue = function focusValue(direction) {
	    var _this$props11 = this.props,
	        isMulti = _this$props11.isMulti,
	        isSearchable = _this$props11.isSearchable;
	    var _this$state4 = this.state,
	        selectValue = _this$state4.selectValue,
	        focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
	
	    if (!isMulti) return;
	    this.setState({
	      focusedOption: null
	    });
	    var focusedIndex = selectValue.indexOf(focusedValue);
	
	    if (!focusedValue) {
	      focusedIndex = -1;
	      this.announceAriaLiveContext({
	        event: 'value'
	      });
	    }
	
	    var lastIndex = selectValue.length - 1;
	    var nextFocus = -1;
	    if (!selectValue.length) return;
	
	    switch (direction) {
	      case 'previous':
	        if (focusedIndex === 0) {
	          // don't cycle from the start to the end
	          nextFocus = 0;
	        } else if (focusedIndex === -1) {
	          // if nothing is focused, focus the last value first
	          nextFocus = lastIndex;
	        } else {
	          nextFocus = focusedIndex - 1;
	        }
	
	        break;
	
	      case 'next':
	        if (focusedIndex > -1 && focusedIndex < lastIndex) {
	          nextFocus = focusedIndex + 1;
	        }
	
	        break;
	    }
	
	    if (nextFocus === -1) {
	      this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	    }
	
	    this.setState({
	      inputIsHidden: nextFocus !== -1,
	      focusedValue: selectValue[nextFocus]
	    });
	  };
	
	  _proto.focusOption = function focusOption(direction) {
	    if (direction === void 0) {
	      direction = 'first';
	    }
	
	    var pageSize = this.props.pageSize;
	    var _this$state5 = this.state,
	        focusedOption = _this$state5.focusedOption,
	        menuOptions = _this$state5.menuOptions;
	    var options = menuOptions.focusable;
	    if (!options.length) return;
	    var nextFocus = 0; // handles 'first'
	
	    var focusedIndex = options.indexOf(focusedOption);
	
	    if (!focusedOption) {
	      focusedIndex = -1;
	      this.announceAriaLiveContext({
	        event: 'menu'
	      });
	    }
	
	    if (direction === 'up') {
	      nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
	    } else if (direction === 'down') {
	      nextFocus = (focusedIndex + 1) % options.length;
	    } else if (direction === 'pageup') {
	      nextFocus = focusedIndex - pageSize;
	      if (nextFocus < 0) nextFocus = 0;
	    } else if (direction === 'pagedown') {
	      nextFocus = focusedIndex + pageSize;
	      if (nextFocus > options.length - 1) nextFocus = options.length - 1;
	    } else if (direction === 'last') {
	      nextFocus = options.length - 1;
	    }
	
	    this.scrollToFocusedOptionOnUpdate = true;
	    this.setState({
	      focusedOption: options[nextFocus],
	      focusedValue: null
	    });
	    this.announceAriaLiveContext({
	      event: 'menu',
	      context: {
	        isDisabled: isOptionDisabled(options[nextFocus])
	      }
	    });
	  };
	
	  // ==============================
	  // Getters
	  // ==============================
	  _proto.getTheme = function getTheme() {
	    // Use the default theme if there are no customizations.
	    if (!this.props.theme) {
	      return defaultTheme;
	    } // If the theme prop is a function, assume the function
	    // knows how to merge the passed-in default theme with
	    // its own modifications.
	
	
	    if (typeof this.props.theme === 'function') {
	      return this.props.theme(defaultTheme);
	    } // Otherwise, if a plain theme object was passed in,
	    // overlay it with the default theme.
	
	
	    return _extends$4({}, defaultTheme, this.props.theme);
	  };
	
	  _proto.getCommonProps = function getCommonProps() {
	    var clearValue = this.clearValue,
	        getStyles = this.getStyles,
	        setValue = this.setValue,
	        selectOption = this.selectOption,
	        props = this.props;
	    var classNamePrefix = props.classNamePrefix,
	        isMulti = props.isMulti,
	        isRtl = props.isRtl,
	        options = props.options;
	    var selectValue = this.state.selectValue;
	    var hasValue = this.hasValue();
	
	    var getValue = function getValue() {
	      return selectValue;
	    };
	
	    var cx = utils.classNames.bind(null, classNamePrefix);
	    return {
	      cx: cx,
	      clearValue: clearValue,
	      getStyles: getStyles,
	      getValue: getValue,
	      hasValue: hasValue,
	      isMulti: isMulti,
	      isRtl: isRtl,
	      options: options,
	      selectOption: selectOption,
	      setValue: setValue,
	      selectProps: props,
	      theme: this.getTheme()
	    };
	  };
	
	  _proto.getNextFocusedValue = function getNextFocusedValue(nextSelectValue) {
	    if (this.clearFocusValueOnUpdate) {
	      this.clearFocusValueOnUpdate = false;
	      return null;
	    }
	
	    var _this$state6 = this.state,
	        focusedValue = _this$state6.focusedValue,
	        lastSelectValue = _this$state6.selectValue;
	    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
	
	    if (lastFocusedIndex > -1) {
	      var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
	
	      if (nextFocusedIndex > -1) {
	        // the focused value is still in the selectValue, return it
	        return focusedValue;
	      } else if (lastFocusedIndex < nextSelectValue.length) {
	        // the focusedValue is not present in the next selectValue array by
	        // reference, so return the new value at the same index
	        return nextSelectValue[lastFocusedIndex];
	      }
	    }
	
	    return null;
	  };
	
	  _proto.getNextFocusedOption = function getNextFocusedOption(options) {
	    var lastFocusedOption = this.state.focusedOption;
	    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
	  };
	
	  _proto.hasValue = function hasValue() {
	    var selectValue = this.state.selectValue;
	    return selectValue.length > 0;
	  };
	
	  _proto.hasOptions = function hasOptions() {
	    return !!this.state.menuOptions.render.length;
	  };
	
	  _proto.countOptions = function countOptions() {
	    return this.state.menuOptions.focusable.length;
	  };
	
	  _proto.isClearable = function isClearable() {
	    var _this$props12 = this.props,
	        isClearable = _this$props12.isClearable,
	        isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
	    // multi select, by default, IS clearable
	
	    if (isClearable === undefined) return isMulti;
	    return isClearable;
	  };
	
	  _proto.isOptionDisabled = function isOptionDisabled(option, selectValue) {
	    return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
	  };
	
	  _proto.isOptionSelected = function isOptionSelected(option, selectValue) {
	    var _this3 = this;
	
	    if (selectValue.indexOf(option) > -1) return true;
	
	    if (typeof this.props.isOptionSelected === 'function') {
	      return this.props.isOptionSelected(option, selectValue);
	    }
	
	    var candidate = this.getOptionValue(option);
	    return selectValue.some(function (i) {
	      return _this3.getOptionValue(i) === candidate;
	    });
	  };
	
	  _proto.filterOption = function filterOption(option, inputValue) {
	    return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
	  };
	
	  _proto.formatOptionLabel = function formatOptionLabel(data, context) {
	    if (typeof this.props.formatOptionLabel === 'function') {
	      var inputValue = this.props.inputValue;
	      var selectValue = this.state.selectValue;
	      return this.props.formatOptionLabel(data, {
	        context: context,
	        inputValue: inputValue,
	        selectValue: selectValue
	      });
	    } else {
	      return this.getOptionLabel(data);
	    }
	  };
	
	  _proto.formatGroupLabel = function formatGroupLabel(data) {
	    return this.props.formatGroupLabel(data);
	  } // ==============================
	  // Mouse Handlers
	  // ==============================
	  ;
	
	  // ==============================
	  // Composition Handlers
	  // ==============================
	  _proto.startListeningComposition = function startListeningComposition() {
	    if (document && document.addEventListener) {
	      document.addEventListener('compositionstart', this.onCompositionStart, false);
	      document.addEventListener('compositionend', this.onCompositionEnd, false);
	    }
	  };
	
	  _proto.stopListeningComposition = function stopListeningComposition() {
	    if (document && document.removeEventListener) {
	      document.removeEventListener('compositionstart', this.onCompositionStart);
	      document.removeEventListener('compositionend', this.onCompositionEnd);
	    }
	  };
	
	  // ==============================
	  // Touch Handlers
	  // ==============================
	  _proto.startListeningToTouch = function startListeningToTouch() {
	    if (document && document.addEventListener) {
	      document.addEventListener('touchstart', this.onTouchStart, false);
	      document.addEventListener('touchmove', this.onTouchMove, false);
	      document.addEventListener('touchend', this.onTouchEnd, false);
	    }
	  };
	
	  _proto.stopListeningToTouch = function stopListeningToTouch() {
	    if (document && document.removeEventListener) {
	      document.removeEventListener('touchstart', this.onTouchStart);
	      document.removeEventListener('touchmove', this.onTouchMove);
	      document.removeEventListener('touchend', this.onTouchEnd);
	    }
	  };
	
	  // ==============================
	  // Renderers
	  // ==============================
	  _proto.constructAriaLiveMessage = function constructAriaLiveMessage() {
	    var _this$state7 = this.state,
	        ariaLiveContext = _this$state7.ariaLiveContext,
	        selectValue = _this$state7.selectValue,
	        focusedValue = _this$state7.focusedValue,
	        focusedOption = _this$state7.focusedOption;
	    var _this$props13 = this.props,
	        options = _this$props13.options,
	        menuIsOpen = _this$props13.menuIsOpen,
	        inputValue = _this$props13.inputValue,
	        screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.
	
	    var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
	      focusedValue: focusedValue,
	      getOptionLabel: this.getOptionLabel,
	      selectValue: selectValue
	    }) : ''; // An aria live message representing the currently focused option in the select.
	
	    var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
	      focusedOption: focusedOption,
	      getOptionLabel: this.getOptionLabel,
	      options: options
	    }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
	
	    var resultsMsg = resultsAriaMessage({
	      inputValue: inputValue,
	      screenReaderMessage: screenReaderStatus({
	        count: this.countOptions()
	      })
	    });
	    return focusedValueMsg + " " + focusedOptionMsg + " " + resultsMsg + " " + ariaLiveContext;
	  };
	
	  _proto.renderInput = function renderInput() {
	    var _this$props14 = this.props,
	        isDisabled = _this$props14.isDisabled,
	        isSearchable = _this$props14.isSearchable,
	        inputId = _this$props14.inputId,
	        inputValue = _this$props14.inputValue,
	        tabIndex = _this$props14.tabIndex;
	    var Input = this.components.Input;
	    var inputIsHidden = this.state.inputIsHidden;
	    var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity
	
	    var ariaAttributes = {
	      'aria-autocomplete': 'list',
	      'aria-label': this.props['aria-label'],
	      'aria-labelledby': this.props['aria-labelledby']
	    };
	
	    if (!isSearchable) {
	      // use a dummy input to maintain focus/blur functionality
	      return React__default.createElement(DummyInput, _extends$4({
	        id: id,
	        innerRef: this.getInputRef,
	        onBlur: this.onInputBlur,
	        onChange: utils.noop,
	        onFocus: this.onInputFocus,
	        readOnly: true,
	        disabled: isDisabled,
	        tabIndex: tabIndex,
	        value: ""
	      }, ariaAttributes));
	    }
	
	    var _this$commonProps = this.commonProps,
	        cx = _this$commonProps.cx,
	        theme = _this$commonProps.theme,
	        selectProps = _this$commonProps.selectProps;
	    return React__default.createElement(Input, _extends$4({
	      autoCapitalize: "none",
	      autoComplete: "off",
	      autoCorrect: "off",
	      cx: cx,
	      getStyles: this.getStyles,
	      id: id,
	      innerRef: this.getInputRef,
	      isDisabled: isDisabled,
	      isHidden: inputIsHidden,
	      onBlur: this.onInputBlur,
	      onChange: this.handleInputChange,
	      onFocus: this.onInputFocus,
	      selectProps: selectProps,
	      spellCheck: "false",
	      tabIndex: tabIndex,
	      theme: theme,
	      type: "text",
	      value: inputValue
	    }, ariaAttributes));
	  };
	
	  _proto.renderPlaceholderOrValue = function renderPlaceholderOrValue() {
	    var _this4 = this;
	
	    var _this$components = this.components,
	        MultiValue = _this$components.MultiValue,
	        MultiValueContainer = _this$components.MultiValueContainer,
	        MultiValueLabel = _this$components.MultiValueLabel,
	        MultiValueRemove = _this$components.MultiValueRemove,
	        SingleValue = _this$components.SingleValue,
	        Placeholder = _this$components.Placeholder;
	    var commonProps = this.commonProps;
	    var _this$props15 = this.props,
	        controlShouldRenderValue = _this$props15.controlShouldRenderValue,
	        isDisabled = _this$props15.isDisabled,
	        isMulti = _this$props15.isMulti,
	        inputValue = _this$props15.inputValue,
	        placeholder = _this$props15.placeholder;
	    var _this$state8 = this.state,
	        selectValue = _this$state8.selectValue,
	        focusedValue = _this$state8.focusedValue,
	        isFocused = _this$state8.isFocused;
	
	    if (!this.hasValue() || !controlShouldRenderValue) {
	      return inputValue ? null : React__default.createElement(Placeholder, _extends$4({}, commonProps, {
	        key: "placeholder",
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }), placeholder);
	    }
	
	    if (isMulti) {
	      var selectValues = selectValue.map(function (opt, index) {
	        var isOptionFocused = opt === focusedValue;
	        return React__default.createElement(MultiValue, _extends$4({}, commonProps, {
	          components: {
	            Container: MultiValueContainer,
	            Label: MultiValueLabel,
	            Remove: MultiValueRemove
	          },
	          isFocused: isOptionFocused,
	          isDisabled: isDisabled,
	          key: _this4.getOptionValue(opt),
	          index: index,
	          removeProps: {
	            onClick: function onClick() {
	              return _this4.removeValue(opt);
	            },
	            onTouchEnd: function onTouchEnd() {
	              return _this4.removeValue(opt);
	            },
	            onMouseDown: function onMouseDown(e) {
	              e.preventDefault();
	              e.stopPropagation();
	            }
	          },
	          data: opt
	        }), _this4.formatOptionLabel(opt, 'value'));
	      });
	      return selectValues;
	    }
	
	    if (inputValue) {
	      return null;
	    }
	
	    var singleValue = selectValue[0];
	    return React__default.createElement(SingleValue, _extends$4({}, commonProps, {
	      data: singleValue,
	      isDisabled: isDisabled
	    }), this.formatOptionLabel(singleValue, 'value'));
	  };
	
	  _proto.renderClearIndicator = function renderClearIndicator() {
	    var ClearIndicator = this.components.ClearIndicator;
	    var commonProps = this.commonProps;
	    var _this$props16 = this.props,
	        isDisabled = _this$props16.isDisabled,
	        isLoading = _this$props16.isLoading;
	    var isFocused = this.state.isFocused;
	
	    if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
	      return null;
	    }
	
	    var innerProps = {
	      onMouseDown: this.onClearIndicatorMouseDown,
	      onTouchEnd: this.onClearIndicatorTouchEnd,
	      'aria-hidden': 'true'
	    };
	    return React__default.createElement(ClearIndicator, _extends$4({}, commonProps, {
	      innerProps: innerProps,
	      isFocused: isFocused
	    }));
	  };
	
	  _proto.renderLoadingIndicator = function renderLoadingIndicator() {
	    var LoadingIndicator = this.components.LoadingIndicator;
	    var commonProps = this.commonProps;
	    var _this$props17 = this.props,
	        isDisabled = _this$props17.isDisabled,
	        isLoading = _this$props17.isLoading;
	    var isFocused = this.state.isFocused;
	    if (!LoadingIndicator || !isLoading) return null;
	    var innerProps = {
	      'aria-hidden': 'true'
	    };
	    return React__default.createElement(LoadingIndicator, _extends$4({}, commonProps, {
	      innerProps: innerProps,
	      isDisabled: isDisabled,
	      isFocused: isFocused
	    }));
	  };
	
	  _proto.renderIndicatorSeparator = function renderIndicatorSeparator() {
	    var _this$components2 = this.components,
	        DropdownIndicator = _this$components2.DropdownIndicator,
	        IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
	
	    if (!DropdownIndicator || !IndicatorSeparator) return null;
	    var commonProps = this.commonProps;
	    var isDisabled = this.props.isDisabled;
	    var isFocused = this.state.isFocused;
	    return React__default.createElement(IndicatorSeparator, _extends$4({}, commonProps, {
	      isDisabled: isDisabled,
	      isFocused: isFocused
	    }));
	  };
	
	  _proto.renderDropdownIndicator = function renderDropdownIndicator() {
	    var DropdownIndicator = this.components.DropdownIndicator;
	    if (!DropdownIndicator) return null;
	    var commonProps = this.commonProps;
	    var isDisabled = this.props.isDisabled;
	    var isFocused = this.state.isFocused;
	    var innerProps = {
	      onMouseDown: this.onDropdownIndicatorMouseDown,
	      onTouchEnd: this.onDropdownIndicatorTouchEnd,
	      'aria-hidden': 'true'
	    };
	    return React__default.createElement(DropdownIndicator, _extends$4({}, commonProps, {
	      innerProps: innerProps,
	      isDisabled: isDisabled,
	      isFocused: isFocused
	    }));
	  };
	
	  _proto.renderMenu = function renderMenu() {
	    var _this5 = this;
	
	    var _this$components3 = this.components,
	        Group = _this$components3.Group,
	        GroupHeading = _this$components3.GroupHeading,
	        Menu = _this$components3.Menu,
	        MenuList = _this$components3.MenuList,
	        MenuPortal = _this$components3.MenuPortal,
	        LoadingMessage = _this$components3.LoadingMessage,
	        NoOptionsMessage = _this$components3.NoOptionsMessage,
	        Option = _this$components3.Option;
	    var commonProps = this.commonProps;
	    var _this$state9 = this.state,
	        focusedOption = _this$state9.focusedOption,
	        menuOptions = _this$state9.menuOptions;
	    var _this$props18 = this.props,
	        captureMenuScroll = _this$props18.captureMenuScroll,
	        inputValue = _this$props18.inputValue,
	        isLoading = _this$props18.isLoading,
	        loadingMessage = _this$props18.loadingMessage,
	        minMenuHeight = _this$props18.minMenuHeight,
	        maxMenuHeight = _this$props18.maxMenuHeight,
	        menuIsOpen = _this$props18.menuIsOpen,
	        menuPlacement = _this$props18.menuPlacement,
	        menuPosition = _this$props18.menuPosition,
	        menuPortalTarget = _this$props18.menuPortalTarget,
	        menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
	        menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
	        noOptionsMessage = _this$props18.noOptionsMessage,
	        onMenuScrollToTop = _this$props18.onMenuScrollToTop,
	        onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
	    if (!menuIsOpen) return null; // TODO: Internal Option Type here
	
	    var render = function render(props) {
	      // for performance, the menu options in state aren't changed when the
	      // focused option changes so we calculate additional props based on that
	      var isFocused = focusedOption === props.data;
	      props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
	      return React__default.createElement(Option, _extends$4({}, commonProps, props, {
	        isFocused: isFocused
	      }), _this5.formatOptionLabel(props.data, 'menu'));
	    };
	
	    var menuUI;
	
	    if (this.hasOptions()) {
	      menuUI = menuOptions.render.map(function (item) {
	        if (item.type === 'group') {
	          var type = item.type,
	              group = _objectWithoutPropertiesLoose$2(item, ["type"]);
	
	          var headingId = item.key + "-heading";
	          return React__default.createElement(Group, _extends$4({}, commonProps, group, {
	            Heading: GroupHeading,
	            headingProps: {
	              id: headingId
	            },
	            label: _this5.formatGroupLabel(item.data)
	          }), item.options.map(function (option) {
	            return render(option);
	          }));
	        } else if (item.type === 'option') {
	          return render(item);
	        }
	      });
	    } else if (isLoading) {
	      var message = loadingMessage({
	        inputValue: inputValue
	      });
	      if (message === null) return null;
	      menuUI = React__default.createElement(LoadingMessage, commonProps, message);
	    } else {
	      var _message = noOptionsMessage({
	        inputValue: inputValue
	      });
	
	      if (_message === null) return null;
	      menuUI = React__default.createElement(NoOptionsMessage, commonProps, _message);
	    }
	
	    var menuPlacementProps = {
	      minMenuHeight: minMenuHeight,
	      maxMenuHeight: maxMenuHeight,
	      menuPlacement: menuPlacement,
	      menuPosition: menuPosition,
	      menuShouldScrollIntoView: menuShouldScrollIntoView
	    };
	    var menuElement = React__default.createElement(index.MenuPlacer, _extends$4({}, commonProps, menuPlacementProps), function (_ref8) {
	      var ref = _ref8.ref,
	          _ref8$placerProps = _ref8.placerProps,
	          placement = _ref8$placerProps.placement,
	          maxHeight = _ref8$placerProps.maxHeight;
	      return React__default.createElement(Menu, _extends$4({}, commonProps, menuPlacementProps, {
	        innerRef: ref,
	        innerProps: {
	          onMouseDown: _this5.onMenuMouseDown,
	          onMouseMove: _this5.onMenuMouseMove
	        },
	        isLoading: isLoading,
	        placement: placement
	      }), React__default.createElement(ScrollCaptorSwitch, {
	        isEnabled: captureMenuScroll,
	        onTopArrive: onMenuScrollToTop,
	        onBottomArrive: onMenuScrollToBottom
	      }, React__default.createElement(ScrollBlock, {
	        isEnabled: menuShouldBlockScroll
	      }, React__default.createElement(MenuList, _extends$4({}, commonProps, {
	        innerRef: _this5.getMenuListRef,
	        isLoading: isLoading,
	        maxHeight: maxHeight
	      }), menuUI))));
	    }); // positioning behaviour is almost identical for portalled and fixed,
	    // so we use the same component. the actual portalling logic is forked
	    // within the component based on `menuPosition`
	
	    return menuPortalTarget || menuPosition === 'fixed' ? React__default.createElement(MenuPortal, _extends$4({}, commonProps, {
	      appendTo: menuPortalTarget,
	      controlElement: this.controlRef,
	      menuPlacement: menuPlacement,
	      menuPosition: menuPosition
	    }), menuElement) : menuElement;
	  };
	
	  _proto.renderFormField = function renderFormField() {
	    var _this6 = this;
	
	    var _this$props19 = this.props,
	        delimiter = _this$props19.delimiter,
	        isDisabled = _this$props19.isDisabled,
	        isMulti = _this$props19.isMulti,
	        name = _this$props19.name;
	    var selectValue = this.state.selectValue;
	    if (!name || isDisabled) return;
	
	    if (isMulti) {
	      if (delimiter) {
	        var value = selectValue.map(function (opt) {
	          return _this6.getOptionValue(opt);
	        }).join(delimiter);
	        return React__default.createElement("input", {
	          name: name,
	          type: "hidden",
	          value: value
	        });
	      } else {
	        var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
	          return React__default.createElement("input", {
	            key: "i-" + i,
	            name: name,
	            type: "hidden",
	            value: _this6.getOptionValue(opt)
	          });
	        }) : React__default.createElement("input", {
	          name: name,
	          type: "hidden"
	        });
	        return React__default.createElement("div", null, input);
	      }
	    } else {
	      var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
	
	      return React__default.createElement("input", {
	        name: name,
	        type: "hidden",
	        value: _value2
	      });
	    }
	  };
	
	  _proto.renderLiveRegion = function renderLiveRegion() {
	    if (!this.state.isFocused) return null;
	    return React__default.createElement(A11yText, {
	      "aria-live": "polite"
	    }, React__default.createElement("p", {
	      id: "aria-selection-event"
	    }, "\xA0", this.state.ariaLiveSelection), React__default.createElement("p", {
	      id: "aria-context"
	    }, "\xA0", this.constructAriaLiveMessage()));
	  };
	
	  _proto.render = function render() {
	    var _this$components4 = this.components,
	        Control = _this$components4.Control,
	        IndicatorsContainer = _this$components4.IndicatorsContainer,
	        SelectContainer = _this$components4.SelectContainer,
	        ValueContainer = _this$components4.ValueContainer;
	    var _this$props20 = this.props,
	        className = _this$props20.className,
	        id = _this$props20.id,
	        isDisabled = _this$props20.isDisabled,
	        menuIsOpen = _this$props20.menuIsOpen;
	    var isFocused = this.state.isFocused;
	    var commonProps = this.commonProps = this.getCommonProps();
	    return React__default.createElement(SelectContainer, _extends$4({}, commonProps, {
	      className: className,
	      innerProps: {
	        id: id,
	        onKeyDown: this.onKeyDown
	      },
	      isDisabled: isDisabled,
	      isFocused: isFocused
	    }), this.renderLiveRegion(), React__default.createElement(Control, _extends$4({}, commonProps, {
	      innerRef: this.getControlRef,
	      innerProps: {
	        onMouseDown: this.onControlMouseDown,
	        onTouchEnd: this.onControlTouchEnd
	      },
	      isDisabled: isDisabled,
	      isFocused: isFocused,
	      menuIsOpen: menuIsOpen
	    }), React__default.createElement(ValueContainer, _extends$4({}, commonProps, {
	      isDisabled: isDisabled
	    }), this.renderPlaceholderOrValue(), this.renderInput()), React__default.createElement(IndicatorsContainer, _extends$4({}, commonProps, {
	      isDisabled: isDisabled
	    }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
	  };
	
	  return Select;
	}(React.Component);
	
	Select.defaultProps = defaultProps;
	
	exports.Select = Select;
	exports.createFilter = createFilter;
	exports.defaultProps = defaultProps;
	exports.defaultTheme = defaultTheme;
	exports.mergeStyles = mergeStyles;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var memoizeOne = _interopDefault(__webpack_require__(50));
	var core = __webpack_require__(20);
	__webpack_require__(4);
	__webpack_require__(3);
	__webpack_require__(25);
	var index$1 = __webpack_require__(66);
	var reactSelect = __webpack_require__(176);
	__webpack_require__(12);
	__webpack_require__(57);
	var stateManager = __webpack_require__(178);
	var createCache = _interopDefault(__webpack_require__(28));
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var NonceProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(NonceProvider, _Component);
	
	  function NonceProvider(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    _this.createEmotionCache = function (nonce) {
	      return createCache({
	        nonce: nonce
	      });
	    };
	
	    _this.createEmotionCache = memoizeOne(_this.createEmotionCache);
	    return _this;
	  }
	
	  var _proto = NonceProvider.prototype;
	
	  _proto.render = function render() {
	    var emotionCache = this.createEmotionCache(this.props.nonce);
	    return React__default.createElement(core.CacheProvider, {
	      value: emotionCache
	    }, this.props.children);
	  };
	
	  return NonceProvider;
	}(React.Component);
	
	var index = stateManager.manageState(reactSelect.Select);
	
	exports.components = index$1.components;
	exports.createFilter = reactSelect.createFilter;
	exports.defaultTheme = reactSelect.defaultTheme;
	exports.mergeStyles = reactSelect.mergeStyles;
	exports.NonceProvider = NonceProvider;
	exports.default = index;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	var defaultProps = {
	  defaultInputValue: '',
	  defaultMenuIsOpen: false,
	  defaultValue: null
	};
	
	var manageState = function manageState(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(StateManager, _Component);
	
	    function StateManager() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.select = void 0;
	      _this.state = {
	        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
	        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
	        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
	      };
	
	      _this.onChange = function (value, actionMeta) {
	        _this.callProp('onChange', value, actionMeta);
	
	        _this.setState({
	          value: value
	        });
	      };
	
	      _this.onInputChange = function (value, actionMeta) {
	        // TODO: for backwards compatibility, we allow the prop to return a new
	        // value, but now inputValue is a controllable prop we probably shouldn't
	        var newValue = _this.callProp('onInputChange', value, actionMeta);
	
	        _this.setState({
	          inputValue: newValue !== undefined ? newValue : value
	        });
	      };
	
	      _this.onMenuOpen = function () {
	        _this.callProp('onMenuOpen');
	
	        _this.setState({
	          menuIsOpen: true
	        });
	      };
	
	      _this.onMenuClose = function () {
	        _this.callProp('onMenuClose');
	
	        _this.setState({
	          menuIsOpen: false
	        });
	      };
	
	      return _this;
	    }
	
	    var _proto = StateManager.prototype;
	
	    _proto.focus = function focus() {
	      this.select.focus();
	    };
	
	    _proto.blur = function blur() {
	      this.select.blur();
	    } // FIXME: untyped flow code, return any
	    ;
	
	    _proto.getProp = function getProp(key) {
	      return this.props[key] !== undefined ? this.props[key] : this.state[key];
	    } // FIXME: untyped flow code, return any
	    ;
	
	    _proto.callProp = function callProp(name) {
	      if (typeof this.props[name] === 'function') {
	        var _this$props;
	
	        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        return (_this$props = this.props)[name].apply(_this$props, args);
	      }
	    };
	
	    _proto.render = function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          defaultInputValue = _this$props2.defaultInputValue,
	          defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
	          defaultValue = _this$props2.defaultValue,
	          props = _objectWithoutPropertiesLoose(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
	
	      return React__default.createElement(SelectComponent, _extends({}, props, {
	        ref: function ref(_ref) {
	          _this2.select = _ref;
	        },
	        inputValue: this.getProp('inputValue'),
	        menuIsOpen: this.getProp('menuIsOpen'),
	        onChange: this.onChange,
	        onInputChange: this.onInputChange,
	        onMenuClose: this.onMenuClose,
	        onMenuOpen: this.onMenuOpen,
	        value: this.getProp('value')
	      }));
	    };
	
	    return StateManager;
	  }(React.Component), _class.defaultProps = defaultProps, _temp;
	};
	
	exports.manageState = manageState;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _innerSliderUtils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PrevArrow =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = _react["default"].cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, {}, customProps));
	      } else {
	        prevArrow = _react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow =
	/*#__PURE__*/
	function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = _react["default"].cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, {}, customProps));
	      } else {
	        nextArrow = _react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var dotCount = getDotCount({
	        slideCount: this.props.slideCount,
	        slidesToScroll: this.props.slidesToScroll,
	        slidesToShow: this.props.slidesToShow,
	        infinite: this.props.infinite
	      }); // Apply join & split to Array to pre-fill it for IE8
	      //
	      // Credit: http://stackoverflow.com/a/13735425/1849458
	
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	        var leftBound = i * _this.props.slidesToScroll;
	        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: _this.props.slidesToScroll,
	          currentSlide: _this.props.currentSlide
	        };
	
	        var onClick = _this.clickHandler.bind(_this, dotOptions);
	
	        return _react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, _react["default"].cloneElement(_this.props.customPaging(i), {
	          onClick: onClick
	        }));
	      });
	      return _react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ },
/* 182 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(4));
	
	var _initialState = _interopRequireDefault(__webpack_require__(182));
	
	var _lodash = _interopRequireDefault(__webpack_require__(126));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _innerSliderUtils = __webpack_require__(18);
	
	var _track = __webpack_require__(185);
	
	var _dots = __webpack_require__(181);
	
	var _arrows = __webpack_require__(179);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(187));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
	      _this.ssrInit();
	
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      }); // To support server-side rendering
	
	      if (!window) {
	        return;
	      }
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, {}, _this.state);
	
	      var setTrackStyle = false;
	
	      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
	        var key = _Object$keys[_i];
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      if (!_reactDom["default"].findDOMNode(_this.track)) return;
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, {}, _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread({}, spec, {}, updatedState, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread({}, spec, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, {}, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, {}, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	
	        return;
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
	        index: index
	      }, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, {}, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread({}, verticalHeightStyle, {}, centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), _react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread({}, _initialState["default"], {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(183);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(125));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(180));
	
	var _innerSliderUtils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(100);
	
	var Slider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "UNSAFE_componentWillMount",
	    value: function UNSAFE_componentWillMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
	      } else {
	        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push(_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push(_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return _react["default"].createElement("div", {
	          className: className
	        }, newChildren);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return _react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _innerSliderUtils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread({}, spec, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push(_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread({
	        outline: "none"
	      }, child.props.style || {}, {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        preCloneSlides.push(_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        postCloneSlides.push(_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return _react["default"].createElement("div", _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(2),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(188);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(34)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 191 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(191);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 193 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(190).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/D-DIN.eb09665e.ttf";

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cart.18b8469d.png";

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/carts.15bed7cd.png";

/***/ },
/* 198 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(198);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 201 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 202 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.cc51a394.js